import { useContext, useEffect, useRef } from "react";
import {
  StyleSheet,
  View,
  TouchableOpacity,
  Dimensions,
  Linking,
  BackHandler,
  Animated,
} from "react-native";
import SummaryInfo from "./SummaryInfo/SummaryInfo";
import NavBar from "../NavBar/NavBar.js";
import { useState } from "react";
import {
  Separator,
  Button,
  LoanId,
  context,
  Title,
  InputBox,
  Spinner,
  AddRemoveButton,
  PageBottom,
  DrawerView,
  IconButton,
} from "../accessories/accessories.js";
import CustomText from "../accessories/CustomText.js";
import Icon from "react-native-vector-icons/FontAwesome";
import Entypo from "react-native-vector-icons/Entypo";
import {
  handleAPI,
  formatCurrency,
  roundNumber,
  cleanValue,
  updateWebURL,
  log,
  FormatPhoneLogin,
  formatDateTimeNew,
  formatSSN,
  handleGetEmpDetails,
  groupByKey,
  handleUserDetails,
  handleLogDWCallToActionEventParent,
  queryStringToObject,
  sortByKey,
  handleGetZipCodeDetails,
  handleGetPlatformName,
  calculateAge,
  handleOpenScanDocFile,
  generateBoxShadowStyle,
  getQueryString,
  handleStructuredClone,
  removeDuplicates,
  handleGetSubjectPropertyAddress,
  handleSelectLoanProgram,
  capitalizeFirstLetter,
} from "../accessories/CommonFunctions.js";
import LeftNavBar from "../NavBar/leftNavBar.js";
import ScrollContainer from "../accessories/ScrollContainer.js";
import ContactInfo from "./ContactInfo/ContactInfo";
import AddressHistory from "./AddressHistory/AddressHistory";
import CreditScore from "./CreditScore/CreditScore";
import Government from "./Government/Government";
import DocumentUpload from "./DocumentUpload/DocumentUpload";
import InterestRate from "./InterestRate/InterestRate";
import Income from "./InCome/Income";
import Assets from "./Assets/Assets";
import { android, ios, web } from "../accessories/Platform";
import { REDIRECT_URL } from "@env";
import ExternalSourceViewer from "../accessories/ExternalSourceViewer";
import BorrowerVerification from "../Plaid/BorrowerVerification";
import AsyncStorage from "@react-native-async-storage/async-storage";
import AppraisalPayment from "./AppraisalPayment/AppraisalPayment";
import Footer from "../accessories/footer";
import ShareApp from "../NavigationBar/ShareApp";
import LoanContacts from "../NavigationBar/LoanContacts";
import DocumentViewer from "./DocumentUpload/DocumentViewer";
import Settings from "../NavigationBar/Setting";
import CalculatorApp from "../NavigationBar/Calculator";
import Swatch from "../accessories/Swatch";
import {
  iActivePageArray,
  iPageArray,
  iPageIdObj,
} from "../NavBar/NavAccessories";
import ArrowSpinner from "../accessories/ArrowSpinner";
import CalculatorMenu from "../accessories/CalculatorMenu";
import OtherLoanVendor from "./Assets/OtherLoanVendor";

let GoToNav = 0;

export default function Home(props) {
  const { contextDetails, setContextDetails } = useContext(context); //Get value from context

  const { userName, SessionId = "", loanId: iLoanId } = contextDetails;

  GoToNav = Number(
    contextDetails["GoToNav"] || props.route.params?.GoToNav || 0
  );
  const { navigation } = props;

  //=======================================State Declaration================================================
  const [pageArray, setPageArray] = useState([
    "summaryInfo",
    "borrowerInfo",
    "borrowerVerification",
    "bankAccounts",
    "addressHistory",
    "creditScore",
    "employment",
    "realEstateOwned",
    "government",
    "documentUpload",
    "eSign",
    "appraisalPayment",
    "reviewYourInterestRate",
    "completed",
  ]);
  // console.log(iPageArray, iPageId, iActivePageArray);
  const [pageId, setPageId] = useState({
    summaryInfo: 0,
    borrowerInfo: 1,
    borrowerVerification: 2,
    bankAccounts: 3,
    addressHistory: 4,
    creditScore: 5,
    income: 6,
    realEstateOwned: 7,
    government: 8,
    documentUpload: 9,
    eSign: 10,
    appraisalPayment: 11,
    reviewYourInterestRate: 12,
    completed: 13,
  });
  const [activePageArray, setActivePageArray] = useState([
    "Summary Info",
    "Borrower Info",
    "Verify Bank Accounts",
    "Bank Accounts",
    "Address History",
    "Credit Scores",
    "Employment",
    "Real Estate Owned",
    "Government",
    "Document Upload",
    "eSign",
    "Appraisal Payment",
    "Review Your Interest Rate",
    "Completed",
  ]);

  const [currentPage, setCurrentPage] = useState(pageArray[0]);
  const [isDisableNext, setIsDisableNext] = useState(false);
  const [progressPercentage, setProgressPercentage] = useState(0);
  const [loanOfficerOption, setLoanOfficerOption] = useState([]);
  const [loanId, setLoanId] = useState(0);
  const [landOnScreen, setLandOnScreen] = useState(null);
  const [pageIndex, setPageIndex] = useState({
      page: 0,
      subPage: 0,
    }),
    //App Payment Alert
    [alertMessage, setAlertMessage] = useState({
      message: null,
      isShow: false,
      type: null,
    });

  const [clickProcessPayment, setClickProcessPayment] = useState(false);
  const [isPaymentDone, setIsPaymentDone] = useState(false);
  const [processPaymentDisabled, setProcessPaymentDisabled] = useState(true);
  const [processingStatus, setProcessingStatus] = useState(true);
  // useEffect(() => {
  const handleHiddenButtonClickDone = () => {
    // Reset triggerHiddenButtonClick after its work is done
    setClickProcessPayment(false);
  };

  const handleProcessPaymentDisabled = (disabled) => {
    // Receive the disabled attribute value from the child

    setProcessPaymentDisabled(disabled);
  };

  const handleProcessingStatus = (ProcessingStatus) => {
    // Reset triggerHiddenButtonClick after its work is done
    setProcessingStatus(ProcessingStatus);
  };

  //   //const eventEmitter = new NativeEventEmitter(NativeModules.MyNativeModule);
  //   //const eventEmitter=new  DeviceEventEmitter();

  //   // Listen for the event sent from AppDelegate
  //   // const subscription = DeviceEventEmitter.addListener('URLDataReceived', ({ data }) => {
  //   //  // console.log('Received data in React Native:', data);
  //   //   setLoanOfficerId(data);
  //   //   AsyncStorage.setItem("LoEmpNum", data || null);
  //   // });

  //   // Clean up subscription when component unmounts
  //   return () => subscription.remove();
  // }, []);

  const [loanProductSelectionStatus, setLoanProductSelectionStatus] = useState({
    isSelected: false,
    status: null,
  });

  const [stickyHeader, setStickyHeader] = useState(false);
  const [hideFooterButtons, setHideFooterButtons] = useState(false);
  const [containerHeightDetails, setContainerHeightDetails] = useState({
    containerHeight: 0,
    contentHeight: 0,
  });
  const bodyContainerRef = useRef(null);
  const bodyContentRef = useRef(null);
  const footerContainerRef = useRef(null);
  const [pullDownRefresh, setPullDownRefresh] = useState(false);
  const [completedPage, setCompletedPage] = useState(null);
  const [inCompletedSubPage, setInCompletedSubPage] = useState([]);
  const [inCompletedSubPageObj, setInCompletedSubPageObj] = useState({});

  const [leftNavStatus, setLeftNavStatus] = useState([]);
  const [scrollToTop, setScrollToTop] = useState(false);
  const [loaderDetails, setLoaderDetails] = useState({ isLoad: false });
  const [documentUploadFlag, setDocumentUploadFlag] = useState({
    headerText: null,
  });
  const [propertyTypeOption, setPropertyTypeOption] = useState([
    { label: "-Select-", value: "" },
  ]);
  const [processStatus, setProcessStatus] = useState("onLoad");
  const [LoanData, setLoanData] = useState({});
  const [InterestRateStatus, setInterestRateStatus] = useState(null);
  const [DetailsArr, setDetailsArr] = useState([]);
  const [additionalBorrowerInfo, setAdditionalBorrowerInfo] = useState([]);
  const [additionalEmploymentInfo, setAdditionalEmploymentInfo] = useState([]);
  const [additionalCounsellingInfo, setAdditionalCounsellingInfo] = useState(
    []
  );
  const [additionalOtherIncomeInfo, setAdditionalOtherIncomeInfo] = useState(
    []
  );
  const [additionalPropertyInfo, setAdditionalPropertyInfo] = useState([]);
  const [additionalBankInfo, setAdditionalBankInfo] = useState([]);
  const [otherIncomeOption, setOtherIncomeOption] = useState([
    { label: "-Select-", value: "" },
  ]);
  const [stateOptions, setStateOptions] = useState([
    { label: "-Select-", value: "" },
  ]);

  const [giftOptions, setGiftOptions] = useState([
    { value: 0, label: "Gift Source" },
    { value: 2, label: "Relative" },
    { value: 3, label: "Government Assistance" },
    { value: 4, label: "Employer" },
    { value: 5, label: "Non-Profit" },
    { value: 6, label: "Local Agency" },
  ]);
  const [otherAccountTypeOption, setOtherAccountTypeOption] = useState([
    { value: "0", label: "Other Account Type" },
    { value: "11", label: "Bridge Loan" },
    { value: "4", label: "Earnest Money Deposit" }, //BordataAssetDetails
    { value: "5", label: "Certificate of Deposit" },
    { value: "3", label: "Gift in Borrower Possession" },
    { value: "20", label: "Gift of Equity" },
    { value: "19", label: "Gift to Be Given at Closing" },
    { value: "22", label: "Life Insurance" }, //BordataAssetDetails
    { value: "6", label: "Money Market Fund" },
    { value: "7", label: "Mutual Funds" },
    { value: "17", label: "Net Equity" },
    { value: "12", label: "Retirement Funds" }, //BordataAssetDetails
    { value: "10", label: "Secured Borrowed Funds" },
    { value: "33", label: "Stocks and Bonds" }, //BordataAssetDetails
    { value: "14", label: "Trust Funds" },
    { value: "37", label: "Grant" },
  ]);

  const [accountTypeOption, setAccountTypeOption] = useState([
    { label: "-Select-", value: "" },
    { label: "Checking", value: "1" },
    { label: "Savings", value: "2" },
    { label: "Other Types", value: "-1" },
  ]);
  const [vendorOptions, setVendorOptions] = useState([
    { label: "-Select-", value: "" },
  ]);
  const [maritalStatusOptions, setMaritalStatusOptions] = useState([
    { value: "0", label: "Select" },
    // { value: "1", label: "Married to Person Not On This Loan" },
    { value: "1", label: "Married - Person Not Yet Entered" },
    { value: "3", label: "Not Married" },
    { value: "2", label: "Separated" },
  ]);
  const [UserId, setUserId] = useState(0);
  const [loanOfficerId, setLoanOfficerId] = useState(0);
  const [creditScoreDetails, SetCreditScoreDetails] = useState({
    Status: -1,
    isAlready: -1,
    Details: [],
    ErrMsg: "",
  });
  const [floatPage, setFloatPage] = useState(null);

  const [isFromDashBoard, setIsFromDashBoard] = useState(true);
  const [DocumentViewProps, setDocumentViewProps] = useState(null);

  const [drawerDetails, setDrawerDetails] = useState({
    isShow: false,
    body: <></>,
    onClose: () => {},
  });
  const [loanOfficers, setLoanOfficers] = useState(
    web
      ? queryStringToObject(window.location?.href || "")["loanOfficerId"] ||
          contextDetails.RecentLoId ||
          0
      : contextDetails.RecentLoId || 0
  );
  const [loanURLDetails, setLoanURLDetails] = useState({});

  const [excludePageIndex, setExcludePageIndex] = useState({
    Ids: [],
    index: [],
  });
  const [screenSize, setScreenSize] = useState(
    web ? [window.innerWidth, window.innerHeight] : [0, 0]
  );
  const [WebLoginId, setWebLoginId] = useState(null);
  const [hideProgress, setHideProgress] = useState(false);
  const [platformType, setPlatformType] = useState("");
  const [pdfView, setPdfView] = useState(false);
  const [showEsignMenu, setShowEsignMenu] = useState(false);
  const [webviewRef, setWebviewRef] = useState(null);
  const [iFrameviewRef, setiFrameviewRef] = useState(null);
  const [isDataLoadedForDocUpload, setIsDataLoadedForDocUpload] =
    useState(false);

  //=======================================useEffect================================================
  if (web) {
    useEffect(() => {
      const styleElement = document.createElement("style");
      styleElement.innerHTML = `
      :focus-visible {
        outline: black auto 1px;
      }
      [data-testid="statusIcon"]{
        font-weight: 600 !important;
      }
      [data-testid="InterestRateModalMobile"] > div{
        align-items: center;
      }
      [data-testid="InterestRateModal"] > div{
        align-items: center;
        left:-8px;
      }
    `;
      document.head.appendChild(styleElement);
      return () => {
        document.head.removeChild(styleElement);
      };
      //if (!web) setHideProgress(false);
    }, []);
    useEffect(() => {
      try {
        if (LoanData["LockLoanApp"] == 1) {
          window.addEventListener("keydown", keydownHandler);
          window.addEventListener("mousedown", keydownHandler);
        } else {
          window.removeEventListener("mousedown", keydownHandler);

          window.removeEventListener("keydown", keydownHandler);
        }
      } catch (error) {}
      return () => {
        window.removeEventListener("keydown", keydownHandler);
        window.removeEventListener("mousedown", keydownHandler);
      };
    }, [LoanData["LockLoanApp"], currentPage]);
  }
  useEffect(() => {
    if (
      [pageId["bankAccounts"], pageId["income"]].includes(pageIndex["page"])
    ) {
      handleGetBankEmpDetails();
    } else if (
      pageIndex["page"] == pageId["borrowerVerification"] &&
      LoanData["viewPlaid"]
    ) {
      setLoanData((prevLoanData) => ({
        ...prevLoanData,
        viewPlaid: false,
        LinkBankAccount: null,
      }));
    }
  }, [pageIndex["page"]]);

  useEffect(() => {
    if (additionalBorrowerInfo.length) {
      let { FirstName, NickName = "", MiddleName, LastName, Suffix } = LoanData;
      FirstName = FirstName || (NickName || "").trim();
      const options = [
        { value: "0", label: "Select" },
        //{ value: "1", label: "Married to a person not on this Loan" },
        { value: "1", label: "Married - Person Not Yet Entered" },
        {
          value: Number(LoanData["UserId"]),
          label: `Married to ${FirstName} ${MiddleName} ${LastName}  ${Suffix}`,
        },
        ...additionalBorrowerInfo
          .slice(1)
          .map(
            ({
              FirstName = (NickName || "").trim(),
              LastName,
              MiddleName,
              Suffix,
              CustId,
            }) => {
              return {
                value: Number(CustId),
                label: `Married to ${FirstName} ${MiddleName} ${LastName} ${Suffix}`,
              };
            }
          ),
        { value: "3", label: "Not Married" },
        { value: "2", label: "Separated" },
      ];

      setMaritalStatusOptions([...options]);
    }
  }, [
    additionalBorrowerInfo,
    LoanData["FirstName"],
    LoanData["NickName"],
    LoanData["MiddleName"],
    LoanData["LastName"],
    LoanData["Suffix"],
  ]);

  const handleMaritalStatusChange = ({
    iAdditionalBorrowerInfo = [...additionalBorrowerInfo],
    changedId,
    isPrimary = false,
    custId = 0,
    index = 0,
  }) => {
    const { UserId, MaritalStatus } = LoanData,
      iMaritalStatus =
        MaritalStatus == custId
          ? 0
          : UserId == changedId
          ? custId
          : MaritalStatus,
      changesIndex = [];

    const newCustId = Number(isPrimary ? UserId : custId);

    iAdditionalBorrowerInfo.slice(1).forEach((borrower, iIndex) => {
      if (index != iIndex + 1) {
        const { CustId } = borrower;
        if (
          [changedId, newCustId].includes(Number(borrower["MaritalStatus"]))
        ) {
          borrower["MaritalStatus"] = 0;
          changesIndex.push(iIndex);
        }
        if (CustId == changedId) {
          borrower["MaritalStatus"] = newCustId;
          changesIndex.push(iIndex);
        }
      }
    });

    if (iMaritalStatus !== null || changesIndex.length) {
      setLoanData((prevLoanData) => {
        return {
          ...prevLoanData,
          MaritalStatus: iMaritalStatus,
          isMaritalStatusChanged: iMaritalStatus != MaritalStatus,
          maritalStatusChangesIndex: changesIndex,
        };
      });
    }
    setAdditionalBorrowerInfo([...iAdditionalBorrowerInfo]);
  };

  useEffect(() => {
    if (android) {
      setPlatformType("android");
    } else if (ios) {
      setPlatformType("ios");
    } else if (isMobileWeb) {
      setPlatformType("isMobileWeb");
    } else if (web) {
      setPlatformType("web");
    } else {
      setPlatformType("");
    }
  }, []);

  useEffect(() => {
    const prePare = async () => {
      setLoanId(loanId || iLoanId);
      handleGetWebLoginId();
      await handleLogDWCallToActionEventParent(
        "Borrower_Loan_Application",
        "LogDWVisitorsEvent",
        "Borrower Loan Application",
        {
          SessionId,
          LoanId: loanId || iLoanId || 0,
          Email:
            additionalBorrowerInfo.length > 0
              ? additionalBorrowerInfo[0]["Email"] || ""
              : LoanData["EmailId"] || "",
        },
        activePageArray[pageIndex["page"]]?.replaceAll(" ", "")
      );

      // handleInsertEventToDW();
    };
    prePare();
  }, [props]);
  useEffect(() => {
    if (processStatus === "orderPlaced") {
      setTimeout(() => {
        setProcessStatus(null);
      }, 3000);
    }
  }, [processStatus]);
  useEffect(() => {
    const prePre = async () => {
      let data = await handleGetEmpDetails(SessionId);
      if (data && data["Message"] !== "An error has occurred.") {
        data = JSON.parse(data);
        let userName = data["Table4"][0]["EmpNum"],
          userType = data["Table1"][0]["Type"],
          // AppDownload = data["Table5"][0]["appDownloadFlag"],
          webPlatForm = handleGetPlatformName();

        // if (
        //   AppDownload == 0 &&
        //   web &&
        //   ["iOS", "Android"].includes(webPlatForm)
        // ) {
        //   setIsDisableNext(false);
        //   AppDownload = true;
        // } else {
        //   AppDownload = false;
        //   setIsDisableNext(true);
        // }

        setContextDetails((prevContextDetails) => {
          return {
            ...prevContextDetails,
            ...{
              userName,
              userType,
              taskTableIndex: !contextDetails["taskTableIndex"],
              // appDownloadFlag: AppDownload,
              webPlatForm,
            },
          };
        });
      }
      if (web) {
        function updateSize() {
          setScreenSize([window.innerWidth, window.innerHeight]);
          handleGetContainerHeight();
        }
        window.addEventListener("resize", updateSize);
        updateSize();
        return () => window.removeEventListener("resize", updateSize);
      }
    };
    prePre();
  }, [SessionId]);

  useEffect(() => {
    updateWebURL({ Screen: currentPage.replaceAll(" ", "") });
    const handleEventsLog = async () => {
      if (loanId && UserId !== 0) {
        handleInsertEventToDW();
      }
    };

    if (
      web &&
      currentPage !== pageArray[pageId["eSign"]] &&
      currentPage !== pageArray[pageId["documentUpload"]] &&
      currentPage !== pageArray[pageId["appraisalPayment"]]
    ) {
      (document.querySelectorAll(".externalFrame") || [])?.forEach((item) => {
        item.src = "";
      });
    }

    handleEventsLog();
  }, [currentPage, UserId]);

  useEffect(() => {
    if (
      Object.keys(LoanData).length > 0 &&
      (additionalBorrowerInfo.length > 0 || loanId == -999)
    ) {
      let { iDetailsArr } = handlePageDetails();

      setDetailsArr(iDetailsArr);

      if (currentPage !== pageArray[pageId["documentUpload"]])
        if (isFromDashBoard && loanId > 0) {
          if ([0].includes(GoToNav)) {
            let { iPageIndex, iCurrentPage } = handleGetPageNumber(false);
            setPageIndex({ ...iPageIndex });

            iCurrentPage && setCurrentPage(iCurrentPage);
          } else if (GoToNav) {
            let { iSubPage } = handleGetPageNumber(true, GoToNav);
            if (GoToNav !== 12) {
              setPageIndex({
                page: GoToNav,
                subPage: iSubPage < 0 ? 0 : iSubPage || 0,
              });
            }
          }
          setIsFromDashBoard(false);
        }
      loanId > 0 && handleUpdateCompletedPage();
    } else if (true) {
      let { iDetailsArr } = handlePageDetails();

      setDetailsArr(iDetailsArr);
    }
    handleGetContainerHeight();
  }, [
    pageIndex,
    LoanData,
    loanOfficers,
    additionalBorrowerInfo,
    additionalEmploymentInfo,
    additionalOtherIncomeInfo,
    additionalBankInfo,
    additionalPropertyInfo,
    additionalCounsellingInfo,
    processStatus,
    creditScoreDetails,
    vendorOptions,
  ]);

  useEffect(() => {
    if (!contextDetails["appDownloadFlag"]) {
      setIsDisableNext(![1, 2].includes(LoanData["LoanPurpose"]));
    }
  }, [LoanData, contextDetails["appDownloadFlag"]]);

  useEffect(() => {
    setLoanId(contextDetails.loanId);
  }, [contextDetails.loanId]);
  //alert(currentPage + " " +   pageArray[pageId["appraisalPayment"]] );

  useEffect(() => {
    if ([1, 2].includes(LoanData["LoanPurpose"])) {
      let iAddressTBD = LoanData["prevAddressTBD"];
      if (LoanData["LoanPurpose"] == 2) {
        iAddressTBD = false;
      }
      setLoanData((prevLoanData) => {
        return {
          ...prevLoanData,
          AddressTBD: iAddressTBD,
        };
      });
    }
    if (loanId < 0) {
      handleNavigateSubPage(0, 0);
    }
  }, [LoanData["LoanPurpose"]]);

  useEffect(() => {
    if (contextDetails["isAssetPullCompleted"]) {
      setContextDetails((prevContextDetails) => {
        return {
          ...prevContextDetails,
          isAssetPullCompleted: false,
          pulledAssetCount: 0,
        };
      });

      setLoanData((prevLoanData) => ({
        ...prevLoanData,
        blAssetOption: (contextDetails["pulledAssetCount"] || 0) === 0 ? 1 : 0,
        assetPullCompleted: true,
      }));
    }
  }, [contextDetails]);

  useEffect(() => {
    if (Object.keys(loanURLDetails).length > 0) {
      pageArray[GoToNav] && setCurrentPage(pageArray[GoToNav]);
      setPageIndex({
        ...{},
        ...{
          page: GoToNav,
          subPage: pageIndex["subPage"],
        },
      });
    }
  }, [props]);

  useEffect(() => {
    try {
      let queryObj = queryStringToObject(window.location?.href || "");
      if (!queryObj["loanId"] && queryObj["Path"] == "Home") {
        updateWebURL({ loanId: -999 });
        setContextDetails((prevContextDetails) => {
          return { ...prevContextDetails, loanId: -999, Path: "Home" };
        });
      }
    } catch (error) {}

    setIsFromDashBoard(true);
    handleGetBorrowerUrl();

    if (!contextDetails["isNewLoanCreated"]) {
      pageArray[GoToNav] && setCurrentPage(pageArray[GoToNav]);

      setPageIndex({
        ...{},
        ...{
          page: GoToNav,
          subPage: pageIndex["subPage"] || 0,
        },
      });
    }
    let LoanId = Number(iLoanId || loanId);

    if (LoanId) {
      handleAPIGetLoanDetails(LoanId, true);

      handleAPI({
        name: "GetLoanOfficerList",
        params: { LoanId },
      })
        .then((response) => {
          setLoanOfficerOption(
            JSON.parse(response)["Table"].map((e) => {
              return { value: e.EmpNumber, label: e.name };
            })
          );
        })
        .catch((err) =>
          console.error("Error form GetLoanOfficerList ====> ", err)
        );

      handleGetLeftNavStatus();
      getCreditDetails(LoanId);
      setProcessStatus(null);
    }
  }, [
    contextDetails["GoToNav"] || props.route.params?.GoToNav,
    contextDetails.loanId,
  ]);

  useEffect(() => {
    handleUpdateCompletedPage();
    handleGetContainerHeight();
  }, [pageIndex, loanOfficerId]);

  useEffect(() => {
    const backHandler = BackHandler.addEventListener(
      "hardwareBackPress",
      () => {
        navigate("DashBoard", { from: "Home" });
      }
    );
    return () => backHandler.remove();
  }, []);

  useEffect(() => {
    if (
      creditScoreDetails.Status === 5 ||
      creditScoreDetails?.Details[0]?.iFinalScanDocID
    )
      handleUpdateCompletedPage();
  }, [creditScoreDetails]);

  const handleGetContainerHeight = () => {
    if (web) {
      try {
        setTimeout(async () => {
          (web && currentPage != pageArray[pageId["appraisalPayment"]]
            ? bodyContentRef?.current?.childNodes[
                currentPage === pageArray[pageId["reviewYourInterestRate"]]
                  ? 0
                  : 1
              ]
            : bodyContentRef.current
          )?.measure((x, y, width, height) => {
            setContainerHeightDetails((prevContainerHeightDetails) => {
              return { ...prevContainerHeightDetails, contentHeight: height };
            });
          });
          bodyContainerRef.current?.measure((x, y, width, height) => {
            setContainerHeightDetails((prevContainerHeightDetails) => {
              return { ...prevContainerHeightDetails, containerHeight: height };
            });
          });
          footerContainerRef.current?.measure((x, y, width, height) => {
            setContainerHeightDetails((prevContainerHeightDetails) => {
              return {
                ...prevContainerHeightDetails,
                footerContainerHeight: height,
              };
            });
          });
        }, 100);
      } catch (error) {
        console.error("Error form ===> ", error);
      }
    }
  };

  useEffect(() => {
    let { containerHeight = 0, contentHeight = 0 } = containerHeightDetails,
      iStickyHeader = false;
    containerHeight = containerHeight - 70;

    if (containerHeight <= contentHeight) iStickyHeader = true;

    if (currentPage === pageArray[pageId["eSign"]]) {
      iStickyHeader = true;
    } else if (currentPage === pageArray[pageId["reviewYourInterestRate"]]) {
      iStickyHeader = true;
    } else if (currentPage === pageArray[pageId["appraisalPayment"]]) {
      iStickyHeader = false;
    }
    setStickyHeader(iStickyHeader);
  }, [containerHeightDetails]);

  const handleAppDownloadSave = () => {
    handleAPI({
      name: "SaveAppDownloadOption",
      params: { WebLoginId: Number(WebLoginId) },
    })
      .then(() => {
        setContextDetails((prevContextDetails) => {
          return {
            ...prevContextDetails,
            ...{ appDownloadFlag: false, appDownloadSkip: true },
          };
        });
      })
      .catch((err) =>
        console.error("Error form handleAppDownloadSave ====> ", err)
      );
  };
  const handleGoToApp = () => {
    window.parent.location.href = "https://directmortgage.com/S/f6QTt";
  };
  const handleNextFrameNavigation = () => {
    setPageIndex({
      ...pageIndex,
      subPage: Number(pageIndex["subPage"]) + 1,
    });
  };
  const handleInsertEventToDW = async () => {
    let data = await handleGetEmpDetails(SessionId),
      iUserName = "",
      iUserId = "";
    if (data && data["Message"] !== "An error has occurred.") {
      data = JSON.parse(data);
      iUserName = data["Table4"][0]["EmpNum"];
      iUserId = data["Table2"][0]["EmpNum"];
    }

    let eventName = activePageArray[pageIndex["page"]];
    handleLogDWCallToActionEventParent(
      eventName,
      "fnLogDWCallToActionEvent",
      "Borrower Loan Application",
      {
        SessionId,
        LoanId: loanId || iLoanId || 0,
        Email:
          additionalBorrowerInfo.length > 0
            ? additionalBorrowerInfo[0]["Email"] || ""
            : LoanData["EmailId"] || "",
        LoanOfficerId: web
          ? queryStringToObject(window.location?.href || "")["loanOfficerId"] ||
            contextDetails.RecentLoId ||
            0
          : contextDetails.RecentLoId || 0,
        Email: contextDetails["Email"],
      },
      activePageArray[pageIndex["page"]]?.replaceAll(" ", "")
    );
  };
  const keydownHandler = (event) => {
    if (
      LoanData["LockLoanApp"] == 1 &&
      !(
        currentPage === pageArray[pageId["documentUpload"]] ||
        currentPage === pageArray[pageId["creditScore"]] ||
        currentPage === pageArray[pageId["appraisalPayment"]]
      )
    ) {
      event.preventDefault();
      return false;
    }
  };
  const handleGetBorrowerUrl = ({ landOn = "" } = {}) => {
    const LoanId = loanId || contextDetails["loanId"];

    // if (
    //   LoanId > 0
    //   // &&
    //   // Object.keys(loanURLDetails).length === 0
    // ) {
    if (LoanId)
      handleAPI({
        name: "GetBorrowerRedirectURLs",
        params: {
          SessionId: SessionId,
          LoanId: LoanId,
          LoanOff: loanOfficers,
        },
      })
        .then((response) => {
          response = response.split("~");

          setLoanURLDetails({
            apprURL: response[0],
            docURL: response[1],
            esignURL: response[2],
            loanLocked: response[3],
            exisLoanId: response[4],
            noeSignExists: response[7],
            blLoanAppRateOptions: response[8],
            assetVendor:
              Number(response[11]) === 106917
                ? "Truv"
                : Number(response[11]) === 105075
                ? "Plaid"
                : "",
          });

          let Ids = [], //7,8,11
            index = []; //10,11,12

          //eSign
          if (response[7] == 1 && landOn != "eSign") {
            Ids.push(7);
            index.push(10);
          }
          //App Payment
          if (!response[0]) {
            Ids.push(8);
            index.push(11);
          }
          // Rate page
          if (response[8] == 2) {
            Ids.push(11);
            index.push(12);
          }
          //Credit Report Page
          if (response[9] == 0) {
            Ids.push(2);
            index.push(5);
          }
          setExcludePageIndex({ Ids, index });

          const newPageArray = handleStructuredClone(iPageArray);

          //==========================
          let array = newPageArray.filter(
            (item, iIndex) => !index.includes(iIndex)
          );

          setPageArray([...array]);
          //==========================
          let iGoToNav = GoToNav;
          if (iGoToNav === newPageArray.indexOf("reviewYourInterestRate")) {
            if (index.includes(newPageArray.indexOf("appraisalPayment")))
              iGoToNav--;
            if (index.includes(newPageArray.indexOf("eSign"))) iGoToNav--;
            if (index.includes(newPageArray.indexOf("creditScore"))) iGoToNav--;
          } else if (
            iGoToNav === newPageArray.indexOf("documentUpload") &&
            index.includes(newPageArray.indexOf("creditScore"))
          ) {
            iGoToNav--;
          } else if (
            iGoToNav === newPageArray.indexOf("eSign") &&
            index.includes(newPageArray.indexOf("creditScore"))
          ) {
            iGoToNav--;
          } else if (
            iGoToNav === newPageArray.indexOf("appraisalPayment") &&
            index.includes(newPageArray.indexOf("creditScore"))
          ) {
            iGoToNav--;
          }
          // if (landOn) {
          //   if (landOn === "eSign") {
          //     setLandOnScreen(landOn);
          //   }
          //   const landOnIndex = array.indexOf(landOn);
          //   array[iGoToNav] && setCurrentPage(array[landOnIndex]);
          //   setPageIndex((prevPageIndex) => {
          //     return {
          //       ...{
          //         page: landOnIndex,
          //         subPage: prevPageIndex["subPage"],
          //       },
          //     };
          //   });
          // } else
          if (landOn !== "eSign") {
            array[iGoToNav] && setCurrentPage(array[iGoToNav]);
            setPageIndex((prevPageIndex) => {
              return {
                ...{
                  page: iGoToNav,
                  subPage: prevPageIndex["subPage"],
                },
              };
            });
          }
          //==========================

          let newPageId = handleStructuredClone(iPageIdObj);
          index.forEach((index) => {
            const key = Object.keys(newPageId).find(
              (k) => newPageId[k] === index
            );
            if (key) {
              delete newPageId[key];
            }
          });
          array.forEach((key, index) => {
            newPageId[key] = index;
          });

          setPageId({ ...newPageId });

          //==========================

          array = handleStructuredClone(iActivePageArray).filter(
            (item, iIndex) => !index.includes(iIndex)
          );

          setActivePageArray([...array]);
          //==========================
        })
        .catch((err) =>
          console.error("Error from GetBorrowerRedirectURLs ====> ", err)
        );
    //}
  };
  const getCreditDetails = async (LoanId, poolCount) => {
    let { Status, isAlready, Details, ErrMsg } =
      creditScoreDetails["Details"].length === 0 || !ErrMsg
        ? await handleGetCreditScoreDetails(LoanId, poolCount !== undefined)
        : creditScoreDetails;

    const inValidData = (Details || []).filter(({ FICOMid }) => !FICOMid);

    if (
      (poolCount && poolCount <= 10 && Details.length == 0 && !ErrMsg) ||
      (processStatus != "onLoad" &&
        (inValidData.length > 0 ||
          (Details || []).length == additionalBorrowerInfo.length))
    ) {
      setTimeout(() => {
        handleGetCreditScoreDetailsPooling(poolCount);
      }, 2500);
    } else {
      if (Details.length > 0) {
        Status = Details[0].iStatus;
      }
      Details = Details.reduce((acc, currentValue) => {
        let groupKey = currentValue["iFinalScanDocID"];
        if (!acc[groupKey]) {
          acc[groupKey] = [];
        }
        acc[groupKey].push(currentValue);
        return acc;
      }, {});
      Details = Object.values(Details).flatMap((subArray) => {
        if (subArray.length > 1) {
          let sortOrder = [subArray[0]].flatMap((obj) => {
            return Object.entries(obj)
              .filter(([key]) => key.includes("BorName"))
              .map(([, value]) => value);
          });
          subArray = subArray.sort((a, b) => {
            const fullNameA = a.FullName,
              fullNameB = b.FullName,
              indexA = sortOrder.indexOf(fullNameA),
              indexB = sortOrder.indexOf(fullNameB);
            return indexA - indexB;
          });
        }
        // if (subArray.length > 0) {
        //   subArray[0]["scanDocID"] = subArray[0]["iFinalScanDocID"];
        // }
        return subArray;
      });
      SetCreditScoreDetails({ Status, isAlready, Details, ErrMsg });
      handleGetLoanOfficerId(loanId || LoanId);
    }
  };
  const handleGetLoanOfficerId = async (loanId) => {
    if (loanId > 0) {
      let loanOfficerId_ = await handleLoanOfficerCredit(loanId);

      setLoanOfficerId(Number(loanOfficerId_));
      setLoanOfficers(Number(loanOfficerId_));
    } else {
      let LoEmpNum = (await AsyncStorage.getItem("LoEmpNum")) || null;
      if (LoEmpNum > 0) {
        setLoanOfficerId(Number(LoEmpNum));
        setLoanOfficers(Number(LoEmpNum));
      }
    }
  };
  const GetLeftNavStatus = async (LoanId) => {
    return await handleAPI({
      name: "GetLeftNavStatus",
      params: { LoanId },
    })
      .then((response) => {
        if (!response || __DEV__) response = "[]";

        if (
          pageId["reviewYourInterestRate"] === GoToNav &&
          LoanData["subjectZip"]
        ) {
          handleSelectLoanProgram(LoanId, (loanProductStatus) => {
            setContextDetails((prevContextDetails) => {
              return { ...prevContextDetails, loanProductStatus };
            });
          });
        }

        if (response && response["Message"] !== "An error has occurred.") {
          return [...(JSON.parse(response) || [])];
        } else {
          return [];
        }
      })
      .catch((err) => console.error("Error from GetLeftNavStatus ====> ", err));
  };

  const handleGetLeftNavStatus = async (statusChangePage, isInclude) => {
    const jLoanId = loanId || iLoanId;
    if (jLoanId > 0) {
      if (statusChangePage) {
        let { page } = pageIndex,
          iLeftNavStatus = isInclude
            ? [...new Set([...leftNavStatus, ...[page]])]
            : leftNavStatus.filter((item) => {
                item !== page;
              });

        setLeftNavStatus([...iLeftNavStatus]);
        setCompletedPage([...(iLeftNavStatus || [])]);
      } else {
        setLeftNavStatus((await GetLeftNavStatus(jLoanId)) || []);
      }
    }
  };
  const handleGetCellPhone = (cellPhone) => {
    let val = cellPhone || "";
    if (val.includes("*5*")) {
      val = val.split("*5*")[1];
    } else if (val.includes("*8*")) {
      val = val.split("*8*")[1];
    }
    val = val.replaceAll("*", "");
    return val;
  };
  // useEffect(() => {
  //   console.log("pageArray", pageArray.length);
  //   console.log("activePageArray", activePageArray.length);
  //   console.log("pageId", Object.keys(pageId).length);
  // }, [pageArray, activePageArray, pageId]);

  const handleClearState = () => {
    log("Cleared", "State Values");
    // setTimeout(() => {
    setProcessStatus(null);
    setPageArray(handleStructuredClone(iPageArray));
    setActivePageArray(handleStructuredClone(iActivePageArray));
    setPageId(handleStructuredClone(iPageIdObj));
    setExcludePageIndex({ Ids: [], index: [] });
    setCurrentPage(pageArray[0]);
    setLoanOfficerOption([]);
    setLoanId(0);
    setPageIndex({ page: 0, subPage: 0 });
    setCompletedPage(null);
    setScrollToTop(false);
    setLoaderDetails({ isLoad: false });
    setDocumentUploadFlag({ headerText: null });
    setLoanData([]);
    setDetailsArr([]);
    setAdditionalBorrowerInfo([]);
    setAdditionalEmploymentInfo([]);
    setAdditionalCounsellingInfo([]);
    setAdditionalOtherIncomeInfo([]);
    setAdditionalPropertyInfo([]);
    setAdditionalBankInfo([]);
    setOtherIncomeOption([]);
    setStateOptions([]);
    setUserId(0);
    setLoanOfficerId(0);
    SetCreditScoreDetails({
      Status: -1,
      isAlready: -1,
      Details: [],
    });
    setIsFromDashBoard(true);
    setLoanOfficers(0);
    setContextDetails((prevContextDetails) => {
      delete prevContextDetails["GoToNav"];
      delete prevContextDetails["loanId"];
      delete prevContextDetails["UserId"];
      prevContextDetails["Path"] = "DashBoard";
      prevContextDetails["loanProductStatus"] = null;

      return { ...prevContextDetails };
    });
    // }, 100);
  };

  const handleOrderAdditionalBorrowerInfo = (array, Id, key) => {
    return array.sort((a, b) => {
      if (a[key] === Id) return -1;
      if (b[key] === Id) return 1;
      return 0;
    });
  };
  const handleDuplicateEmail = (emailId, changedIndex) => {
    const iAdditionalBorrowerInfo = additionalBorrowerInfo;
    iAdditionalBorrowerInfo.forEach((borrower, index) => {
      if (borrower["Email"] == emailId && index !== changedIndex) {
        if (index === 0) {
          setLoanData((prevLoanData) => {
            return {
              ...prevLoanData,
              EmailId: "",
            };
          });
          handleSaveLoanInformation([
            { ColumnName: "EmailId", ColumnValue: "" },
          ]);
        }
        iAdditionalBorrowerInfo[index]["Email"] = "";
        handleSaveAdditionalInfo(
          index - 1,
          11,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          iAdditionalBorrowerInfo
        );
      }
    });
    setAdditionalBorrowerInfo([...iAdditionalBorrowerInfo]);
  };

  const handleGetWebLoginId = async () => {
    try {
      let iWebLoginId = await handleUserDetails(SessionId);

      iWebLoginId = iWebLoginId.split("~");
      setWebLoginId(Number(iWebLoginId[6]));
      setContextDetails((prevContextDetails) => {
        return { ...prevContextDetails, Email: iWebLoginId[4] };
      });
    } catch (error) {}
  };
  const handleGetBorrowerOption = () => {
    return [
      ...additionalBorrowerInfo.map((borr) => {
        return {
          value: borr["CustId"],
          label: `${borr["FirstName"] ? borr["FirstName"] : ""}${
            borr["LastName"] ? " " + borr["LastName"] : ""
          }`?.trim(),
        };
      }),
    ].filter((item) => item["label"]);
  };
  const handleAPIGetLoanDetails = async (
    iLoanId,
    iFlag,
    iStoreCamp,
    poolCount = 0
  ) => {
    iLoanId = Number(iLoanId) || Number(loanId);
    if (iLoanId > 0) {
      if (loanOfficerId === 0) {
        handleGetLoanOfficerId(iLoanId);
      }

      if (vendorOptions.length === 1) {
        handleGetVendorListForNewLoanApp(iLoanId);
      }
    }
    if (stateOptions.length <= 1) {
      handleGetLoanAppOptions({ iLoanId });
    }

    handleAPI({
      name: "GetLoanAppWizard",
      params: { LoanId: iLoanId, SessionId: SessionId, btnflag: 0 },
    })
      .then(async (response) => {
        response = response.split("~");

        let iUserId = 0;
        if (response[3] != "" && response[3] != null) {
          iUserId = JSON.parse(response[3]);
          setUserId(iUserId);
        }

        let iLoanData = JSON.parse(response[0] || "[{}]")[0],
          iAdditionalBorrowerInfo = JSON.parse(response[8] || "[]") || [];

        if (
          (iAdditionalBorrowerInfo.length == 0 ||
            Object.keys(iLoanData)["length"] == 0) &&
          iLoanId > 0 &&
          poolCount < 10
        ) {
          setTimeout(() => {
            handleAPIGetLoanDetails(iLoanId, iFlag, iStoreCamp, poolCount + 1);
          }, 1000);
        } else {
          let loanData_ = {};

          iAdditionalBorrowerInfo = handleOrderAdditionalBorrowerInfo(
            iAdditionalBorrowerInfo,
            iLoanData.UserId,
            "CustId"
          );
          iAdditionalBorrowerInfo = iAdditionalBorrowerInfo.map((item) => {
            item["MaritalStatus"] = Number(item["MaritalStatus"]);
            return item;
          });

          if (iStoreCamp && iLoanData["LoanPurpose"]) {
            handleStoreCampaignDetails(iLoanData);
          }

          let empDetails = [];

          if (response[12] != "" && response[12] != null) {
            empDetails = JSON.parse(response[12]);
            if (!empDetails[0]["CustId"])
              empDetails[0]["CustId"] = JSON.parse(response[3]);
            empDetails.forEach((employment) => {
              employment["Monthly_Base_Pay"] = formatCurrency(
                employment["Monthly_Base_Pay"],
                2
              );
              employment["Monthly_Overtime_Amt"] = formatCurrency(
                employment["Monthly_Overtime_Amt"],
                2
              );
              employment["Monthly_Bonus_Amt"] = formatCurrency(
                employment["Monthly_Bonus_Amt"],
                2
              );
              employment["Monthly_Commission_Amt"] = formatCurrency(
                employment["Monthly_Commission_Amt"],
                2
              );
              employment["Monthly_Total_Pay"] = formatCurrency(
                employment["Monthly_Total_Pay"],
                2
              );

              employment["CurrentYrsInLineofwork"] = employment[
                "CurrentYrsInLineofwork"
              ]
                ? employment["CurrentYrsInLineofwork"]
                : "";
            });

            empDetails = empDetails.filter((employment) => {
              if (employment["CustId"] === 0) {
                handleSaveAdditionalInfo(-1, 6, employment["Id"]); // Deleting empty employment on page load
                return false;
              }
              return true;
            });

            setAdditionalEmploymentInfo(
              handleEmploymentOrder(empDetails, iAdditionalBorrowerInfo)
            );
          }

          if (response[0] != "" && response[0] != null && iFlag) {
            loanData_ = JSON.parse(response[0])[0];
            loanData_ = {
              ...loanData_,
              CreditRpt_Auth: loanData_["CreditRpt_Auth"] ?? 1,
              FrozenCredit: loanData_["FrozenCredit"] || 0,
              prevBankAccountLinked: loanData_["BankAccountLinked"],
              prevLinkBankAccount: loanData_["LinkBankAccount"],
              blAssetOption: 0,
              Real_est_prop: 0,
              LanguagePreference: loanData_["LanguagePreference"] || 1,
              iSpouse_AddBorrower: 0,
              prevAddressTBD: loanData_["AddressTBD"],
              AddressTBD: loanData_["AddressTBD"] == 1 || false,
              OtherIncomeCustId: loanData_["OtherIncomeCustId"] || iUserId,
              CashOutAmount: formatCurrency(
                loanData_["CashOutAmount"],
                2,
                false
              ),
              Refi_Estmt_LnAmt: formatCurrency(
                loanData_["Refi_Estmt_LnAmt"],
                2,
                false
              ),
              Purchase_Estm_LnAmt: formatCurrency(
                loanData_["Purchase_Estm_LnAmt"],
                2,
                false
              ),
              Purchase_Estm_Pur_Price: formatCurrency(
                loanData_["Purchase_Estm_Pur_Price"],
                2,
                false
              ),
              PaidOff: formatCurrency(loanData_["PaidOff"], 2, false),
              Refi_Estmt_Prop_Lnval: formatCurrency(
                loanData_["Refi_Estmt_Prop_Lnval"],
                2,
                false
              ),
              DownPayment: formatCurrency(loanData_["DownPayment"], 2, false),
              Monthly_Rent: formatCurrency(loanData_["Monthly_Rent"], 2, false),
              Monthly_Rent1: formatCurrency(
                loanData_["Monthly_Rent1"],
                2,
                false
              ),
              Monthly_Rent2: formatCurrency(
                loanData_["Monthly_Rent2"],
                2,
                false
              ),
              Monthly_Rent3: formatCurrency(
                loanData_["Monthly_Rent3"],
                2,
                false
              ),
              Bor_money_Amt: formatCurrency(
                loanData_["Bor_money_Amt"],
                2,
                false
              ),
              Own1: loanData_["Own1"] == 1,
              Own2: loanData_["Own2"] == 1,
              Own3: loanData_["Own3"] == 1,
              Rent1: loanData_["Rent1"] == 1,
              Rent2: loanData_["Rent2"] == 1,
              Rent3: loanData_["Rent3"] == 1,
              Living_Rent_Free1: loanData_["Living_Rent_Free1"] == 1,
              Living_Rent_Free2: loanData_["Living_Rent_Free2"] == 1,
              Living_Rent_Free3: loanData_["Living_Rent_Free3"] == 1,
              Monthly_Alimony_Expense: formatCurrency(
                loanData_["Monthly_Alimony_Expense"],
                2,
                false
              ),
              Monthly_Alimony_Income: formatCurrency(
                loanData_["Monthly_Alimony_Income"],
                2,
                false
              ),
              Monthly_ChildSupportExpense: formatCurrency(
                loanData_["Monthly_ChildSupportExpense"],
                2,
                false
              ),
              Monthly_ChildSupportIncome: formatCurrency(
                loanData_["Monthly_ChildSupportIncome"],
                2,
                false
              ),
              Monthly_Base_Pay: formatCurrency(
                loanData_["Monthly_Base_Pay"],
                2,
                false
              ),
              Monthly_Amount: formatCurrency(loanData_["Monthly_Amount"], 2),
              Bank_Amount: formatCurrency(loanData_["Bank_Amount"], 2),
              Presnt_Markt_Val: formatCurrency(
                loanData_["Presnt_Markt_Val"],
                2
              ),
              VA_Entitlmt_Amt: formatCurrency(
                loanData_["VA_Entitlmt_Amt"],
                2,
                false
              ),
              VA_Entitlmt_Amt_used: formatCurrency(
                loanData_["VA_Entitlmt_Amt_used"],
                2,
                false
              ),
              currently_employed:
                empDetails.length > 0 &&
                !loanData_["Retired"] &&
                !loanData_["Not_CurrentlyEmployed"]
                  ? 1
                  : loanData_["currently_employed"],
              Living_Rent_Free:
                (loanData_["Rent"] &&
                  cleanValue(loanData_["Monthly_Rent"]) == 0) ||
                loanData_["Living_Rent_Free"],
              Addrshistry_Years:
                loanData_["Addrshistry_Months"] &&
                !loanData_["Addrshistry_Years"]
                  ? 0
                  : loanData_["Addrshistry_Years"],
              Addrshistry_Months:
                !loanData_["Addrshistry_Months"] &&
                loanData_["Addrshistry_Years"]
                  ? 0
                  : loanData_["Addrshistry_Months"],
              SSN: loanData_["SSN"]
                ?.toString()
                .replaceAll("undefined", "")
                .replaceAll("null", ""),
            };
            if (__DEV__) loanData_["LockLoanApp"] = 0;
            if (empDetails.length === 0 && loanData_["currently_employed"]) {
              loanData_ = {
                ...loanData_,
                currently_employed: 0,
                Retired: 0,
                Not_CurrentlyEmployed: true,
              };
            }

            try {
              if (!loanData_["Addrshistry_Months"]) {
                let [year, month] = (loanData_["Addrshistry_Years"] || "")
                  .split(".")
                  .slice(0, 2);
                loanData_["Addrshistry_Months"] = month || 0;
                loanData_["Addrshistry_Years"] = year || 0;
              }
            } catch (error) {}

            //Getting DownPayment value during load
            try {
              if (Number(loanData_["LoanPurpose"]) === 1) {
                let AppVal = cleanValue(loanData_["Purchase_Estm_Pur_Price"]),
                  lnAmtTxt = cleanValue(loanData_["Purchase_Estm_LnAmt"]),
                  DownPayment = parseFloat(AppVal) - parseFloat(lnAmtTxt),
                  DownPay = cleanValue(DownPayment),
                  DownPaymentPercent = roundNumber(
                    (parseFloat(DownPay) / parseFloat(AppVal)) * 100,
                    2
                  );

                if (isNaN(DownPaymentPercent)) DownPaymentPercent = "0.00";
                loanData_ = {
                  ...loanData_,
                  ...{
                    Purchase_Estm_Pur_Price: formatCurrency(AppVal, 2),
                    DownPayment: formatCurrency(DownPayment, 2),
                    DownPaymentPercent: DownPaymentPercent,
                    Purchase_Estm_LnAmt: formatCurrency(
                      loanData_["Purchase_Estm_LnAmt"],
                      2
                    ),
                  },
                };
              }
            } catch (ex) {
              console.error("Getting DownPayment value during load ===> ", ex);
            }
            if (!(loanData_["NickName"] || "").trim())
              loanData_["NickName"] = (loanData_["FirstName"] || "").trim();

            let subjectPropertyAddress = await handleGetSubjectPropertyAddress(
              iLoanId
            );
            loanData_ = { ...subjectPropertyAddress, ...loanData_ };
          }

          if (response[8] != "" && response[8] != null) {
            iAdditionalBorrowerInfo.forEach((borrower) => {
              borrower["Present Rent"] = formatCurrency(
                borrower["Present Rent"],
                2
              );

              borrower["Present Rent1"] = formatCurrency(
                borrower["Present Rent1"],
                2
              );
              borrower["Present Rent2"] = formatCurrency(
                borrower["Present Rent2"],
                2
              );
              borrower["Present Rent3"] = formatCurrency(
                borrower["Present Rent3"],
                2
              );
              borrower["Bor Own"] =
                borrower["Bor Own"] == "R" &&
                cleanValue(borrower["Present Rent"]) == 0
                  ? "L"
                  : borrower["Bor Own"];

              borrower["VA_Entitlmt_Amt"] = formatCurrency(
                borrower["VA_Entitlmt_Amt"],
                2
              );
              borrower["VA_Entitlmt_Amt_used"] = formatCurrency(
                borrower["VA_Entitlmt_Amt_used"],
                2
              );
              borrower["MoneyBorrowedForDown"] = formatCurrency(
                borrower["MoneyBorrowedForDown"],
                2
              );

              if (!(borrower["NickName"] || "").trim())
                borrower["NickName"] = (borrower["FirstName"] || "").trim();
            });

            setAdditionalBorrowerInfo(
              sortByKey(iAdditionalBorrowerInfo, "CustId")
            );
          }

          if (response[9] != "" && response[9] != null) {
            let iAdditionalOtherIncome = JSON.parse(response[9]);
            iAdditionalOtherIncome.forEach((income) => {
              income["Monthly_Amount"] = formatCurrency(
                income["Monthly_Amount"],
                2
              );
            });

            setAdditionalOtherIncomeInfo(iAdditionalOtherIncome);
          }

          if (response[10] != "" && response[10] != null) {
            let iAdditionalPropertyInfo = JSON.parse(response[10]);
            iAdditionalPropertyInfo.forEach((property) => {
              property["Presnt_Markt_Val"] = formatCurrency(
                property["Presnt_Markt_Val"],
                2
              );
            });
            setAdditionalPropertyInfo(iAdditionalPropertyInfo);
          }

          if (response[11] != "" && response[11] != null) {
            let iAdditionalBankInfo = JSON.parse(response[11]);

            iAdditionalBankInfo.forEach((bank) => {
              const { AccType, AccTypeName } = bank;
              bank["Amount"] = formatCurrency(bank["Amount"], 2);
              if (AccType == 1 && !AccTypeName)
                bank["AccTypeName"] = "Checking";
              else if (AccType == 2 && !AccTypeName)
                bank["AccTypeName"] = "Savings";
              else if (![1, 2].includes(Number(AccType))) {
                bank["AccType"] = "-1";
                bank["AccTypeName"] = "Other Type";
                bank["OtherAccType"] = AccType?.toString();
                bank["TypeDesc"] = getOtherAccountDesc(AccType);
                bank["EarnestMoneyPaidTo"] =
                  bank["paidToId"] + "####" + bank["paidToType"];
              }
            });

            setAdditionalBankInfo(iAdditionalBankInfo);
          } else if (loanData_["blAssetOption"] == 1) {
            handleSaveAdditionalInfo(-1, -3, -3, true);
          }

          let iAdditionalCounsellingInfo = [];
          if (response[14] != "" && response[14] != null) {
            iAdditionalCounsellingInfo = JSON.parse(response[14]);
          }

          iAdditionalBorrowerInfo.forEach((obj) => {
            const existingObject = iAdditionalCounsellingInfo.find(
              (item) => item["CustID"] === obj["CustId"]
            );

            if (existingObject) {
              // If an object with the same id exists, update its properties
              Object.assign(existingObject, {});
            } else {
              // If no object with the same id exists, push the new object to arr
              iAdditionalCounsellingInfo.push({
                Couns_Confirm: null,
                Couns_Comp_Date: null,
                Couns_Type: null,
                Couns_Agency_Name: null,
                LanguagePreference: null,
                OtherLanguageDescription: null,
                CustID: obj["CustId"],
              });
            }
          });
          iAdditionalCounsellingInfo = sortByKey(
            iAdditionalCounsellingInfo,
            "CustID"
          );
          iAdditionalCounsellingInfo = iAdditionalCounsellingInfo.map(
            (item) => {
              item["LanguagePreference"] = item["LanguagePreference"] || 1;
              return item;
            }
          );

          setAdditionalCounsellingInfo(iAdditionalCounsellingInfo);

          setLoanData((prevLoanData) => {
            if (
              currentPage === pageArray[pageId["documentUpload"]] &&
              empDetails.length > 0
            ) {
              prevLoanData["currently_employed"] = 1;
            }
            return { ...loanData_, ...prevLoanData, isLoaded: true };
          });
          setIsDataLoadedForDocUpload(true);
        }
      })
      .catch((err) => console.error("Error from GetLoanAppWizard ====> ", err));
  };
  const handleGetLoanAppOptions = async ({ iLoanId }) => {
    handleAPI({
      name: "GetOtherVendorTypeForNewLoanApp",
      params: { LoanId: iLoanId },
    })
      .then(async (response) => {
        const { parse } = JSON;
        response = JSON["parse"](response)["Table"][0];

        for (const key in response) {
          response[key] = JSON.parse(response[key] || "[]");
        }

        const {
          StateOptionsJson,
          OtherIncomeOptionsJson,
          PropertyTypeOptionsJson,
          AccTypeOption,
          giftOption,
        } = response;

        setOtherIncomeOption(
          OtherIncomeOptionsJson.map((e) => {
            return { value: e.TypeOption, label: e.TypeDesc };
          })
        );

        setStateOptions(
          StateOptionsJson["State"].map((e) => {
            return { value: e.TypeOption, label: e.TypeDesc };
          })
        );

        setPropertyTypeOption(
          PropertyTypeOptionsJson.map((e) => {
            return { value: e.TypeOption, label: e.TypeDesc };
          })
        );

        setAccountTypeOption(AccTypeOption);

        setGiftOptions(giftOption);
      })
      .catch((err) =>
        console.error("Error from GetOtherVendorTypeForNewLoanApp ====> ", err)
      );
  };
  const handleGetVendorListForNewLoanApp = async (LoanID) => {
    handleAPI({
      name: "GetVendorListForNewLoanApp",
      params: { LoanID },
    })
      .then((response) => {
        response = JSON.parse(response);
        response = response
          .filter(({ VendorName, sortname }) => VendorName && sortname)
          .map(({ VendorIdType: value, VendorName: label }) => ({
            value,
            label,
          }));
        setVendorOptions(response);
      })
      .catch((err) =>
        console.error("Error form GetLoanOfficerList ====> ", err)
      );
  };
  const handlePostVendorAdd = async ({ LoanID, bankIndex, VendorId }) => {
    handleGetVendorListForNewLoanApp(LoanID);
    handleUpdateAddtionalBank(bankIndex, "EarnestMoneyPaidTo", VendorId);
  };
  const navigate = (path, option) => {
    if (path === "DashBoard") {
      handleClearState();
    }
    updateWebURL({ ...option, Path: path });
    (navigation || props["navigation"]).navigate(path, option || {});
  };
  const handleGetFirstPageField = (source, cFields, index, cIndex) => {
    let isBlank = cFields.filter((item) => {
      let value = (
        item["name"] === "CellPhone"
          ? source[item["name"]]?.split("*5*")[1]
          : source[item["name"]]
      )
        ?.toString()
        ?.replaceAll("$", "")
        ?.replaceAll(",", "")
        ?.replaceAll("0.00", "")
        ?.replaceAll("%", "");

      return value == item["value"];
    });
    return isBlank.length > 0 && index === -1 ? cIndex : index;
  };
  const handleGetFirstPageFieldNew = (source, cFields) => {
    let isBlank = cFields.filter((item) => {
      let value =
        item["name"] === "CellPhone"
          ? source[item["name"]]?.replaceAll("*5*", "")
          : source[item["name"]];

      if (item["falseCheck"]) return !Number(value);

      if (item["lengthLimit"]) {
        return (
          value?.toString().replace(/[(),\-,\* ]/g, "").length !=
          item["lengthLimit"]
        );
      }

      value = value
        ?.toString()
        ?.replaceAll("$", "")
        ?.replaceAll(",", "")
        ?.replaceAll("0.00", "")
        ?.replaceAll("%", "");

      item["value"] = item["value"]
        ?.toString()
        ?.replaceAll("$", "")
        ?.replaceAll(",", "")
        ?.replaceAll("0.00", "")
        ?.replaceAll("%", "");

      return value == (item["value"] || "");
    });
    return isBlank.length > 0 || false;
  };

  const handleEmploymentOrder = (
    unOrderedEmployment,
    iAdditionalBorrowerInfo,
    isChangePage
  ) => {
    let subPage = pageIndex["subPage"],
      currentIndex = unOrderedEmployment[subPage - 1];

    if (additionalBorrowerInfo?.length > 0)
      iAdditionalBorrowerInfo = additionalBorrowerInfo;

    let orderedEmployment = groupByKey(
      additionalEmploymentInfo.map((employment, index) => {
        let empRow =
          iAdditionalBorrowerInfo?.filter(
            (borrower) =>
              Number(borrower["CustId"]) === Number(employment["CustId"])
          ) || [];
        if (empRow.length > 0) empRow = empRow[0];
        return {
          Name:
            empRow["FirstName"] || empRow["LastName"]
              ? `${empRow["FirstName"]} ${empRow["LastName"]}`
              : `Employment ${index + 1}`,
          CustId: employment["CustId"],
          subName:
            `${employment["Empmt_Emp_Name"]} ${employment["Job_Title"]}`.trim() ||
            `Employment ${index + 1}`,
          Id: employment["Id"],
        };
      }),
      "Name"
    );

    orderedEmployment = orderedEmployment.reduce((result, item) => {
      return result.concat(item.subMenu);
    }, []);

    unOrderedEmployment = sortByKey(unOrderedEmployment, "CustId");

    let newRow = [],
      existingRow = [];
    unOrderedEmployment.forEach((item) => {
      if (item["CustId"] == 0) newRow.push(item);
      else existingRow.push(item);
    });
    unOrderedEmployment = [...existingRow, ...newRow];
    isChangePage &&
      setPageIndex({
        ...pageIndex,
        subPage: unOrderedEmployment.indexOf(currentIndex) + 1,
      });

    return unOrderedEmployment;
  };
  const handleGetFirstPageOption = (value, options, index, cIndex) => {
    value = (isNaN(value) ? value : Number(value)) || "";
    return index === -1 && options.indexOf(value) === -1 ? cIndex : index;
  };
  const handleLoaderDetails = ({ isLoad, text }) => {
    setLoaderDetails({
      ...loaderDetails,
      ...{ isLoad: isLoad, text: text || "Loading..." },
    });
  };
  const handleLogOut = () => {
    handleAPI({
      name: "LogOutSession",
      params: { SessionId: SessionId },
    })
      .then(() => {
        let Path = web ? "Login" : "StartScreen";
        setContextDetails((prevContextDetails) => {
          return { ...prevContextDetails, Path };
        });
        navigate(Path, { userName: userName });
      })
      .catch((err) => console.error("Error from LogOutSession ====> ", err));
  };

  const handleUpdateCompletedPage = (iLeftNavStatus) => {
    if (Object.keys(LoanData).length > 0) {
      iLeftNavStatus = iLeftNavStatus || leftNavStatus;
      let { iCompletedPage = [], iInCompletedSubPage } = handleGetPageNumber(
        true,
        undefined,
        iLeftNavStatus
      );

      iCompletedPage = [
        ...new Set([...iLeftNavStatus, ...iCompletedPage]),
      ].sort();

      setCompletedPage(iCompletedPage);
      setInCompletedSubPage(iInCompletedSubPage);
    }
  };
  const handleGetPageNumber = (iExp, iIndex, iLeftNavStatus) => {
    let iPage = 0,
      iSubPage = -1,
      iCompletedPage = [],
      currentPage_ = currentPage,
      iInCompletedSubPage = [],
      inCompletedSubPageObjNew = {};

    iLeftNavStatus = iLeftNavStatus || leftNavStatus;

    if (Object.keys(LoanData).length > 0) {
      //TODO ======= Summary Info =======
      let iPageId = pageId["summaryInfo"];

      if (
        ((currentPage_ === pageArray[iPageId] || iExp) &&
          !iLeftNavStatus.includes(iPageId)) ||
        (iExp && iIndex === iPageId)
      ) {
        const {
          LoanPurpose,
          Propertybe: ProperType,
          LoanSummaryPropertyType,
          AddressTBD,
          subjectAddress,
          subjectZip,
          subjectCity,
          subjectState,
          Prop_Years,
          Pri_purpose_Refi: priPurpose,
        } = LoanData;

        if (![1, 2].includes(Number(LoanPurpose))) {
          iInCompletedSubPage.push(0);
        }
        if (![1, 2, 3].includes(Number(ProperType))) {
          iInCompletedSubPage.push(LoanPurpose == 1 ? 5 : 4);
        }
        if (!(parseInt(loanOfficerId) && parseInt(loanOfficers))) {
          iInCompletedSubPage.push(LoanPurpose == 1 ? 4 : 3);
        }
        if (!Number(LoanSummaryPropertyType)) {
          iInCompletedSubPage.push(LoanPurpose == 1 ? 5 : 4);
        }

        if (
          LoanPurpose == 1 &&
          !AddressTBD &&
          (!subjectAddress ||
            subjectZip?.toString().length != 5 ||
            !subjectCity ||
            !subjectState ||
            !Prop_Years)
        ) {
          iInCompletedSubPage.push(LoanPurpose == 1 ? 5 : 4);
        } else if (
          LoanPurpose != 1 &&
          (!subjectAddress ||
            subjectZip?.toString().length != 5 ||
            !subjectCity ||
            !subjectState ||
            !Prop_Years)
        ) {
          iInCompletedSubPage.push(LoanPurpose == 1 ? 5 : 4);
        }

        if (LoanPurpose == 2 && ![1, 2].includes(Number(priPurpose))) {
          iInCompletedSubPage.push(5);
        }

        if (LoanPurpose == 1) {
          if (
            handleGetFirstPageFieldNew(LoanData, [
              { name: "Purchase_Estm_Pur_Price", value: "" },
              // { name: "DownPayment", value: 0 },
              // { name: "DownPaymentPercent", value: 0 },
              { name: "Purchase_Estm_LnAmt", value: "" },
            ])
          ) {
            iInCompletedSubPage.push(6);
          }
        } else {
          if (
            handleGetFirstPageFieldNew(LoanData, [
              { name: "Refi_Estmt_Prop_Lnval", value: "" },
              { name: "Refi_Estmt_LnAmt", value: "" },
            ])
          ) {
            iInCompletedSubPage.push(6);
          }
        }
        inCompletedSubPageObjNew[pageArray[iPageId]] = iInCompletedSubPage;

        iSubPage = iInCompletedSubPage.length
          ? iInCompletedSubPage[0]
          : iSubPage;

        if (iIndex === iPageId) {
          return { iPage, iSubPage, iInCompletedSubPage };
        } else if (iExp) {
          iPage++;
          if (iSubPage === -1) iCompletedPage.push(iPageId);

          iSubPage = -1;
          currentPage_ = pageArray[iPage];
        } else if (iPage === iPageId && iSubPage === -1) {
          iPage++;
          currentPage_ = pageArray[iPage];
        }
      } else if (iPage === iPageId && iSubPage === -1 && !iIndex) {
        iPage++;
        currentPage_ = pageArray[iPage];
      }
      //TODO ======= Contact Info =======
      iPageId = pageId["borrowerInfo"];
      if (
        ((currentPage_ === pageArray[iPageId] || iExp) &&
          !iLeftNavStatus.includes(iPageId)) ||
        (iExp && iIndex === iPageId)
      ) {
        iInCompletedSubPage = [];
        if (
          handleGetFirstPageFieldNew(LoanData, [
            { name: "FirstName", value: "" },
            { name: "LastName", value: "" },
            { name: "CellPhone", value: "", lengthLimit: 10 },
            { name: "EmailId", value: "" },
            { name: "BirthDate", value: "" },
            { name: "MaritalStatus", value: "0" },
          ])
        ) {
          iInCompletedSubPage.push(0);
        }

        if (additionalBorrowerInfo.length > 1) {
          additionalBorrowerInfo.slice(1).map((borrower, index) => {
            if (
              handleGetFirstPageFieldNew(borrower, [
                { name: "FirstName", value: "" },
                { name: "LastName", value: "" },
                { name: "CellPhone", value: "", lengthLimit: 10 },
                { name: "Email", value: "" },
                { name: "BirthDate", value: "" },
                { name: "MaritalStatus", value: "0" },
              ])
            ) {
              iInCompletedSubPage.push(index + 1);
            }
          });
        }

        inCompletedSubPageObjNew[pageArray[iPageId]] = iInCompletedSubPage;
        iSubPage = iInCompletedSubPage.length
          ? iInCompletedSubPage[0]
          : iSubPage;

        if (iIndex === iPageId) {
          return { iPage, iSubPage, iInCompletedSubPage };
        } else if (iExp) {
          iPage++;
          if (iSubPage === -1) iCompletedPage.push(iPageId);
          iSubPage = -1;
          currentPage_ = pageArray[iPage];
        } else if (iPage === iPageId && iSubPage === -1) {
          iPage++;
          currentPage_ = pageArray[iPage];
        }
      } else if (iPage === iPageId && iSubPage === -1) {
        iPage++;
        currentPage_ = pageArray[iPage];
      }
      //TODO ======= Borrower Verification =======
      iPageId = pageId["borrowerVerification"];
      if (
        ((currentPage_ === pageArray[iPageId] || iExp) &&
          !iLeftNavStatus.includes(iPageId)) ||
        (iExp && iIndex === iPageId)
      ) {
        const { LinkBankAccount, BankAccountLinked } = LoanData;
        iInCompletedSubPage = [];

        if (LinkBankAccount == 1 && BankAccountLinked != 0) {
          iInCompletedSubPage.push(-1);
        } else if (LinkBankAccount == 2) {
          iInCompletedSubPage.push(-1);
        } else if (LinkBankAccount == 1) {
          iInCompletedSubPage.push(0);
        } else {
          iInCompletedSubPage.push(0);
        }

        iSubPage = iInCompletedSubPage.length
          ? iInCompletedSubPage[0]
          : iSubPage;
        inCompletedSubPageObjNew[pageArray[iPageId]] =
          iInCompletedSubPage.filter((_) => _ >= 0);
        if (iIndex === iPageId) {
          return { iPage, iSubPage, iInCompletedSubPage };
        } else if (iExp) {
          iPage++;
          if (iSubPage === -1) iCompletedPage.push(iPageId);
          iSubPage = -1;
          currentPage_ = pageArray[iPage];
        } else if (iPage === iPageId && iSubPage === -1) {
          iPage++;
          currentPage_ = pageArray[iPage];
        }
      } else if (iPage === iPageId && iSubPage === -1) {
        iPage++;
        currentPage_ = pageArray[iPage];
      }
      //TODO ======= Assets =======
      iPageId = pageId["bankAccounts"];
      if (
        ((currentPage_ === pageArray[iPageId] || iExp) &&
          !iLeftNavStatus.includes(iPageId)) ||
        (iExp && iIndex === iPageId)
      ) {
        iInCompletedSubPage = [];
        const { blAssetOption } = LoanData;

        if (
          additionalBankInfo.length === 0 &&
          ![0, 1].includes(Number(blAssetOption))
        ) {
          iInCompletedSubPage.push(0);
        } else {
          additionalBankInfo.map((bank, index) => {
            const { OtherAccType, AccType } = bank;
            if (!OtherAccType) bank["OtherAccType"] = "0";

            if (
              handleGetFirstPageFieldNew(
                bank,
                [
                  { name: "AccType", value: "" },
                  AccType == "-1" && { name: "OtherAccType", value: "0" },
                  ((![3, 4, 12, 19, 20, 33, 37, 22].includes(
                    Number(OtherAccType)
                  ) &&
                    Number(OtherAccType)) ||
                    AccType != "-1") && { name: "BankName", value: "" },

                  ...(AccType == "-1"
                    ? [12, 33].includes(Number(OtherAccType))
                      ? [{ name: "Description", value: "" }]
                      : [4].includes(Number(OtherAccType))
                      ? [{ name: "Description", value: "" }]
                      : [3, 19, 20, 37].includes(Number(OtherAccType))
                      ? [
                          { name: "BankName", value: "" },
                          { name: "giftfrom", value: "" },
                          { name: "Account", value: "" },
                        ]
                      : [22].includes(Number(OtherAccType))
                      ? [
                          { name: "Description", value: "" },
                          { name: "lifeInsFace", value: 0, falseCheck: true },
                          { name: "lifeInsValue", value: 0, falseCheck: true },
                        ]
                      : []
                    : []),

                  ((![22].includes(Number(OtherAccType)) &&
                    Number(OtherAccType)) ||
                    AccType != "-1") && {
                    name: "Amount",
                    value: "",
                  },
                  (Number(OtherAccType) || AccType != "-1") && {
                    name: "OwnerIdList",
                    value: "",
                  },
                ].filter((item) => item)
              )
            ) {
              iInCompletedSubPage.push(index);
            }
          });
        }

        inCompletedSubPageObjNew[pageArray[iPageId]] = iInCompletedSubPage;

        iSubPage = iInCompletedSubPage.length
          ? iInCompletedSubPage[0]
          : iSubPage;

        if (iIndex === iPageId) {
          return { iPage, iSubPage, iInCompletedSubPage };
        } else if (iExp) {
          iPage++;
          if (
            iSubPage === -1 &&
            (additionalBankInfo.length > 0 || LoanData["blAssetOption"] == 0)
          ) {
            iCompletedPage.push(iPageId);
          }
          iSubPage = -1;
          currentPage_ = pageArray[iPage];
        } else if (iPage === iPageId && iSubPage === -1) {
          iPage++;
          currentPage_ = pageArray[iPage];
        }
      } else if (iPage === iPageId && iSubPage === -1) {
        iPage++;
        currentPage_ = pageArray[iPage];
      }
      //TODO ======= Address History =======
      iPageId = pageId["addressHistory"];
      if (
        ((currentPage_ === pageArray[iPageId] || iExp) &&
          !iLeftNavStatus.includes(iPageId)) ||
        (iExp && iIndex === iPageId)
      ) {
        iInCompletedSubPage = [];
        const {
          Addrshistry_Years,
          Addrshistry_Months,
          Own,
          Rent,
          Living_Rent_Free,
          Monthly_Rent,
        } = LoanData;

        let pageCrossCount = 0;

        //Primary Borr Section
        if (
          handleGetFirstPageFieldNew(LoanData, [
            { name: "Current_Street_Address", value: "" },
            { name: "Addrshistry_ZipCode", value: "", lengthLimit: 5 },
            { name: "Addrshistry_City", value: "" },
            { name: "Addrshistry_State", value: "" },
          ])
        ) {
          iInCompletedSubPage.push(0);
        }
        if (!parseInt(Addrshistry_Years) && !parseInt(Addrshistry_Months)) {
          iInCompletedSubPage.push(0);
        }
        if (!Own && !Rent && !Living_Rent_Free) {
          iInCompletedSubPage.push(0);
        }
        if (Rent && cleanValue(Monthly_Rent || 0) == 0) {
          iInCompletedSubPage.push(0);
        }
        //For Previous Address Info
        let monthCount = handleGetMonthCount(
            Addrshistry_Months || 0,
            Addrshistry_Years || 0
          ),
          totalMonthCount = monthCount;

        if (totalMonthCount < 24) {
          for (let i = 1; i < 4; i++) {
            monthCount = handleGetMonthCount(
              LoanData[`Addrshistry_Months${i}`] || 0,
              LoanData[`Addrshistry_Years${i}`] || 0
            );

            if (totalMonthCount < 24) {
              pageCrossCount++;
              totalMonthCount = totalMonthCount + monthCount;
              if (
                handleGetFirstPageFieldNew(LoanData, [
                  { name: `PrevCurrent_Street_Address${i}`, value: "" },
                  {
                    name: `Addrshistry_ZipCode${i}`,
                    value: "",
                    lengthLimit: 5,
                  },
                  { name: `Addrshistry_City${i}`, value: "" },
                  { name: `Addrshistry_State${i}`, value: "" },
                  { name: `Addrshistry_Years${i}`, value: "" },
                  { name: `Addrshistry_Months${i}`, value: "" },
                ])
              ) {
                iInCompletedSubPage.push(i);
              }

              if (
                !parseInt(LoanData[`Addrshistry_Years${i}`]) &&
                !parseInt(LoanData[`Addrshistry_Months${i}`])
              ) {
                iInCompletedSubPage.push(i);
              }

              if (
                !LoanData[`Own${i}`] &&
                !LoanData[`Rent${i}`] &&
                !LoanData[`Living_Rent_Free${i}`]
              ) {
                iInCompletedSubPage.push(i);
              }
              if (
                LoanData[`Rent${i}`] &&
                cleanValue(LoanData[`Monthly_Rent${i}`] || 0) == 0
              ) {
                iInCompletedSubPage.push(i);
              }
            }
          }
        }
        //============================================
        if (additionalBorrowerInfo.length > 1) {
          //Additional Borr Section

          additionalBorrowerInfo.slice(1).forEach((borrower, index) => {
            //For Previous Address Info
            pageCrossCount++;

            if (
              handleGetFirstPageFieldNew(borrower, [
                { name: "Address1", value: "" },
                { name: "Zip", value: "", lengthLimit: 5 },
                { name: "City", value: "" },
                { name: "State", value: "" },
                { name: "Bor Own Period", value: "" },
              ])
            ) {
              // inCompletePage.push(index + 1);
              iInCompletedSubPage.push(pageCrossCount);
            }

            if (
              borrower["Bor Own"] === "R" &&
              (cleanValue(borrower["Present Rent"]) || 0) == 0
            ) {
              // inCompletePage.push(index + 1);
              iInCompletedSubPage.push(pageCrossCount);
            }

            if (
              borrower["Bor Own"] !== "O" &&
              borrower["Bor Own"] !== "R" &&
              borrower["Bor Own"] !== "L"
            ) {
              iInCompletedSubPage.push(pageCrossCount);
            }

            let month = handleGetBorrYearMonth(
                borrower["Bor Own Period"],
                "Months"
              ),
              year = handleGetBorrYearMonth(
                borrower["Bor Own Period"],
                "Years"
              );

            monthCount = handleGetMonthCount(month, year);

            if (!parseInt(year) && !parseInt(month)) {
              iInCompletedSubPage.push(pageCrossCount);
            }

            totalMonthCount = monthCount;

            for (let i = 1; i < 4; i++) {
              if (totalMonthCount < 24) {
                pageCrossCount++;
                month = handleGetBorrYearMonth(
                  borrower[`Bor For Add${i} Yrs`],
                  "Months"
                );
                year = handleGetBorrYearMonth(
                  borrower[`Bor For Add${i} Yrs`],
                  "Years"
                );
                monthCount = handleGetMonthCount(month, year);
                if (
                  handleGetFirstPageFieldNew(borrower, [
                    { name: `Bor For Add${i}`, value: "" },
                    { name: `BorForZip${i + 1}`, value: "", lengthLimit: 5 },
                    { name: `BorForCity${i + 1}`, value: "" },
                    { name: `BorForState${i + 1}`, value: "" },
                  ])
                ) {
                  // inCompletePage.push(index + 1);
                  iInCompletedSubPage.push(pageCrossCount);
                }
                if (!parseInt(year) && !parseInt(month)) {
                  iInCompletedSubPage.push(pageCrossCount);
                }

                if (
                  borrower[`Bor For Add${i} Own`] !== "O" &&
                  borrower[`Bor For Add${i} Own`] !== "R" &&
                  borrower[`Bor For Add${i} Own`] !== "L"
                ) {
                  iInCompletedSubPage.push(pageCrossCount);
                }

                if (
                  borrower[`Bor For Add${i} Own`] == "R" &&
                  cleanValue(borrower[`Present Rent${i}`] || 0) == 0
                ) {
                  iInCompletedSubPage.push(pageCrossCount);
                }

                totalMonthCount = totalMonthCount + monthCount;
              }
            }
          });
        }

        inCompletedSubPageObjNew[pageArray[iPageId]] = iInCompletedSubPage;
        iSubPage = iInCompletedSubPage.length
          ? iInCompletedSubPage[0]
          : iSubPage;
        // iInCompletedSubPage = convertToArrayCategory(iInCompletedSubPage);
        if (iIndex === iPageId) {
          return { iPage, iSubPage, iInCompletedSubPage };
        } else if (iExp) {
          iPage++;
          if (iSubPage === -1) iCompletedPage.push(iPageId);
          iSubPage = -1;
          currentPage_ = pageArray[iPage];
        } else if (iPage === iPageId && iSubPage === -1) {
          iPage++;
          currentPage_ = pageArray[iPage];
        }

        //============================================
      } else if (iPage === iPageId && iSubPage === -1) {
        iPage++;
        currentPage_ = pageArray[iPage];
      }
      //TODO ======= Credit Report =======
      iPageId = pageId["creditScore"];
      if (
        ((currentPage_ === pageArray[iPageId] || iExp) &&
          !iLeftNavStatus.includes(iPageId) &&
          iPageId) ||
        (iExp && iIndex === iPageId && iPageId)
      ) {
        let { Status, Details } = creditScoreDetails;
        iInCompletedSubPage = [];
        const { CreditReport, FrozenCredit, SSN, CreditRpt_Auth } = LoanData;
        if (![0, 1].includes(Number(CreditReport ?? -1))) {
          iInCompletedSubPage.push(0);
        }
        if (Number(CreditReport ?? -1) == 1) {
          if (
            ![0, 1].includes(Number(FrozenCredit == null ? -1 : FrozenCredit))
          ) {
            iInCompletedSubPage.push(1);
          }

          if (Number(FrozenCredit) === 0) {
            if (SSN?.toString().replace(/-/g, "").length != 9)
              iInCompletedSubPage.push(2);

            additionalBorrowerInfo.slice(1).map((borrower) => {
              if (borrower["SSN"]?.toString().replace(/-/g, "").length != 9)
                iInCompletedSubPage.push(2);
            });

            if (![0, 1].includes(Number(CreditRpt_Auth ?? -1))) {
              iInCompletedSubPage.push(3);
            }
          }
        }
        inCompletedSubPageObjNew[pageArray[iPageId]] = iInCompletedSubPage;
        iSubPage = iInCompletedSubPage.length
          ? iInCompletedSubPage[0]
          : iSubPage;

        if (iIndex === iPageId) {
          return { iPage, iSubPage, iInCompletedSubPage };
        } else if (Status !== 5 && !Details[0]?.iFinalScanDocID) iSubPage = -2;
        if (iExp) {
          iPage++;
          if (iSubPage === -1) iCompletedPage.push(iPageId);
          iSubPage = -1;
          currentPage_ = pageArray[iPage];
        } else if (iPage === iPageId && iSubPage === -1) {
          iPage++;
          currentPage_ = pageArray[iPage];
        }
        if (iSubPage === -2) iSubPage = -1;
      } else if (iPage === iPageId && iSubPage === -1) {
        iPage++;
        currentPage_ = pageArray[iPage];
      }

      //TODO ======= Income =======
      iPageId = pageId["employment"];
      if (
        ((currentPage_ === pageArray[iPageId] || iExp) &&
          !iLeftNavStatus.includes(iPageId)) ||
        (iExp && iIndex === iPageId)
      ) {
        iInCompletedSubPage = [];

        const {
            currently_employed,
            Retired,
            Not_CurrentlyEmployed,
            IsOtherIncome,
            IsAlimonyChildSupport,
          } = LoanData,
          iInCompletedSubPage_ = [];

        if (!currently_employed && !Retired && !Not_CurrentlyEmployed) {
          iInCompletedSubPage.push(0);
        }

        if (currently_employed === 1) {
          if (additionalEmploymentInfo.length == 0) iInCompletedSubPage.push(0);
          let prevCustId = additionalEmploymentInfo[0]?.["CustId"] || 0,
            iIndex = 0;
          additionalEmploymentInfo.forEach((employment, index) => {
            let { CustId } = employment;
            if (CustId != prevCustId) {
              prevCustId = CustId;
              iIndex = iIndex + 1;
            }

            if (
              handleGetFirstPageFieldNew(employment, [
                { name: "CustId", value: "" },
                { name: "Empmt_Emp_Name", value: "" },
                { name: "Emp_Strt_Addrs", value: "" },
                { name: "Emp_ZipCode", value: "", lengthLimit: 5 },
                { name: "Emp_City", value: "" },
                { name: "Emp_State", value: "" },
                { name: "Emp_phone", value: "", lengthLimit: 10 },
                { name: "Job_Title", value: "" },
                { name: "Employed_From", value: "" },
                { name: "Employed_To", value: "" },
                { name: "CurrentYrsInLineofwork", value: 0, falseCheck: true },
              ])
            ) {
              iInCompletedSubPage_.push(iIndex + 1);
            }

            iIndex++;
          });
        } else {
          if (IsOtherIncome) {
            if (
              handleGetFirstPageFieldNew(LoanData, [
                { name: "Payor_Name", value: "" },
                { name: "Source_Other_Incm", value: "0" },
                { name: "Monthly_Amount", value: "" },
                { name: "OtherIncomeCustId", value: "-99" },
              ])
            ) {
              iInCompletedSubPage.push(1);
            }

            additionalOtherIncomeInfo.forEach((income, index) => {
              if (
                handleGetFirstPageFieldNew(income, [
                  { name: "Payor_Name", value: "" },
                  { name: "Source_Other_Incm", value: "0" },
                  { name: "Monthly_Amount", value: "" },
                  { name: "CustId", value: "-99" },
                ])
              ) {
                iInCompletedSubPage.push(index + 2);
              }
            });
          }
        }
        let additionalPageCount =
          currently_employed === 1
            ? removeDuplicates(additionalEmploymentInfo, "CustId")["length"] ||
              0
            : 2;

        if (![0, 1].includes(Number(IsAlimonyChildSupport ?? -1))) {
          iInCompletedSubPage.push(
            additionalPageCount + additionalOtherIncomeInfo.length + 2
          );
        }

        if ([1].includes(Number(IsAlimonyChildSupport ?? -1))) {
          if (
            handleGetFirstPageFieldNew(LoanData, [
              { name: "OtherAlimonyIncomeCustId", value: "-99" },
              // { name: "Monthly_Alimony_Expense", value: "" },
              // { name: "Monthly_Alimony_Income", value: "" },
              // { name: "Monthly_ChildSupportExpense", value: "" },
              // { name: "Monthly_ChildSupportIncome", value: "" },
            ])
          ) {
            iInCompletedSubPage.push(
              additionalPageCount +
                (LoanData["currently_employed"] === 1
                  ? additionalEmploymentInfo.length
                  : additionalOtherIncomeInfo.length) +
                1
            );
          }
        }

        inCompletedSubPageObjNew[pageArray[iPageId]] = [
          iInCompletedSubPage,
          iInCompletedSubPage_,
        ];
        iSubPage = iInCompletedSubPage.length
          ? iInCompletedSubPage[0]
          : iInCompletedSubPage_.length
          ? iInCompletedSubPage_[0]
          : iSubPage;

        if (iIndex === iPageId) {
          iSubPage =
            additionalEmploymentInfo.length > 0 &&
            iSubPage == -1 &&
            currently_employed === 1
              ? 1
              : iSubPage;
          return { iPage, iSubPage, iInCompletedSubPage };
        } else if (iExp) {
          iPage++;
          if (iSubPage === -1) iCompletedPage.push(iPageId);
          iSubPage = -1;
          currentPage_ = pageArray[iPage];
        } else if (iPage === iPageId && iSubPage === -1) {
          iPage++;
          currentPage_ = pageArray[iPage];
        }
      } else if (iPage === iPageId && iSubPage === -1) {
        iPage++;
        currentPage_ = pageArray[iPage];
      }

      //TODO ======= REO =======
      iPageId = pageId["realEstateOwned"];
      if (
        ((currentPage_ === pageArray[iPageId] || iExp) &&
          !iLeftNavStatus.includes(iPageId)) ||
        (iExp && iIndex === iPageId)
      ) {
        iInCompletedSubPage = [];
        const { Real_est_prop } = LoanData;

        if (![0, 1].includes(Number(Real_est_prop ?? -1))) {
          iInCompletedSubPage.push(0);
        }

        if (additionalPropertyInfo.length > 0) {
          additionalPropertyInfo.map((property, index) => {
            const {
              Real_est_Prop_Status,
              Real_est_Subj_Prop,
              Current_residence,
            } = property;
            if (
              handleGetFirstPageFieldNew(property, [
                { name: "Real_est_prop_Addrs", value: "" },
                { name: "Real_est_ZipCode", value: "", lengthLimit: 5 },
                { name: "Real_est_City", value: "" },
                { name: "Real_est_State", value: "" },
                { name: "Presnt_Markt_Val", value: "" },
                { name: "Real_est_Prop_Status", value: "" },
                { name: "PropertyType", value: "" },
                { name: "Months_Ownd_Prop", value: 0, falseCheck: true },
                { name: "OwnerIdList", value: "" },
              ])
            ) {
              iInCompletedSubPage.push(index);
            }
            if (![1, 2, 3, 4].includes(Number(Real_est_Prop_Status ?? -1))) {
              iInCompletedSubPage.push(index);
            }

            if (![0, 1].includes(Number(Real_est_Subj_Prop ?? -1))) {
              iInCompletedSubPage.push(index);
            }

            if (![0, 1].includes(Number(Current_residence ?? -1))) {
              iInCompletedSubPage.push(index);
            }
          });
        }

        inCompletedSubPageObjNew[pageArray[iPageId]] = iInCompletedSubPage;
        iSubPage = iInCompletedSubPage.length
          ? iInCompletedSubPage[0]
          : iSubPage;

        if (iIndex === iPageId) {
          return { iPage, iSubPage, iInCompletedSubPage };
        } else if (iExp) {
          iPage++;
          if (
            iSubPage === -1 &&
            LoanData["Real_est_prop"] !== null &&
            LoanData["Real_est_prop"] !== undefined
          )
            iCompletedPage.push(iPageId);
          iSubPage = -1;
          currentPage_ = pageArray[iPage];
        } else if (iPage === iPageId && iSubPage === -1) {
          iPage++;
          currentPage_ = pageArray[iPage];
        }
      } else if (iPage === iPageId && iSubPage === -1) {
        iPage++;
        currentPage_ = pageArray[iPage];
      }
      //TODO ======= Government =======
      iPageId = pageId["government"];
      if (
        ((currentPage_ === pageArray[iPageId] || iExp) &&
          !iLeftNavStatus.includes(iPageId)) ||
        (iExp && iIndex === iPageId)
      ) {
        iInCompletedSubPage = [];
        //* Declaration Section
        const {
          Citizenship_Status,
          Pri_residence,
          Ownership_intst_Othr_Prop,
          Prop_own,
          Prop_hold,
          Purchase_Transaction,
          Bor_money_realest_trans,
          Apply_mortloan_otherprop,
          Apply_newcredit,
          Prop_sub_to_lien,
          Co_signer,
          Outstanding_judgments,
          Cur_delinquent,
          Party_to_lawsuit,
          Prop_lieu_foreclosure,
          Pre_foreclosure_sale,
          Prop_foreclosed,
          Declare_bankruptcy,
          Types_bankruptcy,
          bType1stBuyer,
          Bor_money_Amt,
        } = LoanData;

        if (
          ![1, 2, 3].includes(Citizenship_Status) ||
          ![0, 1].includes(Pri_residence) ||
          ![0, 1].includes(Ownership_intst_Othr_Prop) ||
          (Ownership_intst_Othr_Prop === 1 && ![1, 2, 3].includes(Prop_own)) ||
          (Ownership_intst_Othr_Prop === 1 && ![1, 2, 3].includes(Prop_hold)) ||
          ![0, 1].includes(Purchase_Transaction) ||
          ![0, 1].includes(Bor_money_realest_trans) ||
          ![0, 1].includes(Apply_mortloan_otherprop) ||
          ![0, 1].includes(Apply_newcredit) ||
          ![0, 1].includes(Prop_sub_to_lien) ||
          ![0, 1].includes(Co_signer) ||
          ![0, 1].includes(Outstanding_judgments) ||
          ![0, 1].includes(Cur_delinquent) ||
          ![0, 1].includes(Party_to_lawsuit) ||
          ![0, 1].includes(Prop_lieu_foreclosure) ||
          ![0, 1].includes(Pre_foreclosure_sale) ||
          ![0, 1].includes(Prop_foreclosed) ||
          ![0, 1].includes(Declare_bankruptcy) ||
          (Declare_bankruptcy === 1 &&
            ![1, 2, 3, 4].includes(Types_bankruptcy)) ||
          ![0, 1].includes(bType1stBuyer) ||
          (Bor_money_realest_trans === 1 && cleanValue(Bor_money_Amt) == 0)
        ) {
          iInCompletedSubPage.push(0);
        }

        additionalBorrowerInfo.slice(1).forEach((borrower, index) => {
          const {
            Citizenship_Status,
            OccupyProperty,
            ["Owe Property"]: OweProperty,
            ["Type Prop Own"]: TypePropOwn,
            ["Hold Title"]: HoldTitle,
            BusinessaffWithSeller,
            LoanOnAnotherProp,
            MoneyBorrowedForDown,
            Downpayment,
            ApplyingNewCredit,
            PropAssCleanEnergy,
            ["Co-maker"]: CoMaker,
            Jugdements,
            Delinquent,
            Lawsuit,
            ConveyedTitle,
            Obligated,
            Forclosed,
            Bankruptcy,
            blChapter7,
            blChapter11,
            blChapter12,
            blChapter13,
            bType1stBuyer,
          } = borrower;

          if (
            ![1, 2, 3].includes(parseInt(Citizenship_Status)) ||
            ![0, 1].includes(parseInt(OccupyProperty)) ||
            ![0, 1].includes(parseInt(OweProperty)) ||
            (OweProperty === 1 && ![1, 2, 3].includes(parseInt(TypePropOwn))) ||
            (OweProperty === 1 && ![1, 2, 3].includes(parseInt(HoldTitle))) ||
            ![0, 1].includes(parseInt(BusinessaffWithSeller)) ||
            ![0, 1].includes(parseInt(LoanOnAnotherProp)) ||
            (parseInt(LoanOnAnotherProp) === 1 &&
              cleanValue(MoneyBorrowedForDown) == 0) ||
            ![0, 1].includes(parseInt(Downpayment)) ||
            ![0, 1].includes(parseInt(ApplyingNewCredit)) ||
            ![0, 1].includes(parseInt(PropAssCleanEnergy)) ||
            ![0, 1].includes(parseInt(CoMaker)) ||
            ![0, 1].includes(parseInt(Jugdements)) ||
            ![0, 1].includes(parseInt(Delinquent)) ||
            ![0, 1].includes(parseInt(Lawsuit)) ||
            ![0, 1].includes(parseInt(ConveyedTitle)) ||
            ![0, 1].includes(parseInt(Obligated)) ||
            ![0, 1].includes(parseInt(Forclosed)) ||
            ![0, 1].includes(parseInt(Bankruptcy)) ||
            (parseInt(Bankruptcy) === 1 &&
              ![1, 2, 3, 4].includes(parseInt(blChapter7)) &&
              ![1, 2, 3, 4].includes(parseInt(blChapter11)) &&
              ![1, 2, 3, 4].includes(parseInt(blChapter12)) &&
              ![1, 2, 3, 4].includes(parseInt(blChapter13))) ||
            ![0, 1].includes(parseInt(bType1stBuyer))
          ) {
            iInCompletedSubPage.push((index + 1) * 4);
          }
        });

        //* Demographic Section

        const {
          Demographic_Info,
          Sex,
          Ethinicity,
          HispanicSubcategory,
          OtherOrigin,
          Race,
          PrincipalTribe,
          NaticHawaiSubCategory,
          OtherPacificIslandRace,
          AsianRaceSubCategory,
          OtherAsianRace,
        } = LoanData;

        if (
          ![1, 2, 3, 4].includes(parseInt(Demographic_Info)) ||
          Number(Sex) === 4 ||
          Number(Ethinicity) === 3 ||
          (Number(Ethinicity) === 1 && parseInt(HispanicSubcategory) === 0) ||
          ((8 & Number(HispanicSubcategory)) === 8 &&
            Number(Ethinicity) === 1 &&
            !OtherOrigin) ||
          parseInt(Race) === 0 ||
          ((1 & Number(Race)) === 1 && !PrincipalTribe) ||
          ((2 & Number(Race)) === 2 && parseInt(NaticHawaiSubCategory) === 0) ||
          ((8 & Number(NaticHawaiSubCategory)) === 8 &&
            (2 & Number(Race)) === 2 &&
            !OtherPacificIslandRace) ||
          ((4 & Number(Race)) === 4 && parseInt(AsianRaceSubCategory) === 0) ||
          ((64 & Number(AsianRaceSubCategory)) === 64 &&
            (4 & Number(Race)) === 4 &&
            !OtherAsianRace)
        ) {
          iInCompletedSubPage.push(1);
        }

        additionalBorrowerInfo.slice(1).forEach((borrower, index) => {
          const {
            Demographic_Info: borrowerDemographic_Info,
            Sex: borrowerSex,
            Ethnicity: borrowerEthnicity,
            HispanicSubcategory: borrowerHispanicSubcategory,
            RaceIndian: borrowerRaceIndian,
            RaceHawaiian: borrowerRaceHawaiian,
            RaceAsian: borrowerRaceAsian,
            RaceWhite: borrowerRaceWhite,
            RaceBlack: borrowerRaceBlack,
            PrincipalTribe: borrowerPrincipalTribe,
            NaticHawaiSubCategory: borrowerNaticHawaiSubCategory,
            AsianRaceSubCategory: borrowerAsianRaceSubCategory,
            OtherAsianRace: borrowerOtherAsianRace,
            OtherOrigin,
          } = borrower;

          if (
            ![1, 2, 3, 4].includes(Number(borrowerDemographic_Info)) ||
            parseInt(borrowerSex) === 4 ||
            Number(borrowerEthnicity) === 3 ||
            (Number(borrowerEthnicity) === 1 &&
              parseInt(borrowerHispanicSubcategory) === 0) ||
            ((8 & Number(borrowerHispanicSubcategory)) === 8 &&
              Number(borrowerEthnicity) === 1 &&
              !OtherOrigin) ||
            (parseInt(borrowerRaceIndian || 0) != 1 &&
              parseInt(borrowerRaceHawaiian || 0) != 1 &&
              parseInt(borrowerRaceAsian || 0) != 1 &&
              parseInt(borrowerRaceWhite || 0) != 1 &&
              parseInt(borrowerRaceBlack || 0) != 1 &&
              parseInt(borrowerRaceBlack || 0) != 1) ||
            (Number(borrowerRaceIndian) === 1 && !borrowerPrincipalTribe) ||
            (Number(borrowerRaceHawaiian) === 1 &&
              parseInt(borrowerAsianRaceSubCategory) === 0) ||
            ((64 & Number(borrowerAsianRaceSubCategory)) === 64 &&
              Number(borrowerRaceAsian) === 1 &&
              !borrowerOtherAsianRace)
          ) {
            iInCompletedSubPage.push((index + 1) * 4 + 1);
          }
        });

        //* VA Section

        const {
          Military_Status,
          Reserves_Active,
          Branch_Service,
          SerMilitaryStatus,
          VA_Entitlmt_Amt,
          VA_Entitlmt_Amt_used,
          VA_Entitlmt_Code,
          VA_Loan_FTU,
          VA_Funding_Fee,
          Currently_serving,
          Currently_retired,
          Active_National_Guard,
          Surviving_spouse,
        } = LoanData;

        if (![1, 2, 8].includes(Number(Military_Status))) {
          iInCompletedSubPage.push(2);
        }

        if (Military_Status !== 8) {
          if (
            ![1, 0].includes(parseInt(Reserves_Active)) ||
            ![1, 2, 3, 4, 5, 6].includes(Number(Branch_Service)) ||
            ![1, 2].includes(Number(SerMilitaryStatus)) ||
            cleanValue(VA_Entitlmt_Amt) == 0 ||
            cleanValue(VA_Entitlmt_Amt_used) == 0 ||
            !VA_Entitlmt_Code ||
            ![0, 1].includes(parseInt(VA_Loan_FTU)) ||
            ![0, 1].includes(parseInt(VA_Funding_Fee)) ||
            ![0, 1].includes(parseInt(Currently_serving)) ||
            ![0, 1].includes(parseInt(Currently_retired)) ||
            ![0, 1].includes(parseInt(Active_National_Guard)) ||
            ![0, 1].includes(parseInt(Surviving_spouse))
          ) {
            iInCompletedSubPage.push(2);
          }
        }

        additionalBorrowerInfo.slice(1).forEach((borrower, index) => {
          const {
            VA_Military_Status,
            VA_Entitlmt_Amt: borrower_VA_Entitlmt_Amt,
            VA_Entitlmt_Amt_used: borrower_VA_Entitlmt_Amt_used,
            VA_Entitlmt_Code: borrower_VA_Entitlmt_Code,
            Reserves_Active: borrower_Reserves_Active,
            Branch_Service: borrower_Branch_Service,
            VAMilitaryServiceStatus: borrower_VAMilitaryServiceStatus,
            VA_Loan_FTU: borrower_VA_Loan_FTU,
            VA_Funding_Fee: borrower_VA_Funding_Fee,
            Currently_serving: borrower_Currently_serving,
            Currently_retired: borrower_Currently_retired,
            Active_National_Guard: borrower_Active_National_Guard,
            Surviving_spouse: borrower_Surviving_spouse,
          } = borrower;

          if (![1, 2, 8].includes(parseInt(VA_Military_Status))) {
            iInCompletedSubPage.push((index + 1) * 4 + 2);
          }

          if (VA_Military_Status !== 8) {
            if (
              cleanValue(borrower_VA_Entitlmt_Amt) == 0 ||
              cleanValue(borrower_VA_Entitlmt_Amt_used) == 0 ||
              !borrower_VA_Entitlmt_Code ||
              ![1, 0].includes(parseInt(borrower_Reserves_Active)) ||
              ![1, 2, 3, 4, 5, 6].includes(parseInt(borrower_Branch_Service)) ||
              ![1, 2].includes(parseInt(borrower_VAMilitaryServiceStatus)) ||
              ![0, 1].includes(parseInt(borrower_VA_Loan_FTU)) ||
              ![0, 1].includes(parseInt(borrower_VA_Funding_Fee)) ||
              ![0, 1].includes(parseInt(borrower_Currently_serving)) ||
              ![0, 1].includes(parseInt(borrower_Currently_retired)) ||
              ![0, 1].includes(parseInt(borrower_Active_National_Guard)) ||
              ![0, 1].includes(parseInt(borrower_Surviving_spouse))
            ) {
              iInCompletedSubPage.push((index + 1) * 4 + 2);
            }
          }
        });

        const {
          Couns_Confirm,
          Couns_Comp_Date,
          Couns_Type,
          Couns_Agency_Name,
          LanguagePreference,
          OtherLanguageDescription,
        } = LoanData;

        if (![1, 2].includes(parseInt(Couns_Confirm))) {
          iInCompletedSubPage.push(3);
        }

        if (
          Couns_Confirm === 1 &&
          (!Couns_Comp_Date ||
            ![2, 1].includes(Couns_Type) ||
            !Couns_Agency_Name ||
            !LanguagePreference ||
            (LanguagePreference == 7 && !OtherLanguageDescription))
        ) {
          iInCompletedSubPage.push(3);
        }

        additionalCounsellingInfo.slice(1).forEach((borrower, index) => {
          const {
            Couns_Confirm: borrower_Couns_Confirm,
            Couns_Comp_Date: borrower_Couns_Comp_Date,
            Couns_Type: borrower_Couns_Type,
            Couns_Agency_Name: borrower_Couns_Agency_Name,
            LanguagePreference: borrower_LanguagePreference,
            OtherLanguageDescription: borrower_OtherLanguageDescription,
          } = borrower;

          if (![1, 2].includes(parseInt(borrower_Couns_Confirm))) {
            iInCompletedSubPage.push((index + 1) * 4 + 3);
          }

          if (
            borrower_Couns_Confirm === 1 &&
            (!borrower_Couns_Comp_Date ||
              ![2, 1].includes(borrower_Couns_Type) ||
              !borrower_Couns_Agency_Name ||
              !borrower_LanguagePreference ||
              (borrower_LanguagePreference == 7 &&
                !borrower_OtherLanguageDescription))
          ) {
            iInCompletedSubPage.push((index + 1) * 4 + 3);
          }
        });

        inCompletedSubPageObjNew[pageArray[iPageId]] = iInCompletedSubPage;

        iSubPage = iInCompletedSubPage.length
          ? iInCompletedSubPage[0]
          : iSubPage;

        if (iIndex === iPageId) {
          return { iPage, iSubPage, iInCompletedSubPage };
        } else if (iExp) {
          iPage++;
          if (iSubPage === -1) iCompletedPage.push(iPageId);
          iSubPage = -1;
          currentPage_ = pageArray[iPage];
        } else if (iPage === iPageId && iSubPage === -1) {
          iPage++;
          currentPage_ = pageArray[iPage];
        }
      } else if (iPage === iPageId && iSubPage === -1) {
        iPage++;
        currentPage_ = pageArray[iPage];
      }
    }
    if ((iPage === 0 || iPage === 9) && iSubPage === -1) {
      if (!iLeftNavStatus.includes(pageId["documentUpload"])) {
        iPage = pageId["documentUpload"];
        iSubPage = -1;
        currentPage_ = pageArray[iPage];
      } else if (!iLeftNavStatus.includes(pageId["eSign"])) {
        iPage = pageId["eSign"];
        iSubPage = -1;
        currentPage_ = pageArray[iPage];
      } else if (!iLeftNavStatus.includes(pageId["reviewYourInterestRate"])) {
        iPage = pageId["reviewYourInterestRate"];
        iSubPage = -1;
        currentPage_ = pageArray[iPage];
      } else if (loanURLDetails["apprURL"]) {
        iPage = pageArray.length - 1;
        iSubPage = -1;
        currentPage_ = pageArray[iPage];
      }

      if (iPage === 9 && iLeftNavStatus.includes(pageId["documentUpload"])) {
        iPage = 0;
        iSubPage = -1;
        currentPage_ = pageArray[iPage];
      }
    }
    // console.log({ inCompletedSubPageObj });
    setInCompletedSubPageObj(inCompletedSubPageObjNew);
    return {
      iPageIndex: contextDetails["isNewLoanCreated"]
        ? pageIndex
        : {
            page: iPage,
            subPage:
              iSubPage > 0
                ? iSubPage
                : inCompletedSubPageObjNew[pageArray[iPage]]?.[0] || 0,
          },
      iCurrentPage: contextDetails["isNewLoanCreated"]
        ? currentPage
        : currentPage_,
      iCompletedPage,
      iInCompletedSubPage:
        (inCompletedSubPageObjNew[currentPage] || []).length === 1
          ? [
              ...new Set(
                (inCompletedSubPageObjNew[currentPage] || []).filter(
                  (subPageIndex) => subPageIndex > -1
                )
              ),
            ]
          : inCompletedSubPageObjNew[currentPage] || [],
    };
  };
  const handlePageDetails = (page, iLoanId, noLoan) => {
    let currentPage_ = page || currentPage,
      arr = [{ currentPage: currentPage_ }];

    if (Object.keys(LoanData).length > 0 || noLoan) {
      if (currentPage_ === pageArray[pageId["summaryInfo"]]) {
        arr.push({
          Title: "Is this loan for a home purchase or for a refinance?",
          Options: [
            { value: 1, text: "Purchase" },
            { value: 2, text: "Refinance" },
          ],
          ColumnName: "LoanPurpose",
          ColumnValue: LoanData["LoanPurpose"],
          type: 1,
        });

        if (LoanData["LoanPurpose"] === 1) {
          arr.push({
            Title: "Congrats! Where are you in the process?",
            Options: [
              { value: 1, text: `I've found the home I want` },
              { value: 2, text: `I'm just looking` },
              { value: 3, text: `I'm making offers` },
            ],
            ColumnName: "WhichProcess",
            ColumnValue: LoanData["WhichProcess"],
            type: 1,
          });
        }
        if (LoanData["LoanPurpose"] === 2) {
          arr.push({
            Title: "Thank you. What is the purpose of doing a refinance?",
            Options: [
              { value: 1, text: "I want to lower my payment" },
              { value: 2, text: "I want to drop mortgage insurance" },
              { value: 3, text: `I'd like to pull cash out` },
              { value: 4, text: "I want to lower my rate" },
              {
                value: 5,
                text: "I want to shorten my term (pay off my mortgage sooner)",
              },
            ],
            ColumnName: "RefinanceOptions",
            ColumnValue: LoanData["RefinanceOptions"],
            type: 1,
          });
        }
        if (
          (LoanData["WhichProcess"] || 1) === 1 &&
          LoanData["LoanPurpose"] === 1
        ) {
          arr.push({
            Title: "Great! How can we help you most?",
            Options: [
              {
                value: 1,
                text: `I want to see what my rate and monthly payment might be.`,
              },
              {
                value: 2,
                text: `I want to make an offer. I need a pre-qualification letter.`,
              },
              { value: 3, text: `I want to get my application started.` },
              {
                value: 4,
                text: `I have a quote from another lender. Can you beat it?`,
              },
              { value: 5, text: `My offer was accepted.` },
            ],
            ColumnName: "How can we help",
            ColumnValue: LoanData["How can we help"],
            type: 1,
          });
        }
        if (LoanData["WhichProcess"] === 2 && LoanData["LoanPurpose"] === 1) {
          arr.push({
            Title: "Cool! How can we help you most right now?",
            Options: [
              {
                value: 1,
                text: `Show me what my rate and payment might be.`,
              },
              {
                value: 2,
                text: `See today's rates.`,
              },
              { value: 3, text: `Show me how much I can afford.` },
              {
                value: 4,
                text: `I'd just like to talk to a real person`,
              },
            ],
            ColumnName: "How can we help1",
            ColumnValue: LoanData["How can we help1"],
            type: 1,
          });
        }
        if (LoanData["WhichProcess"] === 3 && LoanData["LoanPurpose"] === 1) {
          arr.push({
            Title: "That's exciting! How can we help you most right now?",
            Options: [
              {
                value: 1,
                text: `I want to see what my rate and monthly payment might be.`,
              },
              {
                value: 2,
                text: `I'd love to see what my payment might be.`,
              },
              { value: 3, text: `I need a pre-qualification letter ASAP.` },
              {
                value: 4,
                text: `Chat with someone`,
              },
            ],
            ColumnName: "How can we help2",
            ColumnValue: LoanData["How can we help2"],
            type: 1,
          });
        }
        arr.push({
          Title: "Were you referred to us?",
          widthOption: "40%",
          Options: [
            { value: 1, text: "Yes" },
            { value: 0, text: "No" },
          ],
          ColumnName: "IsReferred",
          ColumnValue: LoanData["IsReferred"],
          type: 1,
          subFields:
            LoanData["IsReferred"] === 1
              ? [
                  {
                    Title: "Referring you?",
                    label: "Refer",
                    ColumnName: "WhoReferred",
                    ColumnValue:
                      LoanData["WhoReferred"] != 0
                        ? LoanData["WhoReferred"]
                        : "",
                    type: 2,
                  },
                ]
              : [],
        });

        arr.push({
          Title:
            "The following loan officer will be assigned to you. Please confirm this is correct, or you can also select a different loan officer.",
          label: "Loan Officer",
          ColumnName: "loanOfficers",
          ColumnValue: parseInt(loanOfficerId) || parseInt(loanOfficers),
          isMap: true,
          onChange: (option) => {
            if (option["value"]) {
              let LoNum = option["value"];
              if (LoNum == "-99") LoNum = 1;
              setLoanOfficers(LoNum);
              setLoanOfficerId(LoNum);
              handleSaveLoanOfficer(LoNum);
            } else {
              setLoanOfficers(0);
              setLoanOfficerId(0);
            }
          },
          type: 3,
          loanId: iLoanId || loanId,
          isLoanCreating: false,
          Option: loanOfficerOption,
          isDisable: LoanData["LockLoanApp"] == 1,
        });

        arr.push({
          Title: "Please tell us about your occupancy",
          Options: [
            { value: 1, text: "Primary Residence" },
            { value: 2, text: "Second Home" },
            { value: 3, text: "Investment Property" },
          ],
          ColumnName: "Propertybe",
          ColumnValue: LoanData["Propertybe"],
          type: 1,
          subFields: [
            {
              Title: "What is the Property Type?",
              label: "Property Type",
              isValid: !LoanData["LoanSummaryPropertyType"],
              ColumnName: "LoanSummaryPropertyType",
              ColumnValue: LoanData["LoanSummaryPropertyType"]?.toString(),
              onBlur: () => {},
              type: 3,
              Option: propertyTypeOption,
              isMap: true,
            },

            {
              Title: "Subject Property Address",
              label: "Property Street Address",
              ColumnName: "subjectAddress",
              ColumnValue: LoanData["subjectAddress"],
              isValid:
                (LoanData["LoanPurpose"] == 1 &&
                  !LoanData["AddressTBD"] &&
                  !LoanData["subjectAddress"]) ||
                (LoanData["LoanPurpose"] == 2 && !LoanData["subjectAddress"]),
              type: 2,
              addTopField: (
                <>
                  {LoanData["LoanPurpose"] !== 2 && (
                    <>
                      <Separator />
                      <View style={{ flexDirection: "row" }}>
                        <CustomText
                          bold={true}
                          style={{ fontSize: web ? 17 : 16, color: "#0f203a" }}
                        >
                          The address is To Be Determined
                        </CustomText>
                        <Swatch
                          size={15}
                          value={Boolean(LoanData["AddressTBD"])}
                          onChange={async (value) => {
                            setLoanData((prevLoanData) => {
                              return {
                                ...prevLoanData,
                                AddressTBD: !LoanData["AddressTBD"],
                              };
                            });
                          }}
                        />
                      </View>
                      <Separator />
                    </>
                  )}
                </>
              ),
            },
            {
              Title: "",
              label: "Property Zip Code",
              ColumnName: "subjectZip",
              keyboardType: "numeric",
              maxLength: 5,
              ColumnValue: LoanData["subjectZip"],
              forceValidation:
                (LoanData["LoanPurpose"] == 1 &&
                  !LoanData["AddressTBD"] &&
                  LoanData["subjectZip"]?.toString().length != 5) ||
                (LoanData["LoanPurpose"] == 2 &&
                  LoanData["subjectZip"]?.toString().length != 5),
              type: 2,
              onBlur: async () => {
                let zipCode = LoanData["subjectZip"];
                if (zipCode.length === 5) {
                  let { city, state } = await handleGetZipCodeDetails(zipCode);
                  setLoanData((prevLoanData) => {
                    return {
                      ...prevLoanData,
                      [`subjectCity`]: city,
                      [`subjectState`]: state,
                    };
                  });
                }
              },
            },
            {
              Title: "",
              label: "Property City",
              ColumnName: "subjectCity",
              ColumnValue: LoanData["subjectCity"],
              isValid:
                (LoanData["LoanPurpose"] == 1 &&
                  !LoanData["AddressTBD"] &&
                  !LoanData["subjectCity"]) ||
                (LoanData["LoanPurpose"] == 2 && !LoanData["subjectCity"]),
              type: 2,
            },
            {
              Title: "",
              label: "Property State",
              ColumnName: "subjectState",
              isValid: !LoanData["subjectState"],
              ColumnValue: LoanData["subjectState"],
              isValid:
                (LoanData["LoanPurpose"] == 1 &&
                  !LoanData["AddressTBD"] &&
                  !LoanData["subjectState"]) ||
                (LoanData["LoanPurpose"] == 2 && !LoanData["subjectState"]),
              onBlur: () => {},
              type: 3,
              Option: stateOptions,
              isMap: true,
            },
            {
              Title: "",
              label: "Year Property Built",
              ColumnName: "Prop_Years",
              isValid: !LoanData["Prop_Years"],
              ColumnValue: LoanData["Prop_Years"],
              isValid:
                (LoanData["LoanPurpose"] == 1 &&
                  !LoanData["AddressTBD"] &&
                  !LoanData["Prop_Years"]) ||
                (LoanData["LoanPurpose"] == 2 && !LoanData["Prop_Years"]),
              type: 2,
              keyboardType: "numeric",
              maxLength: 4,
            },
          ],
        });

        if (LoanData["LoanPurpose"] === 2) {
          arr.push({
            Title: "What is the primary purpose of your refinance?",
            Options: [
              { value: 1, text: "Lower my payment" },
              { value: 2, text: "Cash out" },
            ],
            ColumnName: "Pri_purpose_Refi",
            ColumnValue: LoanData["Pri_purpose_Refi"],
            type: 1,
          });
        }
        if (LoanData["LoanPurpose"] === 1) {
          arr.push({
            type: 2,
            subFields: [
              {
                Title: "What is the estimated purchase price?",
                label: "Estimated purchase value",
                ColumnName: "Purchase_Estm_Pur_Price",
                ColumnValue: LoanData["Purchase_Estm_Pur_Price"],
                isValid: cleanValue(LoanData["Purchase_Estm_Pur_Price"]) == 0,
                isCurrency: true,
                onBlur: handleCalculateDownPaymentPer,
              },
              {
                Title: "What is the estimated Down Payment?",
                label: "Down Payment",
                field: [
                  {
                    ColumnName: "DownPayment",
                    ColumnValue: LoanData["DownPayment"],
                    isCurrency: true,
                    onBlur: DownPmtOnChange,
                  },
                  {
                    ColumnName: "DownPaymentPercent",
                    ColumnValue: LoanData["DownPaymentPercent"],
                    isCurrency: true,
                    onBlur: CalculateDownPayment,
                  },
                ],
              },
              {
                Title: "What would be your estimated loan amount?",
                label: "Estimated Loan Amount",
                ColumnName: "Purchase_Estm_LnAmt",
                isValid: cleanValue(LoanData["Purchase_Estm_LnAmt"]) == 0,
                isCurrency: true,
                ColumnValue: LoanData["Purchase_Estm_LnAmt"],
                onBlur: LnAmtExcChange,
              },
            ],
          });
        } else {
          arr.push({
            type: 2,
            subFields: [
              {
                Title: "What is the estimated property value?",
                label: "Estimated Property Value",
                isValid: cleanValue(LoanData["Refi_Estmt_Prop_Lnval"]) == 0,
                ColumnName: "Refi_Estmt_Prop_Lnval",
                ColumnValue: LoanData["Refi_Estmt_Prop_Lnval"],
                isCurrency: true,
                onBlur: () => {
                  setLoanData({
                    ...LoanData,
                    Refi_Estmt_Prop_Lnval: formatCurrency(
                      LoanData["Refi_Estmt_Prop_Lnval"],
                      2
                    ),
                  });
                },
              },
              {
                Title: "Loan Amount of Loan Being Paid Off?",
                label: "Loan Being Paid Off",
                ColumnName: "PaidOff",
                ColumnValue: LoanData["PaidOff"],
                isCurrency: true,
                onBlur: () => {
                  CalculateLnAmt("PaidOff");
                },
              },
              LoanData["Pri_purpose_Refi"] === 2
                ? {
                    Title: "Cash Out Amount Requested?",
                    label: "Cash Out Amount",
                    ColumnName: "CashOutAmount",
                    ColumnValue: LoanData["CashOutAmount"],
                    isCurrency: true,
                    onBlur: () => {
                      CalculateLnAmt("CashOutAmount");
                    },
                  }
                : null,
              {
                Title: "What would be your estimated loan amount?",
                label: "Estimated Loan Amount",
                ColumnName: "Refi_Estmt_LnAmt",
                isValid: cleanValue(LoanData["Refi_Estmt_LnAmt"]) == 0,
                ColumnValue: LoanData["Refi_Estmt_LnAmt"],
                isCurrency: true,
                onBlur: () => {
                  CalculateLnAmt("Refi_Estmt_LnAmt");
                },
              },
            ].filter((_) => _),
          });
        }
      } else if (currentPage_ === pageArray[pageId["borrowerInfo"]]) {
        arr.push(
          ...[
            {
              Title: (
                <CustomText
                  bold={true}
                  style={{
                    fontSize: web ? 24 : 21,
                    marginBottom: web ? 30 : 15,
                    color: "#41464d",
                  }}
                >
                  Complete your contact information for{" \n"}
                  <CustomText bold={true} style={{ backgroundColor: "cyan" }}>
                    {LoanData["FirstName"] || LoanData["LastName"]
                      ? `${LoanData["FirstName"] || ""} ${
                          LoanData["LastName"] || ""
                        }`
                      : `borrower`}
                  </CustomText>
                  {LoanData["FirstName"] || LoanData["LastName"] ? `.` : `?`}
                </CustomText>
              ),
              type: 2,
              subFields: [
                {
                  Title: "",
                  label: "First Name",
                  ColumnName: "FirstName",
                  isValid: !LoanData["FirstName"],
                  ColumnValue: LoanData["FirstName"] || "",
                  onBlur: () => {
                    if (
                      (LoanData["NickName"] || "")?.toString().trim() === ""
                    ) {
                      setLoanData((prevLoanData) => {
                        return {
                          ...prevLoanData,
                          NickName: capitalizeFirstLetter(
                            LoanData["FirstName"]
                          ),
                        };
                      });
                    }
                  },
                },
                {
                  Title: "",
                  label: "Nickname",
                  ColumnName: "NickName",
                  ColumnValue: LoanData["NickName"]?.toString().trim(),
                  onBlur: () => {},
                },
                {
                  Title: "",
                  label: "Middle Name",
                  ColumnName: "MiddleName",
                  ColumnValue: LoanData["MiddleName"],
                  onBlur: () => {},
                },
                {
                  Title: "",
                  label: "Last Name",
                  ColumnName: "LastName",
                  isValid: !LoanData["LastName"],
                  ColumnValue: LoanData["LastName"],
                  onBlur: () => {},
                },
                {
                  Title: "",
                  label: "Social Security Number",
                  ColumnName: "SSN",
                  keyboardType: "numeric",
                  ColumnValue: LoanData["SSN"],
                  maxLength: 9,
                  onBlur: () => {
                    setLoanData({
                      ...LoanData,
                      SSN: formatSSN(LoanData["SSN"], 2),
                    });
                  },
                },
                {
                  Title: "",
                  label: "Suffix",
                  placeholder: "Suffix",
                  ColumnName: "Suffix",
                  ColumnValue: LoanData["Suffix"],
                  onBlur: () => {},
                  type: 3,
                  Option: [
                    { value: "", label: "-None-" },
                    { value: "I", label: "I" },
                    { value: "II", label: "II" },
                    { value: "III", label: "III" },
                    { value: "IV", label: "IV" },
                    { value: "Jr", label: "Jr" },
                    { value: "Sr", label: "Sr" },
                    { value: "V", label: "V" },
                  ],
                },
                {
                  Title: "",
                  label: "Birthdate",
                  ColumnName: "BirthDate",
                  charLength: 10,
                  placeholder: "MM/DD/YYYY",
                  ColumnValue: LoanData["BirthDate"],
                  isValid: !LoanData["BirthDate"],
                  forceValidation: !(
                    calculateAge(formatDateTimeNew(LoanData["BirthDate"], 2)) >=
                    18
                  ),
                  onBlur: () => {
                    setLoanData({
                      ...LoanData,
                      BirthDate: formatDateTimeNew(LoanData["BirthDate"], 2),
                    });
                  },
                },
                {
                  Title: "",
                  label: "Cell",
                  ColumnName: "CellPhone",
                  maxLength: 10,
                  ColumnValue: handleGetCellPhone(LoanData["CellPhone"]),
                  forceValidation:
                    handleGetCellPhone(LoanData["CellPhone"])
                      .toString()
                      .replace(/[(),\- ]/g, "").length != 10,
                  keyboardType: "phone-pad",
                  onBlur: () => {
                    setLoanData({
                      ...LoanData,
                      CellPhone: `*5*${FormatPhoneLogin(
                        handleGetCellPhone(LoanData["CellPhone"]) || ""
                      )}`,
                    });
                  },
                },
                {
                  Title: "",
                  label: "Email",
                  ColumnName: "EmailId",
                  ColumnValue: LoanData["EmailId"],
                  isValid: !LoanData["EmailId"],
                  // keyboardType: "email-address",
                  onBlur: () => {},
                },
                {
                  Title: "",
                  label: "Number of Dependents",
                  ColumnName: "Dependents",
                  ColumnValue: LoanData["Dependents"],
                  onBlur: () => {},
                  keyboardType: "numeric",
                  charLength: 2,
                },
                {
                  Title: "",
                  label: "Ages of Dependents",
                  ColumnName: "Ages_Dependents",
                  ColumnValue: LoanData["Ages_Dependents"],
                  onBlur: () => {
                    // let iBirthDate = formatDateTimeNew(
                    //   LoanData["BirthDate"],
                    //   2
                    // );
                    // let age = calculateAge(iBirthDate);
                    // setLoanData({
                    //   ...LoanData,
                    //   Ages_Dependents: age,
                    // });
                  },
                  // type: "numeric",
                },
                {
                  Title: "",
                  label: "Marital Status",
                  ColumnName: "MaritalStatus",
                  ColumnValue: LoanData["MaritalStatus"],
                  onBlur: () => {},
                  isValid: LoanData["MaritalStatus"] == 0,
                  type: 3,
                  isMap: true,
                  Option: maritalStatusOptions.filter(
                    ({ value }) => Number(value) !== Number(LoanData["UserId"])
                  ),
                },
              ],
            },
          ]
        );

        arr.push(
          ...additionalBorrowerInfo.slice(1).map((borrower, index) => {
            let obj = {
              isAdditionalBorr: true,
              CustId: borrower["CustId"],
              Title: (
                <CustomText
                  bold={true}
                  style={{
                    fontSize: web ? 24 : 21,
                    marginBottom: web ? 30 : 15,
                    color: "#41464d",
                  }}
                >
                  Complete your contact information for{" \n"}
                  <CustomText bold={true} style={{ backgroundColor: "cyan" }}>
                    {borrower["FirstName"] || borrower["LastName"]
                      ? `${borrower["FirstName"]} ${borrower["LastName"]}`
                      : `borrower ${index + 2}`}
                  </CustomText>
                  {borrower["FirstName"] || borrower["LastName"] ? `.` : `?`}
                </CustomText>
              ),
              removeContent: (
                <View>
                  <Title
                    style={{ fontSize: web ? 22 : 18 }}
                    text="Are you sure you want to remove?"
                  />
                  <View
                    style={{
                      flex: 1,
                      flexDirection: "row-reverse",
                      marginTop: -10,
                      alignSelf: "flex-start",
                    }}
                  >
                    <IconButton
                      onPress={() => {
                        let addBorr = additionalBorrowerInfo.filter(
                          (e, index_) => index + 1 !== index_
                        );

                        if (addBorr.length === 1) {
                          setLoanData({
                            ...LoanData,
                            ...{
                              Spouse_AddBorrower: 0,
                              iSpouse_AddBorrower: 0,
                            },
                          });
                          handleSaveLoanInformation([
                            {
                              ColumnName: "Spouse_AddBorrower",
                              ColumnValue: 0,
                            },
                          ]);
                        }

                        handleUpdateAddtionalBorrower(index, "isRemove", false);
                        setAdditionalBorrowerInfo([...addBorr]);

                        setPageIndex({
                          ...pageIndex,
                          subPage: Number(pageIndex["subPage"]) - 1,
                        });
                        handleSaveAdditionalInfo(
                          -1,
                          5,
                          additionalBorrowerInfo[index + 1]["CustId"]
                        );
                        setScrollToTop(true);
                      }}
                      style={{
                        paddingVertical: 7,
                        paddingHorizontal: 10,
                      }}
                      title={
                        <CustomText
                          bold={true}
                          style={{ fontSize: 16, color: "#fff" }}
                        >
                          Remove
                        </CustomText>
                      }
                    />
                    <IconButton
                      style={{
                        marginRight: 10,
                        paddingVertical: 7,
                        paddingHorizontal: 10,
                      }}
                      buttonType="secondary"
                      onPress={() => {
                        handleUpdateAddtionalBorrower(index, "isRemove", false);
                      }}
                      title={
                        <CustomText
                          bold={true}
                          style={{ fontSize: 16, color: "#508BC9" }}
                        >
                          Cancel
                        </CustomText>
                      }
                    />
                  </View>
                </View>
              ),
              footerContent: (
                <>
                  <AddRemoveButton
                    onPress={() => {
                      handleUpdateAddtionalBorrower(index, "isRemove", true);
                      setScrollToTop(999);
                    }}
                    text={
                      <>
                        Remove{" "}
                        {borrower["FirstName"] || borrower["LastName"]
                          ? `${borrower["FirstName"]} ${borrower["LastName"]}`
                          : `Borrower ${index + 2}`}
                      </>
                    }
                  />
                </>
              ),
              index: index,
              onTextChange: handleUpdateAddtionalBorrower,
              isRemove: borrower["isRemove"] || false,
              type: 2,
              subFields: [
                {
                  Title: "",
                  label: "First Name",
                  ColumnName: "FirstName",
                  ColumnValue: borrower["FirstName"],
                  isValid: !borrower["FirstName"],
                  onBlur: () => {
                    if (
                      (borrower["NickName"] || "")?.toString().trim() === ""
                    ) {
                      handleUpdateAddtionalBorrower(
                        index,
                        "NickName",
                        capitalizeFirstLetter(borrower["FirstName"])
                      );
                    }
                  },
                },
                {
                  Title: "",
                  label: "Nickname",
                  ColumnName: "NickName",
                  ColumnValue: borrower["NickName"].toString().trim(),
                  onBlur: () => {},
                },
                {
                  Title: "",
                  label: "Middle Name",
                  ColumnName: "MiddleName",
                  ColumnValue: borrower["MiddleName"],
                  onBlur: () => {},
                },
                {
                  Title: "",
                  label: "Last Name",
                  ColumnName: "LastName",
                  isValid: !borrower["LastName"],
                  ColumnValue: borrower["LastName"],
                  onBlur: () => {},
                },
                {
                  Title: "",
                  label: "Social Security Number",
                  ColumnName: "SSN",
                  keyboardType: "numeric",
                  maxLength: 9,
                  ColumnValue: borrower["SSN"],
                  onBlur: () => {
                    handleUpdateAddtionalBorrower(
                      index,
                      "SSN",
                      formatSSN(borrower["SSN"], 2)
                    );
                  },
                },
                {
                  Title: "",
                  label: "Suffix",
                  placeholder: "Suffix",
                  ColumnName: "Suffix",
                  ColumnValue: borrower["Suffix"],
                  onBlur: () => {},
                  type: 3,
                  Option: [
                    { value: "", label: "-None-" },
                    { value: "I", label: "I" },
                    { value: "II", label: "II" },
                    { value: "III", label: "III" },
                    { value: "IV", label: "IV" },
                    { value: "Jr", label: "Jr" },
                    { value: "Sr", label: "Sr" },
                    { value: "V", label: "v" },
                  ],
                },
                {
                  Title: "",
                  label: "Birthdate",
                  ColumnName: "BirthDate",
                  placeholder: "MM/DD/YYYY",
                  charLength: 10,
                  ColumnValue: borrower["BirthDate"],
                  isValid: !borrower["BirthDate"],
                  forceValidation: !(
                    calculateAge(formatDateTimeNew(borrower["BirthDate"], 2)) >=
                    18
                  ),
                  onBlur: () => {
                    handleUpdateAddtionalBorrower(
                      index,
                      "BirthDate",
                      formatDateTimeNew(borrower["BirthDate"], 2)
                    );
                  },
                },
                {
                  Title: "",
                  label: "Cell",
                  ColumnName: "CellPhone",
                  maxLength: 10,
                  ColumnValue: handleGetCellPhone(borrower["CellPhone"]),
                  isValid: !handleGetCellPhone(borrower["CellPhone"]),
                  forceValidation:
                    handleGetCellPhone(borrower["CellPhone"])
                      .toString()
                      .replace(/[(),\- ]/g, "").length != 10,
                  keyboardType: "phone-pad",
                  onBlur: () => {
                    handleUpdateAddtionalBorrower(
                      index,
                      "CellPhone",
                      FormatPhoneLogin(
                        handleGetCellPhone(borrower["CellPhone"])
                      )
                    );
                  },
                },
                {
                  Title: "",
                  label: "Email",
                  ColumnName: "Email",
                  ColumnValue: borrower["Email"],
                  isValid: !borrower["Email"],
                  // keyboardType: "email-address",
                  onBlur: () => {},
                },
                {
                  Title: "",
                  label: "Number of Dependents",
                  ColumnName: "Dependents",
                  keyboardType: "numeric",
                  ColumnValue: borrower["Dependents"],

                  onBlur: () => {},
                  charLength: 2,
                },
                {
                  Title: "",
                  label: "Ages of Dependents",
                  ColumnName: "Ages_Dependents",
                  ColumnValue: borrower["Ages_Dependents"],
                  // type: "numeric",
                  onBlur: () => {
                    // let iBirthDate = formatDateTimeNew(
                    //   borrower["BirthDate"],
                    //   2
                    // );
                    // let age = calculateAge(iBirthDate);
                    // handleUpdateAddtionalBorrower(
                    //   index,
                    //   "Ages_Dependents",
                    //   age
                    // );
                  },
                },
                {
                  Title: "",
                  label: "Marital Status",
                  ColumnName: "MaritalStatus",
                  ColumnValue: borrower["MaritalStatus"],
                  isValid: borrower["MaritalStatus"] == 0,
                  onBlur: () => {},
                  isMap: true,

                  type: 3,
                  Option: maritalStatusOptions.filter(
                    ({ value }) => Number(value) !== Number(borrower["CustId"])
                  ),
                },
              ],
            };

            return obj;
          })
        );
        // if (additionalBorrowerInfo.length <= 1)
        arr.push({
          Title:
            "Is there a spouse or any additional borrowers you would like to add to this loan?",
          Options: [
            { value: 1, text: "Add Spouse" },
            { value: 2, text: "Add Additional Borrower" },
            { value: 0, text: "No" },
          ],
          ColumnName: "iSpouse_AddBorrower",
          ColumnValue: LoanData["iSpouse_AddBorrower"] || 0,
          type: 1,
        });
      } else if (currentPage_ === pageArray[pageId["borrowerVerification"]]) {
        arr.push({
          Title: "How would you like to provide your bank account information?",
          Options: [
            {
              value: 2,
              text: "Input Manually",
              additionalText:
                "(Manually enter the bank account information. \nAccount statements will be required)",
            },
            {
              value: 1,
              text: "Import Automatically",
              additionalText: `(Bank Accounts are imported via ${loanURLDetails["assetVendor"]}. \nThis speeds up the Loan Application process)`,
            },
          ],
          ColumnName: "LinkBankAccount",
          ColumnValue: LoanData["LinkBankAccount"],
          type: 1,
          viewPlaid: LoanData["viewPlaid"],
          bodyContent: "LinkBankAccount",
          isBankAccountLinked: LoanData["BankAccountLinked"] || 0,
          handleFrameNavigation: handleNextFrameNavigation,
          handleSaveLoanInformation: (value, isSave) => {
            setLoanData({
              ...LoanData,
              ...{ BankAccountLinked: value, LinkBankAccount: 1 },
            });
            isSave &&
              handleSaveLoanInformation(
                [
                  {
                    ColumnName: "BankAccountLinked",
                    ColumnValue: value,
                  },
                  {
                    ColumnName: "LinkBankAccount",
                    ColumnValue: 1,
                  },
                ],
                loanId
              );
          },
          handleResetPlaidDetails: handleResetPlaidDetails,
          details: {
            emailId:
              additionalBorrowerInfo.length > 0
                ? additionalBorrowerInfo[0]?.["Email"]
                : LoanData["EmailId"],
            userName: userName,
            loanId: loanId,
            loanOfficerId: loanOfficerId || 1,
            CustId: UserId,
          },
        });
      } else if (currentPage_ === pageArray[pageId["addressHistory"]]) {
        //Primary Borr Section
        arr.push({
          Title: (
            <CustomText
              bold={true}
              style={{
                fontSize: web ? 24 : 21,
                marginBottom: web ? 30 : 15,
                color: "#41464d",
              }}
            >
              Now tell us about your address history for{" \n"}
              <CustomText bold={true} style={{ backgroundColor: "cyan" }}>
                {LoanData["FirstName"] || LoanData["LastName"]
                  ? `${LoanData["FirstName"] || ""} ${
                      LoanData["LastName"] || ""
                    }`
                  : `borrower`}
              </CustomText>
              {LoanData["FirstName"] || LoanData["LastName"] ? `.` : `?`}
            </CustomText>
          ),
          type: 2,
          // isCheckMonthCount: true,
          footerContent: {
            Title: "Do you Own or Rent?",
            Options: [
              { value: 1, text: "Own" },
              { value: 2, text: "Rent" },
              { value: 3, text: "Living Rent Free" },
            ],
            ColumnName: "Own or Rent",
            ColumnValue: LoanData["Own"]
              ? 1
              : LoanData["Rent"]
              ? 2
              : LoanData["Living_Rent_Free"]
              ? 3
              : 0,
            type: 1,
            subFields: LoanData["Rent"]
              ? {
                  Title: "",
                  label: "Monthly Rent",
                  isCurrency: true,
                  ColumnName: "Monthly_Rent",
                  ColumnValue: LoanData["Monthly_Rent"],
                  isValid: cleanValue(LoanData["Monthly_Rent"] || 0) == 0,
                  type: 2,
                  onBlur: () => {
                    setLoanData({
                      ...LoanData,
                      Monthly_Rent: formatCurrency(LoanData["Monthly_Rent"], 2)
                        .toString()
                        .replaceAll("-", ""),
                    });
                  },
                }
              : {},
          },
          subFields: [
            {
              Title: "",
              label: "Current Street Address",
              ColumnName: "Current_Street_Address",
              ColumnValue: LoanData["Current_Street_Address"],
              isValid: !LoanData["Current_Street_Address"],
              onBlur: () => {},
            },
            {
              Title: "",
              keyboardType: "numeric",
              label: "Zip Code",
              maxLength: 5,
              placeholder: "Zip Code",
              ColumnName: "Addrshistry_ZipCode",
              ColumnValue:
                LoanData["Addrshistry_ZipCode"] != 0
                  ? LoanData["Addrshistry_ZipCode"]
                  : "",
              forceValidation:
                LoanData["Addrshistry_ZipCode"]?.toString().length != 5,
              onBlur: async () => {
                let zipCode = LoanData["Addrshistry_ZipCode"];
                if (zipCode) {
                  let { city, state } = await handleGetZipCodeDetails(zipCode);
                  setLoanData({
                    ...LoanData,
                    [`Addrshistry_City`]: city,
                    [`Addrshistry_State`]: state,
                  });
                }
              },
            },
            {
              Title: "",
              label: "City",
              ColumnName: "Addrshistry_City",
              ColumnValue: LoanData["Addrshistry_City"],
              isValid: !LoanData["Addrshistry_City"],
              onBlur: () => {},
            },
            {
              Title: "",
              label: "State",
              placeholder: "State",
              ColumnName: "Addrshistry_State",
              ColumnValue: LoanData["Addrshistry_State"],
              onBlur: () => {},
              type: 3,
              Option: stateOptions,
              isMap: true,
            },
            {
              Title: "",
              label: "Years",
              ColumnName: "Addrshistry_Years",
              ColumnValue: parseInt(LoanData["Addrshistry_Years"] || 0) || 0,
              isValid:
                !parseInt(LoanData["Addrshistry_Years"]) &&
                !parseInt(LoanData["Addrshistry_Months"]),
              keyboardType: "numeric",
              formatZero: true,
              onBlur: () => {},
            },
            {
              Title: "",
              label: "Months",
              ColumnName: "Addrshistry_Months",
              ColumnValue: parseInt(LoanData["Addrshistry_Months"] || 0) || 0,
              isValid:
                !parseInt(LoanData["Addrshistry_Months"]) &&
                parseInt(LoanData["Addrshistry_Years"] || 0) < 2,
              keyboardType: "numeric",
              formatZero: true,
              onBlur: () => {},
            },
          ],
        });

        //For Previous Address Info

        let totalMonthCount = handleGetMonthCount(
          parseInt(LoanData["Addrshistry_Months"] || 0) || 0,
          parseInt(LoanData["Addrshistry_Years"] || 0) || 0
        );
        if (totalMonthCount < 24) {
          for (let i = 0; i < 4; i++) {
            if (totalMonthCount < 24) {
              totalMonthCount += handleGetMonthCount(
                parseInt(LoanData[`Addrshistry_Months${i}`] || 0) || 0,
                parseInt(LoanData[`Addrshistry_Years${i}`] || 0) || 0
              );
              i = i === 0 ? "" : i;
              if (i !== "")
                arr.push({
                  Title: (
                    <CustomText
                      bold={true}
                      style={{
                        fontSize: web ? 24 : 21,
                        marginBottom: web ? 30 : 15,
                        color: "#41464d",
                      }}
                    >
                      Please continue to add a two year address history for
                      {" \n"}
                      <CustomText
                        bold={true}
                        style={{ backgroundColor: "cyan" }}
                      >
                        {LoanData["FirstName"] || LoanData["LastName"]
                          ? `${LoanData["FirstName"] || ""} ${
                              LoanData["LastName"] || ""
                            }`
                          : `borrower`}
                      </CustomText>
                      {LoanData["FirstName"] || LoanData["LastName"]
                        ? `.`
                        : `?`}
                    </CustomText>
                  ),
                  type: 2,
                  isCheckMonthCount: true,
                  index: i,
                  // [`isAddressHistory${i}`]: true,
                  footerContent: {
                    Title: "Do you Own or Rent?",
                    Options: [
                      { value: 1, text: "Own" },
                      { value: 2, text: "Rent" },
                      { value: 3, text: "Living Rent Free" },
                    ],
                    ColumnName: "Own or Rent",
                    ColumnValue:
                      Number(LoanData[`Own${i}`]) === 1
                        ? 1
                        : Number(LoanData[`Rent${i}`]) === 1
                        ? 2
                        : Number(LoanData[`Living_Rent_Free${i}`]) === 1
                        ? 3
                        : 0,
                    type: 1,
                    subFields:
                      Number(LoanData[`Rent${i}`]) === 1
                        ? {
                            Title: "",
                            label: "Monthly Rent",
                            isCurrency: true,
                            ColumnName: `Monthly_Rent${i}`,
                            ColumnValue: LoanData[`Monthly_Rent${i}`],
                            isValid:
                              cleanValue(LoanData[`Monthly_Rent${i}`] || 0) ==
                              0,
                            type: 2,
                            onBlur: () => {
                              setTimeout(() => {
                                setLoanData({
                                  ...LoanData,
                                  [`Monthly_Rent${i}`]: formatCurrency(
                                    LoanData[`Monthly_Rent${i}`],
                                    2
                                  )
                                    .toString()
                                    .replaceAll("-", ""),
                                });
                              }, 100);
                            },
                          }
                        : {},
                    footerButton: (
                      <>
                        <AddRemoveButton
                          onPress={() => {
                            let iLoanData = LoanData;
                            iLoanData[`Monthly_Rent${i}`] = "$0.00";
                            iLoanData[`PrevCurrent_Street_Address${i}`] = "";
                            iLoanData[`Addrshistry_ZipCode${i}`] = "";
                            iLoanData[`Addrshistry_City${i}`] = "";
                            iLoanData[`Addrshistry_State${i}`] = "";
                            iLoanData[`Addrshistry_Years${i}`] = "";
                            iLoanData[`Addrshistry_Months${i}`] = "";
                            iLoanData[`Own${i}`] = null;
                            iLoanData[`Rent${i}`] = null;
                            iLoanData[`Living_Rent_Free${i}`] = null;
                            setLoanData({ ...iLoanData });
                          }}
                          text={<>Remove Previous Address</>}
                        />
                      </>
                    ),
                  },
                  subFields: [
                    {
                      Title: "",
                      label: "Street Address",
                      placeholder: "Street",
                      ColumnName: `PrevCurrent_Street_Address${i}`,
                      ColumnValue: LoanData[`PrevCurrent_Street_Address${i}`],
                      isValid: !LoanData[`PrevCurrent_Street_Address${i}`],
                      onBlur: () => {},
                    },
                    {
                      Title: "",
                      keyboardType: "numeric",
                      label: "Zip Code",
                      placeholder: "Zip Code",
                      maxLength: 5,
                      ColumnName: `Addrshistry_ZipCode${i}`,
                      ColumnValue:
                        LoanData[`Addrshistry_ZipCode${i}`] != 0
                          ? LoanData[`Addrshistry_ZipCode${i}`]
                          : "",
                      forceValidation:
                        LoanData[`Addrshistry_ZipCode${i}`]?.toString()
                          .length != 5,
                      onBlur: async () => {
                        let zipCode = LoanData[`Addrshistry_ZipCode${i}`];
                        if (zipCode) {
                          let { city, state } = await handleGetZipCodeDetails(
                            zipCode
                          );
                          setLoanData({
                            ...LoanData,
                            [`Addrshistry_City${i}`]: city,
                            [`Addrshistry_State${i}`]: state,
                          });
                        }
                      },
                    },
                    {
                      Title: "",
                      label: "City",
                      ColumnName: `Addrshistry_City${i}`,
                      ColumnValue: LoanData[`Addrshistry_City${i}`],
                      isValid: !LoanData[`Addrshistry_City${i}`],
                      onBlur: () => {},
                    },
                    {
                      Title: "",
                      label: "State",
                      placeholder: "State",
                      ColumnName: `Addrshistry_State${i}`,
                      ColumnValue: LoanData[`Addrshistry_State${i}`],
                      onBlur: () => {},
                      type: 3,
                      Option: stateOptions,
                      isMap: true,
                    },
                    {
                      Title: "",
                      label: "Years",
                      ColumnName: `Addrshistry_Years${i}`,
                      ColumnValue: LoanData[`Addrshistry_Years${i}`] || 0,
                      isValid:
                        !parseInt(LoanData[`Addrshistry_Years${i}`]) &&
                        !parseInt(LoanData[`Addrshistry_Months${i}`]),
                      onBlur: () => {},
                      keyboardType: "numeric",
                      formatZero: true,
                    },
                    {
                      Title: "",
                      label: "Months",
                      ColumnName: `Addrshistry_Months${i}`,
                      ColumnValue:
                        parseInt(LoanData[`Addrshistry_Months${i}`]) || 0,
                      isValid:
                        !parseInt(LoanData[`Addrshistry_Months${i}`]) &&
                        parseInt(LoanData[`Addrshistry_Years${i}`] || 0) < 2,
                      onBlur: () => {
                        if (!parseInt(LoanData[`Addrshistry_Months${i}`]))
                          setLoanData((prevLoanData) => {
                            return {
                              ...prevLoanData,
                              [`Addrshistry_Months${i}`]: 0,
                            };
                          });
                      },
                      keyboardType: "numeric",
                      formatZero: true,
                    },
                  ],
                });
            }
          }
        }
        //============================================

        //Additional Borr Section

        let sBorr = [];
        additionalBorrowerInfo.slice(1).forEach((borrower, index) => {
          totalMonthCount = handleGetMonthCount(
            parseInt(
              handleGetBorrYearMonth(borrower["Bor Own Period"], "Months") || 0
            ) || 0,
            parseInt(
              handleGetBorrYearMonth(borrower["Bor Own Period"], "Years") || 0
            ) || 0
          );
          sBorr.push({
            isCheckAddMonthCount: true,
            isAddressHistory: true,
            // BorrGroup: `Borr_${index}`,
            type: 2,
            index: index,
            flag: 12,
            handleCopyPriAddress: handleCopyPriAddress,
            onTextChange: handleUpdateAddtionalBorrower,
            Title: (
              <CustomText
                bold={true}
                style={{
                  fontSize: web ? 24 : 21,
                  marginBottom: web ? 30 : 15,
                  color: "#41464d",
                }}
              >
                Now tell us about your address history for{" \n"}
                <CustomText bold={true} style={{ backgroundColor: "cyan" }}>
                  {borrower["FirstName"] || borrower["LastName"]
                    ? `${borrower["FirstName"] || ""} ${
                        borrower["LastName"] || ""
                      }`
                    : `borrower`}
                </CustomText>
                {borrower["FirstName"] || borrower["LastName"] ? `.` : `?`}
              </CustomText>
            ),

            headerContent: {
              Title: (
                <>
                  Is your{" "}
                  <CustomText bold={true} style={{ backgroundColor: "yellow" }}>
                    current
                  </CustomText>{" "}
                  address the same as the primary borrower's address?
                </>
              ),
              Options: [
                { value: 0, text: "No" },
                { value: 1, text: "Yes" },
              ],
              ColumnName: `btnSameAsProperty${index + 1}`,
              ColumnValue:
                LoanData[`btnSameAsProperty${index + 1}`] == 1 ? 1 : 0,
              type: 1,
              widthOption: "40%",
            },
            footerContent: {
              Title: "Do you Own or Rent?",
              Options: [
                { value: 1, text: "Own" },
                { value: 2, text: "Rent" },
                { value: 3, text: "Living Rent Free" },
              ],
              ColumnName: "Own or Rent",
              ColumnValue:
                borrower["Bor Own"] == "O"
                  ? 1
                  : borrower["Bor Own"] == "R"
                  ? 2
                  : borrower["Bor Own"] == "L"
                  ? 3
                  : 0,
              type: 1,
              subFields:
                borrower["Bor Own"] == "R"
                  ? {
                      Title: "",
                      label: "Monthly Rent",
                      isCurrency: true,
                      ColumnName: "Present Rent",
                      ColumnValue: borrower["Present Rent"],
                      isValid: cleanValue(borrower["Present Rent"] || 0) == 0,
                      type: 2,
                      onBlur: () => {
                        handleUpdateAddtionalBorrower(
                          index,
                          "Present Rent",
                          formatCurrency(borrower["Present Rent"], 2)
                            .toString()
                            .replaceAll("-", "")
                        );
                      },
                    }
                  : {},
            },
            subFields: [
              {
                Title: "",
                label: "Current Street Address",
                ColumnName: "Address1",
                ColumnValue: borrower["Address1"],
                isValid: !borrower["Address1"],
                onBlur: () => {},
              },
              {
                Title: "",
                keyboardType: "numeric",
                label: "Zip Code",
                placeholder: "Zip Code",
                ColumnName: "Zip",
                maxLength: 5,
                ColumnValue: borrower["Zip"] != 0 ? borrower["Zip"] : "",
                forceValidation: borrower["Zip"]?.toString().length != 5,
                onBlur: async () => {
                  let zipCode = borrower["Zip"];
                  if (zipCode) {
                    let { city, state } = await handleGetZipCodeDetails(
                      zipCode
                    );
                    let additionalBorrowerInfo_ = additionalBorrowerInfo;
                    additionalBorrowerInfo_[index + 1]["City"] = city;
                    additionalBorrowerInfo_[index + 1]["State"] = state;
                    setAdditionalBorrowerInfo([
                      ...[],
                      ...additionalBorrowerInfo_,
                    ]);
                  }
                },
              },
              {
                Title: "",
                label: "City",
                ColumnName: "City",
                ColumnValue: borrower["City"],
                isValid: !borrower["City"],
                onBlur: () => {},
              },
              {
                Title: "",
                label: "State",
                placeholder: "State",
                ColumnName: "State",
                ColumnValue: borrower["State"],
                onBlur: () => {},
                type: 3,
                Option: stateOptions,
                isMap: true,
              },
              {
                Title: "",
                label: "Years",
                ColumnName: "Bor Own Period",
                ColumnValue:
                  handleGetBorrYearMonth(borrower["Bor Own Period"], "Years") ||
                  0,
                isValid:
                  !parseInt(
                    handleGetBorrYearMonth(borrower["Bor Own Period"], "Years")
                  ) &&
                  !parseInt(
                    handleGetBorrYearMonth(borrower["Bor Own Period"], "Months")
                  ),
                onBlur: () => {},
                keyboardType: "numeric",
                formatZero: true,
              },
              {
                Title: "",
                label: "Months",
                ColumnName: "Bor Own Period",
                ColumnValue: handleGetBorrYearMonth(
                  borrower["Bor Own Period"],
                  "Months"
                ),
                isValid:
                  !parseInt(
                    handleGetBorrYearMonth(borrower["Bor Own Period"], "Months")
                  ) &&
                  (parseInt(
                    handleGetBorrYearMonth(borrower["Bor Own Period"], "Years")
                  ) || 0) < 2,
                onBlur: () => {},
                keyboardType: "numeric",
                formatZero: true,
              },
            ],
          });
          //For Previous Address Info
          if (totalMonthCount < 24) {
            for (let i = 1; i < 4; i++) {
              if (totalMonthCount < 24) {
                totalMonthCount += handleGetMonthCount(
                  parseInt(
                    handleGetBorrYearMonth(
                      borrower[`Bor For Add${i} Yrs`],
                      "Months"
                    ) || 0
                  ) || 0,
                  parseInt(
                    handleGetBorrYearMonth(
                      borrower[`Bor For Add${i} Yrs`],
                      "Years"
                    ) || 0
                  ) || 0
                );

                sBorr.push({
                  Title: (
                    <CustomText
                      bold={true}
                      style={{
                        fontSize: web ? 24 : 21,
                        marginBottom: web ? 30 : 15,
                        color: "#41464d",
                      }}
                    >
                      Please continue to add a two year address history for
                      {" \n"}
                      <CustomText
                        bold={true}
                        style={{ backgroundColor: "cyan" }}
                      >
                        {borrower["FirstName"] || borrower["LastName"]
                          ? `${borrower["FirstName"] || ""} ${
                              borrower["LastName"] || ""
                            }`
                          : `borrower`}
                      </CustomText>
                      {borrower["FirstName"] || borrower["LastName"]
                        ? `.`
                        : `?`}
                    </CustomText>
                  ),
                  type: 2,
                  // isCheckAddMonthCount: true,
                  isAddressHistory: true,
                  isAddtionalPrevAddressHistory: true,
                  flag: i + 16, // DB update statement basedon this flag
                  onTextChange: handleUpdateAddtionalBorrower,
                  prevAddIndex: i,
                  // BorrGroup: `Borr_${index}`,
                  index: index,
                  footerContent: {
                    Title: "Do you Own or Rent?",
                    Options: [
                      { value: 1, text: "Own" },
                      { value: 2, text: "Rent" },
                      { value: 3, text: "Living Rent Free" },
                    ],
                    ColumnName: "Own or Rent",
                    ColumnValue:
                      borrower[`Bor For Add${i} Own`] == "O"
                        ? 1
                        : borrower[`Bor For Add${i} Own`] == "R"
                        ? 2
                        : borrower[`Bor For Add${i} Own`] == "L"
                        ? 3
                        : 0,
                    type: 1,
                    subFields:
                      borrower[`Bor For Add${i} Own`] == "R"
                        ? {
                            Title: "",
                            label: "Monthly Rent",
                            isCurrency: true,
                            ColumnName: `Present Rent${i}`,
                            ColumnValue: borrower[`Present Rent${i}`],
                            isValid:
                              cleanValue(borrower[`Present Rent${i}`] || 0) ==
                              0,
                            type: 2,
                            onBlur: () => {
                              handleUpdateAddtionalBorrower(
                                index,
                                [`Present Rent${i}`],
                                formatCurrency(borrower[`Present Rent${i}`], 2)
                                  .toString()
                                  .replaceAll("-", "")
                              );
                            },
                          }
                        : {},
                    footerButton: (
                      <>
                        <TouchableOpacity
                          activeOpacity={1}
                          onPress={() => {
                            let iAdditionalBorrowerInfo =
                                additionalBorrowerInfo,
                              borrower = iAdditionalBorrowerInfo[index + 1];
                            borrower[`Bor For Add${i} Own`] = null;
                            borrower[`Bor For Add${i}`] = "";
                            borrower[`BorForZip${i + 1}`] = "";
                            borrower[`BorForCity${i + 1}`] = "";
                            borrower[`BorForState${i + 1}`] = "";
                            borrower[`Bor For Add${i} Yrs`] = "0.0";
                            borrower[`Present Rent${i}`] = "$0.00";
                            iAdditionalBorrowerInfo[index + 1] = borrower;
                            setAdditionalBorrowerInfo([
                              ...iAdditionalBorrowerInfo,
                            ]);
                          }}
                          style={[
                            styles.buttonContainer,
                            { backgroundColor: "#d43f3a" },
                          ]}
                        >
                          <CustomText
                            style={[
                              {
                                color: "#fff",
                                marginTop: web ? 7 : 3,
                                fontSize: 20,
                                alignSelf: "center",
                              },
                              web ? { width: "max-content" } : {},
                            ]}
                          >
                            {"  "}Remove Previous Address{"  "}
                          </CustomText>
                        </TouchableOpacity>
                      </>
                    ),
                  },
                  subFields: [
                    {
                      Title: "",
                      label: "Current Street Address",
                      ColumnName: `Bor For Add${i}`,
                      ColumnValue: borrower[`Bor For Add${i}`],
                      isValid: !borrower[`Bor For Add${i}`],
                      onBlur: () => {},
                    },
                    {
                      Title: "",
                      keyboardType: "numeric",
                      maxLength: 5,
                      label: "Zip Code",
                      placeholder: "Zip Code",
                      ColumnName: `BorForZip${i + 1}`,
                      ColumnValue:
                        borrower[`BorForZip${i + 1}`] != 0
                          ? borrower[`BorForZip${i + 1}`]
                          : "",
                      forceValidation:
                        borrower[`BorForZip${i + 1}`]?.toString().length != 5,
                      onBlur: async () => {
                        let zipCode = borrower[`BorForZip${i + 1}`];
                        if (zipCode) {
                          let { city, state } = await handleGetZipCodeDetails(
                            zipCode
                          );
                          let additionalBorrowerInfo_ = additionalBorrowerInfo;
                          additionalBorrowerInfo_[index + 1][
                            `BorForCity${i + 1}`
                          ] = city;
                          additionalBorrowerInfo_[index + 1][
                            `BorForState${i + 1}`
                          ] = state;
                          setAdditionalBorrowerInfo([
                            ...[],
                            ...additionalBorrowerInfo_,
                          ]);
                        }
                      },
                    },
                    {
                      Title: "",
                      label: "City",
                      ColumnName: `BorForCity${i + 1}`,
                      ColumnValue: borrower[`BorForCity${i + 1}`],
                      isValid: !borrower[`BorForCity${i + 1}`],
                      onBlur: () => {},
                    },
                    {
                      Title: "",
                      label: "State",
                      placeholder: "State",
                      ColumnName: `BorForState${i + 1}`,
                      ColumnValue: borrower[`BorForState${i + 1}`],
                      onBlur: () => {},
                      type: 3,
                      Option: stateOptions,
                      isMap: true,
                    },
                    {
                      Title: "",
                      label: "Years",
                      ColumnName: `Bor For Add${i} Yrs`,
                      ColumnValue:
                        handleGetBorrYearMonth(
                          borrower[`Bor For Add${i} Yrs`],
                          "Years"
                        ) || 0,
                      isValid:
                        !parseInt(
                          handleGetBorrYearMonth(
                            borrower[`Bor For Add${i} Yrs`],
                            "Years"
                          )
                        ) &&
                        !parseInt(
                          handleGetBorrYearMonth(
                            borrower[`Bor For Add${i} Yrs`],
                            "Months"
                          )
                        ),
                      keyboardType: "numeric",
                      formatZero: true,
                      onBlur: () => {},
                    },
                    {
                      Title: "",
                      label: "Months",
                      ColumnName: `Bor For Add${i} Yrs`,
                      ColumnValue:
                        handleGetBorrYearMonth(
                          borrower[`Bor For Add${i} Yrs`],
                          "Months"
                        ) || 0,
                      isValid:
                        !parseInt(
                          handleGetBorrYearMonth(
                            borrower[`Bor For Add${i} Yrs`],
                            "Months"
                          )
                        ) &&
                        (parseInt(
                          handleGetBorrYearMonth(
                            borrower[`Bor For Add${i} Yrs`],
                            "Years"
                          )
                        ) || 0) < 2,
                      keyboardType: "numeric",
                      formatZero: true,
                      onBlur: () => {},
                    },
                  ],
                });
              }
            }
          }
        });
        arr.push(...sBorr);

        //============================================
      } else if (currentPage_ === pageArray[pageId["creditScore"]]) {
        let { Status, Details, ErrMsg } = creditScoreDetails;

        if (Status === 5 || Details[0]?.iFinalScanDocID) {
          arr.push({
            type: -1,
            bodyContent: (
              <>
                <CustomText
                  bold={true}
                  style={{ color: "#41464d", fontSize: 22 }}
                >
                  Credit Scores.
                </CustomText>
                <CustomText style={{ color: "#41464d", fontSize: 16 }}>
                  Here are your credit scores.
                </CustomText>
                <Separator />
                <CustomText
                  bold={true}
                  style={{ color: "#41464d", fontSize: 22, marginBottom: 10 }}
                >
                  Your Qualifying Score: {Details[0]["FICOMid"]}
                </CustomText>
                <Separator />
                <>
                  {Details.map((item, index) => {
                    return (
                      <View key={index}>
                        {/* <View style={{ flexDirection: "row" }}> */}
                        <View style={{ flexDirection: web ? "row" : "column" }}>
                          <CustomText
                            bold={true}
                            style={{
                              color: "#41464d",
                              fontSize: web ? 22 : 20,
                              marginBottom: 5,
                            }}
                          >
                            {/* {item[`BorName${index === 0 ? "" : "1"}`] || ""} */}
                            {item[`FullName`] || ""}
                          </CustomText>
                          <TouchableOpacity
                            activeOpacity={1}
                            style={{
                              borderRadius: 20,
                              paddingVertical: web ? 6 : 2,
                              alignSelf: web ? "center" : "flex-start",
                              paddingHorizontal: web ? 12 : 5,
                              borderColor: "#043888",
                              borderWidth: 2,
                              marginBottom: web ? 25 : 5,
                              marginLeft: 5,
                            }}
                            onPress={async () => {
                              let ScanDocId = item["iFinalScanDocID"],
                                url = await handleOpenScanDocFile(
                                  SessionId,
                                  ScanDocId,
                                  loanId
                                );
                              if (ScanDocId != undefined) {
                                // url = `../../../BorrowerApplication/Presentation/Webforms/ScanDocumentsManager.aspx?SessionId=${SessionId}&Id=${ScanDocId}`;
                                if (web) {
                                  if (
                                    window.location.host.indexOf(
                                      "localhost"
                                    ) !== -1
                                  )
                                    url = url.replace("../../..", REDIRECT_URL);
                                }
                              }
                              if (web) {
                                window.open(
                                  url,
                                  "_blank",
                                  "toolbar=1, scrollbars=1, resizable=1, width=" +
                                    1015 +
                                    ", height=" +
                                    800
                                );
                              } else {
                                navigation.navigate("Pdf", {
                                  url,
                                  backTo: "Home",
                                  GoToNav: 5,
                                  isNeedBack: true,
                                  onBack: () => {},
                                });
                              }
                            }}
                          >
                            <CustomText
                              style={{
                                fontSize: web ? 11 : 12,
                                color: "#043888",
                              }}
                            >
                              View Credit Report
                            </CustomText>
                          </TouchableOpacity>
                        </View>
                        <CustomText
                          style={{
                            color: "#41464d",
                            fontSize: 16,
                            marginBottom: 5,
                          }}
                        >
                          Experian: {item["FICOExp"] || 0}
                        </CustomText>
                        <CustomText
                          style={{
                            color: "#41464d",
                            fontSize: 16,
                            marginBottom: 5,
                          }}
                        >
                          Equifax: {item["FICOEqu"] || 0}
                        </CustomText>
                        <CustomText
                          style={{
                            color: "#41464d",
                            fontSize: 16,
                            marginBottom: 5,
                          }}
                        >
                          Transunion: {item["FICOTran"] || 0}
                        </CustomText>
                        <Separator />
                      </View>
                    );
                  })}
                </>
              </>
            ),
          });
        }

        arr.push({
          Title:
            "The next step is your Credit Report. Would you like to order that now, or skip to the next step?",
          Options: [
            { value: 1, text: "Get Credit Report" },
            { value: 0, text: "Skip and Complete Later" },
          ],
          ColumnName: "CreditReport",
          ColumnValue: LoanData["CreditReport"],
          type: 1,
        });
        arr.push({
          Title:
            "Good, let's get your credit report. Have you frozen your credit report?",
          Options: [
            { value: 0, text: "No", type: "primary" },
            { value: 1, text: "Yes", type: "secondary" },
          ],
          ColumnName: "FrozenCredit",
          ColumnValue: LoanData["FrozenCredit"],
          type: 1,
          widthOption: "40%",
        });
        arr.push({
          type: -1,
          isSSNDetails: true,
          bodyContent: (
            <>
              <Title
                text={
                  "Please provide the social security numbers requested below."
                }
              />
              <>
                <Title
                  text={
                    LoanData["FirstName"] || LoanData["LastName"]
                      ? `${LoanData["FirstName"] || ""} ${
                          LoanData["LastName"] || ""
                        }`
                      : `borrower`
                  }
                />
                <InputBox
                  label="Social Security Number"
                  placeholder="SSN"
                  keyboardType="numeric"
                  maxLength={9}
                  forceValidation={
                    LoanData["SSN"]?.toString().replace(/-/g, "").length != 9
                  }
                  onBlur={() => {
                    handleOptionPress(
                      formatSSN(LoanData["SSN"]),
                      true,
                      null,
                      "SSN"
                    );
                  }}
                  onChangeText={(text) => {
                    try {
                      handleOptionPress(text, true, null, "SSN");
                    } catch (e) {}
                  }}
                  value={LoanData["SSN"] || ""}
                />
              </>
              <>
                {additionalBorrowerInfo.slice(1).map((borrower, index) => {
                  return (
                    <View key={index}>
                      <Title
                        text={
                          borrower["FirstName"] || borrower["LastName"]
                            ? `${borrower["FirstName"] || ""} ${
                                borrower["LastName"] || ""
                              }`
                            : `borrower`
                        }
                      />
                      <InputBox
                        label="Social Security Number" //
                        placeholder="SSN"
                        maxLength={9}
                        keyboardType="numeric"
                        forceValidation={
                          borrower["SSN"]?.toString().replace(/-/g, "")
                            .length != 9
                        }
                        onBlur={() => {
                          handleUpdateAddtionalBorrower(
                            index,
                            "SSN",
                            formatSSN(borrower["SSN"])
                          );
                        }}
                        onChangeText={(text) => {
                          try {
                            handleUpdateAddtionalBorrower(index, "SSN", text);
                          } catch (e) {}
                        }}
                        value={borrower["SSN"]}
                      />
                    </View>
                  );
                })}
              </>
            </>
          ),
        });

        if (Number(LoanData["FrozenCredit"]) === 1) {
          arr.push({
            type: -1,
            pageName: "unFreeze",
            bodyContent: (
              <>
                <CustomText>
                  <CustomText style={{ fontSize: 17 }} bold={true}>
                    No Problem...{" "}
                  </CustomText>
                  <CustomText
                    style={{
                      lineHeight: 25,
                      fontSize: 16,
                    }}
                  >
                    Before we can order your credit report you will need to
                    unfreeze your account. Once completed, you can return to
                    this credit report page and answer that your credit report
                    is not frozen. Here are some helpful links with instructions
                    to unfreeze your credit report.
                  </CustomText>
                </CustomText>
                <Separator />
                <View>
                  <CustomText
                    style={{ lineHeight: 26, fontSize: 17 }}
                    bold={true}
                  >
                    Experian
                  </CustomText>
                  <CustomText style={{ lineHeight: 26, fontSize: 16 }}>
                    888-397-3742
                  </CustomText>
                  <CustomText
                    style={{
                      lineHeight: 25,
                      fontSize: 16,
                      color: "#2971bf",
                    }}
                    onPress={() =>
                      Linking.openURL(
                        "https://www.experian.com/freeze/center.html"
                      )
                    }
                  >
                    https://www.experian.com/freeze/center.html
                  </CustomText>
                </View>
                <Separator />

                <View>
                  <CustomText
                    style={{ lineHeight: 26, fontSize: 17 }}
                    bold={true}
                  >
                    Equifax
                  </CustomText>
                  <CustomText style={{ lineHeight: 26, fontSize: 16 }}>
                    888-298-0045
                  </CustomText>
                  <CustomText
                    style={{
                      lineHeight: 25,
                      fontSize: 16,
                      color: "#2971bf",
                    }}
                    onPress={() =>
                      Linking.openURL(
                        "https://www.equifax.com/personal/credit-report-services/credit-freeze/"
                      )
                    }
                  >
                    https://www.equifax.com/personal/credit-report-services/credit-freeze/
                  </CustomText>
                </View>
                <Separator />
                <View>
                  <CustomText
                    style={{ lineHeight: 26, fontSize: 17 }}
                    bold={true}
                  >
                    Transunion
                  </CustomText>
                  <CustomText style={{ lineHeight: 26, fontSize: 16 }}>
                    800-916-8800
                  </CustomText>
                  <CustomText
                    style={{
                      lineHeight: 25,
                      fontSize: 16,
                      color: "#2971bf",
                    }}
                    onPress={() =>
                      Linking.openURL(
                        "https://www.transunion.com/credit-freeze"
                      )
                    }
                  >
                    https://www.transunion.com/credit-freeze
                  </CustomText>
                </View>
                <Separator />
              </>
            ),
          });
        }

        if (Number(LoanData["FrozenCredit"] || 0) === 0) {
          arr.push({
            Title: "We need your credit authorization",
            Options: [
              { value: 0, text: "No", type: "secondary" },
              { value: 1, text: "Yes", type: "primary" },
            ],
            bodyText: (
              <>
                <CustomText
                  style={{
                    fontSize: web ? "17px" : 16,
                    lineHeight: 25,
                  }}
                >
                  Your credit information will help us understand more about
                  your personal and financial background and ensure we give you
                  the most accurate mortage options. To help us, we need the
                  following authorization.
                </CustomText>
                <Separator />
                <CustomText
                  style={{
                    fontSize: web ? "17px" : 16,
                    lineHeight: 25,
                  }}
                >
                  I authorize Lender/Broker to order a consumer credit report
                  and verify other credit information identified on such
                  reports, including past and present mortgage and landlord
                  references.
                </CustomText>
                <Separator />
                <Separator />
              </>
            ),
            ColumnName: "CreditRpt_Auth",
            ColumnValue: LoanData["CreditRpt_Auth"],
            type: 1,
            widthOption: "40%",
          });
        }

        (LoanData["creditReportOrdered"] ||
          Status === 5 ||
          Details[0]?.iFinalScanDocID) &&
          arr.push({
            Title: "Credit Report Ordered",
            bodyText: (
              <>
                <CustomText
                  style={{
                    fontSize: web ? "17px" : 16,
                    lineHeight: 25,
                  }}
                >
                  Thank you. Your credit report has been ordered. This typically
                  takes up to 2 minutes to complete.
                </CustomText>
                <Separator />
                <CustomText
                  style={{
                    fontSize: web ? "17px" : 16,
                    lineHeight: 25,
                  }}
                >
                  You can wait on this screen for the result, or you can proceed
                  to the next step. To come back later, simply click the pancake
                  menu in the upper left, and click on the "Credit Scores" area
                  in the left side navigation options.
                  {"\n\n"}
                </CustomText>
                {ErrMsg && (
                  <>
                    <CustomText
                      style={{
                        fontSize: web ? "17px" : 16,
                        lineHeight: 25,
                        color: "red",
                      }}
                    >
                      The following errors occurred. Please fix and request a
                      new order.{"\n\n"}- {ErrMsg}
                    </CustomText>

                    <CustomText
                      style={{
                        ...{
                          fontSize: !isMobileWeb && web ? 19 : 16,
                          color: "#1172c1",
                          marginTop: 20,
                        },
                        ...(web ? { cursor: "pointer" } : {}),
                      }}
                      onPress={() => {
                        setProcessStatus("creditReportReOrderded");
                        handleOrderCreditReport();
                      }}
                    >
                      Try Again
                      {processStatus === "creditReportReOrderded" && (
                        <ArrowSpinner
                          isSpinner={true}
                          size={20}
                          color="#295b9a"
                          style={{ marginLeft: 10 }}
                          duration={1200}
                        />
                      )}
                      {processStatus === "orderPlaced" && (
                        <CustomText
                          style={{
                            fontSize: !isMobileWeb && web ? 18 : 15,
                            marginLeft: 10,
                          }}
                        >
                          <Icon size={20} name={"check"} color={"green"} />{" "}
                          Order Placed.
                        </CustomText>
                      )}
                    </CustomText>
                  </>
                )}
                <Separator />
                <Separator />
              </>
            ),
            type: 1,
            widthOption: "40%",
          });
      } else if (currentPage_ === pageArray[pageId["employment"]]) {
        arr.push({
          Title:
            "Tell us about your employment history. What best describes your current employment?",
          Options: [
            { value: 1, text: "I’m currently employed" }, //currently_employed
            { value: 2, text: "I’m Retired" }, //Retired
            { value: 3, text: "I’m not currently employed." }, //Not_CurrentlyEmployed
          ],
          ColumnName: "CurrentlyEmployed",
          ColumnValue: LoanData["currently_employed"]
            ? 1
            : LoanData["Retired"]
            ? 2
            : LoanData["Not_CurrentlyEmployed"]
            ? 3
            : 0,
          type: 1,
          footerContent: <></>,
        });
        if (LoanData["currently_employed"] === 1) {
          let loopCustId = additionalEmploymentInfo.length
            ? additionalEmploymentInfo[0]?.["CustId"]
            : 0;

          arr.push(
            ...handleEmploymentOrder(additionalEmploymentInfo)
              .map((employment, index) => {
                let empOption = {
                  Title:
                    index === 0
                      ? "Tell us about your Employment."
                      : `Employment ${index + 1}?`,
                  type: 2,
                  index: index,
                  isAdditionalEmployment: true, //!(index === 0),
                  isRemove: employment["isRemove"] || false,

                  onChangeText: (name, value) =>
                    handleUpdateAddtionalEmployment(index, name, value),
                  subFields: [
                    {
                      ColumnName: "Id",
                      ColumnValue: employment["Id"],
                    },
                    {
                      ColumnName: "iCustId",
                      ColumnValue: employment["CustId"],
                    },
                    {
                      Title: "For Which Borrower",
                      label: "",
                      ColumnName: "CustId",
                      ColumnValue: employment["CustId"],
                      onBlur: () => {},
                      // isMap: !true,
                      type: 6,
                      Option: handleGetBorrowerOption(),
                    },
                    // {
                    //   Title: "",
                    //   label: "For Which Borrower",
                    //   ColumnName: "CustId",
                    //   ColumnValue: employment["CustId"],
                    //   onBlur: () => {},
                    //   isMap: true,
                    //   type: 3,
                    //   Option: handleGetBorrowerOption(),
                    // },
                    {
                      Title: "",
                      type: 2,
                      label: "Employer Name",
                      ColumnName: "Empmt_Emp_Name",
                      ColumnValue: employment["Empmt_Emp_Name"],
                      isValid: !employment["Empmt_Emp_Name"],
                      onBlur: () => {},
                    },
                    {
                      Title: "",
                      type: 2,
                      label: "Employer Street Address",
                      ColumnName: "Emp_Strt_Addrs",
                      ColumnValue: employment["Emp_Strt_Addrs"],
                      isValid: !employment["Emp_Strt_Addrs"],
                      onBlur: () => {},
                    },
                    {
                      Title: "",
                      type: 2,
                      keyboardType: "numeric",
                      maxLength: 5,
                      // type: "numeric",
                      label: "Employer Zip Code",
                      placeholder: "Zip Code",
                      ColumnName: "Emp_ZipCode",
                      forceValidation:
                        employment["Emp_ZipCode"]?.toString().length != 5,
                      ColumnValue:
                        employment["Emp_ZipCode"] != 0
                          ? employment["Emp_ZipCode"]
                          : "",
                      onBlur: async () => {
                        let zipCode = employment["Emp_ZipCode"];
                        if (zipCode) {
                          let { city, state } = await handleGetZipCodeDetails(
                            zipCode
                          );

                          let additionalEmploymentInfo_ =
                            additionalEmploymentInfo;
                          additionalEmploymentInfo_[index][`Emp_City`] = city;
                          additionalEmploymentInfo_[index][`Emp_State`] = state;
                          setAdditionalEmploymentInfo(
                            handleEmploymentOrder([...additionalEmploymentInfo])
                          );
                        }
                      },
                    },
                    {
                      Title: "",
                      type: 2,
                      label: "Employer City",
                      isValid: !employment["Emp_City"],
                      ColumnName: "Emp_City",
                      ColumnValue: employment["Emp_City"],
                      onBlur: () => {},
                    },
                    {
                      Title: "",
                      label: "State",
                      placeholder: "State",
                      isValid: !employment["Emp_State"],
                      ColumnName: "Emp_State",
                      ColumnValue: employment["Emp_State"],
                      onBlur: () => {},
                      type: 3,
                      Option: stateOptions,
                      isMap: true,
                    },
                    {
                      Title: "",
                      type: 2,
                      label: "Employer Phone",
                      isValid: !employment["Emp_phone"],
                      forceValidation:
                        employment["Emp_phone"]
                          .toString()
                          .replace(/[(),\- ]/g, "").length != 10,
                      ColumnName: "Emp_phone",
                      keyboardType: "phone-pad",
                      maxLength: 10,
                      ColumnValue: employment["Emp_phone"],
                      onBlur: () => {
                        handleUpdateAddtionalEmployment(
                          index,
                          "Emp_phone",
                          FormatPhoneLogin(employment["Emp_phone"])
                        );
                      },
                    },
                    {
                      Title: "What is your job title?",
                      type: 2,
                      label: "Job Title",
                      isValid: !employment["Job_Title"],
                      ColumnName: "Job_Title",
                      ColumnValue: employment["Job_Title"],
                      onBlur: () => {},
                    },
                    {
                      type: 1,
                      widthOption: "40%",
                      Title: "Are you Employed By Family?",
                      Options: [
                        { value: 0, text: "No" },
                        { value: 1, text: "Yes" },
                      ],
                      ColumnName: "Employedbyfamily",
                      ColumnValue: employment["Employedbyfamily"] || 0,
                    },
                    {
                      type: 1,
                      widthOption: "40%",
                      Title: "Are you Self Employed?",
                      Options: [
                        { value: "N", text: "No" },
                        { value: "Y", text: "Yes" },
                      ],
                      ColumnName: "Self Employed",
                      ColumnValue: employment["Self Employed"],
                    },
                    {
                      Title: "What date did you begin employment there?",
                      type: 2,
                      label: "Employed From",
                      placeholder: "MM/DD/YYYY",
                      charLength: 10,
                      isValid: !employment["Employed_From"],
                      ColumnName: "Employed_From",
                      ColumnValue: employment["Employed_From"],
                      onBlur: () => {
                        handleUpdateAddtionalEmployment(
                          index,
                          "Employed_From",
                          formatDateTimeNew(employment["Employed_From"], 2)
                        );
                      },
                    },
                    {
                      Title: "",
                      type: 2,
                      label: "Employed To",
                      placeholder: "MM/DD/YYYY",
                      charLength: 10,
                      isValid: !employment["Employed_To"],
                      ColumnName: "Employed_To",
                      ColumnValue: employment["Employed_To"],
                      onBlur: () => {
                        handleUpdateAddtionalEmployment(
                          index,
                          "Employed_To",
                          formatDateTimeNew(employment["Employed_To"], 2)
                        );
                      },
                    },
                    {
                      Title: "",
                      type: 2,
                      label: "Years In Line of Work",
                      forceValidation:
                        Number(employment["CurrentYrsInLineofwork"]) == 0,
                      ColumnName: "CurrentYrsInLineofwork",
                      ColumnValue: employment["CurrentYrsInLineofwork"],
                      keyboardType: "numeric",
                      onBlur: () => {},
                    },
                    {
                      Title:
                        "Who is the person or department and phone number to contact to verify your employment?",
                      type: 2,
                      label: "HR Contact Person",
                      ColumnName: "HR_Contact_Person",
                      ColumnValue: employment["HR_Contact_Person"],
                      onBlur: () => {},
                    },
                    {
                      Title: "",
                      type: 2,
                      label: "HR Phone",
                      ColumnName: "HR_Phone",
                      keyboardType: "phone-pad",
                      maxLength: 10,
                      ColumnValue: employment["HR_Phone"],
                      onBlur: () => {
                        handleUpdateAddtionalEmployment(
                          index,
                          "HR_Phone",
                          FormatPhoneLogin(employment["HR_Phone"])
                        );
                      },
                    },
                    {
                      Title: "What is your monthly income?",
                      type: 2,
                      label: "Monthly Base Pay",
                      isCurrency: true,
                      ColumnName: "Monthly_Base_Pay",
                      ColumnValue: employment["Monthly_Base_Pay"],
                      onBlur: () => {
                        handleUpdateAddtionalEmployment(
                          index,
                          "Monthly_Base_Pay",
                          formatCurrency(employment["Monthly_Base_Pay"], 2)
                        );
                      },
                    },

                    {
                      Title: "",
                      type: 2,
                      label: "Monthly Overtime Amount",
                      isCurrency: true,
                      ColumnName: "Monthly_Overtime_Amt",
                      ColumnValue: employment["Monthly_Overtime_Amt"],
                      onBlur: () => {
                        handleUpdateAddtionalEmployment(
                          index,
                          "Monthly_Overtime_Amt",
                          formatCurrency(employment["Monthly_Overtime_Amt"], 2)
                        );
                      },
                    },
                    {
                      Title: "",
                      type: 2,
                      label: "Monthly Bonus Amount",
                      isCurrency: true,
                      ColumnName: "Monthly_Bonus_Amt",
                      ColumnValue: employment["Monthly_Bonus_Amt"],
                      onBlur: () => {
                        handleUpdateAddtionalEmployment(
                          index,
                          "Monthly_Bonus_Amt",
                          formatCurrency(employment["Monthly_Bonus_Amt"], 2)
                        );
                      },
                    },
                    {
                      Title: "",
                      type: 2,
                      label: "Monthly Commissions Amount",
                      isCurrency: true,
                      ColumnName: "Monthly_Commission_Amt",
                      ColumnValue: employment["Monthly_Commission_Amt"],
                      onBlur: () => {
                        handleUpdateAddtionalEmployment(
                          index,
                          "Monthly_Commission_Amt",
                          formatCurrency(
                            employment["Monthly_Commission_Amt"],
                            2
                          )
                        );
                      },
                    },
                    {
                      Title: "",
                      type: 2,
                      label: "Monthly Total Pay",
                      isCurrency: true,
                      ColumnName: "Monthly_Total_Pay",
                      ColumnValue:
                        formatCurrency(
                          Number(cleanValue(employment["Monthly_Base_Pay"])) +
                            Number(
                              cleanValue(employment["Monthly_Overtime_Amt"])
                            ) +
                            Number(
                              cleanValue(employment["Monthly_Bonus_Amt"])
                            ) +
                            Number(
                              cleanValue(employment["Monthly_Commission_Amt"])
                            ),
                          2
                        ) || formatCurrency(employment["Monthly_Total_Pay"], 2),
                      onBlur: () => {},
                      disabled: true,
                    },
                  ],
                  removeContent: (
                    <View>
                      <Title
                        style={{ fontSize: web ? 22 : 18 }}
                        text={`Are you sure you want to remove ${employment["Empmt_Emp_Name"]}?`}
                      />
                      <View
                        style={{
                          flex: 1,
                          flexDirection: "row-reverse",
                          marginTop: -10,
                          alignSelf: "flex-start",
                        }}
                      >
                        <IconButton
                          onPress={() => {
                            let addEmp = additionalEmploymentInfo.filter(
                              (e, index_) => index !== index_
                            );

                            handleUpdateAddtionalEmployment(
                              index,
                              "isRemove",
                              false
                            );
                            setAdditionalEmploymentInfo([...addEmp]);

                            setPageIndex({
                              ...pageIndex,
                              subPage: Number(pageIndex["subPage"]) - 1,
                            });
                            handleSaveAdditionalInfo(-1, 6, employment["Id"]);
                            setScrollToTop(true);
                          }}
                          style={{
                            paddingVertical: 7,
                            paddingHorizontal: 10,
                          }}
                          title={
                            <CustomText
                              bold={true}
                              style={{ fontSize: 16, color: "#fff" }}
                            >
                              Remove
                            </CustomText>
                          }
                        />
                        <IconButton
                          buttonType="secondary"
                          style={{
                            marginRight: 10,
                            paddingVertical: 7,
                            paddingHorizontal: 10,
                          }}
                          onPress={() => {
                            handleUpdateAddtionalEmployment(
                              index,
                              "isRemove",
                              false
                            );
                          }}
                          title={
                            <CustomText
                              bold={true}
                              style={{ fontSize: 16, color: "#508BC9" }}
                            >
                              Cancel
                            </CustomText>
                          }
                        />
                      </View>
                    </View>
                  ),
                  footerButton: (
                    <>
                      {/* {index === additionalEmploymentInfo.length - 1 && (
                        <>
                          <AddRemoveButton
                            isAdd={true}
                            onPress={async () => {
                              let json = [],
                                DetailsArr_ = DetailsArr.slice(1);
                              DetailsArr_[pageIndex["subPage"]][
                                "subFields"
                              ]?.forEach((item) => {
                                if (item["field"] !== undefined) {
                                  item["field"].forEach((item_) => {
                                    json.push({
                                      ColumnName: item_["ColumnName"],
                                      ColumnValue:
                                        item_["ColumnName"] === "CellPhone"
                                          ? `*5*${item_["ColumnValue"]}`
                                          : item_["ColumnValue"],
                                    });
                                  });
                                }
                                if (
                                  item["ColumnName"] !== undefined &&
                                  item["ColumnValue"] !== undefined
                                ) {
                                  json.push({
                                    ColumnName: item["ColumnName"],
                                    ColumnValue:
                                      item["ColumnName"] === "CellPhone"
                                        ? `*5*${item["ColumnValue"]}`
                                        : item["ColumnValue"],
                                  });
                                }
                              });
                              let json_ = [{}];
                              json.forEach((item) => {
                                if (item.ColumnName === "Self Employed")
                                  json_[0]["SelfEmployed"] = item.ColumnValue;
                                else
                                  json_[0][item.ColumnName] = item.ColumnValue;
                              });
                              await handleSaveAdditionalInfo(-2, -1, -4, true);

                              handleSaveAdditionalInfo(
                                -1,
                                1,
                                additionalEmploymentInfo[
                                  DetailsArr_[pageIndex["subPage"]]["index"]
                                ]["Id"],
                                null,
                                json_
                              );
                            }}
                            text={
                              <>
                                Add {index + 2}
                                {index + 2 === 2
                                  ? `nd`
                                  : index + 2 === 3
                                  ? "rd"
                                  : "th"}{" "}
                                Employer
                              </>
                            }
                          />
                        </>
                      )} */}

                      <AddRemoveButton
                        onPress={() => {
                          handleUpdateAddtionalEmployment(
                            index,
                            "isRemove",
                            true
                          );
                          setScrollToTop(999);
                        }}
                        text={<>Remove Employer</>}
                      />
                    </>
                  ),
                };
                if (loopCustId != employment["CustId"]) {
                  let iLoopCustId = loopCustId;
                  loopCustId = employment["CustId"];

                  return [
                    {
                      Title: "Tell us about your employment history.",
                      Options: [
                        { value: 1, text: "Add More Employment" },
                        { value: 0, text: "This Step Is Completed" },
                      ],
                      isAddAdditionalEmployment: true,
                      CustId: iLoopCustId,
                      ColumnName: `blEmployment${index}`,
                      ColumnValue: LoanData[`blEmployment${index}`] || 0,
                      type: 1,
                      footerContent: <></>,
                    },
                    empOption,
                  ];
                } else {
                  return empOption;
                }
              })
              .flat()
          );
          additionalEmploymentInfo.length &&
            arr.push({
              Title: "Tell us about your employment history.",
              Options: [
                { value: 1, text: "Add More Employment" },
                { value: 0, text: "This Step Is Completed" },
              ],
              isAddAdditionalEmployment: true,
              ColumnName: "blEmployment",
              CustId:
                additionalEmploymentInfo?.[additionalEmploymentInfo.length - 1][
                  "CustId"
                ],

              ColumnValue: LoanData["blEmployment"] || 0,
              type: 1,
              footerContent: <></>,
            });
        } else {
          arr.push({
            type: 1,
            widthOption: "40%",
            Title: "Do you receive other types of income?",
            Options: [
              { value: false, text: "No" },
              { value: true, text: "Yes" },
            ],
            ColumnName: "IsOtherIncome",
            ColumnValue: LoanData["IsOtherIncome"],
            subFields: LoanData["IsOtherIncome"]
              ? [
                  {
                    Title: "",
                    label: "Payor Name",
                    ColumnName: "Payor_Name",
                    ColumnValue: LoanData["Payor_Name"],
                    isValid: !LoanData["Payor_Name"],
                    type: 2,
                  },
                  {
                    Title: "",
                    label: "Source of Other Income",
                    ColumnName: "Source_Other_Incm",
                    ColumnValue: LoanData["Source_Other_Incm"],
                    isValid: Number(LoanData["Source_Other_Incm"]) === 0,
                    isMap: true,
                    onBlur: () => {},
                    type: 3,
                    Option: otherIncomeOption,
                  },
                  {
                    Title: "",
                    label: "Monthly Amount",
                    ColumnName: "Monthly_Amount",
                    isCurrency: true,
                    ColumnValue: LoanData["Monthly_Amount"],
                    isValid:
                      !LoanData["Monthly_Amount"] ||
                      LoanData["Monthly_Amount"] === 0 ||
                      LoanData["Monthly_Amount"] === "$0.00",
                    type: 2,
                    onBlur: () => {
                      setLoanData({
                        ...LoanData,
                        Monthly_Amount: formatCurrency(
                          LoanData["Monthly_Amount"],
                          2
                        ),
                      });
                    },
                  },
                  {
                    Title: "For Which Borrower",
                    label: "",
                    ColumnName: "OtherIncomeCustId",
                    ColumnValue: LoanData["OtherIncomeCustId"],
                    isValid: LoanData["OtherIncomeCustId"] == "-99",
                    // isMap: true,
                    onBlur: () => {},
                    type: 6,
                    Option: handleGetBorrowerOption(),
                  },
                ]
              : [],
          });
          if (LoanData["IsOtherIncome"]) {
            arr.push(
              ...additionalOtherIncomeInfo.map((income, index) => {
                return {
                  type: 1,
                  isAdditionalIncome: true,
                  isRemove: income["isRemove"] || false,
                  custId: income["Id"],
                  Title: `Do you receive other types of income ${index + 2}?`,
                  onChangeText: (name, value) =>
                    handleUpdateAddtionalOtherIncome(index, name, value),
                  subFields: [
                    {
                      Title: "",
                      label: "Payor Name",
                      ColumnName: "Payor_Name",
                      ColumnValue: income["Payor_Name"],
                      isValid: !income["Payor_Name"],
                      type: 2,
                    },
                    {
                      Title: "",
                      label: "Source of Other Income",
                      ColumnName: "Source_Other_Incm",
                      ColumnValue: income["Source_Other_Incm"],
                      isValid: Number(income["Source_Other_Incm"]) === 0,
                      isMap: true,
                      onBlur: () => {},
                      type: 3,
                      Option: otherIncomeOption,
                    },
                    {
                      Title: "",
                      label: "Monthly Amount",
                      isCurrency: true,
                      ColumnName: "Monthly_Amount",
                      ColumnValue: income["Monthly_Amount"],
                      isValid:
                        !income["Monthly_Amount"] ||
                        income["Monthly_Amount"] === 0 ||
                        income["Monthly_Amount"] === "$0.00",
                      type: 2,
                      onBlur: () => {
                        handleUpdateAddtionalOtherIncome(
                          index,
                          "Monthly_Amount",
                          formatCurrency(income["Monthly_Amount"], 2)
                        );
                      },
                    },
                    {
                      Title: "For Which Borrower",
                      label: "",
                      ColumnName: "CustId",
                      ColumnValue: income["CustId"],
                      isValid: income["CustId"] == "-99",
                      // isMap: true,
                      onBlur: () => {},
                      type: 6,
                      Option: handleGetBorrowerOption(),
                    },
                  ],
                  removeContent: (
                    <View>
                      <Title
                        style={{ fontSize: web ? 22 : 18 }}
                        text={`Are you sure you want to remove ${income["Payor_Name"]}?`}
                      />
                      <View
                        style={{
                          flex: 1,
                          flexDirection: "row-reverse",
                          marginTop: -10,
                          alignSelf: "flex-start",
                        }}
                      >
                        <IconButton
                          onPress={() => {
                            let addIncome = additionalOtherIncomeInfo.filter(
                              (e, index_) => index !== index_
                            );
                            handleUpdateAddtionalOtherIncome(
                              index,
                              "isRemove",
                              false
                            );
                            setAdditionalOtherIncomeInfo([...addIncome]);

                            setPageIndex({
                              ...pageIndex,
                              subPage: Number(pageIndex["subPage"]) - 1,
                            });
                            handleSaveAdditionalInfo(-1, 7, income["Id"]);
                            setScrollToTop(true);
                          }}
                          style={{
                            paddingVertical: 7,
                            paddingHorizontal: 10,
                          }}
                          title={
                            <CustomText
                              bold={true}
                              style={{ fontSize: 16, color: "#fff" }}
                            >
                              Remove
                            </CustomText>
                          }
                        />
                        <IconButton
                          buttonType="secondary"
                          style={{
                            marginRight: 10,
                            paddingVertical: 7,
                            paddingHorizontal: 10,
                          }}
                          onPress={() => {
                            handleUpdateAddtionalOtherIncome(
                              index,
                              "isRemove",
                              false
                            );
                          }}
                          title={
                            <CustomText
                              bold={true}
                              style={{ fontSize: 16, color: "#508BC9" }}
                            >
                              Cancel
                            </CustomText>
                          }
                        />
                      </View>
                    </View>
                  ),
                  footerButton: (
                    <>
                      <TouchableOpacity
                        activeOpacity={1}
                        onPress={() => {
                          handleUpdateAddtionalOtherIncome(
                            index,
                            "isRemove",
                            true
                          );
                          setScrollToTop(999);
                        }}
                        style={[
                          styles.buttonContainer,
                          { backgroundColor: "#d43f3a" },
                        ]}
                      >
                        <CustomText
                          style={[
                            {
                              color: "#fff",
                              marginTop: web ? 7 : 3,
                              fontSize: 20,
                              alignSelf: "center",
                            },
                            web ? { width: "max-content" } : {},
                          ]}
                        >
                          {"  "}Remove Other Income{" "}
                        </CustomText>
                      </TouchableOpacity>
                    </>
                  ),
                };
              })
            );
          }
          arr.push({
            Title: "Tell us about your Other Income.",
            Options: [
              { value: 1, text: "Add More Other Income" },
              { value: 0, text: "This Step Is Completed" },
            ],
            isAddAdditionalOtherIncome: true,
            ColumnName: "blOtherIncome",
            ColumnValue: LoanData["blOtherIncome"] || 0,
            type: 1,
            footerContent: <></>,
          });
        }
        arr.push({
          type: 1,
          widthOption: "40%",
          Title: "Is there any alimony or child support expenses or income?",
          Options: [
            { value: 0, text: "No" },
            { value: 1, text: "Yes" },
          ],
          ColumnName: "IsAlimonyChildSupport",
          ColumnValue: LoanData["IsAlimonyChildSupport"],
          subFields: LoanData["IsAlimonyChildSupport"]
            ? [
                {
                  Title: "For Which Borrower",
                  label: "",
                  ColumnName: "OtherAlimonyIncomeCustId",
                  isValid: LoanData["OtherAlimonyIncomeCustId"] == "-99",
                  ColumnValue:
                    LoanData["OtherAlimonyIncomeCustId"] ||
                    additionalBorrowerInfo?.[0]?.["CustId"] ||
                    UserId,
                  type: 6,
                  // isMap: true,
                  onBlur: () => {},
                  Option: handleGetBorrowerOption(),
                },
                {
                  Title: "",
                  label: "Monthly Alimony Expense",
                  isCurrency: true,
                  ColumnName: "Monthly_Alimony_Expense",
                  ColumnValue: LoanData["Monthly_Alimony_Expense"],
                  type: 2,
                  onBlur: () => {
                    setLoanData({
                      ...LoanData,
                      Monthly_Alimony_Expense: formatCurrency(
                        LoanData["Monthly_Alimony_Expense"],
                        2
                      ),
                    });
                  },
                },
                {
                  Title: "",
                  label: "Monthly Alimony Income",
                  isCurrency: true,
                  ColumnName: "Monthly_Alimony_Income",
                  ColumnValue: LoanData["Monthly_Alimony_Income"],
                  type: 2,
                  onBlur: () => {
                    setLoanData({
                      ...LoanData,
                      Monthly_Alimony_Income: formatCurrency(
                        LoanData["Monthly_Alimony_Income"],
                        2
                      ),
                    });
                  },
                },
                {
                  Title: "",
                  label: "Monthly Child Support Expense",
                  isCurrency: true,
                  ColumnName: "Monthly_ChildSupportExpense",
                  ColumnValue: LoanData["Monthly_ChildSupportExpense"],
                  type: 2,
                  onBlur: () => {
                    setLoanData({
                      ...LoanData,
                      Monthly_ChildSupportExpense: formatCurrency(
                        LoanData["Monthly_ChildSupportExpense"],
                        2
                      ),
                    });
                  },
                },
                {
                  Title: "",
                  label: "Monthly Child Support income",
                  ColumnName: "Monthly_ChildSupportIncome",
                  isCurrency: true,
                  ColumnValue: LoanData["Monthly_ChildSupportIncome"],
                  type: 2,
                  onBlur: () => {
                    setLoanData({
                      ...LoanData,
                      Monthly_ChildSupportIncome: formatCurrency(
                        LoanData["Monthly_ChildSupportIncome"],
                        2
                      ),
                    });
                  },
                },
              ]
            : [],
        });
      } else if (currentPage_ === pageArray[pageId["bankAccounts"]]) {
        arr.push(
          ...additionalBankInfo.map((bank, index) => {
            return {
              type: 1,
              Title: `What is your ${index + 1}${
                index + 1 === 1
                  ? "st"
                  : index + 1 === 2
                  ? `nd`
                  : index + 1 === 3
                  ? "rd"
                  : "th"
              } bank name?`,
              index: index,
              isAdditionalBank: true,
              onChangeText: (name, value) => {
                handleUpdateAddtionalBank(index, name, value);
              },
              isRemove: bank["isRemove"] || false,
              subFields: [
                {
                  Title: "",
                  label: "Account Type",
                  ColumnName: "AccType",
                  ColumnValue: bank["AccType"],
                  type: 3,
                  Option: accountTypeOption,
                  isMap: true,
                },
                bank["AccType"] == "-1" && {
                  Title: "",
                  label: "Other Type",
                  ColumnName: "OtherAccType",
                  isValid: !bank["OtherAccType"],
                  ColumnValue: bank["OtherAccType"],
                  type: 3,
                  Option: otherAccountTypeOption,
                  isMap: true,
                },
                ((![3, 4, 12, 19, 20, 33, 37, 22].includes(
                  Number(bank["OtherAccType"])
                ) &&
                  Number(bank["OtherAccType"])) ||
                  bank["AccType"] != "-1") && {
                  Title: "",
                  label: "Bank Name",
                  ColumnName: "BankName",
                  ColumnValue: bank["BankName"],
                  isValid: !bank["BankName"],
                  type: 2,
                },

                ...(bank["AccType"] == "-1"
                  ? [11, 5, 6, 7, 17, 10, 14].includes(
                      Number(bank["OtherAccType"])
                    )
                    ? [
                        {
                          Title: "",
                          label: "Address",
                          ColumnName: "BankAddress",
                          ColumnValue: bank["BankAddress"],
                          type: 2,
                        },
                        {
                          Title: "",
                          type: 2,
                          keyboardType: "numeric",
                          maxLength: 5,
                          label: "Zip Code",
                          placeholder: "Zip Code",
                          ColumnName: "BankZip",
                          ColumnValue: bank["BankZip"],
                          onBlur: async () => {
                            let zipCode = bank["BankZip"];
                            if (zipCode) {
                              let { city, state } =
                                await handleGetZipCodeDetails(zipCode);
                              let iAdditionalBankInfo = additionalBankInfo;
                              iAdditionalBankInfo[index][`BankCity`] = city;
                              iAdditionalBankInfo[index][`BankState`] = state;
                              setAdditionalBankInfo([...iAdditionalBankInfo]);
                            }
                          },
                        },
                        {
                          Title: "",
                          type: 2,
                          label: "City",
                          ColumnName: "BankCity",
                          ColumnValue: bank["BankCity"],
                          onBlur: () => {},
                        },
                        {
                          Title: "",
                          label: "State",
                          placeholder: "State",
                          ColumnName: "BankState",
                          ColumnValue: bank["BankState"],
                          onBlur: () => {},
                          type: 3,
                          Option: stateOptions,
                          isMap: true,
                        },
                      ]
                    : [12, 33].includes(Number(bank["OtherAccType"]))
                    ? [
                        {
                          Title: "",
                          label: "Description",
                          ColumnName: "Description",
                          ColumnValue: bank["Description"],
                          isValid: !bank["Description"],
                          type: 2,
                        },
                      ]
                    : [4].includes(Number(bank["OtherAccType"]))
                    ? [
                        {
                          Title: "",
                          label: "Description",
                          ColumnName: "Description",
                          ColumnValue: bank["Description"],
                          isValid: !bank["Description"],
                          type: 2,
                        },
                        {
                          Title: "",
                          label: "Earnest Money Paid To",
                          ColumnName: "EarnestMoneyPaidTo",
                          ColumnValue: bank["EarnestMoneyPaidTo"],
                          onBlur: () => {},
                          type: 3,
                          Option: vendorOptions,
                          isMap: true,
                        },
                      ]
                    : [3, 19, 20, 37].includes(Number(bank["OtherAccType"]))
                    ? [
                        {
                          Title: "",
                          label: "Donor Name",
                          ColumnName: "BankName",
                          ColumnValue: bank["BankName"],
                          isValid: !bank["BankName"],
                          type: 2,
                        },
                        {
                          Title: "",
                          label: "Source of Funds",
                          ColumnName: "AccountName",
                          ColumnValue: bank["AccountName"],
                          type: 2,
                        },
                        {
                          Title: "",
                          label: "Donor Address",
                          ColumnName: "BankAddress",
                          ColumnValue: bank["BankAddress"],
                          type: 2,
                        },
                        {
                          Title: "",
                          type: 2,
                          keyboardType: "numeric",
                          maxLength: 5,
                          label: "Zip Code",
                          placeholder: "Zip Code",
                          ColumnName: "BankZip",
                          ColumnValue: bank["BankZip"],
                          onBlur: async () => {
                            let zipCode = bank["BankZip"];
                            if (zipCode) {
                              let { city, state } =
                                await handleGetZipCodeDetails(zipCode);
                              let iAdditionalBankInfo = additionalBankInfo;
                              iAdditionalBankInfo[index][`BankCity`] = city;
                              iAdditionalBankInfo[index][`BankState`] = state;
                              setAdditionalBankInfo([...iAdditionalBankInfo]);
                            }
                          },
                        },
                        {
                          Title: "",
                          type: 2,
                          label: "City",
                          ColumnName: "BankCity",
                          ColumnValue: bank["BankCity"],
                          onBlur: () => {},
                        },
                        {
                          Title: "",
                          label: "State",
                          placeholder: "BankState",
                          ColumnName: "BankState",
                          ColumnValue: bank["BankState"],
                          onBlur: () => {},
                          type: 3,
                          Option: stateOptions,
                          isMap: true,
                        },
                        {
                          Title: "",
                          label: "Gift Source",
                          placeholder: "giftfrom",
                          ColumnName: "giftfrom",
                          isValid: !bank["giftfrom"],
                          ColumnValue: bank["giftfrom"],
                          onBlur: () => {},
                          type: 3,
                          Option: giftOptions,
                          isMap: true,
                        },
                        {
                          Title: "",
                          type: 2,
                          label: "Relationship",
                          ColumnName: "Account",
                          ColumnValue: bank["Account"],
                          isValid: !bank["Account"],
                          onBlur: () => {},
                        },
                      ]
                    : [22].includes(Number(bank["OtherAccType"]))
                    ? [
                        {
                          Title: "",
                          label: "Description",
                          ColumnName: "Description",
                          ColumnValue: bank["Description"],
                          isValid: !bank["Description"],
                          type: 2,
                        },

                        {
                          Title: "",
                          label: "Life Insurance Face",
                          ColumnName: "lifeInsFace",
                          ColumnValue: bank["lifeInsFace"],
                          isValid: !bank["lifeInsFace"],
                          type: 2,
                        },

                        {
                          Title: "",
                          label: "Life Insurance Value",
                          ColumnName: "lifeInsValue",
                          ColumnValue: bank["lifeInsValue"],
                          isValid: !bank["lifeInsValue"],
                          type: 2,
                        },
                      ]
                    : []
                  : []),

                ((![22].includes(Number(bank["OtherAccType"])) &&
                  Number(bank["OtherAccType"])) ||
                  bank["AccType"] != "-1") && {
                  Title: "How much money do you keep there?",
                  label: "Amount",
                  isCurrency: true,
                  ColumnName: "Amount",
                  ColumnValue: bank["Amount"],
                  isValid: !bank["Amount"].replaceAll("$0.00", ""),
                  onBlur: () => {
                    handleUpdateAddtionalBank(
                      index,
                      "Amount",
                      formatCurrency(bank["Amount"], 2)
                    );
                  },
                  type: 2,
                },
                (Number(bank["OtherAccType"]) || bank["AccType"] != "-1") && {
                  label: "",
                  Title: "Owner(s) of this Asset",
                  placeholder: "Owner(s) of this Asset",
                  ColumnName: "OwnerIdList",
                  ColumnValue: bank["OwnerIdList"],
                  type: 6,
                  Option: handleGetBorrowerOption(),
                  isMultiple: true,
                },
                {
                  ColumnName: "AssetId",
                  ColumnValue: bank["AssetId"],
                },
              ].filter((item) => item),
              footerButton: (
                <>
                  <AddRemoveButton
                    onPress={() => {
                      handleUpdateAddtionalBank(index, "isRemove", true);
                      setScrollToTop(999);
                    }}
                    text={"Remove Bank"}
                  />
                </>
              ),
              removeContent: (
                <View>
                  <Title
                    style={{ fontSize: web ? 22 : 18 }}
                    text={`Are you sure you want to remove ${
                      bank["BankName"] || ""
                    } ?`}
                  />
                  <View
                    style={{
                      flex: 1,
                      flexDirection: "row-reverse",
                      marginTop: -10,
                      alignSelf: "flex-start",
                    }}
                  >
                    <IconButton
                      onPress={() => {
                        let addBank = additionalBankInfo.filter(
                          (e, index_) => index !== index_
                        );
                        handleUpdateAddtionalBank(index, "isRemove", false);
                        setAdditionalBankInfo([...addBank]);
                        index !== 0 &&
                          setPageIndex({
                            ...pageIndex,
                            subPage: Number(pageIndex["subPage"]) - 1,
                          });
                        handleSaveAdditionalInfo(-1, 8, bank["Id"]);
                        setScrollToTop(true);
                      }}
                      style={{
                        paddingVertical: 7,
                        paddingHorizontal: 10,
                      }}
                      title={
                        <CustomText
                          bold={true}
                          style={{ fontSize: 16, color: "#fff" }}
                        >
                          Remove
                        </CustomText>
                      }
                    />
                    <IconButton
                      style={{
                        marginRight: 10,
                        paddingVertical: 7,
                        paddingHorizontal: 10,
                      }}
                      buttonType="secondary"
                      onPress={() =>
                        handleUpdateAddtionalBank(index, "isRemove", false)
                      }
                      title={
                        <CustomText
                          bold={true}
                          style={{ fontSize: 16, color: "#508BC9" }}
                        >
                          Cancel
                        </CustomText>
                      }
                    />
                  </View>
                </View>
              ),
            };
          })
        );

        arr.push({
          Title: "Tell us about any additional Assets",
          Options: [
            { value: 1, text: "Add More Assets" },
            { value: 0, text: "This Step Is Completed" },
          ],
          ColumnName: "blAssetOption",
          ColumnValue: LoanData["blAssetOption"],
          type: 1,
          footerContent: <></>,
        });
      } else if (currentPage_ === pageArray[pageId["realEstateOwned"]]) {
        // if (Number(LoanData["Real_est_prop"]) === 1) {
        arr.push(
          ...additionalPropertyInfo.map((property, index) => {
            return {
              index: index,
              isAdditionalProperty: true,
              isRemove: property["isRemove"] || false,
              onChangeText: (name, value) => {
                handleUpdateAddtionalPropertyInfo(index, name, value);
              },
              Title: `Real estate properties ${index + 1}?`,
              subFields: [
                {
                  Title: "",
                  label: "Property Address",
                  ColumnName: "Real_est_prop_Addrs",
                  ColumnValue: property["Real_est_prop_Addrs"],
                  isValid: !property["Real_est_prop_Addrs"],
                  type: 2,
                },
                {
                  Title: "",
                  type: 2,
                  keyboardType: "numeric",
                  maxLength: 5,
                  label: "Zip Code",
                  placeholder: "Zip Code",
                  ColumnName: "Real_est_ZipCode",
                  forceValidation:
                    property["Real_est_ZipCode"]?.toString().length != 5,
                  ColumnValue:
                    property["Real_est_ZipCode"] != 0
                      ? property["Real_est_ZipCode"]
                      : "",
                  onBlur: async () => {
                    let zipCode = property["Real_est_ZipCode"];
                    if (zipCode) {
                      let { city, state } = await handleGetZipCodeDetails(
                        zipCode
                      );
                      let additionalPropertyInfo_ = additionalPropertyInfo;
                      additionalPropertyInfo_[index][`Real_est_City`] = city;
                      additionalPropertyInfo_[index][`Real_est_State`] = state;
                      setAdditionalPropertyInfo([...additionalPropertyInfo_]);
                    }
                  },
                },

                {
                  Title: "",
                  label: "City",
                  ColumnName: "Real_est_City",
                  isValid: !property["Real_est_City"],
                  ColumnValue: property["Real_est_City"],
                  type: 2,
                },
                {
                  Title: "",
                  label: "State",
                  placeholder: "State",
                  ColumnName: "Real_est_State",
                  isValid: !property["Real_est_State"],
                  ColumnValue: property["Real_est_State"],
                  onBlur: () => {},
                  type: 3,
                  Option: stateOptions,
                  isMap: true,
                },
                {
                  Title: "What is the estimated value of the property?",
                  label: "Present Market Value",
                  isCurrency: true,
                  placeholder: "Market Value",
                  ColumnName: "Presnt_Markt_Val",
                  isValid: cleanValue(property["Presnt_Markt_Val"]) == 0,
                  ColumnValue: property["Presnt_Markt_Val"],
                  type: 2,
                  onBlur: () => {
                    handleUpdateAddtionalPropertyInfo(
                      index,
                      "Presnt_Markt_Val",
                      formatCurrency(property["Presnt_Markt_Val"], 2)
                    );
                  },
                },
                {
                  Title: "What is the Property Status?",

                  Options: [
                    { value: 1, text: "Currently Own" },
                    { value: 2, text: "2nd Home" },
                    { value: 3, text: "Rental" },
                    { value: 4, text: "Pending Sale" },
                  ],
                  ColumnName: "Real_est_Prop_Status",
                  ColumnValue: property["Real_est_Prop_Status"],
                  isValid: !property["Real_est_Prop_Status"],
                  type: 1,
                },
                {
                  Title:
                    "The loan you are applying for – is it for this property",
                  widthOption: "40%",
                  Options: [
                    { value: 0, text: "No" },
                    { value: 1, text: "Yes" },
                  ],
                  ColumnName: "Real_est_Subj_Prop",
                  ColumnValue: property["Real_est_Subj_Prop"],
                  type: 1,
                },
                {
                  Title: "Is this your current residence?",
                  widthOption: "40%",
                  Options: [
                    { value: 0, text: "No" },
                    { value: 1, text: "Yes" },
                  ],
                  ColumnName: "Current_residence",
                  ColumnValue: property["Current_residence"],
                  type: 1,
                },

                {
                  Title: "What is the Property Type?",
                  label: "Property Type",
                  placeholder: "State",
                  ColumnName: "PropertyType",
                  isValid: !property["PropertyType"],
                  ColumnValue: property["PropertyType"]?.toString(),
                  onBlur: () => {},
                  type: 3,
                  Option: [
                    { value: "", label: "--Select--" },
                    { value: "SFR", label: "Single Family Residence" },
                    { value: "2 unit", label: "2 unit" },
                    { value: "3 unit", label: "3 unit" },
                    { value: "4 unit", label: "4 unit" },
                    { value: "5+ unit", label: "5+ unit" },
                    { value: "Com", label: "Condominium" },
                    { value: "Condo", label: "Commercial" },
                    { value: "Ind", label: "Industrial" },
                    { value: "Manu", label: "Manufactured" },
                    { value: "Raw Land", label: "Raw Land" },
                    { value: "Farm or Ranch", label: "Farm or Ranch" },
                  ],
                  isMap: true,
                },
                {
                  Title: "How long have you owned this property?",
                  label: "Months Owned Property",
                  placeholder: "Months Owned Property",
                  ColumnName: "Months_Ownd_Prop",
                  ColumnValue: property["Months_Ownd_Prop"],
                  isValid: !property["Months_Ownd_Prop"],
                  type: 2,
                  keyboardType: "numeric",
                },
                {
                  label: "",
                  Title: "Owner(s) of this Asset",
                  placeholder: "Owner(s) of this Asset",
                  ColumnName: "OwnerIdList",
                  ColumnValue: property["OwnerIdList"],
                  isValid: !property["OwnerIdList"],
                  type: 6,
                  Option: handleGetBorrowerOption(),
                  isMultiple: true,
                },
              ],
              footerButton: (
                <>
                  <AddRemoveButton
                    onPress={() => {
                      handleUpdateAddtionalPropertyInfo(
                        index,
                        "isRemove",
                        true
                      );
                      setScrollToTop(999);
                    }}
                    text={<>Remove Property</>}
                  />
                </>
              ),
              removeContent: (
                <View style={{ marginTop: -10 }}>
                  <Title
                    text={`Are you sure you want to remove ${
                      property["BankName"] || ""
                    } ?`}
                    style={{ fontSize: web ? 22 : 18 }}
                  />
                  <View
                    style={{
                      flex: 1,
                      flexDirection: "row-reverse",
                      marginBottom: 20,
                      marginTop: -10,
                      alignSelf: "flex-start",
                    }}
                  >
                    <IconButton
                      onPress={() => {
                        let addProp = additionalPropertyInfo.filter(
                          (e, index_) => index !== index_
                        );
                        handleUpdateAddtionalPropertyInfo(
                          index,
                          "isRemove",
                          false
                        );
                        setAdditionalPropertyInfo([...addProp]);
                        if (addProp.length) {
                          setPageIndex({
                            ...pageIndex,
                            subPage: Number(pageIndex["subPage"]) - 1,
                          });
                        }
                        handleSaveAdditionalInfo(-1, 9, property["Id"]);
                        setScrollToTop(true);
                      }}
                      style={{
                        paddingVertical: 7,
                        paddingHorizontal: 10,
                      }}
                      title={
                        <CustomText
                          bold={true}
                          style={{ fontSize: 16, color: "#fff" }}
                        >
                          Remove
                        </CustomText>
                      }
                    />
                    <IconButton
                      style={{
                        marginRight: 10,
                        paddingVertical: 7,
                        paddingHorizontal: 10,
                      }}
                      onPress={() =>
                        handleUpdateAddtionalPropertyInfo(
                          index,
                          "isRemove",
                          false
                        )
                      }
                      buttonType="secondary"
                      title={
                        <CustomText
                          bold={true}
                          style={{ fontSize: 16, color: "#508BC9" }}
                        >
                          Cancel
                        </CustomText>
                      }
                    />
                  </View>
                </View>
              ),
            };
          })
        );
        // }
        arr.push({
          type: 1,
          Title: "Tell us about any additional real estate properties",
          Options: [
            { value: 0, text: "I have none" },
            {
              value: 1,
              text: `I do have additional real estate properties   `,
            },
          ],
          ColumnName: "Real_est_prop",
          ColumnValue: LoanData["Real_est_prop"],
        });
      } else if (currentPage_ === pageArray[pageId["government"]]) {
        arr.push({
          Title:
            "You are almost done. The following are government monitoring questions.",
          // onChangeText: (name, value) => {},
          subFields: [
            {
              type: 1,
              Title: (
                <CustomText
                  bold={true}
                  style={{
                    fontSize: web ? 24 : 21,
                    marginBottom: web ? 30 : 15,
                    color: "#41464d",
                  }}
                >
                  Declarations for{" \n"}
                  <CustomText bold={true} style={{ backgroundColor: "cyan" }}>
                    {LoanData["FirstName"] || LoanData["LastName"]
                      ? `${LoanData["FirstName"] || ""} ${
                          LoanData["LastName"] || ""
                        }`
                      : `borrower`}
                  </CustomText>
                  {LoanData["FirstName"] || LoanData["LastName"] ? `.` : `?`}
                </CustomText>
              ),
              Options: [{ value: 1, text: "Default Selections" }],
              onPress: () => {
                setLoanData({
                  ...LoanData,
                  ...{
                    Citizenship_Status: 1,
                    Pri_residence: 1,
                    Ownership_intst_Othr_Prop: 0,
                    Purchase_Transaction: 0,
                    Bor_money_realest_trans: 0,
                    Bor_money_Amt: 0.0,
                    Apply_mortloan_otherprop: 0,
                    Apply_newcredit: 0,
                    Prop_sub_to_lien: 0,
                    Co_signer: 0,
                    Outstanding_judgments: 0,
                    Cur_delinquent: 0,
                    Party_to_lawsuit: 0,
                    Prop_lieu_foreclosure: 0,
                    Pre_foreclosure_sale: 0,
                    Prop_foreclosed: 0,
                    Declare_bankruptcy: 0,
                    Types_bankruptcy: null,
                    bType1stBuyer: 0,
                  },
                });
              },
              ColumnName: "DefaultSelection",
              ColumnValue: LoanData["DefaultSelection"],
            },
            {
              type: 1,
              Title: `Specify Citizenship Status`,
              Options: [
                { value: 1, text: "U.S. Citizen" },
                { value: 2, text: "Permanent Resident Alien" },
                { value: 3, text: "Non Permanant Resident Alien" },
              ],
              ColumnName: "Citizenship_Status",
              ColumnValue: LoanData["Citizenship_Status"],
              isYellow:
                [1, 2, 3].indexOf(LoanData["Citizenship_Status"]) === -1,
            },
            {
              type: 1,
              widthOption: "40%",
              Title: `A. Will you occupy the property as your primary residence?`,
              Options: [
                { value: 0, text: "No" },
                { value: 1, text: "Yes" },
              ],
              ColumnName: "Pri_residence",
              ColumnValue: LoanData["Pri_residence"],
              isYellow: [0, 1].indexOf(LoanData["Pri_residence"]) === -1,
            },
            {
              type: 1,
              widthOption: "40%",
              Title: `If YES, have you had an ownership interest in another property in the last three years?`,
              Options: [
                { value: 0, text: "No" },
                { value: 1, text: "Yes" },
              ],
              ColumnName: "Ownership_intst_Othr_Prop",
              ColumnValue: LoanData["Ownership_intst_Othr_Prop"],
              isYellow:
                [0, 1].indexOf(LoanData["Ownership_intst_Othr_Prop"]) === -1,
            },
            LoanData["Ownership_intst_Othr_Prop"] === 1 && {
              type: 1,
              Title: `If YES, complete (1) and (2) below:`,
              isYellow: [1, 2, 3].indexOf(LoanData["Prop_own"]) === -1,
            },
            LoanData["Ownership_intst_Othr_Prop"] === 1 && {
              type: 1,
              Title: `(1) What type of property did you own: primary residence (PR), FHA secondary residence (SR), second home (SH), or investment property (IP)?`,
              Options: [
                { value: 1, text: "Primary Residence" },
                { value: 2, text: "2nd Home" },
                { value: 3, text: "Investment Property" },
              ],
              ColumnName: "Prop_own",
              ColumnValue: LoanData["Prop_own"],
              isYellow: [1, 2, 3].indexOf(LoanData["Prop_own"]) === -1,
            },
            LoanData["Ownership_intst_Othr_Prop"] === 1 && {
              type: 1,
              Title: `(2) How did you hold title to the property: by yourself (S), jointly with your spouse (SP), or jointly with another person (O)?`,
              Options: [
                { value: 1, text: "Self" },
                { value: 2, text: "Joint with spouse" },
                { value: 3, text: "Joint with other" },
              ],
              ColumnName: "Prop_hold",
              ColumnValue: LoanData["Prop_hold"],
              isYellow: [1, 2, 3].indexOf(LoanData["Prop_hold"]) === -1,
            },

            {
              type: 1,
              widthOption: "40%",
              Title: `B. If this is a Purchase Transaction: Do you have a family relationship or business affiliation with the seller of the property?`,
              Options: [
                { value: 0, text: "No" },
                { value: 1, text: "Yes" },
              ],
              ColumnName: "Purchase_Transaction",
              ColumnValue: LoanData["Purchase_Transaction"],
              isYellow: [0, 1].indexOf(LoanData["Purchase_Transaction"]) === -1,
            },
            {
              type: 1,
              widthOption: "40%",
              Title: `C. Are you borrowing any money for this real estate transaction (e.g., money for your closing costs or down payment) or obtaining any money from another party, such as the seller or realtor, that you have not disclosed on this loan application?`,
              Options: [
                { value: 0, text: "No" },
                { value: 1, text: "Yes" },
              ],
              ColumnName: "Bor_money_realest_trans",
              ColumnValue: LoanData["Bor_money_realest_trans"],
              isYellow:
                [0, 1].indexOf(LoanData["Bor_money_realest_trans"]) === -1,
            },
            LoanData["Bor_money_realest_trans"] === 1 && {
              type: 2,
              label: "Amount",
              isCurrency: true,
              Title: `If YES, what is the amount of this money?`,
              ColumnName: "Bor_money_Amt",
              ColumnValue: LoanData["Bor_money_Amt"],
              isValid: cleanValue(LoanData["Bor_money_Amt"]) == 0,
              onBlur: () => {
                setLoanData({
                  ...LoanData,
                  Bor_money_Amt: formatCurrency(LoanData["Bor_money_Amt"], 2),
                });
              },
            },
            {
              type: 1,
              widthOption: "40%",
              Title: `D. 1. Have you or will you be applying for a mortgage loan on another property (not the property securing this loan) on or before closing this transaction that is not disclosed on this loan application?`,
              Options: [
                { value: 0, text: "No" },
                { value: 1, text: "Yes" },
              ],
              ColumnName: "Apply_mortloan_otherprop",
              ColumnValue: LoanData["Apply_mortloan_otherprop"],
              isYellow:
                [0, 1].indexOf(LoanData["Apply_mortloan_otherprop"]) === -1,
            },
            {
              type: 1,
              widthOption: "40%",
              Title: `D. 2.Have you or will you be applying for any new credit (e.g., installment loan, credit card, etc.) on or before closing this loan that is not disclosed on this application?`,
              Options: [
                { value: 0, text: "No" },
                { value: 1, text: "Yes" },
              ],
              ColumnName: "Apply_newcredit",
              ColumnValue: LoanData["Apply_newcredit"],
              isYellow: [0, 1].indexOf(LoanData["Apply_newcredit"]) === -1,
            },
            {
              type: 1,
              widthOption: "40%",
              Title: `E. Will this property be subject to a lien that could take priority over the first mortgage lien, such as a clean energy lien paid through your property taxes (e.g., the Property Assessed Clean Energy Program)?`,
              Options: [
                { value: 0, text: "No" },
                { value: 1, text: "Yes" },
              ],
              ColumnName: "Prop_sub_to_lien",
              ColumnValue: LoanData["Prop_sub_to_lien"],
              isYellow: [0, 1].indexOf(LoanData["Prop_sub_to_lien"]) === -1,
            },
            {
              type: 1,
              widthOption: "40%",
              Title: `F. Are you a Co_signer or guarantor on any debt or loan that is not disclosed on this application?`,
              Options: [
                { value: 0, text: "No" },
                { value: 1, text: "Yes" },
              ],
              ColumnName: "Co_signer",
              ColumnValue: LoanData["Co_signer"],
              isYellow: [0, 1].indexOf(LoanData["Co_signer"]) === -1,
            },
            {
              type: 1,
              widthOption: "40%",
              Title: `G. Are there any outstanding judgments against you?`,
              Options: [
                { value: 0, text: "No" },
                { value: 1, text: "Yes" },
              ],
              ColumnName: "Outstanding_judgments",
              ColumnValue: LoanData["Outstanding_judgments"],
              isYellow:
                [0, 1].indexOf(LoanData["Outstanding_judgments"]) === -1,
            },
            {
              type: 1,
              widthOption: "40%",
              Title: `H. Are you currently delinquent or in default on a Federal debt?`,
              Options: [
                { value: 0, text: "No" },
                { value: 1, text: "Yes" },
              ],
              ColumnName: "Cur_delinquent",
              ColumnValue: LoanData["Cur_delinquent"],
              isYellow: [0, 1].indexOf(LoanData["Cur_delinquent"]) === -1,
            },
            {
              type: 1,
              widthOption: "40%",
              Title: `I. Are you a party to a lawsuit in which you potentially have any personal financial liability?`,
              Options: [
                { value: 0, text: "No" },
                { value: 1, text: "Yes" },
              ],
              ColumnName: "Party_to_lawsuit",
              ColumnValue: LoanData["Party_to_lawsuit"],
              isYellow: [0, 1].indexOf(LoanData["Party_to_lawsuit"]) === -1,
            },
            {
              type: 1,
              widthOption: "40%",
              Title: `J. Have you conveyed title to any property in lieu of foreclosure in the past 7 years?`,
              Options: [
                { value: 0, text: "No" },
                { value: 1, text: "Yes" },
              ],
              ColumnName: "Prop_lieu_foreclosure",
              ColumnValue: LoanData["Prop_lieu_foreclosure"],
              isYellow:
                [0, 1].indexOf(LoanData["Prop_lieu_foreclosure"]) === -1,
            },
            {
              type: 1,
              widthOption: "40%",
              Title: `K. Within the past 7 years, have you completed a pre-foreclosure sale or short sale, whereby the property was sold to a third party and the Lender agreed to accept less than the outstanding mortgage balance due?`,
              Options: [
                { value: 0, text: "No" },
                { value: 1, text: "Yes" },
              ],
              ColumnName: "Pre_foreclosure_sale",
              ColumnValue: LoanData["Pre_foreclosure_sale"],
              isYellow: [0, 1].indexOf(LoanData["Pre_foreclosure_sale"]) === -1,
            },
            {
              type: 1,
              widthOption: "40%",
              Title: `L. Have you had property foreclosed upon in the last 7 years?`,
              Options: [
                { value: 0, text: "No" },
                { value: 1, text: "Yes" },
              ],
              ColumnName: "Prop_foreclosed",
              ColumnValue: LoanData["Prop_foreclosed"],
              isYellow: [0, 1].indexOf(LoanData["Prop_foreclosed"]) === -1,
            },
            {
              type: 1,
              widthOption: "40%",
              Title: `M. Have you declared bankruptcy within the past 7 years?`,
              Options: [
                { value: 0, text: "No" },
                { value: 1, text: "Yes" },
              ],
              ColumnName: "Declare_bankruptcy",
              ColumnValue: LoanData["Declare_bankruptcy"],
              isYellow: [0, 1].indexOf(LoanData["Declare_bankruptcy"]) === -1,
            },
            LoanData["Declare_bankruptcy"] === 1 && {
              type: 1,
              Title: `If YES, identify the type(s) of bankruptcy:`,
              Options: [
                { value: 1, text: "Chapter 7" },
                { value: 2, text: "Chapter 11" },
                { value: 3, text: "Chapter 12" },
                { value: 4, text: "Chapter 13" },
              ],
              ColumnName: "Types_bankruptcy",
              ColumnValue: LoanData["Types_bankruptcy"],
              isYellow:
                [1, 2, 3, 4].indexOf(LoanData["Types_bankruptcy"]) === -1,
            },
            {
              type: 1,
              widthOption: "40%",
              Title: `Are you a First Time Home Buyer?`,
              Options: [
                { value: 0, text: "No" },
                { value: 1, text: "Yes" },
              ],
              ColumnName: "bType1stBuyer",
              ColumnValue: LoanData["bType1stBuyer"],
              isYellow: [0, 1].indexOf(LoanData["bType1stBuyer"]) === -1,
            },
          ],
        });

        arr.push({
          Title: (
            <CustomText
              bold={true}
              style={{
                fontSize: web ? 24 : 21,
                marginBottom: web ? 30 : 15,
                color: "#41464d",
              }}
            >
              Demographic Information for{" \n"}
              <CustomText bold={true} style={{ backgroundColor: "cyan" }}>
                {LoanData["FirstName"] || LoanData["LastName"]
                  ? `${LoanData["FirstName"] || ""} ${
                      LoanData["LastName"] || ""
                    }`
                  : `borrower`}
              </CustomText>
              {LoanData["FirstName"] || LoanData["LastName"] ? `.` : `?`}
            </CustomText>
          ),
          // onChangeText: (name, value) => {
          //   // handleUpdateAddtionalBorrower(index, name, value);
          // },
          // isAddtionalDeclaration: true,
          subFields: [
            {
              type: 1,
              Title: "Application was taken by",
              Options: [
                { value: 1, text: "Face-to-face (including video)" },
                { value: 2, text: "Mail or Fax" },
                { value: 3, text: "Telephone" },
                { value: 4, text: "Internet or Email" },
              ],
              ColumnName: "Demographic_Info",
              ColumnValue: LoanData["Demographic_Info"],
              isYellow:
                [1, 2, 3, 4].indexOf(parseInt(LoanData["Demographic_Info"])) ==
                -1,
            },
            {
              type: 1,
              Title: `Sex`,
              isBitWise: true,
              resetBitWise: 4,
              Options: [
                { value: 1, text: "Male" },
                { value: 2, text: "Female" },
                { value: 4, text: "I do not wish to provide this information" },
              ],
              ColumnName: "Sex",
              ColumnValue: Number(LoanData["Sex"]),
              isYellow: Number(LoanData["Sex"] || 0) === 0,
            },
            {
              type: 1,
              Title: `Ethinicity`,
              Options: [
                { value: 1, text: "Hispanic or Latino" },
                { value: 2, text: "Not Hispanic nor Latino" },
                { value: 3, text: "I do not wish to provide this information" },
              ],
              ColumnName: "Ethinicity",
              ColumnValue: Number(LoanData["Ethinicity"]),
              isYellow: ![1, 2, 3].includes(Number(LoanData["Ethinicity"])),
            },
            Number(LoanData["Ethinicity"]) === 1 && {
              type: 1,
              Title: `Select Hispanic Type`,
              Options: [
                { value: 1, text: "Mexican" },
                { value: 2, text: "Puerto Rican" },
                { value: 4, text: "Cuban" },
                { value: 8, text: "Other Hispanic or Latino" },
              ],
              isBitWise: true,
              resetBitWise: -1,
              ColumnName: "HispanicSubcategory",
              ColumnValue: Number(LoanData["HispanicSubcategory"]),
              isYellow: parseInt(LoanData["HispanicSubcategory"]) === 0,
            },
            (8 & Number(LoanData["HispanicSubcategory"])) === 8 &&
              Number(LoanData["Ethinicity"]) === 1 && {
                type: 5,
                Title: ``,
                label: "Other Hispanic Type Description",
                ColumnName: "OtherOrigin",
                ColumnValue: LoanData["OtherOrigin"],
                isValid: !LoanData["OtherOrigin"],
              },

            {
              type: 1,
              Title: `Race`,
              isYellow: parseInt(LoanData["Race"]) === 0,
            },
            {
              type: 1,
              Title: "",
              isBitWise: true,
              ColumnName: "Race",
              resetBitWise: 32,
              ColumnValue: LoanData["Race"],
              Options: [{ value: 1, text: "American Indian or Alaska Native" }],
            },
            (1 & Number(LoanData["Race"])) === 1 && {
              type: 5,
              Title: ``,
              label: "American Indian Type Description",
              ColumnName: "PrincipalTribe",
              ColumnValue: LoanData["PrincipalTribe"],
              isValid: !LoanData["PrincipalTribe"],
            },
            {
              type: 1,
              Title: "",
              isBitWise: true,
              resetBitWise: 32,
              ColumnName: "Race",
              ColumnValue: LoanData["Race"],
              Options: [
                { value: 2, text: "Native Hawaiian or Other pacific Islander" },
              ],
            },
            (2 & Number(LoanData["Race"])) === 2 && {
              type: 1,
              Title: "Select Native Hawaiian Type",
              isBitWise: true,
              resetBitWise: -1,
              ColumnName: "NaticHawaiSubCategory",
              ColumnValue: LoanData["NaticHawaiSubCategory"],
              Options: [
                { value: 1, text: "Native Hawaiian" },
                { value: 2, text: "Guamanian or Chamorro" },
                { value: 4, text: "Samoan" },
                { value: 8, text: "Other Pacific Islander" },
              ],
              isYellow: parseInt(LoanData["NaticHawaiSubCategory"]) == 0,
            },
            (8 & Number(LoanData["NaticHawaiSubCategory"])) === 8 &&
              (2 & Number(LoanData["Race"])) === 2 && {
                type: 5,
                Title: ``,
                label: "Other Pacific Islander Type Description",
                ColumnName: "OtherPacificIslandRace",
                ColumnValue: LoanData["OtherPacificIslandRace"],
                isValid: !LoanData["OtherPacificIslandRace"],
              },
            {
              type: 1,
              Title: "",
              isBitWise: true,
              resetBitWise: 32,
              ColumnName: "Race",
              ColumnValue: LoanData["Race"],
              Options: [{ value: 4, text: "Asian" }],
            },
            (4 & Number(LoanData["Race"])) === 4 && {
              type: 1,
              Title: "Select Asian Type",
              isBitWise: true,
              resetBitWise: -1,
              ColumnName: "AsianRaceSubCategory",
              ColumnValue: LoanData["AsianRaceSubCategory"],
              Options: [
                { value: 1, text: "Asian Indian" },
                { value: 2, text: "Chinese" },
                { value: 4, text: "Filipino" },
                { value: 8, text: "Japanese" },
                { value: 16, text: "Korean" },
                { value: 32, text: "Vietnamese" },
                { value: 64, text: "Other Asian" },
              ],
              isYellow: parseInt(LoanData["AsianRaceSubCategory"]) === 0,
            },
            (64 & Number(LoanData["AsianRaceSubCategory"])) === 64 &&
              (4 & Number(LoanData["Race"])) === 4 && {
                type: 5,
                Title: ``,
                label: "Other Asian Type Description",
                ColumnName: "OtherAsianRace",
                ColumnValue: LoanData["OtherAsianRace"],
                isValid: !LoanData["OtherAsianRace"],
              },
            {
              type: 1,
              Title: "",
              isBitWise: true,
              resetBitWise: 32,
              ColumnName: "Race",
              ColumnValue: LoanData["Race"],
              Options: [{ value: 8, text: "White" }],
            },
            {
              type: 1,
              Title: "",
              isBitWise: true,
              resetBitWise: 32,
              ColumnName: "Race",
              ColumnValue: LoanData["Race"],
              Options: [{ value: 16, text: "Black or African American" }],
            },
            LoanData["Demographic_Info"] !== 1 && {
              type: 1,
              Title: "",
              isBitWise: true,
              resetBitWise: 32,
              ColumnName: "Race",
              ColumnValue: LoanData["Race"],
              Options: [
                {
                  value: 32,
                  text: "I do not wish to provide this information",
                },
              ],
            },
          ],
        });

        arr.push({
          Title: (
            <CustomText
              bold={true}
              style={{
                fontSize: web ? 24 : 21,
                marginBottom: web ? 30 : 15,
                color: "#41464d",
              }}
            >
              VA Section for{" \n"}
              <CustomText bold={true} style={{ backgroundColor: "cyan" }}>
                {LoanData["FirstName"] || LoanData["LastName"]
                  ? `${LoanData["FirstName"] || ""} ${
                      LoanData["LastName"] || ""
                    }`
                  : `borrower`}
              </CustomText>
              {LoanData["FirstName"] || LoanData["LastName"] ? `.` : `?`}
            </CustomText>
          ),
          subFields: [
            ...[
              {
                type: 1,
                Title: "VA Military Status",
                Options: [
                  { value: 8, text: "None" },
                  { value: 1, text: "Regular Military" },
                  { value: 2, text: "Reserves or National Guard" },
                ],
                ColumnName: "Military_Status",
                ColumnValue: LoanData["Military_Status"],
                isYellow:
                  [1, 2, 8].indexOf(Number(LoanData["Military_Status"])) == -1,
              },
            ],
            ...(LoanData["Military_Status"] && LoanData["Military_Status"] !== 8
              ? [
                  {
                    type: 1,
                    widthOption: "40%",
                    Title: "In Reserves and Active",
                    Options: [
                      { value: 0, text: "No" },
                      { value: 1, text: "Yes" },
                    ],
                    ColumnName: "Reserves_Active",
                    ColumnValue: LoanData["Reserves_Active"],
                    isYellow:
                      [1, 0].indexOf(parseInt(LoanData["Reserves_Active"])) ==
                      -1,
                  },
                  {
                    type: 1,
                    Title: "Branch Of Service",
                    Options: [
                      { value: 1, text: "Army" },
                      { value: 2, text: "Navy" },
                      { value: 3, text: "Air Force" },
                      { value: 4, text: "Marine Corps" },
                      { value: 5, text: "Coast Gaurd" },
                      { value: 6, text: "Other" },
                    ],
                    ColumnName: "Branch_Service",
                    ColumnValue: LoanData["Branch_Service"],
                    isYellow:
                      [1, 2, 3, 4, 5, 6].indexOf(
                        Number(LoanData["Branch_Service"])
                      ) == -1,
                  },
                  {
                    type: 1,
                    Title: "Military Status",
                    Options: [
                      { value: 1, text: "Separated from Service" },
                      { value: 2, text: "In Service" },
                    ],
                    ColumnName: "SerMilitaryStatus",
                    ColumnValue: LoanData["SerMilitaryStatus"],
                    isYellow:
                      [1, 2].indexOf(Number(LoanData["SerMilitaryStatus"])) ==
                      -1,
                  },
                  {
                    type: 2,
                    Title: "",
                    label: "VA Entitlement Amount",
                    placeholder: "Amount",
                    isCurrency: true,
                    ColumnName: "VA_Entitlmt_Amt",
                    ColumnValue: LoanData["VA_Entitlmt_Amt"],
                    isValid: cleanValue(LoanData["VA_Entitlmt_Amt"]) == 0,
                    onBlur: () => {
                      setLoanData({
                        ...LoanData,
                        VA_Entitlmt_Amt: formatCurrency(
                          LoanData["VA_Entitlmt_Amt"],
                          2
                        ),
                      });
                    },
                  },
                  {
                    type: 2,
                    Title: "",
                    label: "VA Entitlement Amount Used",
                    placeholder: "Amount",
                    isCurrency: true,
                    ColumnName: "VA_Entitlmt_Amt_used",
                    ColumnValue: LoanData["VA_Entitlmt_Amt_used"],
                    isValid: cleanValue(LoanData["VA_Entitlmt_Amt_used"]) == 0,
                    onBlur: () => {
                      setLoanData({
                        ...LoanData,
                        VA_Entitlmt_Amt_used: formatCurrency(
                          LoanData["VA_Entitlmt_Amt_used"],
                          2
                        ),
                      });
                    },
                  },
                  {
                    type: 2,
                    Title: "",
                    label: "VA Entitlement Code",
                    placeholder: "VA Entitlement Code",
                    ColumnName: "VA_Entitlmt_Code",
                    ColumnValue: LoanData["VA_Entitlmt_Code"],
                    isValid: !LoanData["VA_Entitlmt_Code"],
                    keyboardType: "numeric",
                  },
                  {
                    type: 1,
                    widthOption: "40%",
                    Title: "VA Loan - First Time Use",
                    Options: [
                      { value: 0, text: "No" },
                      { value: 1, text: "Yes" },
                    ],
                    ColumnName: "VA_Loan_FTU",
                    ColumnValue: LoanData["VA_Loan_FTU"],
                    isYellow:
                      [0, 1].indexOf(parseInt(LoanData["VA_Loan_FTU"])) == -1,
                  },
                  {
                    type: 1,
                    widthOption: "40%",
                    Title: "Exempt From VA Funding Fee",
                    Options: [
                      { value: 0, text: "No" },
                      { value: 1, text: "Yes" },
                    ],
                    ColumnName: "VA_Funding_Fee",
                    ColumnValue: LoanData["VA_Funding_Fee"],
                    isYellow:
                      [0, 1].indexOf(parseInt(LoanData["VA_Funding_Fee"])) ==
                      -1,
                  },
                  {
                    type: 1,
                    widthOption: "40%",
                    Title:
                      "Currently serving on active duty with projected expiration date of service/tour",
                    Options: [
                      { value: 0, text: "No" },
                      { value: 1, text: "Yes" },
                    ],
                    ColumnName: "Currently_serving",
                    ColumnValue: LoanData["Currently_serving"],
                    isYellow:
                      [0, 1].indexOf(parseInt(LoanData["Currently_serving"])) ==
                      -1,
                  },
                  LoanData["Currently_serving"]
                    ? {
                        type: 2,
                        Title: "",
                        placeholder: "Date (MM/DD/YYYY)",
                        charLength: 10,
                        ColumnName: "Exp_date_service",
                        ColumnValue: LoanData["Exp_date_service"],
                        onBlur: () => {
                          setLoanData({
                            ...LoanData,
                            Exp_date_service: formatDateTimeNew(
                              LoanData["Exp_date_service"]
                            ),
                          });
                        },
                      }
                    : {},
                  {
                    type: 1,
                    widthOption: "40%",
                    Title:
                      "Currently retired, discharged, or separated from service",
                    Options: [
                      { value: 0, text: "No" },
                      { value: 1, text: "Yes" },
                    ],
                    ColumnName: "Currently_retired",
                    ColumnValue: LoanData["Currently_retired"],
                    isYellow:
                      [0, 1].indexOf(parseInt(LoanData["Currently_retired"])) ==
                      -1,
                  },
                  {
                    type: 1,
                    widthOption: "40%",
                    Title:
                      "Only period of service was as a non-activated member of the Reserve or National Guard",
                    Options: [
                      { value: 0, text: "No" },
                      { value: 1, text: "Yes" },
                    ],
                    ColumnName: "Active_National_Guard",
                    ColumnValue: LoanData["Active_National_Guard"],
                    isYellow:
                      [0, 1].indexOf(
                        parseInt(LoanData["Active_National_Guard"])
                      ) == -1,
                  },
                  {
                    type: 1,
                    widthOption: "40%",
                    Title: "Surviving spouse",
                    Options: [
                      { value: 0, text: "No" },
                      { value: 1, text: "Yes" },
                    ],
                    ColumnName: "Surviving_spouse",
                    ColumnValue: LoanData["Surviving_spouse"],
                    isYellow:
                      [0, 1].indexOf(parseInt(LoanData["Surviving_spouse"])) ==
                      -1,
                  },
                ]
              : []),
          ],
        });
        arr.push({
          Title: (
            <CustomText
              bold={true}
              style={{
                fontSize: web ? 24 : 21,
                marginBottom: web ? 30 : 15,
                color: "#41464d",
              }}
            >
              Have you attended a Homeownership Counseling Seminar within the
              last 12 Months? for{" \n"}
              <CustomText bold={true} style={{ backgroundColor: "cyan" }}>
                {LoanData["FirstName"] || LoanData["LastName"]
                  ? `${LoanData["FirstName"] || ""} ${
                      LoanData["LastName"] || ""
                    }`
                  : `borrower`}
              </CustomText>
              {LoanData["FirstName"] || LoanData["LastName"] ? `.` : `?`}
            </CustomText>
          ),
          subFields: [
            ...[
              {
                type: 1,
                Title: "",
                widthOption: "40%",
                Options: [
                  { value: 2, text: "No" },
                  { value: 1, text: "Yes" },
                ],
                ColumnName: "Couns_Confirm",
                ColumnValue: LoanData["Couns_Confirm"],
              },
            ],
            ...(LoanData["Couns_Confirm"] === 1
              ? [
                  {
                    type: 2,
                    Title: "",
                    label: "Counseling Completed Date",
                    placeholder: "MM/DD/YYYY",
                    charLength: 10,
                    ColumnName: "Couns_Comp_Date",
                    ColumnValue: LoanData["Couns_Comp_Date"],
                    isValid: !LoanData["Couns_Comp_Date"],
                    onBlur: () => {
                      setLoanData({
                        ...LoanData,
                        Couns_Comp_Date: formatDateTimeNew(
                          LoanData["Couns_Comp_Date"]
                        ),
                      });
                    },
                  },
                  {
                    type: 1,
                    Title: "Counseling Type",
                    Options: [
                      { value: 1, text: "Counseling" },
                      { value: 2, text: "Education" },
                    ],
                    ColumnName: "Couns_Type",
                    ColumnValue: LoanData["Couns_Type"],
                    isYellow: [2, 1].indexOf(LoanData["Couns_Type"]) == -1,
                  },
                  LoanData["Couns_Type"] == 1
                    ? {
                        type: 3,
                        isMap: true,
                        label: "What format was the counseling?",
                        Option: [
                          { value: 0, label: "Select" },
                          { value: 1, label: "Face-to-Face" },
                          { value: 2, label: "Telephone" },
                          { value: 3, label: "Internet" },
                          { value: 4, label: "Hybrid" },
                        ],
                        ColumnName: "Couns_FormatType2",
                        ColumnValue: LoanData["Couns_FormatType2"],
                        isYellow: !LoanData["Couns_FormatType2"],
                      }
                    : LoanData["Couns_Type"] == 2
                    ? {
                        type: 3,
                        isMap: true,
                        label: "What format was the counseling?",
                        Option: [
                          { value: 0, label: "Select" },
                          { value: 1, label: "Attended Workshop in Person" },
                          { value: 2, label: "Completed Web-Based Workshop" },
                        ],
                        ColumnName: "Couns_FormatType",
                        ColumnValue: LoanData["Couns_FormatType"],
                        isYellow: !LoanData["Couns_FormatType"],
                      }
                    : false,

                  {
                    type: 2,
                    Title: "",
                    label: "Counseling Agency Name",
                    placeholder: "Agency Name",
                    ColumnName: "Couns_Agency_Name",
                    ColumnValue: LoanData["Couns_Agency_Name"],
                    isValid: !LoanData["Couns_Agency_Name"],
                  },
                  {
                    type: 3,
                    isMap: true,
                    label: "Home Counseling Language",
                    Option: [
                      { value: 1, label: "English" },
                      { value: 2, label: "Spanish" },
                      { value: 3, label: "Chinese" },
                      { value: 4, label: "Vietnamese" },
                      { value: 5, label: "Korean" },
                      { value: 6, label: "Tagalog" },
                      { value: 7, label: "Other" },
                    ],
                    ColumnName: "LanguagePreference",
                    ColumnValue:
                      Number(LoanData["LanguagePreference"] || 0) || 0,
                    isYellow: !LoanData["LanguagePreference"],
                  },
                  LoanData["LanguagePreference"] == 7 && {
                    type: 2,
                    Title: "",
                    label: "Other Language Description",
                    placeholder: "Other Language",
                    ColumnName: "OtherLanguageDescription",
                    ColumnValue: LoanData["OtherLanguageDescription"],
                    isValid: !LoanData["OtherLanguageDescription"],
                  },
                ]
              : []),
          ].filter((ele) => typeof ele !== "boolean"),
        });

        additionalBorrowerInfo.slice(1).forEach((borrower, index) => {
          let sBorr = [];
          sBorr.push({
            Title: "",
            onChangeText: (name, value) => {
              if (value == borrower[name]) value = null;
              handleUpdateAddtionalBorrower(index, name, value);
            },
            index: index + 1,
            isAddtionalDeclaration: true,
            subFields: [
              {
                type: 1,
                Title: (
                  <CustomText
                    bold={true}
                    style={{
                      fontSize: web ? 24 : 21,
                      marginBottom: web ? 30 : 15,
                      color: "#41464d",
                    }}
                  >
                    Declarations for{" \n"}
                    <CustomText bold={true} style={{ backgroundColor: "cyan" }}>
                      {borrower["FirstName"] || borrower["LastName"]
                        ? `${borrower["FirstName"] || ""} ${
                            borrower["LastName"] || ""
                          }`
                        : `borrower`}
                    </CustomText>
                    {borrower["FirstName"] || borrower["LastName"] ? `.` : `?`}
                  </CustomText>
                ),
                Options: [{ value: 1, text: "Default Selections" }],
                ColumnName: "DefaultSelection",
                ColumnValue: borrower["DefaultSelection"],
                onPress: () => {
                  let additionalBorrowerInfo_ = additionalBorrowerInfo;
                  additionalBorrowerInfo_[index + 1] = {
                    ...additionalBorrowerInfo_[index + 1],
                    ...{
                      Citizenship_Status: 1,
                      OccupyProperty: 1,
                      "Owe Property": 0,
                      "Type Prop Own": 0,
                      "Hold Title": 0,
                      BusinessaffWithSeller: 0,
                      LoanOnAnotherProp: 0,
                      MoneyBorrowedForDown: "$0.00",
                      Downpayment: 0,
                      ApplyingNewCredit: 0,
                      PropAssCleanEnergy: 0,
                      "Co-maker": 0,
                      Jugdements: 0,
                      Delinquent: 0,
                      Lawsuit: 0,
                      ConveyedTitle: 0,
                      Obligated: 0,
                      Forclosed: 0,
                      Bankruptcy: 0,
                      blChapter7: 0,
                      blChapter11: 0,
                      blChapter12: 0,
                      blChapter13: 0,
                      bType1stBuyer: 0,
                    },
                  };
                  setAdditionalBorrowerInfo([
                    ...[],
                    ...additionalBorrowerInfo_,
                  ]);
                },
              },
              {
                type: 1,
                Title: `Specify Citizenship Status`,
                Options: [
                  { value: 1, text: "U.S. Citizen" },
                  { value: 2, text: "Permanent Resident Alien" },
                  { value: 3, text: "Non Permanant Resident Alien" },
                ],
                ColumnName: "Citizenship_Status",
                ColumnValue: parseInt(borrower["Citizenship_Status"]),
                isYellow:
                  [1, 2, 3].indexOf(
                    parseInt(borrower["Citizenship_Status"])
                  ) === -1,
              },
              {
                type: 1,
                widthOption: "40%",
                Title: `A. Will you occupy the property as your primary residence?`,
                Options: [
                  { value: 0, text: "No" },
                  { value: 1, text: "Yes" },
                ],
                ColumnName: "OccupyProperty",
                ColumnValue: parseInt(borrower["OccupyProperty"]),
                isYellow:
                  [0, 1].indexOf(parseInt(borrower["OccupyProperty"])) === -1,
              },
              {
                type: 1,
                widthOption: "40%",
                Title: `If YES, have you had an ownership interest in another property in the last three years?`,
                Options: [
                  { value: 0, text: "No" },
                  { value: 1, text: "Yes" },
                ],
                ColumnName: "Owe Property",
                ColumnValue: parseInt(borrower["Owe Property"]),
                isYellow:
                  [0, 1].indexOf(parseInt(borrower["Owe Property"])) === -1,
              },
              parseInt(borrower["Owe Property"]) === 1 && {
                type: 1,
                Title: `If YES, complete (1) and (2) below:`,
                isYellow:
                  [1, 2, 3].indexOf(parseInt(borrower["Type Prop Own"])) === -1,
              },
              parseInt(borrower["Owe Property"]) === 1 && {
                type: 1,
                Title: `(1) What type of property did you own: primary residence (PR), FHA secondary residence (SR), second home (SH), or investment property (IP)?`,
                Options: [
                  { value: 1, text: "Primary Residence" },
                  { value: 2, text: "2nd Home" },
                  { value: 3, text: "Investment Property" },
                ],
                ColumnName: "Type Prop Own",
                ColumnValue: parseInt(borrower["Type Prop Own"]),
                isYellow:
                  [1, 2, 3].indexOf(parseInt(borrower["Type Prop Own"])) === -1,
              },
              parseInt(borrower["Owe Property"]) === 1 && {
                type: 1,
                Title: `(2) How did you hold title to the property: by yourself (S), jointly with your spouse (SP), or jointly with another person (O)?`,
                Options: [
                  { value: 1, text: "Self" },
                  { value: 2, text: "Joint with spouse" },
                  { value: 3, text: "Joint with other" },
                ],
                ColumnName: "Hold Title",
                ColumnValue: parseInt(borrower["Hold Title"]),
                isYellow:
                  [1, 2, 3].indexOf(parseInt(borrower["Hold Title"])) === -1,
              },

              {
                type: 1,
                widthOption: "40%",
                Title: `B. If this is a Purchase Transaction: Do you have a family relationship or business affiliation with the seller of the property?`,
                Options: [
                  { value: 0, text: "No" },
                  { value: 1, text: "Yes" },
                ],
                ColumnName: "BusinessaffWithSeller",
                ColumnValue: parseInt(borrower["BusinessaffWithSeller"]),
                isYellow:
                  [0, 1].indexOf(
                    parseInt(borrower["BusinessaffWithSeller"])
                  ) === -1,
              },
              {
                type: 1,
                widthOption: "40%",
                Title: `C. Are you borrowing any money for this real estate transaction (e.g., money for your closing costs or down payment) or obtaining any money from another party, such as the seller or realtor, that you have not disclosed on this loan application?`,
                Options: [
                  { value: 0, text: "No" },
                  { value: 1, text: "Yes" },
                ],
                ColumnName: "LoanOnAnotherProp",
                ColumnValue: parseInt(borrower["LoanOnAnotherProp"]),
                isYellow:
                  [0, 1].indexOf(parseInt(borrower["LoanOnAnotherProp"])) ===
                  -1,
              },
              parseInt(borrower["LoanOnAnotherProp"]) === 1 && {
                type: 2,
                label: "Amount",
                isCurrency: true,
                Title: `If YES, what is the amount of this money?`,
                ColumnName: "MoneyBorrowedForDown",
                ColumnValue: borrower["MoneyBorrowedForDown"],
                isValid: cleanValue(borrower["MoneyBorrowedForDown"]) == 0,
                onBlur: (iValue) => {
                  handleUpdateAddtionalBorrower(
                    index,
                    "MoneyBorrowedForDown",
                    formatCurrency(
                      iValue || borrower["MoneyBorrowedForDown"],
                      2
                    )
                  );
                },
              },
              {
                type: 1,
                widthOption: "40%",
                Title: `D. 1. Have you or will you be applying for a mortgage loan on another property (not the property securing this loan) on or before closing this transaction that is not disclosed on this loan application?`,
                Options: [
                  { value: 0, text: "No" },
                  { value: 1, text: "Yes" },
                ],
                ColumnName: "Downpayment",
                ColumnValue: parseInt(borrower["Downpayment"]),
                isYellow:
                  [0, 1].indexOf(parseInt(borrower["Downpayment"])) === -1,
              },
              {
                type: 1,
                widthOption: "40%",
                Title: `D. 2.Have you or will you be applying for any new credit (e.g., installment loan, credit card, etc.) on or before closing this loan that is not disclosed on this application?`,
                Options: [
                  { value: 0, text: "No" },
                  { value: 1, text: "Yes" },
                ],
                ColumnName: "ApplyingNewCredit",
                ColumnValue: parseInt(borrower["ApplyingNewCredit"]),
                isYellow:
                  [0, 1].indexOf(parseInt(borrower["ApplyingNewCredit"])) ===
                  -1,
              },
              {
                type: 1,
                widthOption: "40%",
                Title: `E. Will this property be subject to a lien that could take priority over the first mortgage lien, such as a clean energy lien paid through your property taxes (e.g., the Property Assessed Clean Energy Program)?`,
                Options: [
                  { value: 0, text: "No" },
                  { value: 1, text: "Yes" },
                ],
                ColumnName: "PropAssCleanEnergy",
                ColumnValue: parseInt(borrower["PropAssCleanEnergy"]),
                isYellow:
                  [0, 1].indexOf(parseInt(borrower["PropAssCleanEnergy"])) ===
                  -1,
              },
              {
                type: 1,
                widthOption: "40%",
                Title: `F. Are you a Co_signer or guarantor on any debt or loan that is not disclosed on this application?`,
                Options: [
                  { value: 0, text: "No" },
                  { value: 1, text: "Yes" },
                ],
                ColumnName: "Co-maker",
                ColumnValue: parseInt(borrower["Co-maker"]),
                isYellow: [0, 1].indexOf(parseInt(borrower["Co-maker"])) === -1,
              },
              {
                type: 1,
                widthOption: "40%",
                Title: `G. Are there any outstanding judgments against you?`,
                Options: [
                  { value: 0, text: "No" },
                  { value: 1, text: "Yes" },
                ],
                ColumnName: "Jugdements",
                ColumnValue: parseInt(borrower["Jugdements"]),
                isYellow:
                  [0, 1].indexOf(parseInt(borrower["Jugdements"])) === -1,
              },
              {
                type: 1,
                widthOption: "40%",
                Title: `H. Are you currently delinquent or in default on a Federal debt?`,
                Options: [
                  { value: 0, text: "No" },
                  { value: 1, text: "Yes" },
                ],
                ColumnName: "Delinquent",
                ColumnValue: parseInt(borrower["Delinquent"]),
                isYellow:
                  [0, 1].indexOf(parseInt(borrower["Delinquent"])) === -1,
              },
              {
                type: 1,
                widthOption: "40%",
                Title: `I. Are you a party to a lawsuit in which you potentially have any personal financial liability?`,
                Options: [
                  { value: 0, text: "No" },
                  { value: 1, text: "Yes" },
                ],
                ColumnName: "Lawsuit",
                ColumnValue: parseInt(borrower["Lawsuit"]),
                isYellow: [0, 1].indexOf(parseInt(borrower["Lawsuit"])) === -1,
              },
              {
                type: 1,
                widthOption: "40%",
                Title: `J. Have you conveyed title to any property in lieu of foreclosure in the past 7 years?`,
                Options: [
                  { value: 0, text: "No" },
                  { value: 1, text: "Yes" },
                ],
                ColumnName: "ConveyedTitle",
                ColumnValue: parseInt(borrower["ConveyedTitle"]),
                isYellow:
                  [0, 1].indexOf(parseInt(borrower["ConveyedTitle"])) === -1,
              },
              {
                type: 1,
                widthOption: "40%",
                Title: `K. Within the past 7 years, have you completed a pre-foreclosure sale or short sale, whereby the property was sold to a third party and the Lender agreed to accept less than the outstanding mortgage balance due?`,
                Options: [
                  { value: 0, text: "No" },
                  { value: 1, text: "Yes" },
                ],
                ColumnName: "Obligated",
                ColumnValue: parseInt(borrower["Obligated"]),
                isYellow:
                  [0, 1].indexOf(parseInt(borrower["Obligated"])) === -1,
              },
              {
                type: 1,
                widthOption: "40%",
                Title: `L. Have you had property foreclosed upon in the last 7 years?`,
                Options: [
                  { value: 0, text: "No" },
                  { value: 1, text: "Yes" },
                ],
                ColumnName: "Forclosed",
                ColumnValue: parseInt(borrower["Forclosed"]),
                isYellow:
                  [0, 1].indexOf(parseInt(borrower["Forclosed"])) === -1,
              },
              {
                type: 1,
                widthOption: "40%",
                Title: `M. Have you declared bankruptcy within the past 7 years?`,
                Options: [
                  { value: 0, text: "No" },
                  { value: 1, text: "Yes" },
                ],
                ColumnName: "Bankruptcy",
                ColumnValue: parseInt(borrower["Bankruptcy"]),
                isYellow:
                  [0, 1].indexOf(parseInt(borrower["Bankruptcy"])) === -1,
              },
              parseInt(borrower["Bankruptcy"]) === 1 && {
                type: 1,
                Title: `If YES, identify the type(s) of bankruptcy:`,
                Options: [
                  { value: 1, text: "Chapter 7" },
                  { value: 2, text: "Chapter 11" },
                  { value: 3, text: "Chapter 12" },
                  { value: 4, text: "Chapter 13" },
                ],
                ColumnName: "Chapter",
                ColumnValue:
                  parseInt(borrower["blChapter7"]) === 1
                    ? 1
                    : parseInt(borrower["blChapter11"]) === 1
                    ? 2
                    : parseInt(borrower["blChapter12"]) === 1
                    ? 3
                    : parseInt(borrower["blChapter13"]) === 1
                    ? 4
                    : null,
                isYellow:
                  parseInt(borrower["blChapter7"]) !== 1 &&
                  parseInt(borrower["blChapter11"]) !== 1 &&
                  parseInt(borrower["blChapter12"]) !== 1 &&
                  parseInt(borrower["blChapter13"]) !== 1,
              },
              {
                type: 1,
                widthOption: "40%",
                Title: `Are you a First Time Home Buyer?`,
                Options: [
                  { value: 0, text: "No" },
                  { value: 1, text: "Yes" },
                ],
                ColumnName: "bType1stBuyer",
                ColumnValue: parseInt(borrower["bType1stBuyer"]),
                isYellow:
                  [0, 1].indexOf(parseInt(borrower["bType1stBuyer"])) === -1,
              },
            ],
          });
          arr.push(...sBorr);
          sBorr = [];
          sBorr.push({
            Title: (
              <CustomText
                bold={true}
                style={{
                  fontSize: web ? 24 : 21,
                  marginBottom: web ? 30 : 15,
                  color: "#41464d",
                }}
              >
                Demographic Information for{" \n"}
                <CustomText bold={true} style={{ backgroundColor: "cyan" }}>
                  {borrower["FirstName"] || borrower["LastName"]
                    ? `${borrower["FirstName"] || ""} ${
                        borrower["LastName"] || ""
                      }`
                    : `borrower`}
                </CustomText>
                {borrower["FirstName"] || borrower["LastName"] ? `.` : `?`}
              </CustomText>
            ),
            onChangeText: (name, value) => {
              handleUpdateAddtionalBorrower(index, name, value);
            },
            index: index + 1,
            isAddtionalDemographic: true,
            subFields: [
              {
                type: 1,
                Title: "Application was taken by",
                Options: [
                  { value: 1, text: "Face-to-face (including video)" },
                  { value: 2, text: "Mail or Fax" },
                  { value: 3, text: "Telephone" },
                  { value: 4, text: " Internet or Email" },
                ],
                ColumnName: "Demographic_Info",
                ColumnValue: borrower["Demographic_Info"],
                isYellow:
                  [1, 2, 3, 4].indexOf(Number(borrower["Demographic_Info"])) ==
                  -1,
              },
              {
                type: 1,
                Title: `Sex`,
                isBitWise: true,
                resetBitWise: 4,
                Options: [
                  { value: 1, text: "Male" },
                  { value: 2, text: "Female" },
                  {
                    value: 4,
                    text: "I do not wish to provide this information",
                  },
                ],
                ColumnName: "Sex",
                ColumnValue: Number(borrower["Sex"]),
                isYellow: Number(borrower["Sex"] || 0) === 0,
              },
              {
                type: 1,
                Title: `Ethinicity`,
                Options: [
                  { value: 1, text: "Hispanic or Latino" },
                  { value: 2, text: "Not Hispanic nor Latino" },
                  {
                    value: 3,
                    text: "I do not wish to provide this information",
                  },
                ],
                ColumnName: "Ethnicity",
                ColumnValue: Number(borrower["Ethnicity"]) || 0,
                isYellow: ![1, 2, 3].includes(Number(borrower["Ethnicity"])),
              },
              Number(borrower["Ethnicity"]) === 1 && {
                type: 1,
                Title: `Select Hispanic Type`,
                Options: [
                  { value: 1, text: "Mexican" },
                  { value: 2, text: "Puerto Rican" },
                  { value: 4, text: "Cuban" },
                  { value: 8, text: "Other Hispanic or Latino" },
                ],
                isBitWise: true,
                resetBitWise: -1,
                ColumnName: "HispanicSubcategory",
                ColumnValue: Number(borrower["HispanicSubcategory"]),
                isYellow: parseInt(borrower["HispanicSubcategory"]) === 0,
              },
              (8 & Number(borrower["HispanicSubcategory"])) === 8 &&
                Number(borrower["Ethnicity"]) === 1 && {
                  type: 5,
                  Title: ``,
                  label: "Other Hispanic Type Description",
                  ColumnName: "OtherOrigin",
                  ColumnValue: borrower["OtherOrigin"],
                  isValid: !borrower["OtherOrigin"],
                  onBlur: (iValue) => {
                    handleUpdateAddtionalBorrower(index, "OtherOrigin", iValue);
                  },
                },

              {
                type: 1,
                Title: `Race`,
                isYellow:
                  parseInt(borrower["RaceIndian"] || 0) != 1 &&
                  parseInt(borrower["RaceHawaiian"] || 0) != 1 &&
                  parseInt(borrower["RaceAsian"] || 0) != 1 &&
                  parseInt(borrower["RaceWhite"] || 0) != 1 &&
                  parseInt(borrower["RaceBlack"] || 0) != 1 &&
                  parseInt(borrower["Race"] || 0) != 1 &&
                  parseInt(borrower["RaceBlack"] || 0) != 1,
              },
              {
                type: 1,
                Title: "",
                ColumnName: "RaceIndian",
                ColumnValue: borrower["RaceIndian"],
                Options: [
                  { value: 1, text: "American Indian or Alaska Native" },
                ],
              },
              Number(borrower["RaceIndian"]) === 1 && {
                type: 5,
                Title: ``,
                label: "American Indian Type Description",
                ColumnName: "PrincipalTribe",
                ColumnValue: borrower["PrincipalTribe"],
                isValid: !borrower["PrincipalTribe"],
                onBlur: (iValue) => {
                  handleUpdateAddtionalBorrower(
                    index,
                    "PrincipalTribe",
                    iValue
                  );
                },
              },
              {
                type: 1,
                Title: "",
                ColumnName: "RaceHawaiian",
                ColumnValue: borrower["RaceHawaiian"],
                Options: [
                  {
                    value: 1,
                    text: "Native Hawaiian or Other pacific Islander",
                  },
                ],
              },
              Number(borrower["RaceHawaiian"]) === 1 && {
                type: 1,
                Title: "Select Native Hawaiian Type",
                isBitWise: true,
                resetBitWise: -1,
                ColumnName: "NaticHawaiSubCategory",
                ColumnValue: borrower["NaticHawaiSubCategory"],
                Options: [
                  { value: 1, text: "Native Hawaiian" },
                  { value: 2, text: "Guamanian or Chamorro" },
                  { value: 4, text: "Samoan" },
                  { value: 8, text: "Other Pacific Islander" },
                ],

                isYellow: parseInt(borrower["NaticHawaiSubCategory"]) === 0,
              },
              (8 & Number(borrower["NaticHawaiSubCategory"])) === 8 &&
                borrower["RaceHawaiian"] === 1 && {
                  type: 5,
                  Title: ``,
                  label: "Other Pacific Islander Type Description",
                  ColumnName: "OtherPacificIslandRace",
                  ColumnValue: borrower["OtherPacificIslandRace"],
                  isValid: !borrower["OtherPacificIslandRace"],
                  onBlur: (iValue) => {
                    handleUpdateAddtionalBorrower(
                      index,
                      "OtherPacificIslandRace",
                      iValue
                    );
                  },
                },
              {
                type: 1,
                Title: "",
                ColumnName: "RaceAsian",
                ColumnValue: borrower["RaceAsian"],
                Options: [{ value: 1, text: "Asian" }],
              },
              Number(borrower["RaceAsian"]) === 1 && {
                type: 1,
                Title: "Select Asian Type",
                isBitWise: true,
                resetBitWise: -1,
                ColumnName: "AsianRaceSubCategory",
                ColumnValue: borrower["AsianRaceSubCategory"],
                Options: [
                  { value: 1, text: "Asian Indian" },
                  { value: 2, text: "Chinese" },
                  { value: 4, text: "Filipino" },
                  { value: 8, text: "Japanese" },
                  { value: 16, text: "Korean" },
                  { value: 32, text: "Vietnamese" },
                  { value: 64, text: "Other Asian" },
                ],
                isYellow: parseInt(borrower["AsianRaceSubCategory"]) === 0,
              },
              (64 & Number(borrower["AsianRaceSubCategory"])) === 64 &&
                Number(borrower["RaceAsian"]) === 1 && {
                  type: 5,
                  Title: ``,
                  label: "Other Asian Type Description",
                  ColumnName: "OtherAsianRace",
                  ColumnValue: borrower["OtherAsianRace"],
                  isValid: !borrower["OtherAsianRace"],
                  onBlur: (iValue) => {
                    handleUpdateAddtionalBorrower(
                      index,
                      "OtherAsianRace",
                      iValue
                    );
                  },
                },
              {
                type: 1,
                Title: "",
                ColumnName: "RaceWhite",
                ColumnValue: borrower["RaceWhite"],
                Options: [{ value: 1, text: "White" }],
              },
              {
                type: 1,
                Title: "",
                ColumnName: "RaceBlack",
                ColumnValue: borrower["RaceBlack"],
                Options: [{ value: 1, text: "Black or African American" }],
              },
              {
                type: 1,
                Title: "",
                ColumnName: "Race",
                ColumnValue: borrower["Race"],
                Options: [
                  {
                    value: 1,
                    text: "I do not wish to provide this information",
                  },
                ],
              },
            ].filter((ele) => typeof ele !== "boolean"),
          });
          arr.push(...sBorr);
          sBorr = [];
          sBorr.push({
            isVAMilitary: true,
            index: index + 1,
            onChangeText: (name, value) => {
              handleUpdateAddtionalBorrower(index, name, value);
            },
            Title: (
              <CustomText
                bold={true}
                style={{
                  fontSize: web ? 24 : 21,
                  marginBottom: web ? 30 : 15,
                  color: "#41464d",
                }}
              >
                VA Section for{" \n"}
                <CustomText bold={true} style={{ backgroundColor: "cyan" }}>
                  {borrower["FirstName"] || borrower["LastName"]
                    ? `${borrower["FirstName"] || ""} ${
                        borrower["LastName"] || ""
                      }`
                    : `borrower`}
                </CustomText>
                {borrower["FirstName"] || borrower["LastName"] ? `.` : `?`}
              </CustomText>
            ),

            subFields: [
              ...[
                {
                  type: 1,
                  Title: "VA Military Status",
                  Options: [
                    { value: 8, text: "None" },
                    { value: 1, text: "Regular Military" },
                    { value: 2, text: "Reserves or National Guard" },
                  ],
                  ColumnName: "VA_Military_Status",
                  ColumnValue: parseInt(borrower["VA_Military_Status"]),
                  isYellow:
                    [1, 2, 8].indexOf(Number(borrower["VA_Military_Status"])) ==
                    -1,
                },
              ],
              ...(borrower["VA_Military_Status"] &&
              parseInt(borrower["VA_Military_Status"]) !== 8
                ? [
                    {
                      type: 1,
                      widthOption: "40%",
                      Title: "In Reserves and Active",
                      Options: [
                        { value: 0, text: "No" },
                        { value: 1, text: "Yes" },
                      ],
                      ColumnName: "Reserves_Active",
                      ColumnValue: borrower["Reserves_Active"],
                      isYellow:
                        [1, 0].indexOf(parseInt(borrower["Reserves_Active"])) ==
                        -1,
                    },
                    {
                      type: 1,
                      Title: "Branch Of Service",
                      Options: [
                        { value: 1, text: "Army" },
                        { value: 2, text: "Navy" },
                        { value: 3, text: "Air Force" },
                        { value: 4, text: "Marine Corps" },
                        { value: 5, text: "Coast Gaurd" },
                        { value: 6, text: "Other" },
                      ],
                      ColumnName: "Branch_Service",
                      ColumnValue: borrower["Branch_Service"],
                      isYellow:
                        [1, 2, 3, 4, 5, 6].indexOf(
                          Number(borrower["Branch_Service"])
                        ) == -1,
                    },
                    {
                      type: 1,
                      Title: "Military Status",
                      Options: [
                        { value: 1, text: "Separated from Service" },
                        { value: 2, text: "In Service" },
                      ],
                      ColumnName: "VAMilitaryServiceStatus",
                      ColumnValue: borrower["VAMilitaryServiceStatus"],
                      isYellow:
                        [1, 2].indexOf(
                          Number(borrower["VAMilitaryServiceStatus"])
                        ) == -1,
                    },
                    {
                      type: 2,
                      Title: "",
                      label: "VA Entitlement Amount",
                      placeholder: "Amount",
                      isCurrency: true,
                      ColumnName: "VA_Entitlmt_Amt",
                      ColumnValue: borrower["VA_Entitlmt_Amt"],
                      isValid: cleanValue(borrower["VA_Entitlmt_Amt"]) == 0,
                      onBlur: (value) => {
                        handleUpdateAddtionalBorrower(
                          index,
                          "VA_Entitlmt_Amt",
                          formatCurrency(value, 2)
                        );
                      },
                    },
                    {
                      type: 2,
                      Title: "",
                      label: "VA Entitlement Amount Used",
                      placeholder: "Amount",
                      isCurrency: true,
                      ColumnName: "VA_Entitlmt_Amt_used",
                      ColumnValue: borrower["VA_Entitlmt_Amt_used"],
                      isValid:
                        cleanValue(borrower["VA_Entitlmt_Amt_used"]) == 0,
                      onBlur: (value) => {
                        handleUpdateAddtionalBorrower(
                          index,
                          "VA_Entitlmt_Amt_used",
                          formatCurrency(value, 2)
                        );
                      },
                    },
                    {
                      type: 2,
                      Title: "",
                      label: "VA Entitlement Code",
                      placeholder: "Code",
                      ColumnName: "VA_Entitlmt_Code",
                      ColumnValue: borrower["VA_Entitlmt_Code"],
                      isValid: !borrower["VA_Entitlmt_Code"],
                      keyboardType: "numeric",
                      onBlur: (value) => {
                        handleUpdateAddtionalBorrower(
                          index,
                          "VA_Entitlmt_Code",
                          value
                        );
                      },
                    },
                    {
                      type: 1,
                      widthOption: "40%",
                      Title: "VA Loan - First Time Use",
                      Options: [
                        { value: 0, text: "No" },
                        { value: 1, text: "Yes" },
                      ],
                      ColumnName: "VA_Loan_FTU",
                      ColumnValue: borrower["VA_Loan_FTU"],
                      isYellow:
                        [0, 1].indexOf(parseInt(borrower["VA_Loan_FTU"])) == -1,
                    },
                    {
                      type: 1,
                      widthOption: "40%",
                      Title: "Exempt From VA Funding Fee",
                      Options: [
                        { value: 0, text: "No" },
                        { value: 1, text: "Yes" },
                      ],
                      ColumnName: "VA_Funding_Fee",
                      ColumnValue: borrower["VA_Funding_Fee"],
                      isYellow:
                        [0, 1].indexOf(parseInt(borrower["VA_Funding_Fee"])) ==
                        -1,
                    },
                    {
                      type: 1,
                      widthOption: "40%",
                      Title:
                        "Currently serving on active duty with projected expiration date of service/tour",

                      Options: [
                        { value: 0, text: "No" },
                        { value: 1, text: "Yes" },
                      ],
                      ColumnName: "Currently_serving",
                      ColumnValue: borrower["Currently_serving"],
                      isYellow:
                        [0, 1].indexOf(
                          parseInt(borrower["Currently_serving"])
                        ) == -1,
                    },
                    parseInt(borrower["Currently_serving"]) == 1
                      ? {
                          type: 2,
                          Title: "",
                          placeholder: "Date (MM/DD/YYYY)",
                          charLength: 10,
                          ColumnName: "MilitaryServiceExpectedCompletionDate",
                          ColumnValue:
                            borrower["MilitaryServiceExpectedCompletionDate"],
                          onBlur: (value) => {
                            handleUpdateAddtionalBorrower(
                              index,
                              "MilitaryServiceExpectedCompletionDate",
                              formatDateTimeNew(value)
                            );
                          },
                        }
                      : {},

                    {
                      type: 1,
                      widthOption: "40%",
                      Title:
                        "Currently retired, discharged, or separated from service",
                      Options: [
                        { value: 0, text: "No" },
                        { value: 1, text: "Yes" },
                      ],
                      ColumnName: "Currently_retired",
                      ColumnValue: borrower["Currently_retired"],
                      isYellow:
                        [0, 1].indexOf(
                          parseInt(borrower["Currently_retired"])
                        ) == -1,
                    },
                    {
                      type: 1,
                      widthOption: "40%",
                      Title:
                        "Only period of service was as a non-activated member of the Reserve or National Guard",
                      Options: [
                        { value: 0, text: "No" },
                        { value: 1, text: "Yes" },
                      ],
                      ColumnName: "Active_National_Guard",
                      ColumnValue: borrower["Active_National_Guard"],
                      isYellow:
                        [0, 1].indexOf(
                          parseInt(borrower["Active_National_Guard"])
                        ) == -1,
                    },
                    {
                      type: 1,
                      widthOption: "40%",
                      Title: "Surviving spouse",
                      Options: [
                        { value: 0, text: "No" },
                        { value: 1, text: "Yes" },
                      ],
                      ColumnName: "Surviving_spouse",
                      ColumnValue: borrower["Surviving_spouse"],
                      isYellow:
                        [0, 1].indexOf(
                          parseInt(borrower["Surviving_spouse"])
                        ) == -1,
                    },
                  ]
                : []),
            ],
          });
          arr.push(...sBorr);
          sBorr = [];
          let Counselling = additionalCounsellingInfo[index + 1];

          sBorr.push({
            index: index + 1,
            isAddCounselling: true,
            onChangeText: (name, value) => {
              let additionalCounsellingInfo_ = additionalCounsellingInfo;
              if (!additionalCounsellingInfo_[index + 1]) {
                additionalCounsellingInfo_.push({
                  Couns_Confirm: null,
                  Couns_Comp_Date: null,
                  Couns_Type: null,
                  Couns_Agency_Name: null,
                  LanguagePreference: null,
                  OtherLanguageDescription: null,
                });
              }
              // if (additionalCounsellingInfo_[index + 1][name] == value)
              //   value = null;

              additionalCounsellingInfo_[index + 1][name] = value;

              setAdditionalCounsellingInfo([...additionalCounsellingInfo_]);

              //handleUpdateAddtionalBorrower(index + 1, name, value);
            },
            Title: (
              <CustomText
                bold={true}
                style={{
                  fontSize: web ? 24 : 21,
                  marginBottom: web ? 30 : 15,
                  color: "#41464d",
                }}
              >
                Have you attended a Homeownership Counseling Seminar within the
                last 12 Months? for{" \n"}
                <CustomText bold={true} style={{ backgroundColor: "cyan" }}>
                  {additionalBorrowerInfo[index + 1]["FirstName"] ||
                  additionalBorrowerInfo[index + 1]["LastName"]
                    ? `${
                        additionalBorrowerInfo[index + 1]["FirstName"] || ""
                      } ${additionalBorrowerInfo[index + 1]["LastName"] || ""}`
                    : `borrower`}
                </CustomText>
                {additionalBorrowerInfo[index + 1]["FirstName"] ||
                additionalBorrowerInfo[index + 1]["LastName"]
                  ? `.`
                  : `?`}
              </CustomText>
            ),
            subFields: [
              ...[
                {
                  type: 1,
                  Title: "",
                  widthOption: "40%",
                  Options: [
                    { value: 2, text: "No" },
                    { value: 1, text: "Yes" },
                  ],
                  ColumnName: "Couns_Confirm",
                  ColumnValue: Counselling?.Couns_Confirm,
                },
              ],
              ...(Counselling?.Couns_Confirm === 1
                ? [
                    {
                      type: 2,
                      Title: "",
                      label: "Counseling Completed Date",
                      placeholder: "Date",
                      ColumnName: "Couns_Comp_Date",
                      ColumnValue: Counselling?.Couns_Comp_Date,
                      isValid: !Counselling?.Couns_Comp_Date,
                      onBlur: () => {
                        let additionalCounsellingInfo_ =
                          additionalCounsellingInfo;
                        additionalCounsellingInfo_[index + 1][
                          "Couns_Comp_Date"
                        ] = formatDateTimeNew(
                          additionalCounsellingInfo[index + 1][
                            "Couns_Comp_Date"
                          ]
                        );
                        setAdditionalCounsellingInfo([
                          ...[],
                          ...additionalCounsellingInfo_,
                        ]);
                      },
                    },
                    {
                      type: 1,
                      Title: "Counseling Type",
                      Options: [
                        { value: 1, text: "Counseling" },
                        { value: 2, text: "Education" },
                      ],
                      ColumnName: "Couns_Type",
                      ColumnValue: Counselling?.Couns_Type,
                      isYellow:
                        [2, 1].indexOf(parseInt(Counselling?.Couns_Type)) == -1,
                    },
                    Counselling?.Couns_Type == 1
                      ? {
                          type: 3,
                          isMap: true,
                          label: "What format was the counseling?",
                          Option: [
                            { value: 0, label: "Select" },
                            { value: 1, label: "Face-to-Face" },
                            { value: 2, label: "Telephone" },
                            { value: 3, label: "Internet" },
                            { value: 4, label: "Hybrid" },
                          ],
                          ColumnName: "Couns_FormatType2",
                          ColumnValue: Counselling["Couns_FormatType2"],
                          isYellow: !Counselling["Couns_FormatType2"],
                        }
                      : Counselling?.Couns_Type == 2
                      ? {
                          type: 3,
                          isMap: true,
                          label: "What format was the counseling?",
                          Option: [
                            { value: 0, label: "Select" },
                            { value: 1, label: "Attended Workshop in Person" },
                            { value: 2, label: "Completed Web-Based Workshop" },
                          ],
                          ColumnName: "Couns_FormatType",
                          ColumnValue: Counselling["Couns_FormatType"],
                          isYellow: !Counselling["Couns_FormatType"],
                        }
                      : false,
                    {
                      type: 2,
                      Title: "",
                      label: "Counseling Agency Name",
                      placeholder: "Agency Name",
                      ColumnName: "Couns_Agency_Name",
                      ColumnValue: Counselling?.Couns_Agency_Name,
                      isValid: !Counselling?.Couns_Agency_Name,
                    },
                    {
                      type: 3,
                      isMap: true,
                      label: "Home Counseling Language",
                      Option: [
                        { value: 1, label: "English" },
                        { value: 2, label: "Spanish" },
                        { value: 3, label: "Chinese" },
                        { value: 4, label: "Vietnamese" },
                        { value: 5, label: "Korean" },
                        { value: 6, label: "Tagalog" },
                        { value: 7, label: "Other" },
                      ],
                      ColumnName: "LanguagePreference",
                      ColumnValue: Counselling?.LanguagePreference,
                      isYellow: !Counselling?.LanguagePreference,
                    },
                    Counselling?.LanguagePreference == 7 && {
                      type: 2,
                      Title: "",
                      label: "Other Language Description",
                      placeholder: "Other Language",
                      ColumnName: "OtherLanguageDescription",
                      ColumnValue: Counselling?.OtherLanguageDescription,
                      isValid: !Counselling?.OtherLanguageDescription,
                    },
                  ]
                : []),
            ].filter((ele) => typeof ele !== "boolean"),
          });
          arr.push(...sBorr);
        });
      }
    }
    // console.log(arr);
    return {
      iDetailsArr: arr,
    };
  };
  const handleAddAddtionalProperty = (Id) => {
    let OwnerIdList = additionalBorrowerInfo[0]["CustId"] || UserId;

    let addProp = [
      ...additionalPropertyInfo,
      ...[
        {
          Id: Id,
          CustId: UserId || 0,
          Real_est_prop_Addrs: "",
          Real_est_ZipCode: "",
          Real_est_City: "",
          Real_est_State: "",
          Presnt_Markt_Val: 0,
          Real_est_Subj_Prop: 0,
          Current_residence: 0,
          PropertyType: "",
          Months_Ownd_Prop: "",
          Real_est_Prop_Status: null,
          OwnerIdList,
        },
      ],
    ];
    return addProp;
  };
  const handleAddAddtionalBank = (AssetId) => {
    let OwnerIdList = additionalBorrowerInfo[0]["CustId"] || UserId;

    let addBank = [
      ...additionalBankInfo,
      ...[
        {
          Id: AssetId,
          AccType: 1,
          CustId: 0,
          BankName: "",
          Amount: "$0.00",
          OwnerIdList,
          AssetId: AssetId,
          isNewRecord: true,
          AccTypeName: "Checking",
        },
      ],
    ];
    return addBank;
  };
  const handleUpdateAddtionalPropertyInfo = (index, name, value) => {
    let additionalPropertyInfo_ = additionalPropertyInfo;
    if (name == "OwnerIdList" && !value) {
      value = UserId;
    }
    additionalPropertyInfo_[index][name] = value;
    setAdditionalPropertyInfo([...[], ...additionalPropertyInfo_]);
  };
  const handleUpdateAddtionalBank = (index, name, value) => {
    let additionalBankInfo_ = additionalBankInfo;
    if (name === "OtherAccType" && [4, 12, 33, 22].includes(Number(value))) {
      additionalBankInfo_[index]["Description"] =
        additionalBankInfo_[index]["TypeDesc"] ||
        otherAccountTypeOption.filter(
          ({ value: iValue }) => value == iValue
        )[0]["label"];
    }

    if (name == "OwnerIdList" && !value) {
      value = UserId;
    }

    if (name === "EarnestMoneyPaidTo" && value == "-1####-1") {
      setDrawerDetails({
        isShow: true,
        bankIndex: index,
        body: "addOtherLoanVendor",
        onClose: () => {
          setDrawerDetails({
            isShow: false,
            body: <></>,
            onClose: () => {},
          });
        },
      });
    }

    if (name === "AccType") {
      let AccTypeName = accountTypeOption.filter((type) => type.value == value),
        iAdditionalBankInfo = additionalBankInfo_[index];
      iAdditionalBankInfo = {
        ...iAdditionalBankInfo,
        ...{
          [name]: value,
          AccTypeName: value ? AccTypeName[0]["label"] : "",
        },
      };
      if (iAdditionalBankInfo["isNewRecord"]) {
        iAdditionalBankInfo = {
          ...iAdditionalBankInfo,
          ...{
            OwnerIdList: additionalBorrowerInfo[0]["CustId"],
          },
        };
      }
      additionalBankInfo_[index] = iAdditionalBankInfo;
    } else additionalBankInfo_[index][name] = value;
    setAdditionalBankInfo([...[], ...additionalBankInfo_]);
  };

  const handleUpdateAddtionalEmployment = (index, name, value) => {
    let additionalEmploymentInfo_ = additionalEmploymentInfo;
    additionalEmploymentInfo_[index][name] = value;
    const Id = additionalEmploymentInfo[index]["Id"];
    additionalEmploymentInfo_ = handleEmploymentOrder(
      [...[], ...additionalEmploymentInfo_],
      null,
      name === "CustId"
    );

    setAdditionalEmploymentInfo(additionalEmploymentInfo_);
    if (name === "CustId") {
      let list = handleGetEmpploymentList(additionalEmploymentInfo_),
        subPage = 0;
      list.forEach((item, index) => {
        item["subMenu"]?.forEach((iItem, iIndex) => {
          subPage++;
          if (iItem?.Id == Id) {
            setPageIndex({
              ...pageIndex,
              subPage: subPage,
            });
          }
        });
      });
    }
  };
  const handleUpdateAddtionalOtherIncome = (index, name, value) => {
    let additionalOtherIncomeInfo_ = additionalOtherIncomeInfo;
    additionalOtherIncomeInfo_[index][name] = value;
    setAdditionalOtherIncomeInfo([...[], ...additionalOtherIncomeInfo_]);
  };
  const handleAddAditionalIncomeType = async (flag) => {
    await handleSaveAdditionalInfo(-2, -2, -1, true, [], null, flag);
  };
  const handleGetCreditScoreDetails = async (LoanId, iErrFlag) => {
    return await handleAPI({
      name: "GetCreditInfoForNewLoanApp",
      params: {
        CustId: UserId,
        LoanId: loanId || LoanId,
        SessionId: SessionId,
      },
    })
      .then((response) => {
        response = response.split("~");
        let status = -1,
          isAlready = -1,
          Details = [],
          ErrMsg = "";

        if (response[0] != "" && response[0] != null)
          status = JSON.parse(response[0]);
        if (response[1] != "" && response[1] != null)
          isAlready = JSON.parse(response[1]);

        if (response[2] != "" && response[2] != null)
          Details = JSON.parse(response[2]);
        if (response[3] != "" && response[3] != null && iErrFlag)
          ErrMsg = response[3];

        return { Status: status, isAlready, Details, ErrMsg };
      })
      .catch((e) => console.error("Error From GetCreditScoreDetails ====>", e));
  };
  const handleGetCreditScoreDetailsPooling = async (poolCount) => {
    if (poolCount <= 10) {
      poolCount++;
      await getCreditDetails(loanId, poolCount);
    }
  };
  const handleOrderCreditReport = async () => {
    setTimeout(() => {
      setProcessStatus("orderPlaced");
    }, 2000);
    return await handleAPI({
      name: "OrderCreditReport",
      params: { CustId: UserId, LoanId: loanId, SessionId: SessionId },
    })
      .then((response) => {
        handleGetCreditScoreDetailsPooling(1);
        handleUpdateCompletedPage();

        handleLogDWCallToActionEventParent(
          "Credit Report",
          "fnLogDWCallToActionEvent",
          "Borrower Loan Application",
          {
            SessionId,
            LoanId: loanId || iLoanId || 0,
            Email:
              additionalBorrowerInfo.length > 0
                ? additionalBorrowerInfo[0]["Email"] || ""
                : LoanData["EmailId"] || "",
            LoanOfficerId: web
              ? queryStringToObject(window.location?.href || "")[
                  "loanOfficerId"
                ] ||
                contextDetails.RecentLoId ||
                0
              : contextDetails.RecentLoId || 0,
            Email: contextDetails["Email"],
          },
          activePageArray[pageIndex["page"]]?.replaceAll(" ", "")
        );
        return response;
      })
      .catch((e) => console.error("Error From OrderCreditReport ====>", e));
  };
  const handleLoanOfficerCredit = async (iLoanId) => {
    return await handleAPI({
      name: "CheckLnOfficerForCreditReport",
      params: { LoanId: iLoanId || loanId },
    })
      .then((response) => {
        return response;
      })
      .catch((e) =>
        console.error("Error From CheckLnOfficerForCreditReport ====>", e)
      );
  };
  const handleGetMonthCount = (month, year) => {
    return Number(year || 0) * 12 + Number(month || 0);
  };
  const handleGetBorrYearMonth = (value = 0, base) => {
    try {
      let Num = value || "",
        years = Num.toString().split(".").slice(0, 2)[0],
        months = Num.toString().split(".").slice(0, 2)[1];
      if (months == "" || months == undefined) {
        months = 0;
      } else {
        //  Year and Months calculation on 21-Nov-2018 Modified by AB
        if (
          // months == "08" ||
          months == "16" ||
          months == "25" ||
          months == "33" ||
          months == "41" ||
          months == "58" ||
          months == "66" ||
          months == "75" ||
          months == "83" ||
          months == "91"
        ) {
          months = Math.ceil(("0." + months) * 12);
        } else if (months == "05") months = 6;
      }

      return base === "Years" ? years : base === "Months" ? months : 0;
    } catch (error) {
      return 0;
    }
  };
  const handleAddAditionalIncome = () => {
    let addIncome = [
      ...additionalOtherIncomeInfo,
      ...[
        {
          Id: 0,
          CustId: additionalBorrowerInfo?.[0]?.["CustId"] || UserId,
          Payor_Name: "",
          Source_Other_Incm: 0,
          Monthly_Amount: "$0.00",
        },
      ],
    ];
    return addIncome;
  };
  const handleAddAditionalBorrower = () => {
    let addBorr = [
      ...additionalBorrowerInfo,
      ...[
        {
          Id: 0,
          CustId: 0,
          FirstName: "",
          LastName: "",
          MiddleName: "",
          NickName: "",
          Suffix: "",
          Dependents: 0,
          Ages_Dependents: "",
          BirthDate: "",
          SSN: "",
          Sex: "",
          "Bor For Add1": "",
          BorForZip2: "",
          BorForCity2: "",
          BorForState2: "",
          "Bor For Add1 Yrs": 0,
          "Bor For Add1 Own": "",
          "Bor For Add2": "",
          "Bor For Add2 Own": "",
          BorForZip3: "",
          BorForCity3: "",
          BorForState3: "",
          "Bor For Add2 Yrs": 0,
          "Bor For Add3": "",
          "Bor For Add3 Own": "",
          BorForZip4: "",
          BorForCity4: "",
          BorForState4: "",
          "Bor For Add3 Yrs": 0,
          MaritalStatus: 1,
          CellPhone: "",
          Email: "",
          VA_Entitlmt_Amt: "$0.00",
          VA_Entitlmt_Amt_used: "$0.00",
          VA_Entitlmt_Code: 0,
          Branch_Service: 0,
          OtherAsianRace: "",
          Bankruptcy: "",
          blChapter7: "0",
          blChapter11: "0",
          blChapter12: "0",
          blChapter13: "0",
          Citizenship_Status: "1",
          Pri_residence: "0",
          bTypeNonPerResAlien: "0",
          OccupyProperty: "",
          "Owe Property": "",
          "Type Prop Own": "",
          "Hold Title": "",
          BusinessaffWithSeller: "",
          Downpayment: "",
          MoneyBorrowedForDown: "$0.00",
          LoanOnAnotherProp: "",
          ApplyingNewCredit: "",
          PropAssCleanEnergy: "",
          "Co-maker": "",
          Jugdements: "",
          Delinquent: "",
          Lawsuit: "",
          ConveyedTitle: "",
          Obligated: "",
          Forclosed: "",
          Address1: "",
          City: "",
          Zip: "",
          State: "",
          "Bor Own Period": 0,
          FlagSameAsAbove: 1,
          "Bor Own": "",
          "Present Rent": "$0.00",
          Ethnicity: 0,
          RaceIndian: 0,
          RaceAsian: 0,
          RaceBlack: 0,
          RaceHawaiian: 0,
          RaceWhite: 0,
          Demographic_Info: 4,
          HispanicSubcategory: 0,
          MilitaryServiceExpectedCompletionDate: "",
          Couns_Confirm: 0,
          Couns_FormatType: 0,
          Couns_FormatType2: 0,
          Couns_Comp_Date: "",
          Couns_Type: 0,
          Couns_Agency_Name: "",
          LanguagePreference: "",
          OtherLanguageDescription: "",
          Bor_For_Add1_Own: "",
          Bor_For_Add2_Own: "",
          Bor_For_Add3_Own: "",
          "Present Rent1": "$0.00",
          "Present Rent2": "$0.00",
          "Present Rent3": "$0.00",
        },
      ],
    ];
    return addBorr;
    // setAdditionalBorrowerInfo(addBorr);
  };
  const handleCopyPriAddress = (index, name, value) => {
    let additionalBorrowerInfo_ = additionalBorrowerInfo,
      { MaritalStatus } = additionalBorrowerInfo_[index + 1],
      { CustId = 0, MaritalStatus: spouseMaritalStatus } =
        additionalBorrowerInfo_.filter(
          ({ CustId }) => CustId == MaritalStatus
        )[0] || {},
      isCopyFormprimary =
        (spouseMaritalStatus > CustId && index == 0) ||
        spouseMaritalStatus < CustId ||
        CustId < 10;

    if (value !== 0 && isCopyFormprimary) {
      let {
        Current_Street_Address,
        Addrshistry_ZipCode,
        Addrshistry_City,
        Addrshistry_State,
        Addrshistry_Years,
        Addrshistry_Months,
        Monthly_Rent,
        Own,
        Rent,
        Living_Rent_Free,
        PrevCurrent_Street_Address1,
        PrevCurrent_Street_Address2,
        PrevCurrent_Street_Address3,
        Addrshistry_ZipCode1,
        Addrshistry_ZipCode2,
        Addrshistry_ZipCode3,
        Addrshistry_City1,
        Addrshistry_City2,
        Addrshistry_City3,
        Addrshistry_State1,
        Addrshistry_State2,
        Addrshistry_State3,
        Addrshistry_Years1,
        Addrshistry_Years2,
        Addrshistry_Years3,
        Addrshistry_Months1,
        Addrshistry_Months2,
        Addrshistry_Months3,
        Monthly_Rent1,
        Monthly_Rent2,
        Monthly_Rent3,
        Own1,
        Own2,
        Own3,
        Rent1,
        Rent2,
        Rent3,
        Living_Rent_Free1,
        Living_Rent_Free2,
        Living_Rent_Free3,
      } = LoanData;
      additionalBorrowerInfo_[index + 1] = {
        ...additionalBorrowerInfo_[index + 1],
        ...{
          Address1: Current_Street_Address,
          Zip: Addrshistry_ZipCode,
          City: Addrshistry_City,
          State: Addrshistry_State,
          "Bor Own Period": `${parseInt(Addrshistry_Years) || 0}.${
            parseInt(Addrshistry_Months) || 0
          }`,
          "Present Rent": Monthly_Rent,
          "Bor Own": Own ? "O" : Rent ? "R" : Living_Rent_Free ? "L" : "",
          [`Bor For Add1`]: PrevCurrent_Street_Address1,
          [`BorForZip2`]: Addrshistry_ZipCode1,
          [`BorForCity2`]: Addrshistry_City1,
          [`BorForState2`]: Addrshistry_State1,
          [`Bor For Add1 Yrs`]: `${parseInt(Addrshistry_Years1) || 0}.${
            parseInt(Addrshistry_Months1) || 0
          }`,
          "Present Rent1": Monthly_Rent1,
          "Bor For Add1 Own": Own1
            ? "O"
            : Rent1
            ? "R"
            : Living_Rent_Free1
            ? "L"
            : "",
          [`Bor For Add2`]: PrevCurrent_Street_Address2,
          [`BorForZip3`]: Addrshistry_ZipCode2,
          [`BorForCity3`]: Addrshistry_City2,
          [`BorForState3}`]: Addrshistry_State2,
          [`Bor For Add2 Yrs`]: `${parseInt(Addrshistry_Years2) || 0}.${
            parseInt(Addrshistry_Months2) || 0
          }`,
          "Present Rent2": Monthly_Rent2,
          "Bor For Add2 Own": Own2
            ? "O"
            : Rent2
            ? "R"
            : Living_Rent_Free2
            ? "L"
            : "",
          [`Bor For Add3`]: PrevCurrent_Street_Address3,
          [`BorForZip4`]: Addrshistry_ZipCode3,
          [`BorForCity4`]: Addrshistry_City3,
          [`BorForState4`]: Addrshistry_State3,
          [`Bor For Add3 Yrs`]: `${parseInt(Addrshistry_Years3) || 0}.${
            parseInt(Addrshistry_Months3) || 0
          }`,
          "Present Rent3": Monthly_Rent3,
          "Bor For Add3 Own": Own3
            ? "O"
            : Rent3
            ? "R"
            : Living_Rent_Free3
            ? "L"
            : "",
        },
      };
    } else if (!isCopyFormprimary) {
      const {
        Address1,
        Zip,
        City,
        State,
        "Bor Own Period": borOwnPeriod,
        "Present Rent": presentRent,
        "Bor Own": borOwn,
        "Bor For Add1": borForAdd1,
        BorForZip2: borForZip2,
        BorForCity2: borForCity2,
        BorForState2: borForState2,
        "Bor For Add1 Yrs": borForAdd1Yrs,
        "Present Rent1": presentRent1,
        "Bor For Add1 Own": borForAdd1Own,
        "Bor For Add2": borForAdd2,
        BorForZip3: borForZip3,
        BorForCity3: borForCity3,
        BorForState3: borForState3,
        "Bor For Add2 Yrs": borForAdd2Yrs,
        "Present Rent2": presentRent2,
        "Bor For Add2 Own": borForAdd2Own,
        "Bor For Add3": borForAdd3,
        BorForZip4: borForZip4,
        BorForCity4: borForCity4,
        BorForState4: borForState4,
        "Bor For Add3 Yrs": borForAdd3Yrs,
        "Present Rent3": presentRent3,
        "Bor For Add3 Own": borForAdd3Own,
      } = additionalBorrowerInfo_[index];
      additionalBorrowerInfo_[index + 1] = {
        ...additionalBorrowerInfo_[index + 1],
        ...{
          Address1,
          Zip,
          City,
          State,
          "Bor Own Period": borOwnPeriod,
          "Present Rent": presentRent,
          "Bor Own": borOwn,
          "Bor For Add1": borForAdd1,
          BorForZip2: borForZip2,
          BorForCity2: borForCity2,
          BorForState2: borForState2,
          "Bor For Add1 Yrs": borForAdd1Yrs,
          "Present Rent1": presentRent1,
          "Bor For Add1 Own": borForAdd1Own,
          "Bor For Add2": borForAdd2,
          BorForZip3: borForZip3,
          BorForCity3: borForCity3,
          BorForState3: borForState3,
          "Bor For Add2 Yrs": borForAdd2Yrs,
          "Present Rent2": presentRent2,
          "Bor For Add2 Own": borForAdd2Own,
          "Bor For Add3": borForAdd3,
          BorForZip4: borForZip4,
          BorForCity4: borForCity4,
          BorForState4: borForState4,
          "Bor For Add3 Yrs": borForAdd3Yrs,
          "Present Rent3": presentRent3,
          "Bor For Add3 Own": borForAdd3Own,
        },
      };
    }
    // setAdditionalBorrowerInfo([...[], ...additionalBorrowerInfo_]);
    // handleUpdateAddtionalBorrower(index, name, value, additionalBorrowerInfo);
    handleOptionPress(value, null, null, name);
  };
  const handleSaveSSnDetails = ({
    LoanData: iLoanData,
    additionalBorrowerInfo: iAdditionalBorrowerInfo,
  }) => {
    const json = [
      {
        ColumnName: "SSN",
        ColumnValue: iLoanData["SSN"],
      },
    ];
    handleSaveLoanInformation(json);

    if (iAdditionalBorrowerInfo.length > 0) {
      iAdditionalBorrowerInfo.slice(1).forEach((borr) => {
        handleSaveAdditionalInfo(-1, 16, null, null, {
          SSN: borr["SSN"] || "",
          CustId: borr["CustId"],
        });
      });
    }
  };
  const handleUpdateAddtionalBorrower = (
    index,
    name,
    value,
    iAdditionalBorrowerInfo,
    label,
    iExp,
    prevAddIndex
  ) => {
    let additionalBorrowerInfo_ =
      iAdditionalBorrowerInfo || additionalBorrowerInfo;
    console.log({
      additionalBorrowerInfo: additionalBorrowerInfo_,
    });
    if (name === "Own or Rent") {
      additionalBorrowerInfo_[index + 1] = {
        ...additionalBorrowerInfo_[index + 1],
        [prevAddIndex ? `Bor For Add${prevAddIndex} Own` : "Bor Own"]:
          value === 1 ? "O" : value === 2 ? "R" : value === 3 ? "L" : "",
      };
    } else if (
      name === "Bor Own Period" ||
      (name.indexOf("Bor For Add") > -1 && name.indexOf("Yrs") > -1)
    ) {
      let val = (additionalBorrowerInfo_[index + 1][name] || "")
        .toString()
        .split(".")
        .slice(0, 2);
      if (val.length === 1) val.push("0");
      label === "Months" ? (val[1] = value) : (val[0] = value);
      value = val.join(".");
      additionalBorrowerInfo_[index + 1][name] = value;
    } else if (iExp) {
      if (label === "Months" || label === "Years") {
        let val = additionalBorrowerInfo_[index + 1][name]
          .toString()
          .split(".")
          .slice(0, 2);
        if (val.length === 1) val.push("0");
        label === "Months" ? (val[1] = value) : (val[0] = value);
        value = val.join(".");
      }
      additionalBorrowerInfo_[index + 1][name] = value;
    } else if (name === "CellPhone") {
      value = `*5*${value}`;
      additionalBorrowerInfo_[index + 1][name] = value;
    } else if (name === "Chapter") {
      additionalBorrowerInfo_[index + 1]["blChapter7"] = value === 1 ? 1 : 0;
      additionalBorrowerInfo_[index + 1]["blChapter11"] = value === 2 ? 1 : 0;
      additionalBorrowerInfo_[index + 1]["blChapter12"] = value === 3 ? 1 : 0;
      additionalBorrowerInfo_[index + 1]["blChapter13"] = value === 4 ? 1 : 0;
    } else if (
      currentPage === pageArray[pageId["government"]] &&
      !DetailsArr.slice(1)[pageIndex["subPage"]]["VA_Military_Status"] !== false
    ) {
      let obj = DetailsArr.slice(1)[pageIndex["subPage"]]["subFields"].filter(
        (field) => {
          return field["ColumnName"] === name;
        }
      );
      if (obj.length === 1) obj = obj[0];
      else {
        obj = obj.filter((obj_) => obj_["Options"][0]["value"] === value)[0];
      }
      if (!obj) obj = {};
      if (obj["ColumnValue"]?.toString() === "NaN") obj["ColumnValue"] = null;
      if (!obj["resetBitWise"]) obj["resetBitWise"] = -1;
      let val = parseInt(additionalBorrowerInfo_[index + 1][name]) || 0;
      if (obj["isBitWise"] && obj["resetBitWise"] !== value) {
        if ((value & val) === value) value = val - value;
        else value = val + value;
        if ((obj["resetBitWise"] & val) === obj["resetBitWise"])
          value = value - obj["resetBitWise"];
      } else if (obj["resetBitWise"] == value && (value & val) === value) {
        value = val - value;
      } else if (value === additionalBorrowerInfo_[index + 1][name])
        value = null;

      additionalBorrowerInfo_[index + 1][name] = value;
    } else {
      additionalBorrowerInfo_[index + 1][name] = value;
    }

    if (name === "MaritalStatus") {
      handleMaritalStatusChange({
        changedId: Number(value),
        iAdditionalBorrowerInfo: additionalBorrowerInfo_,
        custId: additionalBorrowerInfo_[index + 1]["CustId"],
        index: index + 1,
      });
    }

    setAdditionalBorrowerInfo([...[], ...additionalBorrowerInfo_]);
  };
  const handleSaveRequiredFields = (josn, callBack = () => {}) => {
    handleSaveLoanInformation(josn, loanId, false, callBack);
  };
  const handleSaveSubjectProperty = (callBack = () => {}) => {
    let {
      ssn,
      firstname,
      lastname,
      PhoneNumber,
      subjectAddress: subjectaddress,
      subjectCity: subjectcity,
      subjectState: subjectstate,
      subjectZip: subjectzip,
      SSN,
    } = LoanData;

    const strjson = `{"contactinfo":[{"ssn":"${
      SSN || ssn
    }","firstname":"${firstname}","lastname":"${lastname}","PhoneNumber":"${PhoneNumber}","subjectaddress":"${subjectaddress}","subjectzip":"${subjectzip}","subjectcity":"${subjectcity}","subjectstate":"${subjectstate}","SessionId":"${SessionId}","loanid":"${loanId}"}]}`;

    handleAPI({
      name: "savecontactdetails",
      params: { JsonInput: JSON.stringify(strjson) },
    })
      .then((response) => {
        callBack();
      })
      .catch((e) => console.error("Error Form savecontactdetails ====>", e));
  };
  const handleUpdateAddtionalCounsellingInfo = ({
    iLanguagePreference,
    index,
  }) => {
    setAdditionalCounsellingInfo((prevAdditionalCounsellingInfo) => {
      prevAdditionalCounsellingInfo[index]["LanguagePreference"] =
        iLanguagePreference;
      return [...prevAdditionalCounsellingInfo];
    });
  };
  const getOtherAccountDesc = (AccType) => {
    const otherAccount = otherAccountTypeOption.filter(
      ({ value }) => value == AccType
    );
    return otherAccount["length"] ? otherAccount[0]["label"] : "";
  };
  const handleSaveAdditionalInfo = async (
    index,
    flag,
    iCustId,
    isAdd,
    inputJSON_,
    isPrimarySave,
    AddValue,
    iAdditionalBorrowerInfo,
    isSaveMaritalStatus = true
  ) => {
    let InputJSON = {},
      CustId_;
    if (index !== -1 && flag === 11) {
      let {
        FirstName,
        NickName,
        MiddleName,
        LastName,
        Suffix,
        Dependents,
        BirthDate,
        Ages_Dependents,
        MaritalStatus,
        CustId,
        Email,
        CellPhone,
        SpouseCustID = MaritalStatus > 10 ? MaritalStatus : 0,
      } = (iAdditionalBorrowerInfo || additionalBorrowerInfo)[index + 1];
      if (CellPhone)
        CellPhone = `*5*${CellPhone.toString().replaceAll("*5*", "")}`;

      InputJSON = {
        FirstName,
        NickName: NickName?.toString().trim(),
        MiddleName,
        LastName,
        Suffix,
        Dependents,
        BirthDate,
        Ages_Dependents,
        MaritalStatus,
        CustId,
        EmailId: Email,
        CellPhone,
        SpouseCustID,
      };

      if (!iAdditionalBorrowerInfo) {
        handleDuplicateEmail(Email, index + 1);

        if (LoanData["isMaritalStatusChanged"] && isSaveMaritalStatus) {
          setLoanData((prevLoanData) => {
            return {
              ...prevLoanData,
              isMaritalStatusChanged: false,
            };
          });
          handleSaveLoanInformation(
            [
              {
                ColumnName: "MaritalStatus",
                ColumnValue: LoanData["MaritalStatus"],
              },
            ],
            false
          );
        }
      }
      if (FirstName == "" && LastName == "") {
        setTimeout(() => {
          let addBorr = additionalBorrowerInfo.filter(
            (e, index_) => index + 1 !== index_
          );

          if (addBorr.length === 1) {
            setLoanData({
              ...LoanData,
              ...{
                Spouse_AddBorrower: 0,
                iSpouse_AddBorrower: 0,
              },
            });
            handleSaveLoanInformation([
              {
                ColumnName: "Spouse_AddBorrower",
                ColumnValue: 0,
              },
            ]);
          }

          handleUpdateAddtionalBorrower(index, "isRemove", false);
          setAdditionalBorrowerInfo([...addBorr]);

          setPageIndex((prevPageIndex) => ({
            ...prevPageIndex,
            subPage:
              Number(prevPageIndex["subPage"]) -
              (Number(prevPageIndex["Page"]) == 1 ? 0 : 1),
          }));

          handleSaveAdditionalInfo(
            -1,
            5,
            additionalBorrowerInfo[index + 1]["CustId"]
          );
          setScrollToTop(true);
        }, 500);

        return;
      }
      if (index !== -1 && flag === 11) {
        InputJSON = [InputJSON];
      }
      CustId_ = CustId;
    } else if (index !== -1 && flag === 12) {
      let { Address1, Zip, City, State, CustId } =
        additionalBorrowerInfo[index + 1];
      InputJSON = inputJSON_ || {
        Address1,
        Zip,
        City,
        State,
        CustId,
        BorOwnPeriod: additionalBorrowerInfo[index + 1]["Bor Own Period"],
        BorOwn: additionalBorrowerInfo[index + 1]["Bor Own"] || 0,
        PresentRent: additionalBorrowerInfo[index + 1]["Present Rent"],
      };
      CustId_ = CustId;
    }
    InputJSON.CustId = CustId_ || iCustId || 0;

    if (
      flag === 1 ||
      flag === 2 ||
      flag === 3 ||
      flag === 4 ||
      flag === 10 ||
      flag === 13 ||
      flag === 14 ||
      flag === 15 ||
      flag === 16 ||
      flag === 17 ||
      flag === 18 ||
      flag === 19
    ) {
      InputJSON = inputJSON_;
    }
    log("SaveAdditionalInfo", InputJSON, flag);
    // return;
    if (LoanData["LockLoanApp"] != 1) {
      try {
        handleAPI({
          name: "SaveAdditionalInfo",
          params: {
            CustId:
              CustId_ ||
              iCustId ||
              InputJSON?.CustId ||
              inputJSON_?.CustId ||
              0,
            LoanId: loanId,
            InputJSON: JSON.stringify(InputJSON || {}),
            flag: flag,
            SessionId: SessionId,
          },
        })
          .then(async (CustId) => {
            try {
              let columnName = null,
                ColumnValue = 0;
              if (flag === -2 && isAdd) {
                let addIncome = handleAddAditionalIncome();
                addIncome[addIncome.length - 1]["Id"] = parseInt(CustId);
                setAdditionalOtherIncomeInfo([...[], ...addIncome]);
                columnName = "blOtherIncome";

                setScrollToTop(true);
              } else if (iCustId === -3 && isAdd) {
                let addBank = handleAddAddtionalBank(CustId);
                setAdditionalBankInfo([...[], ...addBank]);
                columnName = "blAssetOption";

                if (isAdd === "pointLast") {
                  let subPage = addBank.length - 1;
                  handleCheckNextPage({
                    subPage: subPage < 0 ? 0 : subPage,
                    page: pageId["bankAccounts"],
                  });
                }
              } else if (flag === -4 && iCustId === -2 && isAdd) {
                let addProp = handleAddAddtionalProperty(CustId);
                setAdditionalPropertyInfo([...[], ...addProp]);
                columnName = "Real_est_prop";
              } else if (iCustId === -4 && isAdd) {
                let addEmp_ = handleAddAditionalEmployment();

                addEmp_[addEmp_.length - 1]["Id"] = CustId;
                addEmp_[addEmp_.length - 1]["CustId"] =
                  AddValue || additionalBorrowerInfo[0]["CustId"];

                setAdditionalEmploymentInfo(handleEmploymentOrder(addEmp_));
                if (additionalEmploymentInfo.length == 0) {
                  let { page, subPage } = pageIndex;
                  subPage = subPage + 1;
                  let page_ = { subPage: subPage, page: page };
                  setPageIndex({ ...page_ });
                }

                setScrollToTop(true);
              } else if ((flag === 0 && index === -1) || isAdd) {
                let addBorr_ = handleAddAditionalBorrower();

                addBorr_[addBorr_.length - 1]["CustId"] = CustId;
                if (LoanData["iSpouse_AddBorrower"] == 1) {
                  if (addBorr_.length == 2) {
                    setLoanData((prevLoanData) => {
                      return {
                        ...prevLoanData,
                        MaritalStatus: addBorr_[1]["CustId"],
                        isMaritalStatusChanged: true,
                      };
                    });
                    addBorr_[1]["MaritalStatus"] =
                      addBorr_[0]["CustId"] || LoanData["UserId"];
                  } else {
                    addBorr_[addBorr_.length - 1]["MaritalStatus"] = 1;
                  }
                }
                setProcessStatus("");

                setAdditionalBorrowerInfo(addBorr_);
                columnName = "iSpouse_AddBorrower";
                // const iLeftNavStatus = (await GetLeftNavStatus(loanId)) || [];
                // setLeftNavStatus(iLeftNavStatus);
                // handleUpdateCompletedPage(iLeftNavStatus);
              } else if (flag === 11) {
                getCreditDetails(loanId);
                handleGetLeftNavStatus();
              }
              columnName &&
                setLoanData((prevLoanData) => {
                  return { ...prevLoanData, [columnName]: ColumnValue };
                });
            } catch (error) {
              console.error("Error form ==>", error);
            }
          })
          .catch((e) =>
            console.error("Error From SaveAdditionalInfo ====>", e)
          );
      } catch (error) {
        console.error("Error From SaveAdditionalInfo ====>", error);
      }
    }
  };
  const handleAddAditionalEmployment = () => {
    let arr =
        DetailsArr[pageIndex["subPage"] + 1]["subFields"]?.filter(
          (arr) => arr["ColumnName"] === "iCustId"
        ) || [],
      iUserId = arr.length > 0 ? arr[0]["ColumnValue"] : UserId;

    let addEmp = [
      ...additionalEmploymentInfo,
      ...[
        {
          Id: 0,
          CustId: iUserId || UserId,
          Empmt_Emp_Name: "",
          Emp_Strt_Addrs: "",
          Emp_City: "",
          Emp_ZipCode: "",
          Emp_State: "0",
          Emp_phone: "",
          HR_Contact_Person: "",
          HR_Phone: "",
          Job_Title: "",
          Employed_From: "",
          Employed_To: "",
          Monthly_Base_Pay: "$0.00",
          Monthly_Overtime_Amt: "$0.00",
          Monthly_Bonus_Amt: "$0.00",
          Monthly_Commission_Amt: "$0.00",
          "Self Employed": "N",
          Employedbyfamily: 0,
          Monthly_Total_Pay: "$0.00",
        },
      ],
    ];
    return addEmp;
  };
  const handleSaveNewLoan = async (iLoanId) => {
    let DetailsArr_ = DetailsArr.slice(1),
      json = [],
      iLoanData = LoanData || {};
    setLoanData((prevLoanData) => {
      iLoanData = prevLoanData;
      return { ...prevLoanData };
    });

    DetailsArr_.forEach(async (item) => {
      if (item["columnName"] !== "loanOfficers") {
        (item["subFields"] || []).forEach((iItem) => {
          if (iItem["label"] === "Down Payment") {
            iItem["field"].forEach((subItem) => {
              json.push({
                ColumnName: subItem["ColumnName"],
                ColumnValue: iLoanData[subItem["ColumnName"]],
              });
            });
          } else {
            json.push({
              ColumnName: iItem["ColumnName"],
              ColumnValue: iLoanData[iItem["ColumnName"]],
            });
          }
        });

        if (item["ColumnName"]) {
          json.push({
            ColumnName: item["ColumnName"],
            ColumnValue:
              item["ColumnName"] === "loanOfficers"
                ? item["ColumnValue"]
                : iLoanData[item["ColumnName"]],
          });
        }
      }
    });
    __DEV__ && console.log("Json for New Loan ===> ", json, DetailsArr_);

    handleSaveLoanInformation(json, iLoanId, false, () => {
      if (additionalBorrowerInfo.length === 0) {
        handleAPIGetLoanDetails(iLoanId, true, true);
      }
    });
  };
  const handleSaveLoanOfficer = async (LoNum) => {
    if (loanId > 0 && LoNum > 0) {
      return await handleAPI({
        name: "SaveLoanOfficer",
        params: {
          LoanId: loanId,
          LoEmpNum: LoNum || 0,
        },
      })
        .then(() => {
          handleGetBorrowerUrl();
          //return JSON.parse(LoanId);
        })
        .catch((error) =>
          console.error("Error from SaveLoanOfficer ====> ", error)
        );
    }
  };

  const handleNextClick = () => {
    if (currentPage != "eSign" && (!web || isMobileWeb)) setHideProgress(false);

    if (contextDetails["appDownloadFlag"]) {
      if (contextDetails["appDownloadFlag"]) {
        setContextDetails((prevContextDetails) => {
          prevContextDetails["appDownloadFlag"] = false;
          return { ...prevContextDetails };
        });
        pageIndex["subPage"] === 0 &&
          pageIndex["page"] === 0 &&
          setIsDisableNext(false);
      }
    } else {
      (!isDisableNext || GoToNav == pageId["documentUpload"]) &&
        handleNavigation(1);
    }
  };
  // const handleAsyncLoanCeration = async () => {
  //   let iLoanId = loanId;

  //   iLoanId = await handleCreateLoan();
  //   // iLoanId = 495139;

  // };
  const handleGetUserTask = async () => {
    try {
      handleAPI({
        name: "GetUsertasks",
        params: {
          SessionId: SessionId,
        },
      }).then(() => {});
    } catch (error) {}
  };
  const handleCreateLoan = async () => {
    handleAPI({
      name: "CreateLoanOnly",
      params: {
        sessionid: SessionId,
        empid: loanOfficers || 0,
        EventId: 15,
      },
    })
      .then((LoanId) => {
        let iLoanId = JSON.parse(LoanId);
        handleLogDWCallToActionEventParent(
          "Loan Created",
          "fnLogDWCallToActionEvent",
          "Borrower Loan Application",
          {
            SessionId,
            Email: "",
            LoanId: iLoanId,
            LoanOfficerId: web
              ? queryStringToObject(window.location?.href || "")[
                  "loanOfficerId"
                ] ||
                contextDetails.RecentLoId ||
                0
              : contextDetails.RecentLoId || 0,
            Email: contextDetails["Email"],
          },
          activePageArray[pageIndex["page"]]?.replaceAll(" ", "")
        );

        updateWebURL({
          SessionId: SessionId,
          loanId: iLoanId,
          Path: "Home",
        });
        setContextDetails((prevContextDetails) => {
          return {
            ...prevContextDetails,
            loanId: iLoanId,
            isNewLoanCreated: true,
          };
        });

        setTimeout(() => {
          handleSaveNewLoan(iLoanId);
          handleGetUserTask();
        }, 500);
      })
      .catch((error) =>
        console.error("Error from CreateLoanOnly ====> ", error)
      );
  };

  const handleCheckNextPage = (iPage) => {
    if (pageArray.length < iPage["page"] || !pageArray[iPage["page"]]) {
      navigate("DashBoard", { from: "Home" });
    } else {
      setPageIndex({ ...iPage });
      let iCurrentPage = pageArray[iPage["page"]];
      iCurrentPage && setCurrentPage(iCurrentPage);
    }
  };
  const handleGetBankEmpDetails = () => {
    handleAPI({
      name: "getBankEmpDetails",
      params: {
        loanId,
      },
      method: "GET",
    })
      .then((result) => {
        let { bankInfo, employmentInfo: empDetails } =
          JSON["parse"](result)["Table"][0];

        bankInfo = JSON["parse"](bankInfo || "[]");
        empDetails = JSON["parse"](empDetails || "[]");

        if (bankInfo.length > 0) {
          bankInfo.forEach((bank) => {
            const { AccType, AccTypeName } = bank;
            bank["Amount"] = formatCurrency(bank["Amount"], 2);
            if (AccType == 1 && !AccTypeName) bank["AccTypeName"] = "Checking";
            else if (AccType == 2 && !AccTypeName)
              bank["AccTypeName"] = "Savings";
            else if (![1, 2].includes(Number(AccType))) {
              bank["AccType"] = "-1";
              bank["AccTypeName"] = "Other Type";
              bank["OtherAccType"] = AccType?.toString();
              bank["TypeDesc"] = getOtherAccountDesc(AccType);
              bank["EarnestMoneyPaidTo"] =
                bank["paidToId"] + "####" + bank["paidToType"];
            }
          });
          setAdditionalBankInfo([...bankInfo]);
        }

        if (empDetails.length > 0) {
          if (!empDetails[0]["CustId"]) empDetails[0]["CustId"] = userId;
          empDetails.forEach((employment) => {
            employment["Monthly_Base_Pay"] = formatCurrency(
              employment["Monthly_Base_Pay"],
              2
            );
            employment["Monthly_Overtime_Amt"] = formatCurrency(
              employment["Monthly_Overtime_Amt"],
              2
            );
            employment["Monthly_Bonus_Amt"] = formatCurrency(
              employment["Monthly_Bonus_Amt"],
              2
            );
            employment["Monthly_Commission_Amt"] = formatCurrency(
              employment["Monthly_Commission_Amt"],
              2
            );
            employment["Monthly_Total_Pay"] = formatCurrency(
              employment["Monthly_Total_Pay"],
              2
            );

            employment["CurrentYrsInLineofwork"] = employment[
              "CurrentYrsInLineofwork"
            ]
              ? employment["CurrentYrsInLineofwork"]
              : "";
          });

          empDetails = empDetails.filter((employment) => {
            if (employment["CustId"] === 0) {
              handleSaveAdditionalInfo(-1, 6, employment["Id"]); // Deleting empty employment on page load
              return false;
            }
            return true;
          });
          setLoanData((prevLoanData) => {
            return {
              ...prevLoanData,
              currently_employed: 1,
            };
          });

          console.log([
            ...handleEmploymentOrder(empDetails, additionalBorrowerInfo),
          ]);

          setAdditionalEmploymentInfo([
            ...handleEmploymentOrder(empDetails, additionalBorrowerInfo),
          ]);
        }
      })
      .catch((err) =>
        console.error("Error from GetBankEmpDetails ====> ", err)
      );
  };
  const handleNavigation = async (
    direction_,
    iFrom,
    isChangePage = true,
    mainPage
  ) => {
    setScrollToTop(true);

    if (currentPage != "eSign" && (!web || isMobileWeb)) {
      setHideProgress(false);
    }

    if (currentPage == "eSign" && pdfView && (ios || android)) {
      navigation.navigate("Home", {
        GoToNav: 10,
      });
    }

    let { page, subPage } = pageIndex,
      DetailsArr_ = DetailsArr.slice(1);

    if (currentPage === pageArray[pageId["documentUpload"]]) {
      let PublicPage = getQueryString("Publicpage", "");
      if (PublicPage == 1 || GoToNav == pageId["documentUpload"]) {
        navigate("DashBoard", { from: "Home" });
        return;
      }
    }
    if (
      [
        "eSign",
        "documentUpload",
        "appraisalPayment",
        "reviewYourInterestRate",
      ].includes(currentPage)
    ) {
      page = pageId[currentPage];
    }
    if (currentPage === pageArray[pageId["documentUpload"] && isChangePage]) {
      if (direction_ === 1) page++;
      else page--;
      pageArray[page] && setCurrentPage(pageArray[page]);
      let arr = handlePageDetails(pageArray[page])["iDetailsArr"];
      subPage = subPage === 0 ? arr.slice(1).length - 1 : 0;
      setDetailsArr(arr);
      let page_ = { page: page, subPage: subPage };
      handleCheckNextPage(page_);
    } else if (DetailsArr_.length > 0) {
      let details = DetailsArr_[subPage],
        ColumnName = details?.ColumnName || undefined,
        ColumnValue = [null, undefined].includes(details?.ColumnValue)
          ? ColumnName === "LinkBankAccount"
            ? ""
            : undefined
          : details?.ColumnValue,
        json = [
          {
            ColumnName,
            ColumnValue,
          },
        ];
      if (
        ["IsReferred", "Propertybe"].includes(ColumnName) &&
        DetailsArr_[subPage]["subFields"].length > 0
      ) {
        json.push({
          ColumnName: DetailsArr_[subPage]["subFields"][0]["ColumnName"],
          ColumnValue: DetailsArr_[subPage]["subFields"][0]["ColumnValue"],
        });
      }
      let isCreateLoan =
        ColumnName === "loanOfficers" &&
        Number(loanId) === -999 &&
        direction_ === 1 &&
        isChangePage;

      if (isCreateLoan) {
        if (loanOfficers <= 0) {
          return;
        }
        handleCreateLoan();

        subPage++;
        if (subPage === DetailsArr_.length) {
          page++;
          subPage = 0;
          setTimeout(() => {
            let page_ = { page: page, subPage: subPage };

            // (subPage != pageIndex["subPage"] || page != pageIndex["page"]) &&
            setPageIndex({ ...page_ });
          }, 1000);
        }
      } else {
        if (ColumnValue === undefined || ColumnName === undefined) {
          json = [];

          if (page === pageId["addressHistory"] && subPage < 4) {
            let totalMonthCount =
                handleGetMonthCount(
                  LoanData[`Addrshistry_Months`] || 0,
                  LoanData[`Addrshistry_Years`] || 0
                ) || 0,
              monthCount = 0;
            json = [];

            json.push(
              ...[
                {
                  ColumnName: "Current_Street_Address",
                  ColumnValue: LoanData["Current_Street_Address"] || "",
                },
                {
                  ColumnName: "Addrshistry_ZipCode",
                  ColumnValue: LoanData["Addrshistry_ZipCode"] || "",
                },
                {
                  ColumnName: "Addrshistry_City",
                  ColumnValue: LoanData["Addrshistry_City"] || "",
                },
                {
                  ColumnName: "Addrshistry_State",
                  ColumnValue: LoanData["Addrshistry_State"] || "",
                },
                {
                  ColumnName: "Addrshistry_Years",
                  ColumnValue: LoanData["Addrshistry_Years"] || "",
                },
                {
                  ColumnName: "Addrshistry_Months",
                  ColumnValue: LoanData["Addrshistry_Months"] || "",
                },
              ]
            );

            for (let i = 1; i < 4; i++) {
              monthCount = handleGetMonthCount(
                LoanData[`Addrshistry_Months${i}`] || 0,
                LoanData[`Addrshistry_Years${i}`] || 0
              );

              if (totalMonthCount <= 24) {
                totalMonthCount = totalMonthCount + monthCount;
                json.push(
                  ...[
                    {
                      ColumnName: `PrevCurrent_Street_Address${i}`,
                      ColumnValue:
                        LoanData[`PrevCurrent_Street_Address${i}`] || "",
                    },
                    {
                      ColumnName: `Addrshistry_ZipCode${i}`,
                      ColumnValue: LoanData[`Addrshistry_ZipCode${i}`] || "",
                    },
                    {
                      ColumnName: `Addrshistry_City${i}`,
                      ColumnValue: LoanData[`Addrshistry_City${i}`] || "",
                    },
                    {
                      ColumnName: `Addrshistry_State${i}`,
                      ColumnValue: LoanData[`Addrshistry_State${i}`] || "",
                    },
                    {
                      ColumnName: `Addrshistry_Years${i}`,
                      ColumnValue: LoanData[`Addrshistry_Years${i}`] || "",
                    },
                    {
                      ColumnName: `Addrshistry_Months${i}`,
                      ColumnValue: LoanData[`Addrshistry_Months${i}`] || "",
                    },
                    {
                      ColumnName: `Monthly_Rent${i}`,
                      ColumnValue: LoanData[`Monthly_Rent${i}`] || "",
                    },
                    {
                      ColumnName: `Own${i}`,
                      ColumnValue: LoanData[`Own${i}`] ? 1 : 0,
                    },
                    {
                      ColumnName: `Rent${i}`,
                      ColumnValue: LoanData[`Rent${i}`] ? 1 : 0,
                    },
                    {
                      ColumnName: `Living_Rent_Free${i}`,
                      ColumnValue: LoanData[`Living_Rent_Free${i}`] ? 1 : 0,
                    },
                  ]
                );
              }
            }
          } else {
            DetailsArr_[subPage]["subFields"]?.forEach((item) => {
              if (item["field"] !== undefined) {
                item["field"].forEach((item_) => {
                  json.push({
                    ColumnName: item_["ColumnName"],
                    ColumnValue:
                      item_["ColumnName"] === "CellPhone"
                        ? `*5*${item_["ColumnValue"]}`
                        : item_["ColumnValue"],
                  });
                });
              }
              if (
                item["ColumnName"] !== undefined &&
                item["ColumnValue"] !== undefined
              ) {
                const iColumnValue =
                  item["ColumnName"] === "CellPhone"
                    ? `*5*${item["ColumnValue"]}`
                    : item["ColumnName"] === "LanguagePreference"
                    ? item["ColumnValue"] || "1"
                    : item["ColumnValue"];

                if (
                  item["ColumnName"] === "LanguagePreference" &&
                  iColumnValue == "1"
                ) {
                  setLoanData((prevLoanData) => {
                    return {
                      ...prevLoanData,
                      [item["ColumnName"]]: iColumnValue,
                    };
                  });
                }

                json.push({
                  ColumnName: item["ColumnName"],
                  ColumnValue: iColumnValue,
                });
              }
            });
          }
        }

        //Save Subject Property Address
        if (DetailsArr_[subPage]["ColumnName"] == "Propertybe") {
          json.push({
            ColumnName: "AddressTBD",
            ColumnValue: LoanData["AddressTBD"] ? 1 : 0,
          });
          if (
            json.filter(({ ColumnName }) => ColumnName === "Prop_Years")
              .length == 0
          )
            json.push({
              ColumnName: "Prop_Years",
              ColumnValue: LoanData["Prop_Years"],
            });
          handleSaveSubjectProperty();
        } else if (
          DetailsArr_[subPage]["ColumnName"] == "LoanPurpose" &&
          LoanData["LoanPurpose"] == 2
        ) {
          setLoanData((prevLoanData) => {
            return {
              ...prevLoanData,
              AddressTBD: 0,
            };
          });
          json.push({
            ColumnName: "AddressTBD",
            ColumnValue: 0,
          });
        }

        //Save SSN Credit score page =========== Re-Assign Json===================
        // if (DetailsArr_[subPage]["isSSNDetails"] || (DetailsArr[3] !== undefined  && DetailsArr[3]["isSSNDetails"])) {
        if (DetailsArr_[subPage]["isSSNDetails"]) {
          json = [
            {
              ColumnName: "SSN",
              ColumnValue: LoanData["SSN"],
            },
          ];
          if (additionalBorrowerInfo.length > 0) {
            additionalBorrowerInfo.slice(1).forEach((borr) => {
              handleSaveAdditionalInfo(-1, 16, null, null, {
                SSN: borr["SSN"] || "",
                CustId: borr["CustId"],
              });
            });
          }

          // if (
          //   (LoanData["Spouse_AddBorrower"] == 1 ||
          //     LoanData["iSpouse_AddBorrower"] == 1) &&
          //   additionalBorrowerInfo.length > 1
          // ) {
          //   json.push({
          //     ColumnName: "SpouseCustId",
          //     ColumnValue: additionalBorrowerInfo[1].CustId,
          //   });

          //   additionalBorrowerInfo.slice(1).forEach((borr) => {
          //     handleSaveAdditionalInfo(-1, 16, null, null, {
          //       SSN: borr["SSN"] || "",
          //       CustId: borr["CustId"],
          //     });
          //   });
          // } else json.push({ ColumnName: "SpouseSSN", ColumnValue: "" });

          // handleSaveLoanInformation(json);
        }
        //Change Save Json format
        if (
          currentPage === pageArray[pageId["employment"]] &&
          json.length > 0
        ) {
          if (json[0]["ColumnName"] === "CurrentlyEmployed") {
            json = [
              {
                ColumnName: "currently_employed",
                ColumnValue: LoanData["currently_employed"],
              },
              { ColumnName: "Retired", ColumnValue: LoanData["Retired"] },
              {
                ColumnName: "Not_CurrentlyEmployed",
                ColumnValue: LoanData["Not_CurrentlyEmployed"],
              },
            ];
            handleSaveLoanInformation(json);
            if (
              additionalEmploymentInfo.length &&
              !LoanData["currently_employed"]
            ) {
              additionalEmploymentInfo.forEach(({ Id }) => {
                handleSaveAdditionalInfo(-1, 6, Id);
              });
            }
            // return;
          } else if (json[0]["ColumnName"] === "IsOtherIncome") {
            json.push(
              ...[
                {
                  ColumnName: "Payor_Name",
                  ColumnValue: LoanData["Payor_Name"],
                },
                {
                  ColumnName: "Source_Other_Incm",
                  ColumnValue: LoanData["Source_Other_Incm"],
                },
                {
                  ColumnName: "Monthly_Amount",
                  ColumnValue: LoanData["Monthly_Amount"],
                },
                {
                  ColumnName: "OtherIncomeCustId",
                  ColumnValue:
                    LoanData["OtherIncomeCustId"] ||
                    additionalBorrowerInfo[0]["CustId"],
                },
              ]
            );
            if (
              additionalOtherIncomeInfo.length &&
              !LoanData["IsOtherIncome"]
            ) {
              additionalOtherIncomeInfo.forEach(({ Id }) => {
                handleSaveAdditionalInfo(-1, 7, Id);
              });
            }
          } else if (json[0]["ColumnName"] === "IsAlimonyChildSupport") {
            json.push(
              ...[
                {
                  ColumnName: "OtherAlimonyIncomeCustId",
                  ColumnValue: LoanData["OtherAlimonyIncomeCustId"] || UserId,
                },
                {
                  ColumnName: "Monthly_Alimony_Expense",
                  ColumnValue: LoanData["Monthly_Alimony_Expense"],
                },
                {
                  ColumnName: "Monthly_Alimony_Income",
                  ColumnValue: LoanData["Monthly_Alimony_Income"],
                },
                {
                  ColumnName: "Monthly_ChildSupportExpense",
                  ColumnValue: LoanData["Monthly_ChildSupportExpense"],
                },
                {
                  ColumnName: "Monthly_ChildSupportIncome",
                  ColumnValue: LoanData["Monthly_ChildSupportIncome"],
                },
              ]
            );
          }
        }

        //============================================================

        //Special case for saving data in Add History info
        if (
          currentPage === pageArray[pageId["addressHistory"]] &&
          !DetailsArr_[subPage]["isAddressHistory"]
        ) {
          json.push(
            ...[
              {
                ColumnName: `Own`,
                ColumnValue: LoanData[`Own`] ? 1 : 0,
              },
              {
                ColumnName: `Rent`,
                ColumnValue: LoanData[`Rent`] ? 1 : 0,
              },
              {
                ColumnName: `Living_Rent_Free`,
                ColumnValue: LoanData[`Living_Rent_Free`] ? 1 : 0,
              },
              {
                ColumnName: `Monthly_Rent`,
                ColumnValue: LoanData[`Monthly_Rent`] || 0,
              },
            ]
          );
        }

        //====================================
        if (DetailsArr_[subPage]["isAdditionalBorr"]) {
          const { index, CustId } = DetailsArr_[subPage],
            { SSN } = additionalBorrowerInfo[index + 1];
          handleSaveAdditionalInfo(index, 11);
          handleSaveAdditionalInfo(-1, 16, null, null, {
            SSN,
            CustId,
          });
        } else if (DetailsArr_[subPage]["isAddressHistory"]) {
          let index = DetailsArr_[subPage]["index"];
          // json.push({
          //   ColumnName: `btnSameAsProperty${index + 1}`,
          //   ColumnValue: LoanData[`btnSameAsProperty${index + 1}`] || 0,
          // });
          // handleSaveLoanInformation(json);
          let inputJSON = null;
          if (DetailsArr_[subPage]["isAddtionalPrevAddressHistory"]) {
            inputJSON = DetailsArr_[subPage]["subFields"].reduce(
              (result, item) => {
                let ColumnName = item.ColumnName; //BorForZip2
                if (
                  ColumnName.indexOf("Bor For Zip") !== -1 ||
                  ColumnName.indexOf("Bor For City") !== -1 ||
                  ColumnName.indexOf("Bor For State") !== -1
                )
                  ColumnName = ColumnName.replaceAll(" ", "");
                result[ColumnName] = item.ColumnValue;
                return result;
              },
              {}
            );
            let key = `Bor For Add${DetailsArr_[subPage]["prevAddIndex"]} Own`,
              key_ = `Bor For Add${DetailsArr_[subPage]["prevAddIndex"]} Yrs`,
              rentKey = `Present Rent${DetailsArr_[subPage]["prevAddIndex"]}`;
            inputJSON = {
              ...inputJSON,
              [key]: additionalBorrowerInfo[index + 1][key],
              [key_]: `${DetailsArr_[subPage]["subFields"][4]["ColumnValue"]}.${DetailsArr_[subPage]["subFields"][5]["ColumnValue"]}`,
              [rentKey]: cleanValue(additionalBorrowerInfo[index + 1][rentKey]),
              CustId: additionalBorrowerInfo[index + 1]["CustId"],
            };
          }
          // console.log(inputJSON);
          handleSaveAdditionalInfo(
            index,
            DetailsArr_[subPage]["flag"],
            null,
            null,
            inputJSON
          );
        } else if (DetailsArr_[subPage]["isAdditionalBank"]) {
          let {
            BankName,
            Amount,
            Id,
            CustId,
            OwnerIdList,
            AssetId,
            AccType,
            Account = "",
            AccountName = "",
            Address = "",
            BankAddress = "",
            BankCity = "",
            BankState = "",
            BankZip = "",
            OtherAccType = "",
            giftfrom = "",
            lifeInsFace = 0,
            lifeInsValue = 0,
            EarnestMoneyPaidTo = "",
            Description,
          } = additionalBankInfo[DetailsArr_[subPage]["index"]];
          const [paidToId, paidToType] = EarnestMoneyPaidTo.split("####");

          handleUpdateAddtionalBank(
            DetailsArr_[subPage]["index"],
            "isNewRecord",
            false
          );

          let json_ = [
            {
              Bank_Name: BankName,
              Monthly_Amount: Amount,
              CustId: CustId,
              Id: Id,
              OwnerIdCust: OwnerIdList,
              AssetId,
              AccType: AccType == -1 ? OtherAccType : AccType,
              Account,
              AccountName,
              TypeDesc: AccType == -1 ? getOtherAccountDesc(OtherAccType) : "",
              Address,
              BankAddress,
              BankCity,
              BankState,
              BankZip,
              giftfrom,
              lifeInsFace,
              lifeInsValue,
              paidToId,
              paidToType,
              Description,
            },
          ];

          handleSaveAdditionalInfo(
            -1,
            3,
            additionalBankInfo[DetailsArr_[subPage]["index"]]["Id"],
            null,
            json_
          );
        } else if (DetailsArr_[subPage]["isAdditionalIncome"]) {
          // json[3]["ColumnValue"] =
          //   DetailsArr[pageIndex.subPage]["subFields"][3]["ColumnValue"];
          handleSaveAdditionalInfo(
            -1,
            2,
            DetailsArr_[subPage]["custId"],
            null,
            json
          );
        } else if (DetailsArr_[subPage]["isAdditionalEmployment"]) {
          let json_ = [{}];
          json.forEach((item) => {
            if (item.ColumnName === "Self Employed")
              json_[0]["SelfEmployed"] = item.ColumnValue;
            else json_[0][item.ColumnName] = item.ColumnValue;
          });
          if (!json_[0]["CustId"]) {
            json_[0]["CustId"] = UserId;
          }
          handleSaveAdditionalInfo(
            -1,
            1,
            additionalEmploymentInfo[DetailsArr_[subPage]["index"]]["Id"],
            null,
            json_
          );
        } else if (DetailsArr_[subPage]["isAdditionalProperty"]) {
          let json_ = [{}];
          json.forEach((item) => {
            let col = item.ColumnName;
            col = col === "OwnerIdList" ? "OwnerIdCust" : col;

            json_[0][col] = item.ColumnValue;
          });
          json_[0]["CustId"] = UserId;
          json_[0]["AssetId"] =
            additionalPropertyInfo[DetailsArr_[subPage]["index"]]["Id"];

          handleSaveAdditionalInfo(
            -1,
            4,
            additionalPropertyInfo[DetailsArr_[subPage]["index"]]["Id"],
            null,
            json_
          );
        } else if (
          DetailsArr_[subPage]["isAddAdditionalEmployment"] &&
          direction_ === 1 &&
          DetailsArr_[subPage]["ColumnValue"] == 1
        ) {
          await handleSaveAdditionalInfo(
            -2,
            -1,
            -4,
            true,
            null,
            false,
            DetailsArr_[subPage]["CustId"]
          );

          setLoanData((prevLoanData) => {
            return { ...prevLoanData, [DetailsArr_[subPage]["ColumnName"]]: 0 };
          });
          return false;
        } else if (
          DetailsArr_[subPage]["isAddAdditionalOtherIncome"] &&
          direction_ === 1 &&
          DetailsArr_[subPage]["ColumnValue"] == 1
        ) {
          await handleAddAditionalIncomeType(false);
          return false;
        } else if (DetailsArr_[subPage]["isAddtionalDeclaration"]) {
          let borr = additionalBorrowerInfo[DetailsArr_[subPage]["index"]];

          json = [
            {
              Bankruptcy: parseInt(borr["Bankruptcy"]) === 1 ? "Y" : "N",
              blChapter7: borr["blChapter7"],
              blChapter11: borr["blChapter11"],
              blChapter12: borr["blChapter12"],
              blChapter13: borr["blChapter13"],
              USCitizen: parseInt(borr["Citizenship_Status"]) === 1 ? "Y" : "",
              bTypePerResAlien:
                parseInt(borr["Citizenship_Status"]) === 2 ? 1 : "",
              bTypeNonPerResAlien:
                parseInt(borr["Citizenship_Status"]) === 3 ? 1 : "",
              OccupyProperty:
                parseInt(borr["OccupyProperty"]) === 1 ? "Y" : "N",
              OweProperty: parseInt(borr["Owe Property"]) === 1 ? "Y" : "N",
              TypePropOwn:
                parseInt(borr["Type Prop Own"]) === 1
                  ? "PR"
                  : parseInt(borr["Type Prop Own"]) === 2
                  ? "SH"
                  : parseInt(borr["Type Prop Own"]) === 3
                  ? "IP"
                  : "",
              HoldTitle:
                parseInt(borr["Hold Title"]) === 1
                  ? "S"
                  : parseInt(borr["Hold Title"]) === 2
                  ? "SP"
                  : parseInt(borr["Hold Title"]) === 3
                  ? "O"
                  : "",
              BusinessaffWithSeller:
                parseInt(borr["BusinessaffWithSeller"]) === 1 ? "Y" : "N",
              Downpayment: parseInt(borr["Downpayment"]) === 1 ? "Y" : "N",
              MoneyBorrowedForDown: borr["MoneyBorrowedForDown"],
              LoanOnAnotherProp:
                parseInt(borr["LoanOnAnotherProp"]) === 1 ? "Y" : "N",
              ApplyingNewCredit:
                parseInt(borr["ApplyingNewCredit"]) === 1 ? "Y" : "N",
              PropAssCleanEnergy:
                parseInt(borr["PropAssCleanEnergy"]) === 1 ? "Y" : "N",
              Co_maker: parseInt(borr["Co-maker"]) === 1 ? "Y" : "N",
              Jugdements: parseInt(borr["Jugdements"]) === 1 ? "Y" : "N",
              Delinquent: parseInt(borr["Delinquent"]) === 1 ? "Y" : "N",
              Lawsuit: parseInt(borr["Lawsuit"]) === 1 ? "Y" : "N",
              ConveyedTitle: parseInt(borr["ConveyedTitle"]) === 1 ? "Y" : "N",
              Obligated: parseInt(borr["Obligated"]) === 1 ? "Y" : "N",
              Forclosed: parseInt(borr["Forclosed"]) === 1 ? "Y" : "N",
              bType1stBuyer: borr["bType1stBuyer"],
              CustId: borr["CustId"],
            },
          ];
          // console.log("borr", json);
          handleSaveAdditionalInfo(-1, 10, borr["CustId"], null, json);
        } else if (DetailsArr_[subPage]["isAddtionalDemographic"]) {
          let borr = additionalBorrowerInfo[DetailsArr_[subPage]["index"]];

          json = [
            {
              Ethnicity: borr["Ethnicity"] || 0,
              RaceIndian: borr["RaceIndian"],
              RaceAsian: borr["RaceAsian"],
              RaceBlack: borr["RaceBlack"],
              RaceHawaiian: borr["RaceHawaiian"],
              RaceWhite: borr["RaceWhite"],
              InterviewMethod: borr["Demographic_Info"],
              HispanicSubcategory: borr["HispanicSubcategory"],
              OtherOrigin: borr["OtherOrigin"] || "",
              PrincipalTribe: borr["PrincipalTribe"] || "",
              NativeHawaiianSubCategory: borr["RaceHawaiian"] === 1 ? 2 : 0,
              OtherPacificIslandRace: borr["OtherPacificIslandRace"] || 0,
              AsianRaceSubCategory: borr["AsianRaceSubCategory"] || 0,
              OtherAsianRace: borr["OtherAsianRace"],
              Sex: borr["Sex"],
              CustId: borr["CustId"],
            },
          ];
          handleSaveAdditionalInfo(-1, 13, borr["CustId"], null, json);
        } else if (DetailsArr_[subPage]["isVAMilitary"]) {
          let borr = additionalBorrowerInfo[DetailsArr_[subPage]["index"]]; //

          json = [
            {
              CustId: borr["CustId"],
              VAActiveStatus: borr["VA_Military_Status"],
              InReserveandActive: borr["Reserves_Active"],
              VABranchService: borr["Branch_Service"],
              VAMilitaryServiceStatus: borr["VAMilitaryServiceStatus"],
              VAEntitlementAmt: borr["VA_Entitlmt_Amt"]
                ?.toString()
                ?.replaceAll("$", ""),
              VAEntitlementUsed: borr["VA_Entitlmt_Amt_used"]
                ?.toString()
                ?.replaceAll("$", ""),
              VAEntitleCode: borr["VA_Entitlmt_Code"],
              VAFirstTimeUse: borr["VA_Loan_FTU"],
              ExemptFromFundingFee: borr["VA_Funding_Fee"],
              CurActiveDuty: borr["Currently_serving"],
              CurRetired: borr["Currently_retired"],
              NonActiveMemReserve: borr["Active_National_Guard"],
              SurvivingSpouse: borr["Surviving_spouse"],
              MilitaryServiceExpectedCompletionDate:
                borr["MilitaryServiceExpectedCompletionDate"],
            },
          ];
          handleSaveAdditionalInfo(-1, 14, borr["CustId"], null, json);
        } else if (DetailsArr_[subPage]["isAddCounselling"]) {
          let { index } = DetailsArr_[subPage],
            Counselling = additionalCounsellingInfo[index],
            { CustId } = additionalBorrowerInfo[index],
            iLanguagePreference = Counselling["LanguagePreference"] || "1";

          json = [
            {
              CustId: CustId,
              CounselingConfirmationIndicator: Counselling["Couns_Confirm"],
              CounselingCompletedDate: Counselling["Couns_Comp_Date"],
              CounselingType: Counselling["Couns_Type"],
              Couns_FormatType: Counselling["Couns_FormatType"],
              Couns_FormatType2: Counselling["Couns_FormatType2"],
              CounselingAgencyName: Counselling["Couns_Agency_Name"],
              LanguagePreference: iLanguagePreference,
              OtherLanguageDescription: Counselling["OtherLanguageDescription"],
            },
          ];
          if (iLanguagePreference == "1") {
            handleUpdateAddtionalCounsellingInfo({
              iLanguagePreference,
              index,
            });
          }

          handleSaveAdditionalInfo(-1, 15, CustId, null, json);
        } else {
          if (currentPage === pageArray[pageId["government"]]) {
            json = json.filter((value, index, self) => {
              const foundIndex = self.findIndex(
                (obj) =>
                  obj.ColumnName === value.ColumnName &&
                  obj.ColumnValue === value.ColumnValue
              );
              return foundIndex === index;
            });
          }

          //Exception save peocess for asset details
          if (
            pageIndex["page"] === pageId["bankAccounts"] &&
            pageIndex["subPage"] === 0 &&
            additionalBankInfo.length > 0
          ) {
            let json_ = [
              {
                AccType: json[0]["ColumnValue"],
                Bank_Name: json[1]["ColumnValue"],
                Monthly_Amount: json[2]["ColumnValue"],
                OwnerIdCust: json[3]["ColumnValue"],
                AssetId: json[4]["ColumnValue"],
              },
            ];

            handleSaveAdditionalInfo(
              -1,
              3,
              additionalBankInfo[0]?.CustId || UserId,
              null,
              json_,
              true
            );
          } else {
            handleSaveLoanInformation(json);
          }
        }

        //Order credit Report
        if (
          DetailsArr_.length !== 1 &&
          currentPage === pageArray[pageId["creditScore"]] &&
          Number(LoanData["CreditRpt_Auth"]) === 1 &&
          Number(LoanData["CreditReport"]) === 1 &&
          Number(LoanData["FrozenCredit"]) === 0 &&
          !LoanData["creditReportOrdered"] &&
          direction_ === 1 &&
          loanOfficerId != 0 &&
          // creditScoreDetails?.Status !== 5 &&
          DetailsArr_[subPage]["ColumnName"] == "CreditRpt_Auth"
        ) {
          handleOrderCreditReport();
          DetailsArr_.push({});
          setLoanData((prevLoanData) => {
            return { ...prevLoanData, creditReportOrdered: true };
          });
        }
        if (currentPage === pageArray[pageId["creditScore"]]) {
          if (
            LoanData["FrozenCredit"] == 1 &&
            ((DetailsArr_[subPage]["ColumnName"] == "FrozenCredit" &&
              direction_ == 1) ||
              (DetailsArr_[subPage]["pageName"] == "unFreeze" &&
                direction_ == -1))
          ) {
            subPage = subPage + direction_;
          }
          if (
            DetailsArr_[subPage]["ColumnName"] == "CreditReport" &&
            LoanData["CreditReport"] === 0 &&
            direction_ == 1
          ) {
            page++;
            subPage = -1;
          }
        }

        //For Creating new Property, when there is no property - click next form 1st page of REO
        if (
          json.length > 0 &&
          json[0]["ColumnName"] === "Real_est_prop" &&
          json[0]["ColumnValue"] == 1 &&
          direction_ === 1 &&
          iFrom !== ""
        ) {
          await handleSaveAdditionalInfo(-1, -4, -2, true);
          subPage--;
          setTimeout(() => {
            setScrollToTop(true);
          }, 0);
        }

        if (
          json.length > 0 &&
          json[0]["ColumnName"] === "blAssetOption" &&
          json[0]["ColumnValue"] == 1 &&
          direction_ === 1 &&
          iFrom !== ""
        ) {
          await handleSaveAdditionalInfo(-1, -3, -3, true);
          subPage--;
          setTimeout(() => {
            setScrollToTop(true);
          }, 0);
        }

        // For Creating new employmnet
        if (
          json.length > 0 &&
          json[0]["ColumnName"] === "currently_employed" &&
          json[0]["ColumnValue"] == 1 &&
          additionalEmploymentInfo.length === 0 &&
          direction_ === 1 &&
          iFrom !== ""
        ) {
          await handleSaveAdditionalInfo(-2, -1, -4, true);
          subPage--;
          setTimeout(() => {
            setScrollToTop(true);
          }, 0);
        }

        if (
          (ColumnName === "Spouse_AddBorrower" ||
            ColumnName === "iSpouse_AddBorrower") &&
          (ColumnValue === 1 || ColumnValue === 2) &&
          direction_ === 1
        ) {
          setProcessStatus("addingBorrower");
          handleSaveAdditionalInfo(-1, 0);
          subPage = subPage - 1;
        }
        subPage = subPage + direction_;
        if (
          DetailsArr_[subPage]?.isAdditionalIncome &&
          iFrom === "isAdditionalIncome"
        )
          subPage = subPage + 1;

        if (subPage === DetailsArr_.length || subPage < 0) {
          if (direction_ === 1) {
            if (pageId["government"] == page) {
              setDocumentUploadFlag((prevDocumentUploadFlag) => {
                return {
                  ...prevDocumentUploadFlag,
                  headerText: `You have now completed the loan application. Thank you!\n\nYour loan officer will now reach out to you. In the meantime, you can upload your loan documents below.`,
                };
              });
            }

            if (currentPage === pageArray[pageId["borrowerVerification"]]) {
              if (LoanData["LinkBankAccount"] === 1 && !LoanData["viewPlaid"]) {
                subPage--;
                setLoanData((prevLoanData) => ({
                  ...prevLoanData,
                  viewPlaid: true,
                }));
              } else {
                page++;
              }
            } else {
              page++;
            }
          } else {
            if (
              currentPage === pageArray[pageId["borrowerVerification"]] &&
              LoanData["LinkBankAccount"] === 1 &&
              LoanData["viewPlaid"]
            ) {
              subPage = 0;
              setLoanData((prevLoanData) => ({
                ...prevLoanData,
                viewPlaid: false,
              }));
            } else {
              page--;
            }
          }

          // isChangePage && setCurrentPage(pageArray[page]);
          let arr = handlePageDetails(pageArray[page])["iDetailsArr"];

          subPage = subPage < 0 ? arr.slice(1).length - 1 : 0;
          setDetailsArr(arr);
        }
        if (page < 0) page = 0;
        if (subPage < 0) subPage = 0;

        if (page === pageArray.length && subPage === 0) {
          //check this every new page
          subPage = 0;
          page = 0;
          isChangePage && setCurrentPage(pageArray[page]);
          let arr = handlePageDetails(pageArray[page])["iDetailsArr"];
          subPage = subPage < 0 ? arr.slice(1).length - 1 : 0;
          setDetailsArr(arr);
        }

        if (
          ![
            "borrowerVerification",
            "realEstateOwned",
            "creditScore",
            "employment",
          ].includes(currentPage)
        ) {
          if (subPage === DetailsArr_.length || subPage < 0) {
            if (direction_ === 1) page++;
            else page--;
            isChangePage && setCurrentPage(pageArray[page]);
            let arr = handlePageDetails(pageArray[page])["iDetailsArr"];
            subPage = subPage < 0 ? arr.slice(1).length - 1 : 0;
            setDetailsArr(arr);
          }
        }
      }

      let page_ = { page: page, subPage: subPage };

      if (
        currentPage === pageArray[pageId["borrowerVerification"]] &&
        LoanData["LinkBankAccount"] == 2 &&
        !mainPage
      ) {
        if (direction_ == 1 && additionalBankInfo.length == 0) {
          await handleSaveAdditionalInfo(-1, -3, -3, "pointLast");
        } else {
          isChangePage && handleCheckNextPage(page_);
        }
      } else {
        isChangePage && handleCheckNextPage(page_);
      }
    } else if (DetailsArr_.length == 0) {
      if (direction_ === 1) page++;
      else page--;
      pageArray[page] && setCurrentPage(pageArray[page]);
      let page_ = { page: page, subPage: 0 };

      (page !== pageArray.length || isChangePage) && handleCheckNextPage(page_);
    }
  };
  const handleOptionPress = (value, isSubField, index, exception, iExp) => {
    let DetailsArr_ = DetailsArr.slice(1);
    if (
      value !== "" &&
      exception !== "AssetCustId" &&
      exception !== "REOCustId"
    ) {
      if (
        ["numeric", "float"].includes(
          DetailsArr_[pageIndex["subPage"]]?.["subFields"]?.[index]?.["type"]
        )
      )
        value = cleanValue(value);
    }
    if (iExp === "CellPhone") {
      setLoanData((prevLoanData) => ({
        ...prevLoanData,
        CellPhone: `*5*${value}` || "",
      }));
    } else if (iExp === "CurrentlyEmployed") {
      setLoanData((prevLoanData) => ({
        ...prevLoanData,
        ...(value === 1
          ? {
              currently_employed: 1,
              Retired: 0,
              Not_CurrentlyEmployed: 0,
            }
          : value === 2
          ? {
              currently_employed: 0,
              Retired: 1,
              Not_CurrentlyEmployed: 0,
            }
          : value === 3
          ? {
              currently_employed: 0,
              Retired: 0,
              Not_CurrentlyEmployed: 1,
            }
          : {}),
      }));
    } else if (iExp) {
      if (iExp === -1) iExp = "";
      setLoanData((prevLoanData) => ({
        ...prevLoanData,
        ...(value === 1
          ? {
              [`Own${iExp}`]: true,
              [`Rent${iExp}`]: false,
              [`Living_Rent_Free${iExp}`]: false,
            }
          : value === 2
          ? {
              [`Own${iExp}`]: false,
              [`Rent${iExp}`]: true,
              [`Living_Rent_Free${iExp}`]: false,
            }
          : value === 3
          ? {
              [`Own${iExp}`]: false,
              [`Rent${iExp}`]: false,
              [`Living_Rent_Free${iExp}`]: true,
            }
          : {}),
      }));
    } else if (exception !== undefined && exception !== null) {
      // if (exception === "LanguagePreference") {
      //   let val = (LoanData[exception] || "")
      //     .split(",")
      //     .filter((e) => e !== "")
      //     .map((e) => parseInt(e));
      //   if (val.includes(value)) {
      //     val = val.filter((selectedItem) => selectedItem != value);
      //   } else {
      //     val = [...val, value];
      //   }
      //   value = [...new Set(val)];
      //   value = val.join(",");
      // } else
      if (exception === "MaritalStatus") {
        handleMaritalStatusChange({
          changedId: Number(value),
          isPrimary: true,
        });
      } else if (currentPage === pageArray[pageId["government"]]) {
        let obj = DetailsArr_[pageIndex["subPage"]]["subFields"].filter(
          (field) => {
            return field["ColumnName"] === exception;
          }
        );
        if (obj.length === 1) obj = obj[0];
        else {
          obj = obj.filter((obj_) => obj_["Options"][0]["value"] === value)[0];
        }

        let val = LoanData[exception];
        if (obj["isBitWise"] && obj["resetBitWise"] !== value) {
          if ((value & val) === value) value = val - value;
          else value = val + value;
          if ((obj["resetBitWise"] & val) === obj["resetBitWise"])
            value = value - obj["resetBitWise"];
        } else if (obj["resetBitWise"] == value && (value & val) === value) {
          value = val - value;
        } else if (value === obj["ColumnValue"]) value = null;
      }
      setLoanData((prevLoanData) => ({
        ...prevLoanData,
        ...{ [exception]: value },
      }));
    } else if (isSubField) {
      let ColumnName =
        DetailsArr_[pageIndex["subPage"]]["subFields"][index]["ColumnName"];
      setLoanData((prevLoanData) => ({
        ...prevLoanData,
        [ColumnName]: value,
      }));
      if (["FirstName", "LastName"].includes(ColumnName)) {
        handleUpdateAddtionalBorrower(-1, ColumnName, value);
      } else if (ColumnName === "EmailId") {
        handleUpdateAddtionalBorrower(-1, "Email", value);
      }
    } else {
      if (
        value === DetailsArr_[pageIndex["subPage"]]["ColumnValue"] &&
        currentPage !== pageArray[pageId["borrowerVerification"]]
      ) {
        value = null;
      }
      if (
        pageIndex["page"] == 0 &&
        pageIndex["subPage"] == 0 &&
        loanId == "-999"
      ) {
        setInCompletedSubPage(value == 1 ? [4] : value == 2 ? [3] : []);
      }

      const { ColumnName: iColumnName } = DetailsArr_[pageIndex["subPage"]];

      if (iColumnName === "LoanPurpose" && ![1, 2].includes(value)) {
        value = 1;
      }

      setLoanData((prevLoanData) => ({
        ...prevLoanData,
        [iColumnName]: value,
      }));
    }
  };
  const handleResetPlaidDetails = (value) => {
    let BankAccountLinked = 0,
      LinkBankAccount = 0;
    setLoanData((prevLoanData) => {
      LinkBankAccount = prevLoanData["prevLinkBankAccount"] || 0;
      BankAccountLinked = prevLoanData["prevBankAccountLinked"] || 0;
      return {
        ...prevLoanData,
        LinkBankAccount: value == undefined ? LinkBankAccount : value,
        BankAccountLinked: BankAccountLinked,
      };
    });
    let json = [
      {
        ColumnName: "LinkBankAccount",
        ColumnValue: LinkBankAccount,
      },
      {
        ColumnName: "BankAccountLinked",
        ColumnValue: BankAccountLinked,
      },
    ];
    handleSaveLoanInformation(json);
  };
  const handleSaveLoanInformation = async (
    json,
    iLoanId,
    isSaveMaritalStatus = true,
    callBack = () => {}
  ) => {
    json = json.filter(
      (item) =>
        ![
          "loanOfficers",
          "iSpouse_AddBorrower",
          "blOtherIncome",
          "subjectAddress",
          "subjectCity",
          "subjectState",
          "subjectZip",
        ].includes(item["ColumnName"])
    );

    json = json.filter((item) => !item["ColumnName"].includes("blEmployment"));

    const borrowerEmailId = json.filter((item) =>
      item["ColumnName"].includes("EmailId")
    );

    const iJson = json,
      maritalStatus = json.filter((item) =>
        item["ColumnName"].includes("MaritalStatus")
      );

    if (maritalStatus.length) {
      const { ColumnValue } = maritalStatus[0];
      iJson.push({
        ColumnName: "SpouseCustID",
        ColumnValue: ColumnValue > 10 ? ColumnValue : 0,
      });

      json = iJson;
    }

    if (borrowerEmailId?.length) {
      handleDuplicateEmail(borrowerEmailId[0]["ColumnValue"], 0);
    }
    if (LoanData["maritalStatusChangesIndex"]?.length && isSaveMaritalStatus) {
      LoanData["maritalStatusChangesIndex"].forEach((value) => {
        handleSaveAdditionalInfo(
          value,
          11,
          null,
          null,
          null,
          null,
          null,
          null,
          false
        );
      });
      setLoanData((prevLoanData) => {
        return {
          ...prevLoanData,
          isMaritalStatusChanged: false,
          maritalStatusChangesIndex: [],
        };
      });
    }
    if (
      json.length > 0 &&
      json[0]["ColumnName"] === "LinkBankAccount" &&
      json.length === 1
    ) {
      if (json[0]["ColumnValue"] == 2 || !json[0]["ColumnValue"]) {
        let iLoanData = { ...LoanData, BankAccountLinked: 0 };
        if (!json[0]["ColumnValue"]) {
          iLoanData = { ...LoanData, LinkBankAccount: 2 };
          json[0]["ColumnValue"] = 2;
        }
        setLoanData(iLoanData);
        json.push({
          ColumnName: "BankAccountLinked",
          ColumnValue: 0,
        });
      } else if (
        LoanData["LinkBankAccount"] == 1 &&
        LoanData["BankAccountLinked"] == 0
      ) {
        handleResetPlaidDetails(1);
      }
    }

    let inputJSON = JSON.stringify(json);

    console.log("SaveLoanAppWizard", json);
    // return;
    if (
      (iLoanId || loanId) > 0 &&
      json.length > 0 &&
      LoanData["LockLoanApp"] != 1
    ) {
      handleAPI({
        name: "SaveLoanAppWizardNew",
        params: {
          SessionId,
          LoanId: iLoanId || loanId,
          inputJSON,
          UserId: additionalBorrowerInfo[0]?.["CustId"] || UserId,
        },
      })
        .then((res) => {
          callBack();
          // let res = JSON.parse(response)["Table1"][0]["Column1"];
          // console.log(JSON.parse(response));
        })
        .catch((err) =>
          console.error("Error from SaveLoanAppWizard ====> ", err)
        );
    } else {
      callBack();
    }
  };
  const handleCalculateLoanAmt = ({
    iPurPrice,
    iDownPayment,
    iDownPaymentPercent,
    iEstLoanAmt,
  }) => {
    const {
      Purchase_Estm_Pur_Price,
      DownPayment,
      DownPaymentPercent,
      Purchase_Estm_LnAmt,
    } = LoanData;

    const purPrice = cleanValue(iPurPrice || Purchase_Estm_Pur_Price),
      downPayment = cleanValue(iDownPayment || DownPayment),
      downPaymentPercent = cleanValue(
        iDownPaymentPercent || DownPaymentPercent
      ),
      estLoanAmt = cleanValue(iEstLoanAmt || Purchase_Estm_LnAmt);

    const nDownPayment = purPrice * (downPaymentPercent / 100),
      nDownPaymentPercent = (purPrice / nDownPayment) * 100,
      nEstLoanAmt = purPrice - nDownPayment;

    setLoanData((prevLoanData) => {
      return {
        ...prevLoanData,
        Purchase_Estm_Pur_Price: formatCurrency(purPrice),
        DownPayment: formatCurrency(nDownPayment),
        DownPaymentPercent: nDownPaymentPercent,
        Purchase_Estm_LnAmt: formatCurrency(nEstLoanAmt),
      };
    });
  };
  const handleCalculateDownPaymentPer = (DownPayment_, Purchase_Estm_LnAmt) => {
    try {
      if (Number(LoanData["LoanPurpose"]) === 1) {
        let AppVal = cleanValue(LoanData["Purchase_Estm_Pur_Price"]),
          lnAmtTxt = cleanValue(
            Purchase_Estm_LnAmt === 0
              ? ""
              : Purchase_Estm_LnAmt || LoanData["Purchase_Estm_LnAmt"]
          );
        let DownPayment =
            DownPayment_ !== undefined
              ? DownPayment_
              : parseFloat(lnAmtTxt) <= 0
              ? 0
              : parseFloat(AppVal) - parseFloat(lnAmtTxt),
          DownPay = cleanValue(DownPayment),
          DownPaymentPercent = roundNumber(
            (parseFloat(DownPay) / parseFloat(AppVal)) * 100,
            2
          );
        if (parseFloat(lnAmtTxt) <= 0) {
          lnAmtTxt = parseFloat(AppVal);
        }

        if (isNaN(DownPaymentPercent)) DownPaymentPercent = "0.00";
        if (cleanValue(AppVal) == 0) {
          DownPayment = 0;
          DownPaymentPercent = 0;
          lnAmtTxt = 0;
        }

        setLoanData((prevLoanData) => ({
          ...prevLoanData,
          ...{
            Purchase_Estm_Pur_Price: formatCurrency(AppVal, 2),
            DownPayment: formatCurrency(DownPayment, 2),
            DownPaymentPercent: DownPaymentPercent,
            Purchase_Estm_LnAmt: formatCurrency(
              parseFloat(lnAmtTxt)?.toFixed(2),
              2
            ),
          },
        }));
      }
    } catch (ex) {
      console.error("Error form handleCalculateDownPaymentPer ===> ", ex);
    }
  };
  const CalculateDownPayment = () => {
    try {
      if (Number(LoanData["LoanPurpose"]) === 1) {
        let AppVal = cleanValue(LoanData["Purchase_Estm_Pur_Price"]),
          DownPayPer = cleanValue(LoanData["DownPaymentPercent"]),
          DownPayment = cleanValue(LoanData["DownPayment"]);

        if (isNaN(DownPayPer) || DownPayPer < 0) {
          return;
        } else {
          DownPayment = roundNumber(
            (parseFloat(DownPayPer) / 100) * parseFloat(AppVal),
            2
          );
        }
        let DownPay = cleanValue(DownPayment);
        let Purchase_Estm_LnAmt = parseFloat(AppVal) - parseFloat(DownPay),
          AppVal_ = cleanValue(LoanData["Purchase_Estm_Pur_Price"]),
          lnAmtTxt = cleanValue(Purchase_Estm_LnAmt),
          DownPay_ = cleanValue(DownPayment),
          DownPaymentPercent = roundNumber(
            (parseFloat(DownPay_) / parseFloat(AppVal_)) * 100,
            2
          );
        if (isNaN(DownPaymentPercent)) DownPaymentPercent = "0.00";

        let LnAmountExc = Math.floor(cleanValue(lnAmtTxt));

        AppVal = cleanValue(AppVal);
        DownPayment = parseFloat(AppVal) - parseFloat(cleanValue(LnAmountExc));

        handleCalculateDownPaymentPer(DownPayment, Purchase_Estm_LnAmt);
      }
    } catch (ex) {
      console.error("Error form CalculateDownPayment ====> ", ex);
    }
  };
  const LnAmtExcChange = () => {
    if (Number(LoanData["LoanPurpose"]) === 1) {
      let AppVal = LoanData["Purchase_Estm_Pur_Price"],
        LnAmountExc = Math.floor(cleanValue(LoanData["Purchase_Estm_LnAmt"]));

      AppVal = cleanValue(AppVal);
      let DownPayment =
        parseFloat(AppVal) - parseFloat(cleanValue(LnAmountExc));

      handleCalculateDownPaymentPer(DownPayment);
    }
  };

  const DownPmtOnChange = () => {
    try {
      if (Number(LoanData["LoanPurpose"]) === 1) {
        let AppVal = cleanValue(LoanData["Purchase_Estm_Pur_Price"]),
          DownPay = cleanValue(LoanData["DownPayment"]);
        let Purchase_Estm_LnAmt = parseFloat(AppVal) - parseFloat(DownPay),
          AppVal_ = cleanValue(LoanData["Purchase_Estm_Pur_Price"]),
          lnAmtTxt = cleanValue(Purchase_Estm_LnAmt),
          DownPayment = parseFloat(AppVal_) - parseFloat(lnAmtTxt),
          DownPay_ = cleanValue(DownPayment),
          DownPaymentPercent = roundNumber(
            (parseFloat(DownPay_) / parseFloat(AppVal_)) * 100,
            2
          );

        if (isNaN(DownPaymentPercent)) DownPaymentPercent = "0.00";
        setLoanData({
          ...LoanData,
          ...{
            DownPayment: formatCurrency(DownPayment, 2),
            DownPaymentPercent: DownPaymentPercent,
            Purchase_Estm_LnAmt: formatCurrency(Purchase_Estm_LnAmt, 2),
          },
        });
      }
    } catch (error) {
      console.error("Error form DownPmtOnChange ===> ", error);
    }
  };
  const CalculateLnAmt = (ColumnName) => {
    let LoanAmtRemaining = LoanData["PaidOff"],
      CashAmt = LoanData["CashOutAmount"];
    LoanAmtRemaining = cleanValue(LoanAmtRemaining);

    CashAmt = cleanValue(CashAmt);
    if (
      LoanAmtRemaining == "" ||
      LoanAmtRemaining == null ||
      LoanAmtRemaining == undefined
    )
      LoanAmtRemaining = 0;
    if (CashAmt == "" || CashAmt == null || CashAmt == undefined) CashAmt = 0;
    let LnAmt = 0;
    if (LoanData["Pri_purpose_Refi"] === 2) {
      if (ColumnName === "Refi_Estmt_LnAmt") {
        let LoanAmt = LoanData[ColumnName];
        LoanAmt = cleanValue(LoanAmt);
        if (LoanAmt == "" || LoanAmt == null || LoanAmt == undefined)
          LoanAmt = 0;

        CashAmt = parseFloat(LoanAmt) - parseFloat(LoanAmtRemaining);
      }
      LnAmt = parseFloat(LoanAmtRemaining) + parseFloat(CashAmt);
      setLoanData({
        ...LoanData,
        ...{
          CashOutAmount: formatCurrency(CashAmt, 2),
          Refi_Estmt_LnAmt: formatCurrency(LnAmt, 2),
          PaidOff: formatCurrency(LoanData["PaidOff"], 2),
        },
      });
    } else {
      setLoanData({
        ...LoanData,
        ...{
          CashOutAmount: formatCurrency(LoanData["CashOutAmount"], 2),
          Refi_Estmt_LnAmt: formatCurrency(LoanData["Refi_Estmt_LnAmt"], 2),
          PaidOff: formatCurrency(LoanData["PaidOff"], 2),
        },
      });
    }
  };

  const handleStoreCampaignDetails = async (iLoanData) => {
    try {
      let OrgUrl = web ? window.top.document.location.href : `Loan Application`,
        UserDetails = await handleUserDetails(SessionId),
        CampaignDetails = JSON.parse(
          (await AsyncStorage.getItem("CampaignDetails")) || null
        ),
        iCampignId = 202,
        // iCampaign = `Loan Application${!web && `-${ios ? `iOS` : `Android`}`}`,
        iCampaign = `Loan Application`,
        iCampignNum = 14,
        WebLoginId;
      UserDetails = UserDetails.split("~");

      if (!WebLoginId) WebLoginId = UserDetails[6];

      if (OrgUrl) OrgUrl = "";
      if (CampaignDetails && WebLoginId == CampaignDetails["WebLoginId"]) {
        let { CampignId, utm_campaign, CampignNum } = CampaignDetails;
        iCampignId = CampignId;
        iCampaign = utm_campaign;
        iCampignNum = CampignNum;
        AsyncStorage.removeItem("CampaignDetails");
      }
      await handleAPI({
        name: "StoreUTMCampaignWithOutLoginId",
        params: {
          CampignId: iCampignId,
          WebLoginId: WebLoginId,
          utmsource: "Direct Mortgage",
          utmmedium: "Internal",
          utmcampaign: iCampaign,
          utmcontent: "",
          utmterm: "",
          OrgUrl: OrgUrl,
          MsgText: "",
          Email: iLoanData["EmailId"],
          Phone: handleGetCellPhone(iLoanData["CellPhone"]),
          CampignNum: iCampignNum,
          LeadOfficer: loanOfficerId || loanOfficers || 1,
        },
      }).then((response) => {
        console.log("StoreUTMCampaignWithOutLoginId", response);
      });
    } catch (e) {
      console.error(e);
    }
  };

  const handleActiveTab = (index) => {
    if (contextDetails["appDownloadFlag"]) {
      setContextDetails((prevContextDetails) => {
        prevContextDetails["appDownloadFlag"] = false;
        return { ...prevContextDetails };
      });
    } else {
      index = index - 1;
      if (contextDetails.loanId == -99) index = 10;

      if (index !== pageIndex["page"]) {
        handleNavigation(1, "", false, index);
        if (pageArray[index] == "documentUpload") {
          setDocumentUploadFlag((prevDocumentUploadFlag) => {
            return {
              ...prevDocumentUploadFlag,
              headerText: null,
            };
          });
        }
      }
      pageArray[index] && setCurrentPage(pageArray[index]);

      let { iSubPage, iInCompletedSubPage } = handleGetPageNumber(true, index),
        page_ = {
          page: index,
          subPage: iSubPage < 0 ? 0 : iSubPage || 0,
        };

      setPageIndex({ ...page_ });
      setInCompletedSubPage(iInCompletedSubPage);
      setInCompletedSubPageObj((prevInCompletedSubPageObj) => {
        prevInCompletedSubPageObj[pageArray[index]] = iInCompletedSubPage;
        return { ...prevInCompletedSubPageObj };
      });
    }
  };
  const handleNavigateSubPage = async (page, subMenuIndex) => {
    if (contextDetails["appDownloadFlag"]) {
      setContextDetails((prevContextDetails) => {
        prevContextDetails["appDownloadFlag"] = false;
        return { ...prevContextDetails };
      });
    } else {
      (page !== pageIndex["page"] || subMenuIndex !== pageIndex["subPage"]) &&
        handleNavigation(1, "", false);
      if (
        page === pageId["bankAccounts"] &&
        subMenuIndex === 0 &&
        (additionalBankInfo || []).length == 0 &&
        LoanData["LockLoanApp"] == 0
      ) {
        await handleSaveAdditionalInfo(-1, -3, -3, true);
        setLoanData((prevLoanData) => {
          return { ...prevLoanData, blAssetOption: 1 };
        });
      } else if (page === pageId["creditScore"]) {
        let iLoandata = LoanData,
          hasReport =
            creditScoreDetails?.Status === 5 ||
            creditScoreDetails?.Details[0]?.iFinalScanDocID;

        let CreditReportIndex = hasReport ? [2, 3, 4, 5] : [1, 2, 3, 4];
        let FrozenCreditIndex = hasReport ? [3, 4, 5] : [2, 3, 4];

        if (CreditReportIndex.includes(subMenuIndex)) {
          iLoandata["CreditReport"] = 1;
        }
        if (
          FrozenCreditIndex.includes(subMenuIndex) &&
          (!LoanData["FrozenCredit"] ||
            LoanData["FrozenCredit"] === 0 ||
            subMenuIndex === (hasReport ? 3 : 2))
        ) {
          iLoandata["FrozenCredit"] = 0;
        }

        // if (
        //   page === pageId["creditScore"] &&
        //   LoanData["FrozenCredit"] === 1 &&
        //   subMenuIndex === (hasReport ? 4 : 3)
        // ) {
        //   subMenuIndex--;
        // }
      }

      setPageIndex({ page: page, subPage: subMenuIndex });
      pageArray[page] && setCurrentPage(pageArray[page]);
      setScrollToTop(true);
    }
  };
  //=======================================================================================
  let isSmallScreen =
      (web && screenSize[0] > 900) || Dimensions.get("window").width > 900,
    isMobileWeb = Dimensions.get("window").width <= 480;

  const scrollY = useRef(new Animated.Value(0)).current;

  const [iTopEdge, setTopEdge] = useState({});
  let topEdge = web
      ? 0
      : iTopEdge["contentY"] -
          (iTopEdge["contentWrapperHeight"] - iTopEdge["contentHeight"]) || 0,
    inputRange = [topEdge - 3, topEdge - 2, topEdge - 1, topEdge, topEdge + 1];

  const getNavBarProps = () => {
    return {
      currentPage: currentPage,
      activePage: activePageArray[pageIndex["page"] || 0],
      isEsignOnly: contextDetails.loanId == -99,
      navigation: navigation || props["navigation"],
      handleNavigateSubPage: handleNavigateSubPage,
      excludePageIds: excludePageIndex["Ids"] || [],
      handleLogOut: handleLogOut,
      completedPage: completedPage,
      handleClearState: handleClearState,
      handleActiveTab: handleActiveTab,
      isHome: true,
      activePageArray: activePageArray,
      pageId,
      inCompleteTabIndex: inCompletedSubPage,
      inCompletedSubPageObj: inCompletedSubPageObj,
      progressPercentage: progressPercentage,
      loanId: loanId || iLoanId,
      preventNavigation: false, //![1, 2].includes(LoanData["LoanPurpose"]),
      additionalAddressHistoryList: handleGetAddressHistoryList() || [],
      additionalBorrowerList: additionalBorrowerInfo.map((borrower, index) => {
        return {
          Name:
            borrower["FirstName"] || borrower["LastName"]
              ? `${borrower["FirstName"]} ${borrower["LastName"]}`
              : `borrower ${index + 1}`,
        };
      }),
      additionalEmploymentList: [
        { Name: "Employment History" },
        ...(Number(LoanData["currently_employed"]) === 1
          ? handleGetEmpploymentList()
          : [
              { Name: "Other Income" },
              ...(LoanData["IsOtherIncome"]
                ? additionalOtherIncomeInfo.map((income, index) => {
                    return { Name: `Other Income ${index + 2}` };
                  })
                : []),
              { Name: "Additional Other Income" },
            ]),
        ...[{ Name: "Alimony or Child Support" }],
      ],
      additionalBankList: [
        ...additionalBankInfo.map((bank, index) => {
          let { BankName, AccTypeName, OtherAccType, Description, AccType } =
            bank;
          BankName =
            AccType == "-1" && [12, 33, 22, 4].includes(Number(OtherAccType))
              ? Description
              : BankName;
          let empRow = additionalBorrowerInfo.filter(
            (borrower) =>
              Number(borrower["CustId"]) === Number(bank["OwnerIdList"])
          );
          if (empRow.length > 0) empRow = empRow[0];
          return {
            Name: BankName
              ? BankName
              : `Bank ${index + 1}` +
                (AccType > 0 ? (AccTypeName ? " - " + AccTypeName : "") : ""),
          };
        }),
        {
          Name: "Additional Bank",
        },
      ],
      realEstateList: [
        ...additionalPropertyInfo.map((property, index) => {
          return {
            Name: property["Real_est_prop_Addrs"] || `Properties ${index + 1}`,
          };
        }),
        { Name: "Additional Properties" },
      ],
      summaryInfoList: [
        { Name: "Loan Purpose" },
        ...(LoanData["LoanPurpose"] === 1
          ? [
              { Name: "Purchase Status" }, //
              { Name: "Purchase Status 2" },
            ]
          : LoanData["LoanPurpose"] === 2
          ? [{ Name: "Refinance Purpose" }]
          : []),
        { Name: "Who Referred" },
        { Name: "Loan Officers" },
        { Name: "Property Information" },
        ...(LoanData["LoanPurpose"] === 2 ? [{ Name: "Primary Purpose" }] : []),
        { Name: "Loan Amount" },
      ],
      creditPageList: [
        ...(creditScoreDetails?.Status === 5 ||
        creditScoreDetails?.Details[0]?.iFinalScanDocID
          ? [{ Name: "View Credit Report" }]
          : []),
        ...[
          { Name: "Order Report" },
          { Name: "Frozen Credit Report" },
          { Name: "Social Security Number" },
          ...(LoanData["FrozenCredit"] === 1
            ? [{ Name: "Unfreeze Your Account" }]
            : [{ Name: "Credit Authorization" }]),
        ],

        ...(LoanData["creditReportOrdered"] ||
        creditScoreDetails?.Status === 5 ||
        creditScoreDetails?.Details[0]?.iFinalScanDocID
          ? [{ Name: "Credit Report Ordered" }]
          : []),
      ],
      pageIndex: pageIndex,
      isLoaded: LoanData["isLoaded"],
    };
  };

  const handleGetEmpploymentList = (iAdditionalEmploymentInfo) => {
    let list = groupByKey(
      handleEmploymentOrder(
        iAdditionalEmploymentInfo || additionalEmploymentInfo
      ).map((employment, index) => {
        let empRow = additionalBorrowerInfo.filter(
          (borrower) =>
            Number(borrower["CustId"]) === Number(employment["CustId"])
        );
        if (empRow.length > 0) empRow = empRow[0];
        return {
          Name:
            empRow["FirstName"] || empRow["LastName"]
              ? `${empRow["FirstName"]} ${empRow["LastName"]}`
              : `Employment ${index + 1}`,
          CustId: employment["CustId"],
          subName:
            `${employment["Empmt_Emp_Name"]} ${employment["Job_Title"]}`.trim() ||
            `Employment ${index + 1}`,
          Id: employment["Id"],
        };
      }),
      "Name"
    )
      .map(function (item) {
        item["subMenu"]?.push({ Name: "Additional Employment" });
        return item;
      })
      .flat();

    return list;
  };

  const handleGetAddressHistoryList = () => {
    let list = [],
      subMenu = [];

    let totalMonthCount = handleGetMonthCount(
      parseInt(LoanData["Addrshistry_Months"] || 0) || 0,
      parseInt(LoanData["Addrshistry_Years"] || 0) || 0
    );
    subMenu.push({ Name: "Present Address" });
    for (let i = 0; i < 4; i++) {
      if (totalMonthCount < 24) {
        totalMonthCount += handleGetMonthCount(
          parseInt(LoanData[`Addrshistry_Months${i}`] || 0) || 0,
          parseInt(LoanData[`Addrshistry_Years${i}`] || 0) || 0
        );
        i = i === 0 ? "" : i;
        if (i !== "") subMenu.push({ Name: "Previous Address " + i });
      }
    }
    list.push({
      Name:
        LoanData["FirstName"] || LoanData["LastName"]
          ? `${LoanData["FirstName"]} ${LoanData["LastName"]}`
          : `borrower 1`,

      subMenu,
    });

    subMenu = [];

    list.push(
      ...additionalBorrowerInfo.slice(1).map((borrower, index) => {
        subMenu = [{ Name: "Present Address" }];
        totalMonthCount = handleGetMonthCount(
          parseInt(
            handleGetBorrYearMonth(borrower["Bor Own Period"], "Months") || 0
          ) || 0,
          parseInt(
            handleGetBorrYearMonth(borrower["Bor Own Period"], "Years") || 0
          ) || 0
        );

        if (totalMonthCount < 24) {
          for (let i = 1; i < 4; i++) {
            if (totalMonthCount < 24) {
              totalMonthCount += handleGetMonthCount(
                parseInt(
                  handleGetBorrYearMonth(
                    borrower[`Bor For Add${i} Yrs`],
                    "Months"
                  ) || 0
                ) || 0,
                parseInt(
                  handleGetBorrYearMonth(
                    borrower[`Bor For Add${i} Yrs`],
                    "Years"
                  ) || 0
                ) || 0
              );

              subMenu.push({ Name: "Previous Address " + i });
            }
          }
        }
        return {
          Name:
            borrower["FirstName"] || borrower["LastName"]
              ? `${borrower["FirstName"]} ${borrower["LastName"]}`
              : `borrower ${index + 1}`,

          subMenu,
        };
      })
    );
    // console.log(list);
    return list;
  };

  return (
    <View style={styles.mianContainer}>
      <NavBar
        setFloatPage={setFloatPage}
        WebLoginId={WebLoginId}
        userName={userName}
        navigate={navigate}
        {...props}
        isSmallScreen={isSmallScreen}
        settingsDetails={{
          cellPhone: handleGetCellPhone(LoanData["CellPhone"]) || "",
          emailId: LoanData["EmailId"] || "",
          UserId,
        }}
        setProgressPercentage={setProgressPercentage}
        hideProgress={hideProgress}
        {...getNavBarProps()}
        currentPage={currentPage}
        platformType={platformType}
        showEsignMenu={showEsignMenu}
        webviewRef={webviewRef}
        iFrameviewRef={iFrameviewRef}
      />

      <View
        ref={bodyContainerRef}
        style={[
          {
            flex: 1,
            flexDirection: "row",
          },
          web ? { maxHeight: isSmallScreen ? "86vh" : "81vh" } : {},
          web && !isSmallScreen
            ? {
                ...{
                  overflow:
                    currentPage === pageArray[pageId["eSign"]]
                      ? "hidden"
                      : "auto",
                  marginBottom: isMobileWeb ? 0 : 25,
                },
                ...(!isSmallScreen
                  ? { justifyContent: isMobileWeb ? "left" : "center" }
                  : {}),
              }
            : { backgroundColor: "#fff" },
        ]}
        testID="scrollContainer"
      >
        <>
          {isSmallScreen && (
            <>
              <LeftNavBar {...getNavBarProps()} />
            </>
          )}
        </>

        <Separator />
        <View
          style={[
            { flex: 1, flexDirection: "column" },
            (web || (!web && isSmallScreen)) && {
              maxWidth:
                440 +
                (currentPage === pageArray[pageId["reviewYourInterestRate"]]
                  ? 20
                  : 0),
              minHeight:
                440 +
                (currentPage === pageArray[pageId["reviewYourInterestRate"]]
                  ? 20
                  : 0),
              marginBottom: 20,
              position: loaderDetails["isLoad"] ? "fixed" : "relative",
              left: isSmallScreen && web ? 350 : 0,
            },
            currentPage === pageArray[pageId["eSign"]] && {
              ...(web
                ? { maxWidth: "unset", minWidth: "unset", overflow: "hidden" }
                : { overflow: "hidden" }),
            },
            currentPage === pageArray[pageId["appraisalPayment"]] && {
              ...(web
                ? { maxWidth: isMobileWeb ? 420 : "82%", minWidth: "unset" }
                : { overflow: "hidden" }),
            },
            InterestRateStatus == "customizeOptions" && {
              ...(web
                ? {
                    maxWidth: "calc(100% - 350px) ",
                    minWidth: "calc(100% - 350px) ",
                  }
                : {}),
            },
            web && { maxHeight: "85vh" },
          ]}
        >
          {contextDetails["appDownloadFlag"] &&
          !contextDetails["appDownloadSkip"] ? (
            <View style={[styles.container, { top: 25, position: "absolute" }]}>
              <CustomText style={{ fontSize: 24 }} bold={true}>
                Mobile Device Found
              </CustomText>

              <Separator />
              <CustomText style={{ fontSize: 15 }}>
                We noticed you are using a mobile device. Would you like to
                download our mobile app now?
              </CustomText>
              <Separator />
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <TouchableOpacity
                  activeOpacity={1}
                  onPress={() => {
                    handleGoToApp();
                  }}
                  style={{
                    flex: 1,
                    flexDirection: "row",
                    alignItems: "stretch",
                    backgroundColor: "#1a63ad",
                    borderRadius: 20,
                    paddingHorizontal: 20,
                    paddingVertical: 10,
                    borderWidth: 1,
                    borderColor: "#29916c",
                  }}
                >
                  <CustomText
                    style={{ fontSize: 15, color: "#fff" }}
                    bold={true}
                  >
                    Use App
                  </CustomText>
                </TouchableOpacity>
                {/* <TouchableOpacity
                    activeOpacity={1}
                    onPress={() => {
                      handleGoToApp();
                    }}
                  >
                    <Image
                      style={{
                        position: "relative",
                        height: "40px",
                        width: "135px",
                        transform: "scale(0.85)",
                        cursor: "pointer",
                      }}
                      source={
                        contextDetails["webPlatForm"] == "Android"
                          ? require("../../assets/GooglePlay.png")
                          : require("../../assets/AppleAppStore.png")
                      }
                    ></Image>
                  </TouchableOpacity> */}
              </View>
              <Separator />

              <View style={{ flexDirection: "row" }}>
                <View
                  style={[
                    {
                      marginTop: 10,
                      alignSelf: "flex-start",
                      marginBottom: -10,
                      marginRight: 10,
                    },
                    isMobileWeb &&
                      web && {
                        width: "fit-content",
                      },
                  ]}
                >
                  <TouchableOpacity
                    activeOpacity={1}
                    style={{
                      flex: 1,
                      flexDirection: "row",
                      alignItems: "stretch",
                      backgroundColor: "#1a63ad",
                      borderRadius: 20,
                      paddingHorizontal: 10,
                      paddingVertical: 10,
                      borderWidth: 1,
                      borderColor: "#29916c",
                    }}
                    onPress={handleNextClick}
                  >
                    <View style={{ flex: 1, flexDirection: "row" }}>
                      <CustomText
                        style={{
                          color: "#fff",
                          marginTop: -2,
                          fontSize: isMobileWeb ? 12 : 14,
                        }}
                        bold={true}
                      >
                        Continue
                      </CustomText>
                    </View>
                  </TouchableOpacity>
                </View>
                <View
                  style={[
                    {
                      marginTop: 10,
                      alignSelf: "flex-start",
                      marginBottom: -10,
                      marginRight: 10,
                    },
                    isMobileWeb &&
                      web && {
                        width: "fit-content",
                      },
                  ]}
                >
                  <TouchableOpacity
                    activeOpacity={1}
                    style={{
                      flex: 1,
                      flexDirection: "row",
                      alignItems: "stretch",
                      // backgroundColor: "#1a63ad",
                      borderRadius: 20,
                      paddingHorizontal: 10,
                      paddingVertical: 10,
                      borderWidth: 1,
                      borderColor: "#1a63ad", //"#29916c",
                    }}
                    onPress={handleAppDownloadSave}
                  >
                    <View style={{ flex: 1, flexDirection: "row" }}>
                      <CustomText
                        style={{
                          color: "gray", // "#fff",
                          marginTop: -2,
                          fontSize: isMobileWeb ? 12 : 14,
                        }}
                        bold={true}
                      >
                        Continue and Don't Prompt again
                      </CustomText>
                    </View>
                  </TouchableOpacity>
                </View>
              </View>
              <Separator />
              <Separator />
            </View>
          ) : (
            <View
              ref={
                web ||
                currentPage === pageArray[pageId["eSign"]] ||
                currentPage === pageArray[pageId["appraisalPayment"]] ||
                pageArray[pageId["reviewYourInterestRate"]]
                  ? bodyContentRef
                  : null
              }
              style={[
                currentPage === pageArray[pageId["eSign"]] && {
                  flex: 1,
                },
                !web && { flex: 1 },
              ]}
            >
              {currentPage === pageArray[pageId["eSign"]] ? (
                <>
                  {web ? (
                    <View
                      style={{
                        paddingHorizontal: 20,
                        width: isSmallScreen ? "calc(100% - 310px)" : "100%",
                        height: "98%",
                      }}
                    >
                      <ExternalSourceViewer
                        url={`../../../esignpackage/index.html?SessionId=${SessionId}&hideHeader=1&platform=${platformType}`}
                        isNeedBack={false}
                        isSmallScreen={isSmallScreen}
                        setHideFooterButtons={setHideFooterButtons}
                        handleNavigation={handleNavigation}
                        setHideProgress={setHideProgress}
                        fromEsign={true}
                        setPdfView={setPdfView}
                        setShowEsignMenu={setShowEsignMenu}
                        setWebviewRef={setWebviewRef}
                        setiFrameviewRef={setiFrameviewRef}

                        //isDisable={LoanData["LockLoanApp"] == 1} //Disabled when the loan is in Underwriting - Esign
                      />
                    </View>
                  ) : (
                    <ExternalSourceViewer
                      // url={`../../../esignpackage/index.html?SessionId=${SessionId}&hideHeader=1&platform=${platformType}`}
                      url={`../../../esignpackage/index.html?SessionId=${SessionId}&hideHeader=1&platform=${platformType}&pkgCheck=1`}
                      isNeedBack={false}
                      isSmallScreen={isSmallScreen}
                      setHideFooterButtons={setHideFooterButtons}
                      handleNavigation={handleNavigation}
                      setHideProgress={setHideProgress}
                      fromEsign={true}
                      setPdfView={setPdfView}
                      setShowEsignMenu={setShowEsignMenu}
                      setWebviewRef={setWebviewRef}
                      setiFrameviewRef={setiFrameviewRef}

                      //isDisable={LoanData["LockLoanApp"] == 1} //Disabled when the loan is in Underwriting - Esign
                    />
                  )}
                </>
              ) : currentPage === pageArray[pageId["appraisalPayment"]] ? (
                <>
                  <AppraisalPayment
                    setAlertMessage={setAlertMessage}
                    alertMessage={alertMessage}
                    setTopEdge={setTopEdge}
                    navigation={navigation}
                    isSmallScreen={!isSmallScreen}
                    UserId={UserId}
                    loanPurpose={
                      Number(LoanData["LoanPurpose"]) === 1
                        ? 1
                        : Number(LoanData["LoanPurpose"]) === 2
                        ? 3
                        : 0
                    }
                    loanId={loanId}
                    stateOptions={stateOptions}
                    userName={userName}
                    footerButton={<></>}
                    setIsPaymentDone={setIsPaymentDone}
                    triggerHiddenButtonClick={clickProcessPayment}
                    triggerHiddenButtonClickDone={handleHiddenButtonClickDone}
                    ProcessPaymentDisabled={handleProcessPaymentDisabled}
                    ProcessingStatus={handleProcessingStatus}
                  />
                </>
              ) : currentPage ===
                pageArray[pageId["reviewYourInterestRate"]] ? (
                <>
                  {LoanData["UserId"] && loanId && SessionId ? (
                    <View style={{ flex: 1 }}>
                      <InterestRate
                        setFloatPage={setFloatPage}
                        floahandleSaveSubjectPropertytPage={floatPage}
                        isDisable={LoanData["LockLoanApp"] == 1}
                        userId={LoanData["UserId"]}
                        loanId={loanId}
                        SessionId={SessionId}
                        navigation={navigation || props["navigation"]}
                        stateOptions={stateOptions}
                        handleLoaderDetails={handleLoaderDetails}
                        handleGetLeftNavStatus={handleGetLeftNavStatus}
                        userName={userName}
                        handleNextClick={handleNextClick}
                        setInterestRateStatus={setInterestRateStatus}
                        LoanData={LoanData}
                        handleGetBorrowerUrl={handleGetBorrowerUrl}
                        handleSaveSubjectProperty={handleSaveSubjectProperty}
                        handleRequiredFieldData={(key, value) => {
                          setLoanData((prevLoanData) => {
                            return {
                              ...prevLoanData,
                              [key]: value,
                            };
                          });
                        }}
                        additionalBorrowerInfo={additionalBorrowerInfo}
                        handleUpdateAddtionalBorrower={
                          handleUpdateAddtionalBorrower
                        }
                        handleSaveSSnDetails={handleSaveSSnDetails}
                        propertyTypeOption={propertyTypeOption}
                        handleCalculateDownPaymentPer={
                          handleCalculateDownPaymentPer
                        }
                        DownPmtOnChange={DownPmtOnChange}
                        LnAmtExcChange={LnAmtExcChange}
                        CalculateDownPayment={CalculateDownPayment}
                        CalculateLnAmt={CalculateLnAmt}
                        handleSaveRequiredFields={handleSaveRequiredFields}
                      />
                      {!web && (
                        <View
                          style={[
                            {
                              position: "absolute",
                              bottom: 0,
                              backgroundColor: "#fff",
                              paddingHorizontal: 10,
                              paddingVertical: 10,
                              paddingRight: 20,
                              borderRadius: 5,
                              marginTop: -25,
                              width: "100%",
                            },
                          ]}
                        >
                          <View
                            style={[
                              {
                                flexDirection: "row-reverse",
                                justifyContent: "space-between",
                              },
                            ]}
                          >
                            <Button
                              disabled={false}
                              onPress={handleNextClick}
                              title={
                                <>
                                  <CustomText
                                    bold={true}
                                    style={{
                                      fontSize: 14,
                                      color: "#fff",
                                      display: "flex",
                                      alignSelf: "center",
                                    }}
                                  >
                                    Next
                                    {!web ? " " : ""}
                                  </CustomText>
                                  <CustomText>
                                    <Icon
                                      style={{ marginLeft: 5 }}
                                      name="arrow-circle-right"
                                      size={18}
                                      color="white"
                                    />
                                  </CustomText>
                                </>
                              }
                            />
                            <Button
                              onPress={() => {
                                handleNavigation(-1);
                              }}
                              title={
                                <>
                                  <CustomText style={{ marginRight: 5 }}>
                                    <Icon
                                      name="arrow-circle-left"
                                      size={18}
                                      color="white"
                                    />
                                  </CustomText>
                                  <CustomText
                                    bold={true}
                                    style={{
                                      fontSize: 14,
                                      color: "#fff",
                                      display: "flex",
                                      alignSelf: "center",
                                    }}
                                  >
                                    {!web ? " " : ""}
                                    Back
                                  </CustomText>
                                </>
                              }
                            />
                          </View>
                        </View>
                      )}
                    </View>
                  ) : (
                    <View
                      style={[
                        styles["titleWrapper"],
                        {
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "center",
                        },
                      ]}
                    >
                      <View
                        style={{
                          height: web ? 28 : 19,
                          width: web ? 28 : 19,
                        }}
                      >
                        <ArrowSpinner
                          size={web ? 28 : 19}
                          color={"#fff"}
                          isSpinner
                        />
                      </View>
                      <CustomText style={[styles["title"]]} bold={true}>
                        {" Loading..."}
                      </CustomText>
                    </View>
                  )}
                </>
              ) : (
                <>
                  {web && <Separator />}
                  <View
                    onLayout={(event) => {
                      if (!web) {
                        let layout = event.nativeEvent.layout;
                        setTopEdge((prev) => {
                          return {
                            ...prev,
                            contentWrapperY: layout.y,
                            contentWrapperHeight: layout.height,
                          };
                        });
                      }
                    }}
                    style={[
                      styles.container,
                      currentPage === pageArray[pageId["documentUpload"]]
                        ? { padding: 5, marginTop: 5 }
                        : {},
                    ]}
                  >
                    {web && <Separator />}
                    <View
                      style={{
                        flexDirection: "row",
                        width: "100%",
                        justifyContent:
                          LoanData["LinkBankAccount"] === 1 &&
                          LoanData["BankAccountLinked"] !== 1 &&
                          DetailsArr.slice(1)[pageIndex["subPage"]]
                            ?.bodyContent === "LinkBankAccount"
                            ? "space-between"
                            : "flex-end",
                      }}
                    >
                      {LoanData["viewPlaid"] &&
                        LoanData["BankAccountLinked"] !== 1 &&
                        DetailsArr.slice(1)[pageIndex["subPage"]]
                          ?.bodyContent === "LinkBankAccount" && (
                          <CustomText
                            bold={true}
                            style={{
                              marginBottom: 10,
                              color: "#41464d",
                              flexDirection: "row",
                              alignSelf: "flex-start",
                              flex: 1,
                            }}
                            onPress={() => {
                              setLoanData((prevLoanData) => ({
                                ...prevLoanData,
                                viewPlaid: false,
                              }));
                              setPageIndex({ ...pageIndex, subPage: 0 });
                              handleResetPlaidDetails(null);
                              // handleOptionPress(null);
                              if (web) {
                                document
                                  ?.querySelector('iframe[title="Plaid Link"]')
                                  ?.remove();
                              }
                            }}
                          >
                            ← Back
                          </CustomText>
                        )}
                    </View>
                    <View style={{ width: "100%" }}>
                      <ScrollContainer
                        onScroll={Animated.event(
                          [
                            {
                              nativeEvent: { contentOffset: { y: scrollY } },
                            },
                          ],
                          { useNativeDriver: true }
                        )}
                        scrollToTop={scrollToTop}
                        setScrollToTop={setScrollToTop}
                        pullDownRefresh={async () => {
                          if (
                            currentPage === pageArray[pageId["documentUpload"]]
                          ) {
                            setPullDownRefresh(true);
                          } else {
                            await handleAPIGetLoanDetails(loanId, true);
                          }
                        }}
                      >
                        <View
                          ref={!web ? bodyContentRef : null}
                          pointerEvents={
                            //Exclude for Doc Upload and Credit score
                            LoanData["LockLoanApp"] == 1 &&
                            currentPage !==
                              pageArray[pageId["documentUpload"]] &&
                            currentPage !== pageArray[pageId["creditScore"]] &&
                            currentPage !==
                              pageArray[pageId["appraisalPayment"]] &&
                            currentPage !==
                              pageArray[pageId["borrowerVerification"]]
                              ? "none"
                              : "auto"
                          }
                        >
                          {DetailsArr.slice(1).length > 0 ? (
                            <>
                              {DetailsArr.slice(1)[pageIndex["subPage"]] && (
                                <>
                                  {currentPage ===
                                    pageArray[pageId["summaryInfo"]] &&
                                    DetailsArr[0]["currentPage"] ===
                                      pageArray[pageId["summaryInfo"]] && (
                                      <SummaryInfo
                                        detailsArr={
                                          DetailsArr.slice(1)[
                                            pageIndex["subPage"]
                                          ]
                                        }
                                        handleOptionPress={handleOptionPress}
                                        LockLoanApp={
                                          LoanData["LockLoanApp"] || 0
                                        }
                                      />
                                    )}
                                  {currentPage ===
                                    pageArray[pageId["borrowerInfo"]] &&
                                    DetailsArr[0]["currentPage"] ===
                                      pageArray[pageId["borrowerInfo"]] && (
                                      <ContactInfo
                                        detailsArr={
                                          DetailsArr.slice(1)[
                                            pageIndex["subPage"]
                                          ]
                                        }
                                        handleOptionPress={handleOptionPress}
                                        LockLoanApp={
                                          LoanData["LockLoanApp"] || 0
                                        }
                                      />
                                    )}

                                  {currentPage ===
                                    pageArray[pageId["addressHistory"]] &&
                                    DetailsArr[0]["currentPage"] ===
                                      pageArray[pageId["addressHistory"]] && (
                                      <AddressHistory
                                        detailsArr={
                                          DetailsArr.slice(1)[
                                            pageIndex["subPage"]
                                          ]
                                        }
                                        handleOptionPress={handleOptionPress}
                                        LockLoanApp={
                                          LoanData["LockLoanApp"] || 0
                                        }
                                      />
                                    )}
                                  {currentPage ===
                                    pageArray[pageId["creditScore"]] &&
                                    DetailsArr[0]["currentPage"] ===
                                      pageArray[pageId["creditScore"]] && (
                                      <CreditScore
                                        detailsArr={
                                          DetailsArr.slice(1)[
                                            pageIndex["subPage"]
                                          ]
                                        }
                                        handleOptionPress={handleOptionPress}
                                      />
                                    )}
                                  {currentPage ===
                                    pageArray[pageId["employment"]] &&
                                    DetailsArr[0]["currentPage"] ===
                                      pageArray[pageId["employment"]] && (
                                      <Income
                                        detailsArr={
                                          DetailsArr.slice(1)[
                                            pageIndex["subPage"]
                                          ]
                                        }
                                        handleOptionPress={handleOptionPress}
                                        LockLoanApp={
                                          LoanData["LockLoanApp"] || 0
                                        }
                                      />
                                    )}
                                  {((currentPage ===
                                    pageArray[pageId["bankAccounts"]] &&
                                    DetailsArr[0]["currentPage"] ===
                                      pageArray[pageId["bankAccounts"]]) ||
                                    (currentPage ===
                                      pageArray[pageId["realEstateOwned"]] &&
                                      DetailsArr[0]["currentPage"] ===
                                        pageArray[
                                          pageId["realEstateOwned"]
                                        ])) && (
                                    <Assets
                                      detailsArr={
                                        DetailsArr.slice(1)[
                                          pageIndex["subPage"]
                                        ]
                                      }
                                      handleOptionPress={handleOptionPress}
                                      LockLoanApp={LoanData["LockLoanApp"] || 0}
                                    />
                                  )}
                                  {currentPage ===
                                    pageArray[pageId["government"]] &&
                                    DetailsArr[0]["currentPage"] ===
                                      pageArray[pageId["government"]] && (
                                      <Government
                                        detailsArr={
                                          DetailsArr.slice(1)[
                                            pageIndex["subPage"]
                                          ]
                                        }
                                        handleOptionPress={handleOptionPress}
                                        LockLoanApp={
                                          LoanData["LockLoanApp"] || 0
                                        }
                                      />
                                    )}
                                </>
                              )}
                              {currentPage ===
                                pageArray[pageId["borrowerVerification"]] &&
                                DetailsArr[0]["currentPage"] ===
                                  pageArray[pageId["borrowerVerification"]] && (
                                  <BorrowerVerification
                                    detailsArr={DetailsArr.slice(1)[0]}
                                    handleOptionPress={handleOptionPress}
                                    LockLoanApp={LoanData["LockLoanApp"] || 0}
                                    loanId={loanId}
                                    userId={UserId}
                                    assetVendor={loanURLDetails["assetVendor"]}
                                    handleNavigation={handleNavigation}
                                    handleGetBankEmpDetails={
                                      handleGetBankEmpDetails
                                    }
                                  />
                                )}
                              {((web && stickyHeader) ||
                                (!web && topEdge > 0)) && (
                                <>
                                  <Separator />
                                  <PageBottom />
                                  <Separator />
                                  <Separator />
                                </>
                              )}
                            </>
                          ) : (
                            currentPage !==
                              pageArray[pageId["documentUpload"]] &&
                            currentPage !== pageArray[pageId["eSign"]] &&
                            currentPage !== pageArray[pageId["completed"]] && (
                              <>
                                <Spinner />
                              </>
                            )
                          )}
                          {currentPage ===
                            pageArray[pageId["documentUpload"]] && (
                            <View style={{ marginTop: 5 }}>
                              <DocumentUpload
                                setPullDownRefresh={setPullDownRefresh}
                                pullDownRefresh={pullDownRefresh}
                                isDataLoadedForDocUpload={
                                  isDataLoadedForDocUpload
                                }
                                setDocumentViewProps={setDocumentViewProps}
                                loanData={LoanData}
                                documentUploadFlag={documentUploadFlag}
                                handleSaveAdditionalInfo={
                                  handleSaveAdditionalInfo
                                }
                                userId={LoanData["UserId"]}
                                loanId={loanId}
                                SessionId={SessionId}
                                navigation={navigation || props["navigation"]}
                                handleAPIGetLoanDetails={() => {
                                  handleAPIGetLoanDetails(loanId, true);
                                }}
                              />
                              <Separator />
                              <>
                                {loanId > 0 && <LoanId Id={loanId} />}
                                {stickyHeader && (
                                  <>
                                    <PageBottom />
                                    <Separator />
                                    <Separator />
                                  </>
                                )}
                              </>
                            </View>
                          )}
                          {currentPage === pageArray[pageId["completed"]] && (
                            <>
                              <Title
                                text={`Your loan application is ${progressPercentage}% complete.\n`}
                              />
                              <CustomText
                                style={{
                                  marginBottom: 20,
                                  fontSize: web ? 20 : 17,
                                }}
                              >
                                Clicking the Next button will take you to your
                                dashboard. From there, you can also view any
                                remaining tasks.
                              </CustomText>
                            </>
                          )}
                          {web && <Separator />}
                        </View>

                        <View
                          // ref={footerContainerRef}
                          onLayout={(event) => {
                            if (!web) {
                              let layout = event.nativeEvent.layout;
                              setTopEdge((prev) => {
                                return {
                                  ...prev,
                                  contentY: layout.y,
                                  contentHeight: layout.height,
                                };
                              });
                            }
                          }}
                          style={{
                            height: 50,
                          }}
                        ></View>
                        {!web && (
                          <>
                            {Array.from({ length: 10 }).map((_, index) => (
                              <Separator key={index} />
                            ))}
                          </>
                        )}
                      </ScrollContainer>
                    </View>
                  </View>
                </>
              )}
            </View>
          )}
          {((iTopEdge["contentY"] &&
            currentPage !== pageArray[pageId["reviewYourInterestRate"]]) ||
            currentPage == pageArray[pageId["eSign"]] ||
            (web && !contextDetails["appDownloadFlag"])) && (
            <Animated.View
              ref={footerContainerRef}
              style={[
                {
                  backgroundColor: "#fff",
                  paddingHorizontal: web ? 20 : 0,
                  paddingVertical: 10,
                  paddingBottom: 20,
                  alignSelf: android ? "flex-start" : "left",
                  display:
                    currentPage == pageArray[pageId["eSign"]] &&
                    hideFooterButtons
                      ? "none"
                      : "flex",
                },
                Object.keys(LoanData).length == 0 && {
                  display: "none",
                },
                !web &&
                  currentPage !== pageArray[pageId["eSign"]] && {
                    transform: [
                      {
                        translateY: scrollY.interpolate({
                          inputRange,
                          outputRange: [0, 0, 0, 0, -1],
                        }),
                      },
                    ],
                  },
                web &&
                  stickyHeader && {
                    paddingTop:
                      currentPage ===
                      pageArray[pageId["reviewYourInterestRate"]]
                        ? 0
                        : 20,
                    width:
                      currentPage === pageArray[pageId["eSign"]]
                        ? 880
                        : isMobileWeb
                        ? 327
                        : 420,
                    marginLeft: 20,
                    position: "fixed",
                    bottom: 50,
                    borderTopWidth: 2,
                    borderTopColor:
                      currentPage ===
                      pageArray[pageId["reviewYourInterestRate"]]
                        ? "#fff"
                        : "#ccc",
                    borderRadius: 5,
                  },

                web &&
                  stickyHeader &&
                  currentPage === pageArray[pageId["appraisalPayment"]] && {
                    paddingTop: 20,
                    width: isMobileWeb ? 327 : 420,
                    marginLeft: 20,
                    position: "fixed",
                    bottom: 70,
                    borderTopWidth: 2,
                    borderTopColor: "#ccc",
                    borderRadius: 5,
                    borderTopWidth: 2,
                    borderTopColor: "#ccc",
                  },
                web &&
                  !stickyHeader &&
                  currentPage === pageArray[pageId["appraisalPayment"]] && {
                    paddingTop: 20,
                    width: isMobileWeb ? 327 : 420,
                    marginLeft: 20,
                    marginTop: -25,
                    boxShadow: "3px 7px 10px 4px rgb(0 0 0 / 8%)",
                  },

                web &&
                !stickyHeader &&
                currentPage !== pageArray[pageId["appraisalPayment"]]
                  ? // && currentPage !== pageArray[pageId["reviewYourInterestRate"]]
                    {
                      marginLeft: 20,
                      paddingTop: 20,
                      marginTop: -104,
                      // boxShadow: "3px 7px 10px 4px rgb(0 0 0 / 8%)",
                      borderRadius: 5,
                    }
                  : web &&
                    !stickyHeader &&
                    currentPage ===
                      pageArray[pageId["reviewYourInterestRate"]] && {
                      backgroundColor: "#e7e7e7",
                      marginHorizontal: 20,
                      paddingTop: 20,
                      borderRadius: 5,
                      marginTop: -25,
                      boxShadow: "0px 6px 7px 0px rgba(0, 0, 0, 0.25)",
                    },
                isMobileWeb && {
                  width:
                    currentPage === pageArray[pageId["reviewYourInterestRate"]]
                      ? "91%"
                      : "90%",
                  // pageArray[pageId["appraisalPayment"]]
                  //   ? "90%"
                  //   : "90%",
                },
              ]}
            >
              {currentPage === pageArray[pageId["appraisalPayment"]] && (
                <>
                  {alertMessage["isShow"] && alertMessage["message"] && (
                    <View
                      style={{
                        backgroundColor:
                          alertMessage["type"] == "danger"
                            ? "#f2dede"
                            : alertMessage["type"] == "warning"
                            ? "#fcf8e3"
                            : "#dff0d8",
                        borderWidth: 1,
                        borderColor:
                          alertMessage["type"] == "danger"
                            ? "#ebccd1"
                            : alertMessage["type"] == "warning"
                            ? "#faebcc"
                            : "#d6e9c6",
                        padding: 10,
                        flexDirection: "row",
                        marginBottom: 20,
                      }}
                    >
                      <CustomText
                        style={{
                          color:
                            alertMessage["type"] == "danger"
                              ? "#a94442"
                              : alertMessage["type"] == "warning"
                              ? "#8a6d3b"
                              : "#3c763d",
                        }}
                      >
                        {alertMessage["message"]}
                      </CustomText>
                      <TouchableOpacity
                        activeOpacity={1}
                        onPress={() => {
                          setAlertMessage({
                            message: null,
                            isShow: false,
                            type: null,
                          });
                        }}
                      >
                        <Icon
                          name="close"
                          size={14}
                          color="#8a6d3b"
                          style={{ opacity: 0.5 }}
                        />
                      </TouchableOpacity>
                    </View>
                  )}
                  {!isPaymentDone && (
                    <View
                      style={{
                        marginBottom: 25,
                        alignSelf: "center",
                        width: "100%",
                        marginLeft: web ? 0 : 25,
                      }}
                    >
                      <Button
                        disabled={processPaymentDisabled}
                        onPress={(e) => {
                          !processPaymentDisabled &&
                            setClickProcessPayment(true);
                        }}
                        title={
                          <>
                            <CustomText
                              bold={true}
                              style={[
                                {
                                  fontSize: 16,
                                  color: "#fff",
                                  alignSelf: "center",
                                  flex: 1,
                                },
                                web && { textAlign: "center" },
                              ]}
                            >
                              {processingStatus === "Next" ? (
                                <>
                                  <ArrowSpinner
                                    color="#fff"
                                    isSpinner={true}
                                    size={20}
                                    style={{ marginLeft: 20, marginBottom: 5 }}
                                  />
                                </>
                              ) : (
                                "Next - Process Payment"
                              )}
                            </CustomText>
                          </>
                        }
                      />
                      <CustomText
                        style={{ fontSize: 12, marginLeft: web ? 0 : 10 }}
                      >
                        A charge will appear from Direct Services, LLC.
                      </CustomText>
                    </View>
                  )}
                </>
              )}
              <View
                style={[
                  {
                    alignItems: "center",
                    flexDirection: "row-reverse",
                    justifyContent: "space-between",
                    paddingBottom:
                      currentPage === pageArray[pageId["appraisalPayment"]] &&
                      web
                        ? 40
                        : 0,
                  },
                  !web && {
                    width: Dimensions.get("window").width - 10,
                    alignItems: "center",
                  },
                  web &&
                    currentPage === pageArray[pageId["eSign"]] && {
                      width: isMobileWeb ? 327 : 850,
                    },
                ]}
              >
                <Button
                  disabled={
                    (isDisableNext && GoToNav != pageId["documentUpload"]) ||
                    processStatus === "addingBorrower"
                  }
                  onPress={() => {
                    if (currentPage == "eSign" && (!web || isMobileWeb))
                      setHideProgress(false);
                    handleNextClick();
                  }}
                  title={
                    processStatus === "addingBorrower" ? (
                      <View
                        bold={true}
                        style={[
                          {
                            fontSize: 16,
                            color: "#fff",
                            alignSelf: "center",
                            flex: 1,
                            width: 50,
                            height: 25,
                            paddingTop: web ? 8 : 10,
                          },
                          web && { textAlign: "center" },
                        ]}
                      >
                        <ArrowSpinner
                          color="#fff"
                          isSpinner={true}
                          size={20}
                          style={web && { marginHorizontal: 15 }}
                        />
                      </View>
                    ) : (
                      <>
                        <CustomText
                          bold={true}
                          style={{
                            fontSize: 14,
                            color: "#fff",
                            display: "flex",
                            alignSelf: "center",
                          }}
                        >
                          {currentPage ===
                            pageArray[pageId["appraisalPayment"]] &&
                          !isPaymentDone
                            ? "Skip"
                            : "Next"}
                          {!web ? " " : ""}
                        </CustomText>
                        <CustomText>
                          <Icon
                            style={{ marginLeft: 5 }}
                            name="arrow-circle-right"
                            size={18}
                            color="white"
                          />
                        </CustomText>
                      </>
                    )
                  }
                />
                <View>
                  {!(
                    contextDetails["appDownloadFlag"] &&
                    pageIndex["subPage"] === 0 &&
                    pageIndex["page"] === 0
                  ) &&
                    !(
                      contextDetails["appDownloadSkip"] &&
                      pageIndex["subPage"] === 0 &&
                      pageIndex["page"] === 0
                    ) &&
                    !(
                      contextDetails["webPlatForm"] == "Desktop" &&
                      pageIndex["subPage"] === 0 &&
                      pageIndex["page"] === 0
                    ) && (
                      <Button
                        onPress={() => {
                          if (
                            contextDetails["appDownloadFlag"] ||
                            (pageIndex["subPage"] === 0 &&
                              pageIndex["page"] === 0)
                          ) {
                            if (
                              !(
                                pageIndex["subPage"] === 0 &&
                                pageIndex["page"] === 0
                              )
                            ) {
                              setContextDetails((prevContextDetails) => {
                                prevContextDetails["appDownloadFlag"] = false;
                                return { ...prevContextDetails };
                              });
                            } else {
                              setContextDetails((prevContextDetails) => {
                                prevContextDetails["appDownloadFlag"] = true;
                                return { ...prevContextDetails };
                              });
                              setIsDisableNext(false);
                            }
                          } else {
                            if (currentPage == "eSign" && (!web || isMobileWeb))
                              setHideProgress(false);
                            handleNavigation(-1);
                          }
                        }}
                        title={
                          <>
                            <CustomText style={{ marginRight: 5 }}>
                              <Icon
                                name="arrow-circle-left"
                                size={18}
                                color="white"
                              />
                            </CustomText>
                            <CustomText
                              bold={true}
                              style={{
                                fontSize: 14,
                                color: "#fff",
                                display: "flex",
                                alignSelf: "center",
                              }}
                            >
                              {!web ? " " : ""}
                              Back
                            </CustomText>
                          </>
                        }
                      />
                    )}
                </View>
              </View>
            </Animated.View>
          )}

          {!isMobileWeb && web && navigate && (
            <View
              style={[
                {
                  position: "fixed",
                  bottom: 0,
                  width: currentPage === pageArray[pageId["eSign"]] ? 880 : 425,
                  marginLeft: 17,
                },
              ]}
            >
              <Footer
                handleClearState={handleClearState}
                navigate={navigate}
                setFloatPage={setFloatPage}
                From="Home"
                UserId={UserId}
                userName={userName}
                preventNavigation={
                  ![1, 2].includes(LoanData["LoanPurpose"]) || loanId < 0
                }
              />
            </View>
          )}
        </View>
      </View>

      {web && floatPage && (
        <DrawerView
          onClose={() => {
            setFloatPage(null);
          }}
          bodyStyle={
            web && !isMobileWeb ? floatPage?.["option"]?.["style"] : {}
          }
          isShow={floatPage?.["path"] || floatPage?.["body"] ? true : false}
          From="DocumentUpload"
          isSmallScreen={isSmallScreen}
          needHeaderContent={true}
          body={
            floatPage?.["path"] == "ShareApp" ? (
              <ShareApp
                route={{ params: floatPage?.["option"], SessionId }}
                setFloatPage={setFloatPage}
              />
            ) : floatPage?.["path"] === "LoanContacts" ? (
              <LoanContacts
                route={{ params: floatPage?.["option"] }}
                setFloatPage={setFloatPage}
              />
            ) : floatPage?.["path"] === "Settings" ? (
              <Settings
                route={{ params: floatPage?.["option"] }}
                setFloatPage={setFloatPage}
              />
            ) : floatPage?.["path"] === "Calculator" ? (
              <CalculatorApp
                From="Home"
                route={{ params: floatPage?.["option"] }}
                setFloatPage={setFloatPage}
                LoanId={loanId}
              />
            ) : floatPage?.["path"] === "CalculatorMenu" ? (
              <CalculatorMenu
                navigation={navigation || props["navigation"]}
                route={{ params: floatPage?.["option"] }}
                setFloatPage={setFloatPage}
              />
            ) : (
              floatPage?.["body"] || null
            )
          }
        />
      )}
      <DrawerView
        isShow={drawerDetails["isShow"]}
        From="DocumentUpload"
        isSmallScreen={isSmallScreen}
        needHeaderContent={true}
        onClose={() => {
          setDrawerDetails({
            isShow: false,
            body: <></>,
            onClose: () => {},
          });
        }}
        body={
          drawerDetails["body"] == "addOtherLoanVendor" ? (
            <OtherLoanVendor
              handlePostVendorAdd={handlePostVendorAdd}
              bankIndex={drawerDetails["bankIndex"]}
              loanId={loanId}
              SessionId={SessionId}
              stateOptions={stateOptions}
              drawerDetails={drawerDetails}
              onClose={() => {
                setDrawerDetails({
                  isShow: false,
                  body: <></>,
                  onClose: () => {},
                });
              }}
            />
          ) : (
            <></> || <></>
          )
        }
      />
      {web && (
        <DrawerView
          isShow={DocumentViewProps !== null}
          From="DocumentUpload"
          isSmallScreen={isSmallScreen}
          onClose={() => {
            if (DocumentViewProps["unSavedFileStatus"]) {
              setDocumentViewProps((prevDocumentViewProps) => {
                prevDocumentViewProps["processingStatus"] =
                  "cancelConfirmation";
                return { ...prevDocumentViewProps };
              });
            } else {
              setDocumentViewProps(null);
            }
          }}
          needHeaderContent={true}
          body={
            <DocumentViewer
              {...DocumentViewProps}
              handleAPIGetLoanDetails={() =>
                handleAPIGetLoanDetails(loanId, true)
              }
              handleUnSavedFileStatus={(status) => {
                setDocumentViewProps((prevDocumentViewProps) => {
                  prevDocumentViewProps["unSavedFileStatus"] = status;
                  if (!status) prevDocumentViewProps["processingStatus"] = null;
                  return { ...prevDocumentViewProps };
                });
              }}
            />
          }
        />
      )}
      {web && (
        <>
          <div
            style={{ display: "none" }}
            id="btnStatusCheck"
            onClick={() => {
              handleGetLeftNavStatus();
            }}
          />
          <div
            style={{ display: "none" }}
            id="btnBack"
            onClick={() => {
              handleNavigation(-1);
            }}
          />
          <div
            style={{ display: "none" }}
            id="btnNext"
            onClick={() => {
              handleNavigation(1);
            }}
          />
          <div
            style={{ display: "none" }}
            id="btnHideFooterButtons"
            onClick={() => {
              setHideFooterButtons(!hideFooterButtons);
            }}
          />

          <div
            style={{ display: "none" }}
            id="btnHideEsignMenu"
            onClick={() => {
              //setHideFooterButtons(!hideFooterButtons);
              setShowEsignMenu(false);
            }}
          />

          <div
            style={{ display: "none" }}
            id="btnShowEsignMenu"
            onClick={() => {
              setShowEsignMenu(true);
            }}
          />
        </>
      )}
      <>
        <Entypo
          style={[
            { opacity: 0 },
            (!web || isMobileWeb || isSmallScreen) && { height: 0 },
          ]}
          name={`chevron-up`}
        />
        <Entypo
          style={[
            { opacity: 0 },
            (!web || isMobileWeb || isSmallScreen) && { height: 0 },
          ]}
          name={`chevron-down`}
        />
      </>
      {(!web || isMobileWeb) && navigate && (
        <Footer
          navigate={navigate}
          From="Home"
          UserId={UserId}
          userName={userName}
          setFloatPage={setFloatPage}
        />
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  mianContainer: {
    ...{
      flex: 1,
      width: "100%",
      backgroundColor: "color(srgb 0.9498 0.9594 0.9739)",
      // alignItems: "center",
      justifyContent: "center",
    },
    ...(web ? { backgroundColor: "#fff" } : {}),
  },
  titleWrapper: {
    ...{
      padding: 10,
      marginBottom: 25,
      marginHorizontal: 20,
      backgroundColor: "#395D82",
      marginTop: 15,
    },
    ...(web
      ? {
          boxShadow: "0px 6px 12px 0px #00000059",
        }
      : {}),
  },
  title: {
    fontSize: web ? 20 : 16,
    alignSelf: "center",
    color: "#fff",
    marginVertical: 10,
  },
  card: {
    backgroundColor: "white",
    borderRadius: 8,
    paddingVertical: 45,
    paddingHorizontal: 25,
    width: "100%",
    marginVertical: 10,
  },
  container: [
    {
      backgroundColor: "#fff",
      paddingTop: 20,
      paddingBottom: 10,
      paddingHorizontal: web ? 20 : 0,
      marginLeft: 20,
      marginRight: 20,
      marginTop: 0,
      alignItems: "center",
      borderRadius: 5,
      overflow: "hidden",
      boxShadow: "3px 7px 10px 4px rgb(0 0 0 / 8%)",
      flex: 1,
    },
    web && {
      maxWidth: Dimensions.get("window").width <= 480 ? "90%" : 420,
      minWidth: Dimensions.get("window").width <= 480 ? "90%" : 420,
      overflow: "hidden",
      flex: "none",
      marginBottom: 20,
    },
  ],
  fixToText: {
    flexDirection: "row",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "stretch",
  },
  navLeftOption: {
    ...{
      padding: 20,
      borderRadius: 16,
      fontSize: 19,
    },
    ...(web ? { cursor: "pointer" } : {}),
  },
  active: {
    backgroundColor: "#b5d472",
    color: "#fff",
  },

  container_: {
    flex: 1,
    flexDirection: "row",
    // Other styles for the container
  },
  swipeContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  button: {
    // Styles for the buttons
  },
  section: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    width: "100%",
    backgroundColor: "lightgray",
    // Other styles for the section
  },
  buttonContainer: {
    borderRadius: 15,
    height: 40,
    // paddingVertical: 20,
    // paddingHorizontal: 10,
    marginTop: 8,
    // paddingTop: web ? 8 : null,
    alignSelf: "stretch",
    textAlign: "center",
  },
  infoContainer: {
    marginBottom: 10,
  },
  boldText: {
    fontWeight: "bold",
  },
  linkText: {
    color: "blue",
  },
});
